import {
  Component,
  NgModule,
  OnDestroy,
  OnInit,
  EventEmitter,
  Input,
  Output,
  ViewContainerRef,
  OnChanges,
  TemplateRef,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { DemoService } from '../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import { Routes, RouterModule, Router } from '@angular/router';
import { MysqlService } from './../../../../services/mysql.service';

// view iframes
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { Job } from '../../../../shared/models/job.model';
import { SystemFile } from '../../../../shared/models/file.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import {
  HttpClientModule,
  HttpRequest,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';
import { Location } from '@angular/common';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import { Observable, Subject, Subscription, map } from 'rxjs';
;
import { FileUploaderService } from './../../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { SubjectCommunication } from '../../../../shared/models/subjectCommunication.model';
import { SubjectCommunicationAttatchments } from '../../../../shared/models/subjectCommunicationAttachments.model';
// import { ToolbarService, DocumentEditorContainerComponent } from '@syncfusion/ej2-angular-documenteditor';
// import { isNullOrUndefined } from '@syncfusion/ej2-base';
import {
  MultiSelectComponent,
  DropDownListComponent,
} from '@syncfusion/ej2-angular-dropdowns';

// DocX - https://docx.js.org/#/?id=welcome
// import { Document, Packer, Paragraph, TextRun } from 'docx';

import * as $ from 'jquery';
// see: https://www.youtube.com/watch?v=YPBcy6LSxsg

import * as moment from 'moment';
// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';

import {
  ToolbarService,
  LinkService,
  ImageService,
  HtmlEditorService,
} from '@syncfusion/ej2-angular-richtexteditor';
import {
  RichTextEditorComponent,
  NodeSelection,
} from '@syncfusion/ej2-angular-richtexteditor';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { LegalDateTimeService } from './../../../../services/legal-datetime.service';
import { JobSubject } from './../../../../shared/models/jobSubject.model';
import { DataUtil } from '@syncfusion/ej2-data';
import { ObjectBindingPattern } from 'typescript';
import { TabsetComponent } from 'ngx-bootstrap';
@Component({
  selector: 'app-subject-communication-with-vars',
  templateUrl: './subject-communication-with-vars.component.html',
  styleUrls: ['./subject-communication-with-vars.component.scss']
})
export class SubjectCommunicationWithVarsComponent implements OnInit {





// setup as observable?
@Input() item_id?: Observable<any[]>; // impliments on changes.
@Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
@Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
@Input() item_user_level_id? = '5'; // default to agent just in case
@Input() item_brand_type_id? = '';
@Input() show_buttons? = 'no'; // yes | no
@Input() widget_title? = '';
@Input() widget_size? = 'side'; // side | abstract | full

// @Input() job_id?: Observable<any[]>; // impliments on changes.
@Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
@Output('closeParentModel3') closeParentModel3: EventEmitter<any> = new EventEmitter();
@Output('refreshParentGrid') refreshParentGrid: EventEmitter<any> = new EventEmitter();
@Output('refreshInvoiceItemsBelow') refreshInvoiceItemsBelow: EventEmitter<any> = new EventEmitter();
@Output('refreshSujectInvoicePage') refreshSujectInvoicePage: EventEmitter<any> = new EventEmitter();


  // TABS sets the selected
  @ViewChild('staticTabs') staticTabs!: TabsetComponent;
  selected_tab?: number;

creating_file: number;
sending_comms: number;


  currentUserVAR: any;
  sessionUserId: any;
  sessionUserName: any;
  sessionBrandId: any;
  subject_id: number;
  job_status_run: any;
  subject_notes: any;
  subjects: any;
  public who;

  bsModalRef: BsModalRef;
  // MODAL
  modalRef: BsModalRef;
  subject_com_types: any;

  feature = 'Feature 1';
  selectedFeatures: any = [];
  selectedFeaturesJobFiles: any = [];

  allAttachedFiles: any = [];
  allEmailRecipients: any = [];
  allClientEmailRecipients: any = [];
  allLoginEmailRecipients: any = [];
  allClientInvoiceEmailRecipients: any = [];

  // allAttachments: any[] = [];

  // allAttachments: any[] = [];

  allAttachments = [];
  allRecipients = [];

  // as an angular object / model
  /* allAttachments: any = {
  file_name: 'testfilename.file',
  job_file: 0 ,
  subject_file: 0,
}; */
  empList: Array<any> = [];

  modelds: any;

  public placeholder: String = 'All Recipients';

  // toggle elements
  isShow = true;
  isShow_uploaded = true;
  isShow_email_cc = false;
  isShow_note_template = false;
  isShow_old_template = false;
  isShow_editor = false;

  isShow_AdvancedOptions = false;


  email_template_directory = this.gfunc.baseUploadURLEmailTemplatesNOHTTP;
  // public today = Date.now(); /// THIS IS THE WRONG DATE FORMAT!!!... found nov 2023 upon save
  public today = new Date(); // angular default
  // variables for richtexteditor as form
  @ViewChild('fromRTE')
  private rteEle: RichTextEditorComponent;

  public tools: object = {
    items: [
      'Undo',
      'Redo',
      '|',
      'Bold',
      'Italic',
      'Underline',
      'StrikeThrough',
      '|',
      'FontName',
      'FontSize',
      'FontColor',
      'BackgroundColor',
      '|',
      'SubScript',
      'SuperScript',
      '|',
      'LowerCase',
      'UpperCase',
      '|',
      'Formats',
      'Alignments',
      '|',
      'OrderedList',
      'UnorderedList',
      '|',
      'Indent',
      'Outdent',
      '|',
      'CreateLink',
      'Image',
      '|',
      'ClearFormat',
      'Print',
      'SourceCode',
      '|',
      'FullScreen',
    ],
  };

  // demo data
  document_types: any[] = [
    {
      document_id: '1',
      document_type_id: '1',
      document_name: 'Process Instructions',
      document_description: '',
      document_template_file: 'template.docx',
      name_file: 'PS_Instructions',
    },
    {
      document_id: '2',
      document_type_id: '1',
      document_name: 'Process Instructions Combined',
      document_description: '',
      document_template_file: 'template.doc',
      name_file: 'PSC_Instructions',
    },
    {
      document_id: '3',
      document_type_id: '1',
      document_name: 'Field Call Instructions',
      document_description: '',
      document_template_file: 'template.doc',
      name_file: 'FC_Instructions',
    },
    {
      document_id: '4',
      document_type_id: '1',
      document_name: 'Field Call Instructions Combined',
      document_description: '',
      document_template_file: 'template.doc',
      name_file: 'FCC_Instructions',
    },
    {
      document_id: '5',
      document_type_id: '1',
      document_name: 'Enforcement Hearing Instructions',
      document_description: '',
      document_template_file: 'template.doc',
      name_file: 'EH_Instructions',
    },
    {
      document_id: '6',
      document_type_id: '1',
      document_name: 'Occupancy Check Intructions',
      document_description: '',
      document_template_file: 'template.doc',
      name_file: 'OC_Instructions',
    },
    {
      document_id: '7',
      document_type_id: '1',
      document_name: 'Lockout Instructions',
      document_description: '',
      document_template_file: 'template.doc',
      name_file: 'Lockout_Instructions',
    },
  ];
  subject_template_docs: any;
  sent_subject_job_type_id: any;
  sent_subject_com_type_id: any;
  model: SubjectCommunication;
  created_file_name: string;
  tableData: any;
  tableSubjectData: any;
  get_latest_subject_note_id: any;
  job_types: any;
  job_subject_types: any;
  job_plaintiff_types: any;
  job_type_locations: any;
  count2: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  job_type_document_types: any;
  sent_job_type_court_id: any;
  job_type_affidavit_types: any;
  sent_job_type_document_type_id: any;
  doc_check: any = [];
  assignedList: any;
  assignedBrandList: any;

  subjectFullNameOrBusiness: any;

  // iframe
  name = 'Set iframe source';
  url = 'https://angular.io/api/router/RouterLink';
  urlSafe: SafeResourceUrl;
  job_data: any;
  brand_data: any;
  recipient_brand_id: any;
  accounts_brand_id: any;
  brand_account_data: any;
  brand_user_data: any;
  email_template_name: any;
  html_data: string;
  url_non_ssl: string;
  recipient_report_id: any;
  email_template_HTML: any;
  brand_report_id: any;
  brand_invoice_id: any;
  primary_contacts: any;
  filemodel: SystemFile;
  file_created_response: any;
  sessionUserLevel: any;
  system_log_created_response: any;
  file_edit_level: string;
  returned_created_file_id: any;
  subject_invoices: any;
  current_invoice_id: any;
  report_user_contacts: any;
  brand_report_user_id: any;
  DialogObj: any;
  next_date: any;
  final_date: any;
  job_status_id: any;
  message_subject: string;
  set_job_file: number;
  set_subject_file: number;
  allAgentRecipients: any[];
  assignedAgentsList2: any;
  sessionUsername: any;
  sessionUserFullName: string;
  sessionUserFirstName: any;
  client_reference: any;
  cancel_clicked: number;
  click_continue: any;
  set_document_password: string;
  is_encrypted: number;

 // Text editor Settings
 public simpleToolBar: object = {
  type: 'Expand',
  enableFloating: false,
  items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
  'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
  'LowerCase', 'UpperCase', '|',
  'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
  'Outdent', 'Indent', '|',
  'CreateLink', '|', 'ClearFormat', 'Print',
  'SourceCode', '|', 'Undo', 'Redo',
  // {
  //   tooltipText: 'Insert Promotion',
  //   undo: true,
  //   click: this.onClickPromotionButton.bind(this),
  //   template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
  // }
],
table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
  };
  public pasteCleanupSettings: object = {
    prompt: true,
    plainText: false,
    keepFormat: false,
    deniedTags: ['a'],
    deniedAttrs: ['class', 'title', 'id'],
    allowedStyleProps: ['color', 'margin', 'font-size']
}; 
  job_service_timeframe_paragraphs: any;
  client_contacts: any;
  job_type_locations_paragraphs: any;
  job_type_location_paragraphs: any;
  job_type_paragraphs: any;
  job_type_courts_paragraphs: any;
  job_type_court_paragraphs: any;
  job_type_document_type_paragraphs: any;
  job_type_affidavit_type_paragraphs: any;
  job_report_client_user_paragraphs: any;
  current_user_paragraphs: any;
  assignedBrandList_paragraphs: any;
  subject_service_type_model_paragraphs: any;
  subject_contact_numbers_paragraphs: any;
  subject_contact_numbers: string;
  subject_service_type: any;
  job_service_rule_paragraphs: any;
  selected_job_service_rule_description: string;
  subjectServiceOutcome: any;
  subjectLocationStatus: any;
  subjectLocationStatusFound: any;
  subjectExactServiceMethod: any;
  subject_attempt_type: any;
  serviceFellowRelationship: any;
  subject_service_fellow_relationship: any;
  subject_service_agent: any;
  job_report_client: any;
  job_invoice_client_paragraphs: any;
  job_owner_client_paragraphs: any;
  serviceMethod: any;
  subject_service_method: any;
  job_subject_type: any;
  subject_job_subject_type: any;
  job_data_paragraphs: any;
  subject_contact_emails_paragraphs: any;
  subject_contact_emails: string;
  registry_name: any;
  job_registry_name_Upper: any;
  job_type_name: any;
  job_type_name_Upper: any;
  job_type_location_name: any;
  job_type_location_name_Upper: any;
  job_type_court_name: any;
  job_type_court_name_Upper: any;
  job_type_document_type_name: any;
  job_type_document_type_name_Upper: any;
  job_type_affidavit_type_name: any;
  job_type_affidavit_type_name_Upper: any;
  subject_gender_descriptor: string;
  job_special_instructions_HTML: any;
  job_id: any;
  subject_number: any;
  rendered_email: any;
  job_subject_type_name: any;
  job_subject_type_name_Upper: any;
  job_service_rule_name: any;
  job_service_rule_description: any;
  user_brand_paragraphs: any;
  job_service_timeframe_name: any;
  job_service_timeframe_text: any;
  subject_service_type_name: any;
  subject_service_type_description: any;
  subject_service_type_staff_instructions: any;
  subject_service_type_agent_instructions: any;
  subject_service_type_instructions: any;
  message_subject_var: string;
  doc_name_var: any;
  subject_communication_history_created_response: Object;
  set_last_inserted_note: any;
  subject_service_list_paragraphs: Object;
  attempts_paragraphs_model: any;
  var_subject_attempt_type_name_Upper: any;
  set_service_paragraph_rendered: string;
  person_spoken_with_advised_HTML: any;
  vehicles_notes_HTML: any;
  neighbours_notes_HTML: any;
  calling_card_notes_HTML: any;
  postal_mail_notes_HTML: any;
  phone_call_notes_HTML: any;
  attempts_notes_HTML: any;
  email_contents_HTML: any;
  set_general_notes: any;
  property_forsale_or_lease_sign_details_HTML: any;
  property_mail_details_HTML: any;
  property_vehicles_sighted_details_HTML: any;
  property_pets_details_HTML: any;
  property_occupancy_details_HTML: any;
  property_condition_HTML: any;
  property_occupied_details_HTML: any;
  set_property_type_details_HTML: any;
  property_images: any;
  propery_image_0: any;
  propery_image_1: any;
  propery_image_2: any;
  propery_image_3: any;
  propery_image_4: any;
  propery_image_5: any;
  propery_image_6: any;
  propery_image_7: any;
  propery_image_8: any;
  propery_image_9: any;
  propery_image_10: any;
  propery_image_11: string;
  propery_image_12: string;
  propery_image_13: string;
  propery_image_14: string;
  propery_image_15: string;
  propery_image_16: string;
  propery_image_17: string;
  propery_image_18: string;
  propery_image_19: string;
  propery_image_20: string;
  propery_image_21: string;
  propery_image_22: string;
  propery_image_23: string;
  propery_image_24: string;
  propery_image_25: string;
  property_sign_images: any;
  property_sign_image_1: string;
  property_sign_image_2: string;
  property_sign_image_3: string;
  property_sign_image_4: string;
  property_sign_image_5: string;
  property_sign_image_6: string;
  property_sign_image_7: string;
  property_sign_image_8: string;
  property_sign_image_9: string;
  property_sign_image_10: string;
  property_sign_image_11: string;
  property_sign_image_12: string;
  property_sign_image_13: string;
  property_sign_image_14: string;
  property_sign_image_15: string;
  property_sign_image_16: string;
  property_sign_image_17: string;
  property_sign_image_18: string;
  property_sign_image_19: string;
  property_sign_image_20: string;
  property_sign_image_21: string;
  property_sign_image_22: string;
  property_sign_image_23: string;
  property_sign_image_24: string;
  property_sign_image_25: string;
  property_sign_image_0: string;
  property_mail_images: any;
  property_mail_image_0: string;
  property_mail_image_1: string;
  property_mail_image_2: string;
  property_mail_image_3: string;
  property_mail_image_4: string;
  property_mail_image_5: string;
  property_mail_image_6: string;
  property_mail_image_7: string;
  property_mail_image_8: string;
  property_mail_image_9: string;
  property_mail_image_10: string;
  property_mail_image_11: string;
  property_mail_image_12: string;
  property_mail_image_13: string;
  property_mail_image_14: string;
  property_mail_image_15: string;
  property_mail_image_16: string;
  property_mail_image_17: string;
  property_mail_image_18: string;
  property_mail_image_19: string;
  property_mail_image_20: string;
  property_mail_image_21: string;
  property_mail_image_22: string;
  property_mail_image_23: string;
  property_mail_image_24: string;
  property_mail_image_25: string;
  property_vehicles_images: any;
  property_vehicles_image_0: string;
  property_vehicles_image_1: string;
  property_vehicles_image_2: string;
  property_vehicles_image_3: string;
  property_vehicles_image_4: string;
  property_vehicles_image_5: string;
  property_vehicles_image_6: string;
  property_vehicles_image_7: string;
  property_vehicles_image_8: string;
  property_vehicles_image_9: string;
  property_vehicles_image_10: string;
  property_vehicles_image_11: string;
  property_vehicles_image_12: string;
  property_vehicles_image_13: string;
  property_vehicles_image_14: string;
  property_vehicles_image_15: string;
  property_vehicles_image_16: string;
  property_vehicles_image_17: string;
  property_vehicles_image_18: string;
  property_vehicles_image_19: string;
  property_vehicles_image_20: string;
  property_vehicles_image_21: string;
  property_vehicles_image_22: string;
  property_vehicles_image_23: string;
  property_vehicles_image_24: string;
  property_vehicles_image_25: string;
  property_pets_images: any;
  property_pets_image_0: string;
  property_pets_image_1: string;
  property_pets_image_2: string;
  property_pets_image_3: string;
  property_pets_image_4: string;
  property_pets_image_5: string;
  property_pets_image_6: string;
  property_pets_image_7: string;
  property_pets_image_8: string;
  property_pets_image_9: string;
  property_pets_image_10: string;
  property_pets_image_11: string;
  property_pets_image_12: string;
  property_pets_image_13: string;
  property_pets_image_14: string;
  property_pets_image_15: string;
  property_pets_image_16: string;
  property_pets_image_17: string;
  property_pets_image_18: string;
  property_pets_image_19: string;
  property_pets_image_20: string;
  property_pets_image_21: string;
  property_pets_image_22: string;
  property_pets_image_23: string;
  property_pets_image_24: string;
  property_pets_image_25: string;
  property_occupancy_images: any;
  property_occupancy_image_0: string;
  property_occupancy_image_1: string;
  property_occupancy_image_2: string;
  property_occupancy_image_3: string;
  property_occupancy_image_4: string;
  property_occupancy_image_5: string;
  property_occupancy_image_6: string;
  property_occupancy_image_7: string;
  property_occupancy_image_8: string;
  property_occupancy_image_9: string;
  property_occupancy_image_10: string;
  property_occupancy_image_11: string;
  property_occupancy_image_12: string;
  property_occupancy_image_13: string;
  property_occupancy_image_14: string;
  property_occupancy_image_15: string;
  property_occupancy_image_16: string;
  property_occupancy_image_17: string;
  property_occupancy_image_18: string;
  property_occupancy_image_19: string;
  property_occupancy_image_20: string;
  property_occupancy_image_21: string;
  property_occupancy_image_22: string;
  property_occupancy_image_23: string;
  property_occupancy_image_24: string;
  property_occupancy_image_25: string;
  property_condition_images: any;
  property_condition_image_0: string;
  property_condition_image_1: string;
  property_condition_image_2: string;
  property_condition_image_3: string;
  property_condition_image_4: string;
  property_condition_image_5: string;
  property_condition_image_6: string;
  property_condition_image_7: string;
  property_condition_image_8: string;
  property_condition_image_9: string;
  property_condition_image_10: string;
  property_condition_image_11: string;
  property_condition_image_12: string;
  property_condition_image_13: string;
  property_condition_image_14: string;
  property_condition_image_15: string;
  property_condition_image_16: string;
  property_condition_image_17: string;
  property_condition_image_18: string;
  property_condition_image_19: string;
  property_condition_image_20: string;
  property_condition_image_21: string;
  property_condition_image_22: string;
  property_condition_image_23: string;
  property_condition_image_24: string;
  property_condition_image_25: string;
  property_type_images: any;
  property_type_image_0: string;
  property_type_image_1: string;
  property_type_image_2: string;
  property_type_image_3: string;
  property_type_image_4: string;
  property_type_image_5: string;
  property_type_image_6: string;
  property_type_image_7: string;
  property_type_image_8: string;
  property_type_image_9: string;
  property_type_image_10: string;
  property_type_image_11: string;
  property_type_image_12: string;
  property_type_image_13: string;
  property_type_image_14: string;
  property_type_image_15: string;
  property_type_image_16: string;
  property_type_image_17: string;
  property_type_image_18: string;
  property_type_image_19: string;
  property_type_image_20: string;
  property_type_image_21: string;
  property_type_image_22: string;
  property_type_image_23: string;
  property_type_image_24: string;
  property_type_image_25: string;
  service_file_array_images: any;
  service_file_array_image_0: string;
  service_file_array_image_1: string;
  service_file_array_image_2: string;
  service_file_array_image_3: string;
  service_file_array_image_4: string;
  service_file_array_image_5: string;
  service_file_array_image_6: string;
  service_file_array_image_7: string;
  service_file_array_image_8: string;
  service_file_array_image_9: string;
  service_file_array_image_10: string;
  service_file_array_image_11: string;
  service_file_array_image_12: string;
  service_file_array_image_13: string;
  service_file_array_image_14: string;
  service_file_array_image_15: string;
  service_file_array_image_16: string;
  service_file_array_image_17: string;
  service_file_array_image_18: string;
  service_file_array_image_19: string;
  service_file_array_image_20: string;
  service_file_array_image_21: string;
  service_file_array_image_22: string;
  service_file_array_image_23: string;
  service_file_array_image_24: string;
  service_file_array_image_25: string;
  service_paragraphs_model: any;
  service_under_order_HTML: any;
  startTime: any;
  smtp_error: number;
  smtp_error_response: any;
  email_response: any;
  count_email_response: any;

  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private router: Router,

    public HttpClient: HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    private _location: Location,
    public sanitizer: DomSanitizer,
    public gfunc: GlobalFunctionsService,
    public legalDate: LegalDateTimeService
  ) {
  

    this.gfunc.setLoginSessionVars(); // set in a global function file
    this.sessionUserId = this.gfunc.currentUserVAR.user_id;
    this.sessionUsername = this.gfunc.currentUserVAR.username;
    this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
        this.sessionUserLevel = this.gfunc.currentUserVAR.access_level;
        this.sessionUserFullName = this.gfunc.currentUserVAR.first_name + ' ' + this.gfunc.currentUserVAR.surname;
        this.sessionUserFirstName = this.gfunc.currentUserVAR.first_name;
         this.creating_file = 0; // creating file animation and progress
          this.smtp_error = 0;
          this.sending_comms = 0;
      }

  ngOnInit() {

    this.filemodel = new SystemFile();

    this.modelds = new SubjectCommunicationAttatchments();
    this.model = new SubjectCommunication();
    this.model.attached_file_name = '';

    this.subject_id = +this.route.snapshot.paramMap.get('subject_id');
    this.getJobSubject(this.subject_id);
    this.getJobStatusNames();
    this.getSubjectComTypes();

    // agent secrity
    this.getSubjectAgentBrandsAssigned_comms(this.subject_id);

    // popup ask if attatchments
    this.cancel_clicked = 1;
    this.click_continue = 0;

    // testing merging of arrays of files.
    // this.allAttachedFiles  = [...this.selectedFeatures, ...this.selectedFeaturesJobFiles];
  }

  onLegalDateChange(model: any, field: string, value: unknown): void {
    const pickerDate = this.legalDate.coercePickerDate(value);
    model._legalDatePickerValues = model._legalDatePickerValues || {};
    model._legalDatePickerValues[field] = pickerDate;
    model[field] = this.legalDate.fromPickerDate(pickerDate);
  }

  private initializeCommunicationUiState(model: any): void {
    if (!model) {
      return;
    }

    model._legalDatePickerValues = model._legalDatePickerValues || {};
    this.syncLegalDatePickerField(model, 'next_date');
    this.syncLegalDatePickerField(model, 'final_date');
  }

  private syncLegalDatePickerField(model: any, field: string): void {
    if (!model) {
      return;
    }

    model._legalDatePickerValues = model._legalDatePickerValues || {};
    model._legalDatePickerValues[field] = this.legalDate.toPickerDate(model?.[field]);
  }

  private prepareTemplateRenderLookups(model: any): void {
    if (!model) {
      return;
    }

    model._templateLookupState = model._templateLookupState || {};

    this.preloadTemplateLookup(model, 'job_type_location_id', (value) => this.getJobTypeLocation_Q(value));
    this.preloadTemplateLookup(model, 'job_type_court_id', (value) => this.getJobTypeCourt_Q(value));
    this.preloadTemplateLookup(model, 'job_type_document_type_id', (value) => this.getJobTypeDocumentType_Q(value));
    this.preloadTemplateLookup(model, 'job_type_affidavit_type_id', (value) => this.getJobTypeAffidavitType_Q(value));
    this.preloadTemplateLookup(model, 'job_subject_type_id', (value) => this.getJobSubjectType_Q(value));
    this.preloadTemplateLookup(model, 'brand_report_id', (value) => this.getBrand_report_Q(value));
  }

  private preloadTemplateLookup(model: any, field: string, loader: (value: any) => void): void {
    const value = model?.[field];

    if (
      value === undefined ||
      value === null ||
      value === '' ||
      value === '0' ||
      value === 0
    ) {
      return;
    }

    if (model._templateLookupState[field] === value) {
      return;
    }

    model._templateLookupState[field] = value;
    loader(value);
  }

  getJobSubject(subject_id) {
    this._demoService.getJobSubject(subject_id).subscribe(
      (data) => {
        this.subjects = data;
        this.subjects.forEach((subject) => this.initializeCommunicationUiState(subject));
        const res = data[0];
        this.getSubjectNotes(res.subject_id);
        // load subject history
        // this.getSubjectProgress(res.job_id, res.file_number);

        // set the subject name
        if (res.business_name !== '' || res.business_name !== null) {
          this.subjectFullNameOrBusiness = res.business_name;
        }

        if (res.business_name === '' || res.business_name === null) {
          this.subjectFullNameOrBusiness = res.first_name + ' ' + res.surname;
        }

        this.job_id = res.job_id;
        this.subject_number = res.subject_number;

        this.next_date = res.next_date;
        this.final_date = res.final_date;
        this.job_status_id = res.job_status_id;

        this.refreshList(); // loads the file list (diretory)
        this.displaySubjectDocuments(this.subject_id, this.subject_number);

        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
        this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
        this.getJobTypes();
        // this.getSubjectAgentBrandsAssigned(this.subject_id);

        // get the job data to get the brand to send to
        this.getJob(this.job_id);
        this.getSubjectInvoices(this.subject_id);

// mege variables renders
this.getJob_and_brands_Q(res.job_id, res) // was missing 2024!!!

this.getJobServiceRule_Q(res.job_service_rule_id) //? -- from the send comms model

this.getJobServiceTimeframe_Q(res.job_service_timeframe_id)
this.getSubjectServiceType_model_Q(res.subject_service_type_id);

this.getSubjectContactNumbers_Q(this.subject_id)
this.getSubjectContactEmails_Q(this.subject_id)
    // Get Subject Agent - F_agent
this.getSubjectAgentBrandsAssigned_Q(this.subject_id) // get the first agent ID.????

// load subject services (attemps)
this.getSubjectAttemptsAll_Q(subject_id) // attmpts and attend
this.getSubjectServicesOnly_Q(subject_id) // service variables

// end merge calls


        // get job type in relation to subject
        // this.getJobType(res.job_type_id);
        // this.getJobTypeLocation(res.job_type_location_id);
        // this.getJobTypeCourt(res.job_type_court_id);
        // this.getJobTypeDocument(res.job_type_document_type_id);
        // this.getJobTypeAffidavit(res.job_type_affidavit_type_id)
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  getSubjectNotes(subject_id) {
    this._demoService.getSubjectNotes(subject_id).subscribe(
      (data) => {
        this.subject_notes = data;
        // console.log("Done loadng USER");
        // console.log(this.users);
      },
      (error) => {
        //  console.error('Error Loading User!');
        //return console.log(error);
      }
    );
  }

  private getJobStatusNames() {
    this._demoService.getJobStatusNames().subscribe(
      (res) => (this.job_status_run = res),
      (err) => console.error(err.status)
    );
  }

  private getSubjectComTypes() {
    this._demoService.getSubjectComTypes().subscribe(
      (res) => (this.subject_com_types = res),
      (err) => console.error(err.status)
    );
  }

  sendSubjectComTypeID(subject_com_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_subject_com_type_id = subject_com_type_id;
    this.getSubjectTemplateDocs(this.sent_subject_com_type_id); // updates the selected job ID....
    console.log(this.sent_subject_com_type_id);
  }

  private getSubjectTemplateDocs(subject_com_type_id) {
    this._demoService.getSubjectTemplateDocsMenu(subject_com_type_id).subscribe(
      (res) => (this.subject_template_docs = res),
      (err) => console.error(err.status)
    );
  }

  subjectView2(subject_id) {
    this.router
      .navigateByUrl('admin/clients', { skipLocationChange: true })
      .then(() =>
        this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + ''])
      );

    // works but does not refresh the page only if set up as a listner.
    // this.router.navigate(['../'  + subject_id], { relativeTo: this.route });
  }

  jobView(job_id) {
    this.router.navigate(['/admin/jobs/view/' + job_id + '']);
  }

  subjectCommunication(subject_id) {
    this.router.navigate([
      '/admin/jobs/subject/communication/' + subject_id + '',
    ]);
  }

  subjectDocuments(subject_id) {
    this.router.navigate(['/admin/jobs/subject/documents/' + subject_id + '']);
  }

  subjectNotesTab(subject_id) {
    this.router.navigate(['/admin/jobs/subject/notes/' + subject_id + '']);
  }

// need to get the file id from the response
  createDocument(model) {
   // this._mysqlService.createDocument(model).subscribe(
    this._mysqlService. createDocument_2021Test(model).subscribe(
   (data) => {
        // this.trace_candidate_update = data;
        this.toastr.success('Creating Document for you now.');
        const res = data;
        // console.log(res); // not working as response is showing in body
        // // console.log(res._body);
        // console.log(res[0].text()); // Convert response to a string
        // this.created_file_name = res[0].text();
        this.created_file_name = res[0] as string;


        model.attached_file_name = this.created_file_name;
        this.refreshList(); // loads the file list (diretory)
        this.displaySubjectDocuments(this.subject_id, this.subject_number);

        this.set_document_password = res[1] as string;
        console.log('set_document_password: ' + this.set_document_password);
  
        if(model.encrypt_file == true){
          this.is_encrypted = 1; //  encrypted
        }else{
          this.is_encrypted = 0; // no encrypted
        }

        // push to global array
        this.allAttachedFiles.push(this.created_file_name);

        // Start the new array of file
        // this.allAttachments.push(this.created_file_name);

        const pushed_file = {
          file_name: this.created_file_name,
          subject_file: 1,
          job_file: 0,
        }; // multidimentional array push
        // this.allAttachments.push(pushed_file); // old way only works for an array.

        // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
        // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});


          // moved to creatFile function.
                  // this.allAttachments.push({
                  //   file_name: this.created_file_name,
                  //   job_file: 0,
                  //   subject_file: 1,
                  // });
                  // model.allAttachments = this.allAttachments; // ?? this may be causing errors.

        // [{name: currencyName, amount: this.ticker[currencyName].last} ]

        // Set the file locations
        // agent

  
      // set the agent permissions
      model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);


      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      //report_access_array ??
      // if an agent the agent has to be the file_brand_id.
      // need to show the agent_id here! name here // model.brand_report_id
    model.brand_report_id = null;
      }
        // client
        if (model.brand_type_id === '2') {
          this.file_edit_level = '3'; // client cannot edit  (staff member can)
        }
  
        const file_server_location = this.gfunc.fileFolderDocs + model.subject_number;
        const file_url = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
        const file_folder = this.gfunc.fileFolderDocs + model.subject_number;
        
        // const file_folder = '/APP_PHP/assets/docs/' + model.subject_number;
        const file_name = this.created_file_name.slice(0, -5); // removes the extension
        const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
        // UPGRADE Document Model (Insert the File into the database)
        // File Json
        const create_file = {
          file_name: file_name,
          file_display_name: file_name,
          file_ext: 'docx',
          file_server_location: file_server_location,
          file_url: file_url,
          file_folder: file_folder,
          file_make: 'created', // automated / updated / created / uploaded / link_created
          file_notes: 'File created via subject communcation UI',
          file_job_id: this.job_id,
          file_subject_id: this.subject_id,
          file_subject_number: this.subject_number,
          created_by: this.sessionUserId,
          created_date: this.today,
          created_level: this.sessionUserLevel,
          file_brand_id: model.brand_report_id,
          file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
          is_active: '1',
          file_password: this.set_document_password,
          file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
          updated_by: '',
          updated_date: '',
          prev_file_id: '0',    // if updating
          brand_type_id: model.brand_type_id,  // if an agent or a client file
          subject_template_doc_id: model.doc_id,
          subject_com_type_id: model.subject_com_type_id,
          random_file_name: random_file_name,
          full_file_name: this.created_file_name,
          job_id: this.job_id,
          file_number: model.file_number,
          file_reference_number: model.file_reference_number,
          // arrays of sending to - based on subject_template_doc - setup
          agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
          report_access_array: JSON.stringify(this.brand_data), // collect client
          invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
          user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
          is_theme: model.is_theme,
          assigned_to_agents: model.assigned_to_agents,
          is_encrypted: this.is_encrypted
        };
       // console.log( (JSON.stringify(this.assignedBrandList)) );
        this.createFile(create_file);

        // const log_content
        // const log_action
        // Access DOM and get values from HTML template to send to logs
       // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
      // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value;
      // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
      // get the drop down value of text not id.



      },
      (error) => {
        this.toastr.error('Error Creating Document, (if encyption checked) please Check if there must be a Global Company Key set in file recipeint company profile');
       return console.log(error);
      }
    );
  }


// Created to test and process new paragraph templates/merge variables Live without effecting original and current systems and workflows Live.
createDocument_2023_Paragraphs(model, mergeJobData,invoice_id) {
  // generate more data first

  // generate more data first
  this.creating_file = 1; // starts the file creating animation

  this._mysqlService.createDocument_2023_Paragraphs(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Creating Document for you now.');
      const res = data;
      // console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log('TheRespose: ' + res[0].text()); // Convert response to a string
      this.created_file_name = res[0] as string;
      // this.created_file_name = res[0].text();
      model.attached_file_name = this.created_file_name;

      // generate more data first
      this.creating_file = 0; // ends the file creating animation

      this.refreshList(); // loads the file list (diretory)
      this.displaySubjectDocuments(this.subject_id, this.subject_number);

// october need to fix this here?
        this.set_document_password = res[1] as string;
        console.log('set_document_password: ' + this.set_document_password);

        if(model.encrypt_file == true){
          this.is_encrypted = 1; //  encrypted
        }else{
          this.is_encrypted = 0; // no encrypted
        }

      // push to global array
      this.allAttachedFiles.push(this.created_file_name);

      // Start the new array of file
      // this.allAttachments.push(this.created_file_name); 
      
      
      // set the agent permissions
      model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

      // const pushed_file = {
      //   file_name: this.created_file_name,
      //   subject_file: 1,
      //   job_file: 0,
      //   file_id: this.returned_created_file_id
      // }; 
      
// update for file checking was missing
      const pushed_file = {
        // file_name: this.created_file_name,
        // subject_file: 1,
        // job_file: 0,
        // file_id: this.returned_created_file_id,



        file_name: this.created_file_name,
        job_file: 0,
        subject_file: 1,
        subject_number: model.subject_number,
        job_id: model.job_id,
        file_server_location: model.file_server_location,
        file_id: this.returned_created_file_id,
        
      }; 
      
      
      

      
      // multidimentional array push
      // this.allAttachments.push(pushed_file); // old way only works for an array.

      // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});


                // this.allAttachments.push({
                //   file_name: this.created_file_name,
                //   job_file: 0,
                //   subject_file: 1,
                //   file_id: this.returned_created_file_id + 'ete'
                // });
                // model.allAttachments = this.allAttachments; // ?? this may be causing errors.

      // [{name: currencyName, amount: this.ticker[currencyName].last} ]

      // Set the file locations
      //agent
     
      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      //report_access_array ??
      // if an agent the agent has to be the file_brand_id.
      // need to show the agent_id here! name here // model.brand_report_id
    model.brand_report_id = null;
      }
      //client
      if (model.brand_type_id === '2') {
        this.file_edit_level = '3'; // client cannot edit  (staff member can)
      }

                          const file_server_location = this.gfunc.fileFolderDocs + model.subject_number;
                          const file_url = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
                          const file_folder = this.gfunc.fileFolderDocs + model.subject_number;
                          const file_name = this.created_file_name.slice(0, -5); // removes the extension
                          const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
                          // UPGRADE Document Model (Insert the File into the database)
                          // File Json
                          const create_file = {
                            file_name: file_name,
                            file_display_name: file_name,
                            file_ext: 'docx',
                            file_server_location: file_server_location,
                            file_url: file_url,
                            file_folder: file_folder,
                            file_make: 'created', // automated / updated / created / uploaded / link_created
                            file_notes: 'File created via subject communcation UI',
                            file_job_id: this.job_id,
                            file_subject_id: this.subject_id,
                            file_subject_number: this.subject_number,
                            created_by: this.sessionUserId,
                            created_date: this.today,
                            created_level: this.sessionUserLevel,
                            file_brand_id: model.brand_report_id,
                            file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
                            is_active: '1',
                            file_password: this.set_document_password,
                            file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
                            updated_by: this.gfunc.sessionUserId,
                            updated_date: this.gfunc.today,
                            prev_file_id: '0',    // if updating
                            brand_type_id: model.brand_type_id,  // if an agent or a client file
                            subject_template_doc_id: model.doc_id,
                            subject_com_type_id: model.subject_com_type_id,
                            random_file_name: random_file_name,
                            full_file_name: this.created_file_name,
                            job_id: this.job_id,
                            file_number: model.file_number,
                            file_reference_number: model.file_reference_number,
                            // arrays of sending to - based on subject_template_doc - setup
                            agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
                            report_access_array: JSON.stringify(this.brand_data), // collect client
                            invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
                            user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
                            is_theme: model.is_theme,
                            assigned_to_agents:  model.assigned_to_agents,  // set the agent permissions
                            is_encrypted: this.is_encrypted,

                          };
                         // console.log( (JSON.stringify(this.assignedBrandList)) );
                          this.createFile(create_file);





      // const log_content 
      // const log_action
      // Access DOM and get values from HTML template to send to logs
     // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
    // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value; 
    // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
    // get the drop down value of text not id.



    },
    (error) => {
      // this.toastr.error('Error Creating Document');
            // console.log('there was an error' + JSON.stringify(error));
            // console.log('TextError.error: = ' + JSON.stringify(error.error.text));
            // this.created_file_name = error.error.text
      this.newCreatedFile(model, this.created_file_name);
    //  return error.error;
    },
     () => console.log('What do we do next..????' + this.created_file_name)
  );
}


// new with re response code being an error but returns and creatd the file... go fugure.???
newCreatedFile(model, created_file_name){


  model.attached_file_name = this.created_file_name;
  this.refreshList(); // loads the file list (diretory)
  this.displaySubjectDocuments(this.subject_id, this.subject_number);

  // Set the file locations
  //agent
 
  if (model.brand_type_id === '3') {
    this.file_edit_level = '5'; // agent can edit
    }
    //client
    if (model.brand_type_id === '2') {
      this.file_edit_level = '3'; // client cannot edit  (staff member can)
    }
  
  


  const file_server_location = this.gfunc.fileFolderDocs + model.subject_number;
  const file_url = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
  const file_folder = this.gfunc.fileFolderDocs + model.subject_number;
  const file_name = this.created_file_name.slice(0, -5); // removes the extension
  const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
  // UPGRADE Document Model (Insert the File into the database)
  // File Json
  const create_file = {
    file_name: file_name,
    file_display_name: file_name,
    file_ext: 'docx',
    file_server_location: file_server_location,
    file_url: file_url,
    file_folder: file_folder,
    file_make: 'created', // automated / updated / created / uploaded / link_created
    file_notes: 'File created via subject communcation UI',
    file_job_id: this.job_id,
    file_subject_id: this.subject_id,
    file_subject_number: this.subject_number,
    created_by: this.sessionUserId,
    created_date: this.today,
    created_level: this.sessionUserLevel,
    file_brand_id: model.brand_report_id,
    file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
    is_active: '1',
    file_password: '',
    file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
    updated_by: '',
    updated_date: '',
    prev_file_id: '0',    // if updating
    brand_type_id: model.brand_type_id,  // if an agent or a client file
    subject_template_doc_id: model.doc_id,
    subject_com_type_id: model.subject_com_type_id,
    random_file_name: random_file_name,
    full_file_name: this.created_file_name,
    job_id: this.job_id,
    file_number: model.file_number,
    file_reference_number: model.file_reference_number,
    // arrays of sending to - based on subject_template_doc - setup
    agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
    report_access_array: JSON.stringify(this.brand_data), // collect client
    invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
    user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
    is_theme: model.is_theme,
    assigned_to_agents:  model.assigned_to_agents  // set the agent permissions
  };
 // console.log( (JSON.stringify(this.assignedBrandList)) );
  this.createFile(create_file);



  // push to global array
  this.allAttachedFiles.push(this.created_file_name);

  // Start the new array of file
  // this.allAttachments.push(this.created_file_name); 
  
  
  // set the agent permissions
  model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

        // const pushed_file = {
        //   file_name: this.created_file_name,
        //   subject_file: 1,
        //   job_file: 0,
        //   file_id: this.returned_created_file_id
        // }; // multidimentional array push
  // this.allAttachments.push(pushed_file); // old way only works for an array.

  // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
  // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
        // this.allAttachments.push({
        //   file_name: this.created_file_name,
        //   job_file: 0,
        //   subject_file: 1,
        //   file_id: this.returned_created_file_id 
        // });
        // model.allAttachments = this.allAttachments; // ?? this may be causing errors.

  // [{name: currencyName, amount: this.ticker[currencyName].last} ]


}






  sendAgentInstructEmail(model) {

    this.smtp_error = 0; // reset the error warning
    this.sending_comms = 1;

  //.. set cancel clicked if there is attachments so functions below can run.
          if(this.allAttachments.length >= 1){
          this.cancel_clicked = 0;
          }else if(this.allAttachments.length <= 0 && this.click_continue >= 1){
          this.cancel_clicked = 0;
          }   
          else{
          this.cancel_clicked = 1;
          // return;
          };



          if( this.cancel_clicked == 1){
          this.onOpenDialogSendComms(model, model); // need to restructure the comms to ask the question.
          return;
          }






    // model.attached_file_name = this.created_file_name;
    model.attached_file_names = this.selectedFeatures;
    model.attached_job_file_names = this.selectedFeaturesJobFiles;
    model.all_attached_file_names = this.allAttachedFiles;
    model.allAttachments = this.allAttachments;
    model.allRecipients = this.allRecipients;
    console.log(model.attached_file_names);

    this.model.allAttachments = this.allAttachments;
    this.model.allRecipients = this.allRecipients;


    // moved to below
            // // upgrade 2.0 multiple notes and templates.
            // if(model.note_template_HTML_rendered == null){
            //   this.createSubjectNote(model); // Insert a Note to the subject
            // }else{
            //   this.createSubjectNote_with_vars(model)
            // }
            // this.subjectChangeDates(model, this.subject_id); // moved to update before meail.

    
    const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
    console.log('Communication Type Task: ' +  subject_com_type_name);
        //  const subject_com_type_name = document.getElementById('subject_com_type_name').innerText;
         //  console.log('Communication Type Task: ' +  subject_com_type_name);
   const doc_name = document.getElementById('doc_name').innerText;
   console.log('Document Name: ' +  doc_name);

     // set the invoice from the list of invoices (first record)
  if (model.invoice_id == null) {
    model.invoice_id = this.current_invoice_id;
  }

  // const subject_communication_history = {
  //   job_id: model.job_id,
  //   subject_id: model.subject_id,
  //   subject_com_type_id: model.subject_com_type_id,
  //   doc_id: model.doc_id,
  //   change_dates: model.change_dates,
  //   additional_message: model.additional_message,
  //   brand_type_id: model.brand_type_id,
  //   brand_id: model.brand_id,
  //   all_attached_file_names: JSON.stringify(model.all_attached_file_names),
  //   send_to_invoice: model.send_to_invoice,
  //   send_to_report: model.send_to_report,
  //   send_to_logins: model.send_to_logins,
  //   send_to_primary: model.send_to_primary,
  //   allAttachments: JSON.stringify(model.allAttachments),
  //   allRecipients: JSON.stringify(model.allRecipients),
  //   allAttachedFiles: JSON.stringify(model.allAttachedFiles),
  //   brand_report_id: model.brand_report_id,
  //   brand_invoice_id: model.brand_invoice_id,
  //   job_type_name: model.job_type_name,
  //   job_type_location_name: model.job_type_location_name,
  //   brand_report_user_id: model.brand_report_user_id,
  //   email_message_subject: model.email_message_subject,
  //   email_message_recipeints: JSON.stringify(model.email_message_recipeints),
  //   message_subject: model.message_subject,
  //   recipient_name: model.recipient_name,
  //   recipient_type_name: model.recipient_type_name,
  //   recipient_email_address: JSON.stringify(model.recipient_email_address),
  //   email_template_HTML: model.email_template_HTML,
  //   subject_number: model.subject_number,
  //   created_by: this.sessionUserId,
  //   created_date: this.today,
  //   attached_file_names: JSON.stringify(model.attached_file_names),
  //   attached_job_file_names: JSON.stringify(model.attached_job_file_names),
  //   subject_com_type_name: model.subject_com_type_name,
  //      // New Nov 2023 Fields. Captured
  //      email_template_primary_HTML_rendered: model.email_template_primary_HTML_rendered,
  //      email_subject_primary_rendered: model.email_subject_primary_rendered,
  //      note_template_HTML_rendered: model.note_template_HTML_rendered,
  //      email_template_private_HTML_rendered: model.email_template_private_HTML_rendered,
  //      email_subject_private_rendered: model.email_subject_private_rendered,
  //      note_template_private_HTML_rendered: model.note_template_private_HTML_rendered,
  //      is_privacy_emails: model.is_privacy_emails,
  //      is_privacy_notes: model.is_privacy_notes,
  //      is_privacy_no_docs: model.is_privacy_no_docs,
  //      is_privacy_no_emails: model.is_privacy_no_emails,
  //      is_privacy_no_notes: model.is_privacy_no_notes,
  //      created_note_id: model.created_note_id,
  //      created_file_id: model.created_file_id
  // };
  // this.gfunc.createSubjectCommunicationHistory(subject_communication_history);

  
  //   const log_action = 'sent';
  //   const log_name = 'Subject Communicaiton Task: ' + subject_com_type_name  + ' - ' + doc_name + ' -  Emailed';
  //   const create_sys_log = {
  //     log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
  //     log_action: log_action, // automated / updated / created / uploaded / link_created / sent
  //     created_by: this.sessionUserId,
  //     created_date: this.today,
  //     subject_id: this.subject_id,
  //     job_id: this.job_id,
  //     job_reference_number: model.job_reference_number,
  //     file_number: model.file_subject_number,
  //     reference_number: model.job_reference_number,
  //     subject_number: model.subject_number,
  //     log_type_id: '2', // see datatable system_log_types se (2 when a file is sent with an email)
  //     created_level: this.sessionUserLevel,
  //     brand_type_id: model.brand_type_id,
  //     subject_com_type_id: model.subject_com_type_id,
  //     subject_template_doc_id: model.doc_id,
  //     log_name: log_name + ' - ' + this.returned_created_file_id,
  //     file_id: this.returned_created_file_id,
  //     invoice_id: model.invoice_id,
  //   };
  //   this.createSystemLog(create_sys_log);


    this._mysqlService.sendAgentInstructEmailWithVarsWithReporting(model).subscribe(
      (data) => {
        // // this.trace_candidate_update = data;
        // this.toastr.success('Sent Email.');
        // const res = data;
        // // console.log(res); // not working as response is showing in body
        // // // console.log(res._body);
        // // console.log(res[0].text()); // Convert response to a string
        // this.created_file_name = res[0] as string;
        let res = data[0];
        this.email_response = DataUtil.parse.parseJson(data);
    
        this.count_email_response = this.email_response.length
this.toastr.success('Sent Email & Communications Success. SMTP Sent ' + this.count_email_response + ' Emails');


for (let i = 0; i < this.count_email_response; i++) {
// element.primary_contact  += this.changeObject[i].first_name + ' ' + this.changeObject[i].surname + ', ';
          let log_action = 'send-success';
                let log_name = 'Success: Sent' + subject_com_type_name  + ' subject: ' + this.subject_number  + '- ' + doc_name + ' ' + this.email_response[i].notice  + ' ' + this.email_response[i].client_name  + ' ' + this.email_response[i].recipient;
                let create_sys_log = {
                  log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                  log_action: log_action, // automated / updated / created / uploaded / link_created / sent
                  created_by: this.sessionUserId,
                  created_date: this.today,
                  subject_id: this.subject_id,
                  job_id: this.job_id,
                  job_reference_number: model.job_reference_number,
                  file_number: model.file_subject_number,
                  reference_number: model.job_reference_number,
                  subject_number: model.subject_number,
                  log_type_id: '61', // see datatable system_log_types se (2 when a file is sent with an email)
                  created_level: this.sessionUserLevel,
                  brand_type_id: model.brand_type_id,
                  subject_com_type_id: model.subject_com_type_id,
                  subject_template_doc_id: model.doc_id,
                  log_name: log_name,
                  file_id: this.returned_created_file_id,
                  invoice_id: model.invoice_id,
                  brand_id: model.brand_id,
                 // note_id: this.get_latest_subject_note_id, // from above loop
                };
        this.createSystemLog(create_sys_log);



} // end loop




  // upgrade 2.0 multiple notes and templates.
  if(model.note_template_HTML_rendered == null){
    this.createSubjectNote(model); // Insert a Note to the subject
  }else{
    this.createSubjectNote_with_vars(model)
  }
  // this.subjectChangeDates(model, this.subject_id); // moved to update before meail.



        this.subjectChangeDates(model, this.subject_id);
        this.gfunc.onOpenDialog_SuccessCommunication(event, model);

        this.sending_comms = 0;

      },
      (error) => {
  
        this.sending_comms = 0;
        console.log(error.error)
        this.toastr.error('Error sending Email' + error.error);

        this.smtp_error = 1;
        this.smtp_error_response = error.error

  
        const log_action = 'send-fail';
        const log_name = 'FAIL: Email ERROR: YOU NEED TO TRY AGAIN! ' + subject_com_type_name  + ' subject: ' + this.subject_number  + '- ' + doc_name + ' ' + error.error ;
        const create_sys_log = {
          log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
          log_action: log_action, // automated / updated / created / uploaded / link_created / sent
          created_by: this.sessionUserId,
          created_date: this.today,
          subject_id: this.subject_id,
          job_id: this.job_id,
          job_reference_number: model.job_reference_number,
          file_number: model.file_subject_number,
          reference_number: model.job_reference_number,
          subject_number: model.subject_number,
          log_type_id: '60', // see datatable system_log_types se (2 when a file is sent with an email)
          created_level: this.sessionUserLevel,
          brand_type_id: model.brand_type_id,
          subject_com_type_id: model.subject_com_type_id,
          subject_template_doc_id: model.doc_id,
          log_name: log_name,
          file_id: this.returned_created_file_id,
          invoice_id: model.invoice_id,
          brand_id: model.brand_id,
          note_id: this.get_latest_subject_note_id, // from above loop
        };
        this.createSystemLog(create_sys_log);

      }
    );
  }

  // this function is universal for client or email now.
  sendAgentCommunicationEmail(model) {

    this.smtp_error = 0; // reset the error warning
    this.sending_comms = 1;

// console.log('cancel_clicked: ' + this.cancel_clicked)
// console.log('allAttachment.length:  ' + this.allAttachments.length)
// console.log('continue_clicked: ' + this.click_continue)



  //.. set cancel clicked if there is attachments so functions below can run.
  if(this.allAttachments.length >= 1){
    this.cancel_clicked = 0;
  }else if(this.allAttachments.length <= 0 && this.click_continue >= 1){
    this.cancel_clicked = 0;
  }   
  else{
        this.cancel_clicked = 1;
       // return;
    }

      // console.log('cancel_clicked Second: ' + this.cancel_clicked)
      // console.log('allAttachment.length:  ' + this.allAttachments.length)
      // console.log('continue_clicked_second: ' + this.click_continue)


  //     // if no attachemnts ask the question
    // this function will do a check if the variable "cancel_clicked has not also been checked already... infinate loop."
              // if(this.allAttachments.length <= 0 || this.cancel_clicked == 1 || this.cancel_clicked == undefined){
              // this.onOpenDialogSendComms(model, model); // need to restructure the comms to ask the question.
              // return;
              //   }



              // || this.cancel_clicked == undefined
      // this function will do a check if the variable "cancel_clicked has not also been checked already... to stop infinate loop."
      if( this.cancel_clicked == 1){
        this.onOpenDialogSendComms(model, model); // need to restructure the comms to ask the question.
        return;
      }
    


  // if(this.cancel_clicked == 0){
    // model.attached_file_name = this.created_file_name;
    model.attached_file_names = this.selectedFeatures;
    model.attached_job_file_names = this.selectedFeaturesJobFiles;
    model.all_attached_file_names = this.allAttachedFiles;
    model.allAttachments = this.allAttachments;
    model.allRecipients = this.allRecipients;
    console.log(model.attached_file_names);

    // set the default viweing client as the reporting cleint (switch to invoice client if an invoice.)
    if (model.invoice_id > 0) {
      model.brand_id = model.brand_invoice_id;
    }else {
      model.brand_id = model.brand_report_id;
    }

    this.model.allAttachments = this.allAttachments;
    this.model.allRecipients = this.allRecipients;


    // NEED TO IMPLIMENT PRIVACTY ENFORCEMNT
    // set variables and change as per privacy settings of the reciepnts array - all information is pushed there.


    // moved to below.
                  // // upgrade 2.0 multiple notes and templates.
                  // if(model.note_template_HTML_rendered == null){
                  //   this.createSubjectNote(model); // Insert a Note to the subject
                  // }else{
                  //   this.createSubjectNote_with_vars(model)
                  // }

                  // // this.createSubjectNote_with_vars(model)


                  // this.subjectChangeDates(model, this.subject_id); // moved to update before meail.

    const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
    console.log('Communication Type Task: ' +  subject_com_type_name);
        //  const subject_com_type_name = document.getElementById('subject_com_type_name').innerText;
         //  console.log('Communication Type Task: ' +  subject_com_type_name);
   const doc_name = document.getElementById('doc_name').innerText;
   console.log('Document Name: ' +  doc_name);

     // set the invoice from the list of invoices (first record)
  if (model.invoice_id == null) {
    model.invoice_id = this.current_invoice_id;
  }


  // New communication history in loop to REAL and actual data of every recipient // this funciton no wloops all allRecipeints array
  // this.createSubjectCommunicationHistory_with_vars(model);  // -- moved to cerate note loop funciton in nested. -- to get note ID>

        //   // YEP THIS FUNCTION NEEEDS TO RUN IN A LOOP LIKE NOTES..... NEED TO FIX NOW!!!!!
        //   // Might have to move this one to a loop to record proper history.
        //   const subject_communication_history = {
        //     job_id: model.job_id,
        //     subject_id: model.subject_id,
        //     subject_com_type_id: model.subject_com_type_id,
        //     doc_id: model.doc_id,
        //     change_dates: model.change_dates,
        //     additional_message: model.additional_message,
        //     brand_type_id: model.brand_type_id,
        //     brand_id: model.brand_id,
        //     all_attached_file_names: JSON.stringify(model.all_attached_file_names),
        //     send_to_invoice: model.send_to_invoice,
        //     send_to_report: model.send_to_report,
        //     send_to_logins: model.send_to_logins,
        //     send_to_primary: model.send_to_primary,
        //     allAttachments: JSON.stringify(model.allAttachments),
        //     allRecipients: JSON.stringify(model.allRecipients),
        //     allAttachedFiles: JSON.stringify(model.allAttachedFiles),
        //     brand_report_id: model.brand_report_id,
        //     brand_invoice_id: model.brand_invoice_id,
        //     job_type_name: model.job_type_name,
        //     job_type_location_name: model.job_type_location_name,
        //     brand_report_user_id: model.brand_report_user_id,
        //     email_message_subject: model.email_message_subject,
        //     email_message_recipeints: JSON.stringify(model.email_message_recipeints),
        //     message_subject: model.message_subject,
        //     recipient_name: model.recipient_name,
        //     recipient_type_name: model.recipient_type_name,
        //     recipient_email_address: JSON.stringify(model.recipient_email_address),
        //     email_template_HTML: model.email_template_HTML,
        //     subject_number: model.subject_number,
        //     created_by: this.sessionUserId,
        //     created_date: this.today,
        //     attached_file_names: JSON.stringify(model.attached_file_names),
        //     attached_job_file_names: JSON.stringify(model.attached_job_file_names),
        //     subject_com_type_name: model.subject_com_type_name,
        //     // New Nov 2023 Fields. Captured
        //     email_template_primary_HTML_rendered: this.allRecipients[0].email_template_primary_HTML_rendered,
        //     email_subject_primary_rendered: this.allRecipients[0].email_subject_primary_rendered,
        //     note_template_HTML_rendered: model.note_template_HTML_rendered,
        //     email_template_private_HTML_rendered: model.email_template_private_HTML_rendered,
        //     email_subject_private_rendered: model.email_subject_private_rendered,
        //     note_template_private_HTML_rendered: model.note_template_private_HTML_rendered,
        //     is_privacy_emails: model.is_privacy_emails,
        //     is_privacy_notes: model.is_privacy_notes,
        //     is_privacy_no_docs: model.is_privacy_no_docs,
        //     is_privacy_no_emails: model.is_privacy_no_emails,
        //     is_privacy_no_notes: model.is_privacy_no_notes,
        //     created_note_id: model.created_note_id,
        //     created_file_id: model.created_file_id
            
        // /*
        //  */

        //   };
        //   this.gfunc.createSubjectCommunicationHistory(subject_communication_history);

  
    // const log_action = 'sent';
    // const log_name = 'Subject Communicaiton Task: ' + subject_com_type_name  + ' - ' + doc_name + ' -  Emailed';
    // const create_sys_log = {
    //   log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    //   log_action: log_action, // automated / updated / created / uploaded / link_created / sent
    //   created_by: this.sessionUserId,
    //   created_date: this.today,
    //   subject_id: this.subject_id,
    //   job_id: this.job_id,
    //   job_reference_number: model.job_reference_number,
    //   file_number: model.file_subject_number,
    //   reference_number: model.job_reference_number,
    //   subject_number: model.subject_number,
    //   log_type_id: '2', // see datatable system_log_types se (2 when a file is sent with an email)
    //   created_level: this.sessionUserLevel,
    //   brand_type_id: model.brand_type_id,
    //   subject_com_type_id: model.subject_com_type_id,
    //   subject_template_doc_id: model.doc_id,
    //   log_name: log_name + ' - ' + this.returned_created_file_id,
    //   file_id: this.returned_created_file_id,
    //   invoice_id: model.invoice_id,
    //   brand_id: model.brand_id
    // };
    // this.createSystemLog(create_sys_log);


    // moved to below.
                //     // Update invoice status
                // // :: @ Update the Invoice Status to Approved+PDF (4)
                // let invoice_model = {
                //   invoice_id: model.invoice_id,
                //   invoice_communication_status_id: 2,
                //     };
                //   this.updateInvoiceCommunicationStatus(invoice_model);  // moved to top.


// now with full eror checking and seperate for automations file..... [0824_26_b]
    this._mysqlService.sendAgentCommunicationEmailWithVarsWithErrorReporting(model).subscribe(
      (data) => {



        // this.trace_candidate_update = data;
       
            // let res = data;
            // console.log(res); // not working as response is showing in body
            // this.smtp_error = 0;

            // this.toastr.success('Sent Email & Communications Success. ' + res);
         
            let res = data[0];
            this.email_response = DataUtil.parse.parseJson(data);
        
            this.count_email_response = this.email_response.length
 this.toastr.success('Sent Email & Communications Success. SMTP Sent ' + this.count_email_response + ' Emails');


  for (let i = 0; i < this.count_email_response; i++) {
    // element.primary_contact  += this.changeObject[i].first_name + ' ' + this.changeObject[i].surname + ', ';
              let log_action = 'send-success';
                    let log_name = 'Success: Sent' + subject_com_type_name  + ' subject: ' + this.subject_number  + '- ' + doc_name + ' ' + this.email_response[i].notice  + ' ' + this.email_response[i].client_name  + ' ' + this.email_response[i].recipient;
                    let create_sys_log = {
                      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                      log_action: log_action, // automated / updated / created / uploaded / link_created / sent
                      created_by: this.sessionUserId,
                      created_date: this.today,
                      subject_id: this.subject_id,
                      job_id: this.job_id,
                      job_reference_number: model.job_reference_number,
                      file_number: model.file_subject_number,
                      reference_number: model.job_reference_number,
                      subject_number: model.subject_number,
                      log_type_id: '61', // see datatable system_log_types se (2 when a file is sent with an email)
                      created_level: this.sessionUserLevel,
                      brand_type_id: model.brand_type_id,
                      subject_com_type_id: model.subject_com_type_id,
                      subject_template_doc_id: model.doc_id,
                      log_name: log_name,
                      file_id: this.returned_created_file_id,
                      invoice_id: model.invoice_id,
                      brand_id: model.brand_id,
                     // note_id: this.get_latest_subject_note_id, // from above loop
                    };
            this.createSystemLog(create_sys_log);

} // end loop


      // now do the rest of the tasks we have success of the emails....

                  // Update invoice status
              // :: @ Update the Invoice Status to Approved+PDF (4)
              let invoice_model = {
                invoice_id: model.invoice_id,
                invoice_communication_status_id: 2,
                  };
                this.updateInvoiceCommunicationStatus(invoice_model);  // moved to top.


              // upgrade 2.0 multiple notes and templates.
              if(model.note_template_HTML_rendered == null){
                this.createSubjectNote(model); // Insert a Note to the subject
              }else{
                this.createSubjectNote_with_vars(model)
              }

              // this.createSubjectNote_with_vars(model)


              this.subjectChangeDates(model, this.subject_id); // moved to update before meail.




        // console.log(res._body);
        // console.log(res[0].text()); // Convert response to a string

        // this.subjectChangeDates(model, this.subject_id); // moved to to run before email send.
        // now global success function
            
                  this.gfunc.onOpenDialog_SuccessCommunication(event, model);

                  // now close the modal
                  this.closeParentModel.emit();
                  this.closeParentModel3.emit();
                  // refresh the invoice page if
                  if ( model.invoice_id > 0 ) {
                    this.refreshSujectInvoicePage.emit(this.subject_id);
                  }

                  this.sending_comms = 0;
      },
      (error) => {

        this.sending_comms = 0;
        console.log(error.error)
        this.toastr.error('Error sending Email' + error.error);

        this.smtp_error = 1;
        this.smtp_error_response = error.error


  
  const log_action = 'send-fail';
  const log_name = 'FAIL: Email ERROR: YOU NEED TO TRY AGAIN! ' + subject_com_type_name  + ' subject: ' + this.subject_number  + '- ' + doc_name + ' ' + error.error ;
  const create_sys_log = {
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: log_action, // automated / updated / created / uploaded / link_created / sent
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: this.subject_id,
    job_id: this.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_subject_number,
    reference_number: model.job_reference_number,
    subject_number: model.subject_number,
    log_type_id: '60', // see datatable system_log_types se (2 when a file is sent with an email)
    created_level: this.sessionUserLevel,
    brand_type_id: model.brand_type_id,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.doc_id,
    log_name: log_name,
    file_id: this.returned_created_file_id,
    invoice_id: model.invoice_id,
    brand_id: model.brand_id,
    note_id: this.get_latest_subject_note_id, // from above loop
  };
  this.createSystemLog(create_sys_log);


        // Run this anyway ....
            // this.toastr.success('Sent Email & Communications Success.');
            // this.gfunc.onOpenDialog_SuccessCommunication(event, model);
            // return console.log(error);
      }
    );

    // } // end if cancel clicked


  }

  // this function is universal for client or email now.
  sendAffidavitCommunicationEmail(model) {
  
    this.smtp_error = 0; // reset the error warning
    this.sending_comms = 1;

    //.. set cancel clicked if there is attachments so functions below can run.
    if(this.allAttachments.length >= 1){
      this.cancel_clicked = 0;
      }else if(this.allAttachments.length <= 0 && this.click_continue >= 1){
      this.cancel_clicked = 0;
      }   
      else{
      this.cancel_clicked = 1;
      // return;
      };



      if( this.cancel_clicked == 1){
      this.onOpenDialogSendComms(model, model); // need to restructure the comms to ask the question.
      return;
      }
  
  
  
    // model.attached_file_name = this.created_file_name;
    model.attached_file_names = this.selectedFeatures;
    model.attached_job_file_names = this.selectedFeaturesJobFiles;
    model.all_attached_file_names = this.allAttachedFiles;
    model.allAttachments = this.allAttachments;
    model.allRecipients = this.allRecipients;
    console.log(model.attached_file_names);


    // moved to below
              //  // upgrade 2.0 multiple notes and templates.
              //  if(model.note_template_HTML_rendered == null){
              //   this.createSubjectNote(model); // Insert a Note to the subject
              // }else{
              //   this.createSubjectNote_with_vars(model)
              // }


              // this.subjectChangeDates(model, this.subject_id); // moved to update before meail.

    this.model.allAttachments = this.allAttachments;
    this.model.allRecipients = this.allRecipients;


    const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
    console.log('Communication Type Task: ' +  subject_com_type_name);
        //  const subject_com_type_name = document.getElementById('subject_com_type_name').innerText;
         //  console.log('Communication Type Task: ' +  subject_com_type_name);
   const doc_name = document.getElementById('doc_name').innerText;


    this._mysqlService.sendAffidavitCommunicationEmailWithVarsWithReporting(model).subscribe(
      (data) => {
        // this.trace_candidate_update = data;
        // this.toastr.success('Sent Email.');
        // const res = data;
        // console.log(res); // not working as response is showing in body
        // // console.log(res._body);
        // console.log(res[0].text()); // Convert response to a string


                let res = data[0];
                    this.email_response = DataUtil.parse.parseJson(data);
                
                    this.count_email_response = this.email_response.length
            this.toastr.success('Sent Email & Communications Success. SMTP Sent ' + this.count_email_response + ' Emails');


            for (let i = 0; i < this.count_email_response; i++) {
            // element.primary_contact  += this.changeObject[i].first_name + ' ' + this.changeObject[i].surname + ', ';
                      let log_action = 'send-success';
                            let log_name = 'Success: Sent' + subject_com_type_name  + ' subject: ' + this.subject_number  + '- ' + doc_name + ' ' + this.email_response[i].notice  + ' ' + this.email_response[i].client_name  + ' ' + this.email_response[i].recipient;
                            let create_sys_log = {
                              log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                              log_action: log_action, // automated / updated / created / uploaded / link_created / sent
                              created_by: this.sessionUserId,
                              created_date: this.today,
                              subject_id: this.subject_id,
                              job_id: this.job_id,
                              job_reference_number: model.job_reference_number,
                              file_number: model.file_subject_number,
                              reference_number: model.job_reference_number,
                              subject_number: model.subject_number,
                              log_type_id: 61, // see datatable system_log_types se (2 when a file is sent with an email)
                              created_level: this.sessionUserLevel,
                              brand_type_id: model.brand_type_id,
                              subject_com_type_id: model.subject_com_type_id,
                              subject_template_doc_id: model.doc_id,
                              log_name: log_name,
                              file_id: this.returned_created_file_id,
                              invoice_id: model.invoice_id,
                              brand_id: model.brand_id,
                            // note_id: this.get_latest_subject_note_id, // from above loop
                            };
                    // this.createSystemLog(create_sys_log);



                    //  Affidavit Creation - Communications
                    if(model.subject_com_type_id == 4 ){
                    let _log_type_id = 72
                    let log_name = 'Success: Sent' + subject_com_type_name  + ' subject: ' + this.subject_number  + '- ' + doc_name + ' ' + this.email_response[i].notice  + ' ' + this.email_response[i].client_name  + ' ' + this.email_response[i].recipient;
                    let create_sys_log = {
                      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                      log_action: log_action, // automated / updated / created / uploaded / link_created / sent
                      created_by: this.sessionUserId,
                      created_date: this.today,
                      subject_id: this.subject_id,
                      job_id: this.job_id,
                      job_reference_number: model.job_reference_number,
                      file_number: model.file_subject_number,
                      reference_number: model.job_reference_number,
                      subject_number: model.subject_number,
                      log_type_id: _log_type_id, // see datatable system_log_types se (2 when a file is sent with an email)
                      created_level: this.sessionUserLevel,
                      brand_type_id: model.brand_type_id,
                      subject_com_type_id: model.subject_com_type_id,
                      subject_template_doc_id: model.doc_id,
                      log_name: log_name,
                      file_id: this.returned_created_file_id,
                      invoice_id: model.invoice_id,
                    brand_id: model.report_brand_id,
                    };
                    this.createSystemLog(create_sys_log);
                    }
 
                    // Agent Communication
                    if(model.subject_com_type_id == 2 ){
                      let _log_type_id = 73
                      let log_name = 'Success: Sent' + subject_com_type_name  + ' subject: ' + this.subject_number  + '- ' + doc_name + ' ' + this.email_response[i].notice  + ' ' + this.email_response[i].client_name  + ' ' + this.email_response[i].recipient;
                      let create_sys_log = {
                        log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                        log_action: log_action, // automated / updated / created / uploaded / link_created / sent
                        created_by: this.sessionUserId,
                        created_date: this.today,
                        subject_id: this.subject_id,
                        job_id: this.job_id,
                        job_reference_number: model.job_reference_number,
                        file_number: model.file_subject_number,
                        reference_number: model.job_reference_number,
                        subject_number: model.subject_number,
                        log_type_id: _log_type_id, // see datatable system_log_types se (2 when a file is sent with an email)
                        created_level: this.sessionUserLevel,
                        brand_type_id: model.brand_type_id,
                        subject_com_type_id: model.subject_com_type_id,
                        subject_template_doc_id: model.doc_id,
                        log_name: log_name,
                        file_id: this.returned_created_file_id,
                        invoice_id: model.invoice_id,
                      brand_id: model.report_brand_id,
                      };
                      this.createSystemLog(create_sys_log);
                      }

                      // client report
                      if(model.subject_com_type_id == 3 ){
                        let _log_type_id = 74
                        let log_name = 'Success: Sent' + subject_com_type_name  + ' subject: ' + this.subject_number  + '- ' + doc_name + ' ' + this.email_response[i].notice  + ' ' + this.email_response[i].client_name  + ' ' + this.email_response[i].recipient;
                        let create_sys_log = {
                          log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                          log_action: log_action, // automated / updated / created / uploaded / link_created / sent
                          created_by: this.sessionUserId,
                          created_date: this.today,
                          subject_id: this.subject_id,
                          job_id: this.job_id,
                          job_reference_number: model.job_reference_number,
                          file_number: model.file_subject_number,
                          reference_number: model.job_reference_number,
                          subject_number: model.subject_number,
                          log_type_id: _log_type_id, // see datatable system_log_types se (2 when a file is sent with an email)
                          created_level: this.sessionUserLevel,
                          brand_type_id: model.brand_type_id,
                          subject_com_type_id: model.subject_com_type_id,
                          subject_template_doc_id: model.doc_id,
                          log_name: log_name,
                          file_id: this.returned_created_file_id,
                          invoice_id: model.invoice_id,
                        brand_id: model.report_brand_id,
                        };
                        this.createSystemLog(create_sys_log);
                        }

                        // Agent Instruct Communication
                        if(model.subject_com_type_id == 1 ){
                          let _log_type_id = 75
                          let log_name = 'Success: Sent' + subject_com_type_name  + ' subject: ' + this.subject_number  + '- ' + doc_name + ' ' + this.email_response[i].notice  + ' ' + this.email_response[i].client_name  + ' ' + this.email_response[i].recipient;
                          let create_sys_log = {
                            log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                            log_action: log_action, // automated / updated / created / uploaded / link_created / sent
                            created_by: this.sessionUserId,
                            created_date: this.today,
                            subject_id: this.subject_id,
                            job_id: this.job_id,
                            job_reference_number: model.job_reference_number,
                            file_number: model.file_subject_number,
                            reference_number: model.job_reference_number,
                            subject_number: model.subject_number,
                            log_type_id: _log_type_id, // see datatable system_log_types se (2 when a file is sent with an email)
                            created_level: this.sessionUserLevel,
                            brand_type_id: model.brand_type_id,
                            subject_com_type_id: model.subject_com_type_id,
                            subject_template_doc_id: model.doc_id,
                            log_name: log_name,
                            file_id: this.returned_created_file_id,
                            invoice_id: model.invoice_id,
                          brand_id: model.report_brand_id,
                          };
                          this.createSystemLog(create_sys_log);
                          }



                           // Owner Communication
                        if(model.subject_com_type_id == 5 ){
                          let _log_type_id = 76
                          let log_name = 'Success: Sent' + subject_com_type_name  + ' subject: ' + this.subject_number  + '- ' + doc_name + ' ' + this.email_response[i].notice  + ' ' + this.email_response[i].client_name  + ' ' + this.email_response[i].recipient;
                          let create_sys_log = {
                            log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                            log_action: log_action, // automated / updated / created / uploaded / link_created / sent
                            created_by: this.sessionUserId,
                            created_date: this.today,
                            subject_id: this.subject_id,
                            job_id: this.job_id,
                            job_reference_number: model.job_reference_number,
                            file_number: model.file_subject_number,
                            reference_number: model.job_reference_number,
                            subject_number: model.subject_number,
                            log_type_id: _log_type_id, // see datatable system_log_types se (2 when a file is sent with an email)
                            created_level: this.sessionUserLevel,
                            brand_type_id: model.brand_type_id,
                            subject_com_type_id: model.subject_com_type_id,
                            subject_template_doc_id: model.doc_id,
                            log_name: log_name,
                            file_id: this.returned_created_file_id,
                            invoice_id: model.invoice_id,
                          brand_id: model.report_brand_id,
                          };
                          this.createSystemLog(create_sys_log);
                          }

            } // end loop


     // upgrade 2.0 multiple notes and templates.
     if(model.note_template_HTML_rendered == null){
      this.createSubjectNote(model); // Insert a Note to the subject
    }else{
      this.createSubjectNote_with_vars(model)
    }
    // this.subjectChangeDates(model, this.subject_id); // moved to update before meail.

        this.subjectChangeDates(model, this.subject_id);
        this.gfunc.onOpenDialog_SuccessCommunication(event, model);
        this.sending_comms = 0;
        
      },
      (error) => {
   
        this.sending_comms = 0;
        console.log(error.error)
        this.toastr.error('Error sending Email' + error.error);

        this.smtp_error = 1;
        this.smtp_error_response = error.error

  
        const log_action = 'send-fail';
        const log_name = 'FAIL: Email ERROR: YOU NEED TO TRY AGAIN! ' + subject_com_type_name  + ' subject: ' + this.subject_number  + '- ' + doc_name + ' ' + error.error ;
        const create_sys_log = {
          log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
          log_action: log_action, // automated / updated / created / uploaded / link_created / sent
          created_by: this.sessionUserId,
          created_date: this.today,
          subject_id: this.subject_id,
          job_id: this.job_id,
          job_reference_number: model.job_reference_number,
          file_number: model.file_subject_number,
          reference_number: model.job_reference_number,
          subject_number: model.subject_number,
          log_type_id: '60', // see datatable system_log_types se (2 when a file is sent with an email)
          created_level: this.sessionUserLevel,
          brand_type_id: model.brand_type_id,
          subject_com_type_id: model.subject_com_type_id,
          subject_template_doc_id: model.doc_id,
          log_name: log_name,
          file_id: this.returned_created_file_id,
          invoice_id: model.invoice_id,
          brand_id: model.brand_id,
          note_id: this.get_latest_subject_note_id, // from above loop
        };
        this.createSystemLog(create_sys_log);





      }
    );
  }

  sendClientAttServEmail(model) {
    // model.attached_file_name = this.created_file_name;
    model.attached_file_names = this.selectedFeatures;
    model.attached_job_file_names = this.selectedFeaturesJobFiles;
    model.allAttachments = this.allAttachments;
    model.allRecipients = this.allRecipients;
    console.log(model.attached_file_names);

    this.createSubjectNote(model); // Insert a Note to the subject

    this._mysqlService.sendClientAttServ(model).subscribe(
      (data) => {
        // this.trace_candidate_update = data;
        this.toastr.success('Sent Email.');
        const res = data;
        console.log(res); // not working as response is showing in body
        // console.log(res._body);
        console.log(res[0].text()); // Convert response to a string
      },
      (error) => {
        // this.toastr.error('Error sending Email');
                // Run this anyway ....
                this.toastr.success('Sent Email & Communications Success.');
                this.gfunc.onOpenDialog_SuccessCommunication(event, model);
       return console.log(error);
      }
    );
  }

  private refreshList(): void {
    // notice the update here for traces
    this.fileUploader
      .getJobFiles(this.job_id)
      .subscribe((res) => this.displayTableData(res));
  }


  displaySubjectDocuments(subject_id, subject_number) {
    this.fileUploader
      .getJobSubjectFiles(this.subject_id, this.subject_number)
      .subscribe((res) => this.displaySubjectFiles(res));
  }


  private displayTableData(data: any): void {
    // this.tableData = data.json();
    this.tableData = data;
  }

  private displaySubjectFiles(data: any): void {
    // this.tableSubjectData = data.json();
    this.tableSubjectData = data;
  }

  attachFile(filename, job_id) {
    if (confirm('Are you sure you want to Attatch this file? ')) {
      /*
        this._mysqlService.deleteJobFile('nothing', job_id).subscribe(
           data => {
             // this.getTraceNotes(this.trace_id);
            this.refreshList();
             return true;
           },
           error => {
             console.error('Error deleting Job File!');
            return console.log(error);
           }
        );*/

      this.model.attached_file_names = filename;

      console.log(filename);
    }
  }

  attachJobFile(filename, job_id) {
    if (confirm('Are you sure you want to Attatch this file? ')) {
      /*
        this._mysqlService.deleteJobFile('nothing', job_id).subscribe(
           data => {
             // this.getTraceNotes(this.trace_id);
            this.refreshList();
             return true;
           },
           error => {
             console.error('Error deleting Job File!');
            return console.log(error);
           }
        );*/

      this.model.attached_job_file_names = filename;
      // console.log(filename);
    }
  }

  deleteJobFile(filename, job_id) {
    if (confirm('Are you sure you want to delete this file? ')) {
      this._mysqlService.deleteJobFile(filename, job_id).subscribe(
        (data) => {
          // this.getTraceNotes(this.trace_id);
          this.refreshList();
          return true;
        },
        (error) => {
          console.error('Error deleting Job File!');
         return console.log(error);
        }
      );
    }
  }


  



  onAdd(data) {
    if (confirm('Are you sure you want to Attatch this file? ')) {
     // this.selectedFeatures.push(fileName);
      // push to global array
  
  console.log('Send Subject ID: ' + data.file_subject_id + ' JObID: ' + data.file_job_id);
  
      if (data.file_subject_id  >= 1) {
        this.set_job_file = 0;
        this.set_subject_file = 1;
      }
  
      if (data.file_subject_id  <= 0) {
        this.set_job_file = 1;
        this.set_subject_file = 0;
      }
  
      this.allAttachedFiles.push(data.fileName);
      this.allAttachments.push({
        file_name: data.full_file_name,
        job_file: this.set_job_file,
        subject_file: this.set_subject_file,
        subject_number: data.subject_number,
        job_id: data.job_id,
        file_server_location: data.file_server_location,
        file_id: data.file_id
      });
  
  this.allAttachedFiles = this.allAttachedFiles;
  this.model.allAttachedFiles = this.allAttachedFiles;
  this.model.allAttachments = this.allAttachments;
  
  // this.toastr.success('Attatchment added.');
     // this.isShow = !this.isShow; // hides the div again
      // this.isShow_uploaded = !this.isShow_uploaded;
  
      // closes the model when opened from file browser.
      this.modalRef.hide();
    }
  }


  // onAdd(fileName) {
  //   if (confirm('Are you sure you want to Attatch this file? ')) {
  //     this.selectedFeatures.push(fileName);
  //     // push to global array
  //     this.allAttachedFiles.push(fileName);
  //     this.allAttachments.push({
  //       file_name: fileName,
  //       job_file: 0,
  //       subject_file: 1,
  //     });

  //     this.toastr.success('Attatchment added.');
  //     this.isShow = !this.isShow; // hides the div again
  //     // this.isShow_uploaded = !this.isShow_uploaded;

  //     // closes the model when opened from file browser.
  //     this.closeParentModelDefault(fileName);
  //   }
  // }

  onAddJobFile(fileName) {
    if (confirm('Are you sure you want to Attatch this file? ')) {
      this.selectedFeaturesJobFiles.push(fileName);
      // push to global array
      this.allAttachedFiles.push(fileName);
      this.allAttachments.push({
        file_name: fileName,
        job_file: 1,
        subject_file: 0,
      });
      this.toastr.success('Attatchment added.');
      // this.isShow = !this.isShow; // hides the div again
      this.isShow_uploaded = !this.isShow_uploaded;
    }
  }

  onRemoveJobFile() {
    this.selectedFeaturesJobFiles.pop();
    this.toastr.warning('Attatchment removed.');
  }

  onRemoveAllFile() {
    this.allAttachedFiles.pop();
    this.toastr.warning('Attatchment removed.');
    // this.allAttachments.pop();
  }

  onRemove() {
    this.selectedFeatures.pop();
    this.toastr.warning('Attatchment removed.');
  }

  // toggle elements
  toggleDisplay() {
    this.isShow = !this.isShow;
  }

  toggleDisplayUploaded() {
    this.isShow_uploaded = !this.isShow_uploaded;
  }

  // Create New Type of note:
  createSubjectNote(model) {
    // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);
    model.created_by = this.sessionUserId;
    model.note_content =
      'Instruct request emailed to the agent. Manual From Subject Card Screen.';
    model.note_type_id = '1';



// need to check if this effects the others on insert
// this.RemoveElementOthersFromAllRecipients(model.subject_id);
// currentlu saves all the recipients into the array and filters out at read

      // WHEN CREATING A NEW NOTE FROM TEMPLATE!..... Let do a new function.....
    // NEW 2.0 Version I will need to looop throughthe arrays and add all recipient notes....... to the file.
    model.assigned_to_agents = JSON.stringify(this.allRecipients);
    console.log('model.assigned_to_agents: ', model.assigned_to_agents);

    // if (result.job_status === 'OPEN'){
                this._demoService.createSubjectNote(model).subscribe(
                  (data) => {
                    this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
                    this.toastr.info('Note Added');
                    // const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
                    // this.search_results[objIndex].note_added = 'yes';
                  },
                  (error) => {
                    // console.log(error(error));
                    //return console.log(error);
                  }
                );
    // } // end if  open
  }



  createSubjectCommunicationHistory_with_vars(model){

    let  count_of_items = this.allRecipients.length;
    for(let i=0; i < count_of_items; i++) {

    // New Nov 2023 Fields. Captured
    // model.email_template_primary_HTML_rendered = this.allRecipients[i].email_template_primary_HTML_rendered
    // model.email_subject_primary_rendered = this.allRecipients[i].email_subject_primary_rendered,
    // model.note_template_HTML_rendered = this.allRecipients[i].note_template_HTML_rendered,
    // model.email_template_private_HTML_rendered = this.allRecipients[i].email_template_private_HTML_rendered,
    // model.email_subject_private_rendered = this.allRecipients[i].email_subject_private_rendered,
    // model.note_template_private_HTML_rendered = this.allRecipients[i].note_template_private_HTML_rendered,
    // model.is_privacy_emails = this.allRecipients[i].is_privacy_emails,
    // model.is_privacy_notes = this.allRecipients[i].is_privacy_notes,
    // model.is_privacy_no_docs = this.allRecipients[i].is_privacy_no_docs,
    // model.is_privacy_no_emails = this.allRecipients[i].is_privacy_no_emails,
    // model.is_privacy_no_notes = this.allRecipients[i].is_privacy_no_notes,
    // model.created_note_id = this.allRecipients[i].created_note_id,
    // model.created_file_id = this.allRecipients[i].created_file_id

 // Commented Out for now... as now moved into loop. -- of note creation
                //   const subject_communication_history = {
                //     job_id: model.job_id,
                //     subject_id: model.subject_id,
                //     subject_com_type_id: model.subject_com_type_id,
                //     doc_id: model.doc_id,
                //     change_dates: model.change_dates,
                //     additional_message: model.additional_message,
                //     brand_type_id: model.brand_type_id,
                //     brand_id: model.brand_id,
                //     all_attached_file_names: JSON.stringify(model.all_attached_file_names),
                //     send_to_invoice: model.send_to_invoice,
                //     send_to_report: model.send_to_report,
                //     send_to_logins: model.send_to_logins,
                //     send_to_primary: model.send_to_primary,
                //     allAttachments: JSON.stringify(model.allAttachments),
                //     allRecipients: JSON.stringify(model.allRecipients),
                //     allAttachedFiles: JSON.stringify(model.allAttachedFiles),
                //     brand_report_id: model.brand_report_id,
                //     brand_invoice_id: model.brand_invoice_id,
                //     job_type_name: model.job_type_name,
                //     job_type_location_name: model.job_type_location_name,
                //     brand_report_user_id: model.brand_report_user_id,
                    
                //     email_message_subject: this.allRecipients[i].email_message_subject,
                //     email_message_recipeints: JSON.stringify(model.email_message_recipeints),
                //     message_subject: this.allRecipients[i].message_subject,
                //     // recipient_name: model.recipient_name,
                //     // recipient_type_name: model.recipient_type_name,
                //     // recipient_email_address: JSON.stringify(model.recipient_email_address),
                //     recipient_name: this.allRecipients[i].recipient_name,
                //     recipient_type_name: this.allRecipients[i].recipient_type_name,
                //     recipient_email_address: this.allRecipients[i].recipient_email_address,

                //     email_template_HTML: this.allRecipients[i].email_template_HTML,
                //     subject_number: this.allRecipients[i].subject_number,
                //     created_by: this.sessionUserId,
                //     created_date: this.today,
                //     attached_file_names: JSON.stringify(model.attached_file_names),
                //     attached_job_file_names: JSON.stringify(model.attached_job_file_names),
                //     subject_com_type_name: model.subject_com_type_name,
                //     // New Nov 2023 Fields. Captured
                //     email_template_primary_HTML_rendered: this.allRecipients[i].email_template_primary_HTML_rendered,
                //     email_subject_primary_rendered: this.allRecipients[i].email_subject_primary_rendered,
                //     note_template_HTML_rendered: this.allRecipients[i].note_template_HTML_rendered,
                //     email_template_private_HTML_rendered: this.allRecipients[i].email_template_private_HTML_rendered,
                //     email_subject_private_rendered: this.allRecipients[i].email_subject_private_rendered,
                //     note_template_private_HTML_rendered: this.allRecipients[i].note_template_private_HTML_rendered,
                //     is_privacy_emails: this.allRecipients[i].is_privacy_emails,
                //     is_privacy_notes: this.allRecipients[i].is_privacy_notes,
                //     is_privacy_no_docs: this.allRecipients[i].is_privacy_no_docs,
                //     is_privacy_no_emails: this.allRecipients[i].is_privacy_no_emails,
                //     is_privacy_no_notes: this.allRecipients[i].is_privacy_no_notes,
                //     created_note_id: this.allRecipients[i].created_note_id, // these are wrong
                //     created_file_id: this.allRecipients[i].created_file_id, // thse are wrong
                //     email_bcc: this.allRecipients[i].email_bcc,
                //     email_cc: this.allRecipients[i].email_cc,

                //     // 
                //     // email_cc
                    
                // /*
                //  */
                
                //   };


                //     this._demoService.createSubjectCommunicationHistory(subject_communication_history).subscribe(
                //       data => { 
                //         this.subject_communication_history_created_response = data;
                //       this.toastr.success('Communication History Created with vars' + this.allRecipients[i].recipient_name)
                //       // console.log('Comms History Model: ' + JSON.stringify(model))
                //       },
                //       err => console.error(err),
                //       // () => console.log('done loading Trace Types')
                //     );



    } // end loop

  }


   // Create New Type of note: -- This function loops the recipients and adds note for each recipent with email content rendered
   createSubjectNote_with_vars(model) {
    
    let  count_of_items = this.allRecipients.length;
    for(let i=0; i < count_of_items; i++) {

                     // does not make a note if checked in company profile. - no notes
     if( this.allRecipients[i].is_privacy_no_notes != 1){ 
                  // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);
                  model.created_by = this.sessionUserId;
                  // model.note_content =
                  //   'Instruct request emailed to the agent. Manual From Subject Card Screen.';

                  // model.note_content = model.note_template_HTML_rendered;  THIS NEED A FIX AND LOOP!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
                  /// this needs to be decoded first. -- Appends Email Conent to the note (notes are differernt to emails and need decodeing to save in database)


                  // Email does filter at PHP level I think.... easier... that way
                  // privacy enfforcement --- NEED TO SUB CHECKS FOR EMAILS (contents)... and notes creations as well
                                  // if(this.allRecipients[i].is_privacy_notes == 1 ){
                                  //   model.note_content =this.transform2(this.allRecipients[i].note_template_private_HTML_rendered);
                                  // }else{
                                  //   model.note_content = this.transform2(this.allRecipients[i].note_template_HTML_rendered + '<p>Email Contents</p>' + this.allRecipients[i].email_template_primary_HTML_rendered ); // decode first.
                                  // }

                let append_email_cc = '';
                let append_email_bcc = '';
                if(this.allRecipients[i].email_cc){
                append_email_cc = '<p>Email Was CC: ' + this.allRecipients[i].email_cc + '</p>'
                }
                if(this.allRecipients[i].email_bcc){
                append_email_bcc = '<p>Email Was BCC: ' + this.allRecipients[i].email_bcc + '</p>'
                }

                
                // append to email checker,
                if(model.append_email_to_note == 1){
                // privacy level replaced at UI....
                model.note_content = this.transform2(this.allRecipients[i].note_template_HTML_rendered + '<p>Email Contents</p>' + this.allRecipients[i].email_template_primary_HTML_rendered ) + append_email_cc + append_email_bcc ; // decode first.

                }else{
                      // privacy level replaced at UI....
                model.note_content = this.transform2(this.allRecipients[i].note_template_HTML_rendered)  + append_email_cc + append_email_bcc ; // decode first.

                }


 
                  model.note_type_id = '1';

                  this.toastr.info('Creating A Note Tempalate with vars :)')

                  // need to check if this effects the others on insert
                  // this.RemoveElementOthersFromAllRecipients(model.subject_id);
                  // currentlu saves all the recipients into the array and filters out at read

                    // WHEN CREATING A NEW NOTE FROM TEMPLATE!..... Let do a new function.....
                  // NEW 2.0 Version I will need to looop throughthe arrays and add all recipient notes....... to the file.
                  model.assigned_to_agents = JSON.stringify(this.allRecipients);
                  console.log('model.assigned_to_agents: ', model.assigned_to_agents);  // MAY NEED TO CHANGE THIS AND REDUCE THE DATA??????

                  // if (result.job_status === 'OPEN'){
                              this._demoService.createSubjectNoteWithVars(model).subscribe(
                                (data2) => {
                                 let  res2 = data2[0]            
                                 this.set_last_inserted_note = data2;   
                                  this.get_latest_subject_note_id = this.set_last_inserted_note.last_insert_id; // this is the retuned json upon creation.
                                  // console.log('Note Lasdt Insert ID:' + this.get_latest_subject_note_id)
                                  this.toastr.info('Note Added:  ' +  this.allRecipients[i].recipient_name);
                                  // const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
                                  // this.search_results[objIndex].note_added = 'yes';


                                  // COMM HISTORY.
                                  // return the last insert ID of Note to insert into communication history every and add to model.

                                  // Ry a neste dLoop Here
                                  let subject_communication_history = {
                                    job_id: model.job_id,
                                    subject_id: model.subject_id,
                                    subject_com_type_id: model.subject_com_type_id,
                                    doc_id: model.doc_id,
                                    change_dates: model.change_dates,
                                    additional_message: model.additional_message,
                                    brand_type_id: model.brand_type_id,
                                    brand_id: model.brand_id,
                                    all_attached_file_names: JSON.stringify(model.all_attached_file_names),
                                    send_to_invoice: model.send_to_invoice,
                                    send_to_report: model.send_to_report,
                                    send_to_logins: model.send_to_logins,
                                    send_to_primary: model.send_to_primary,
                                    allAttachments: JSON.stringify(model.allAttachments),
                                    allRecipients: JSON.stringify(model.allRecipients),
                                    allAttachedFiles: JSON.stringify(model.allAttachedFiles),
                                    brand_report_id: model.brand_report_id,
                                    brand_invoice_id: model.brand_invoice_id,
                                    job_type_name: model.job_type_name,
                                    job_type_location_name: model.job_type_location_name,
                                    brand_report_user_id: model.brand_report_user_id,
                                    
                                    email_message_subject: this.allRecipients[i].email_message_subject,
                                    email_message_recipeints: JSON.stringify(model.email_message_recipeints),
                                    message_subject: this.allRecipients[i].message_subject,
                                    // recipient_name: model.recipient_name,
                                    // recipient_type_name: model.recipient_type_name,
                                    // recipient_email_address: JSON.stringify(model.recipient_email_address),
                                    recipient_name: this.allRecipients[i].recipient_name,
                                    recipient_type_name: this.allRecipients[i].recipient_type_name,
                                    recipient_email_address: this.allRecipients[i].recipient_email_address,
                              
                                    email_template_HTML: this.allRecipients[i].email_template_HTML,
                                    subject_number: this.allRecipients[i].subject_number,
                                    created_by: this.sessionUserId,
                                    created_date: this.today,
                                    attached_file_names: JSON.stringify(model.attached_file_names),
                                    attached_job_file_names: JSON.stringify(model.attached_job_file_names),
                                    subject_com_type_name: model.subject_com_type_name,
                                    // New Nov 2023 Fields. Captured
                                    email_template_primary_HTML_rendered: this.allRecipients[i].email_template_primary_HTML_rendered,
                                    email_subject_primary_rendered: this.allRecipients[i].email_subject_primary_rendered,
                                    note_template_HTML_rendered: this.allRecipients[i].note_template_HTML_rendered,
                                    email_template_private_HTML_rendered: this.allRecipients[i].email_template_private_HTML_rendered,
                                    email_subject_private_rendered: this.allRecipients[i].email_subject_private_rendered,
                                    note_template_private_HTML_rendered: this.allRecipients[i].note_template_private_HTML_rendered,
                                    is_privacy_emails: this.allRecipients[i].is_privacy_emails,
                                    is_privacy_notes: this.allRecipients[i].is_privacy_notes,
                                    is_privacy_no_docs: this.allRecipients[i].is_privacy_no_docs,
                                    is_privacy_no_emails: this.allRecipients[i].is_privacy_no_emails,
                                    is_privacy_no_notes: this.allRecipients[i].is_privacy_no_notes,
                                    created_note_id: this.get_latest_subject_note_id, // from above loop
                                    created_file_id: this.returned_created_file_id,
                                    email_bcc: this.allRecipients[i].email_bcc,
                                    email_cc: this.allRecipients[i].email_cc,
                              

                                    job_type_id: model.job_type_id,
                                    job_type_location_id: model.job_type_location_id,
                                   job_type_court_id: model.job_type_court_id,
                                   job_type_document_type_id: model.job_type_document_type_id,
                                   job_type_affidavit_type_id: model.job_type_affidavit_type_id,
                                   log_content: JSON.stringify(model)
                                    // 
                                    // email_cc
                                    
                                /*
                                 */
                                
                                  };
                              
                              
                                    this._demoService.createSubjectCommunicationHistory(subject_communication_history).subscribe(
                                      data => { 
                                        this.subject_communication_history_created_response = data;
                                      this.toastr.success('Communication History Created with vars' + this.allRecipients[i].recipient_name)
                                      // console.log('Comms History Model: ' + JSON.stringify(model))


                                                  const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
                                                   
                                                  let doc_name;
                                                  doc_name = document.getElementById('doc_name').innerText;

                                                      // thrid nest create log
                                                      const log_action = 'sent';
                                                      const log_name = 'Subject Communicaiton Task: ' + subject_com_type_name  + ' - ' + doc_name + ' - ' + this.allRecipients[i].recipient_name;
                                                      const create_sys_log = {
                                                        log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                                                        log_action: log_action, // automated / updated / created / uploaded / link_created / sent
                                                        created_by: this.sessionUserId,
                                                        created_date: this.today,
                                                        subject_id: this.subject_id,
                                                        job_id: this.job_id,
                                                        job_reference_number: model.job_reference_number,
                                                        file_number: model.file_subject_number,
                                                        reference_number: model.job_reference_number,
                                                        subject_number: model.subject_number,
                                                        log_type_id: '2', // see datatable system_log_types se (2 when a file is sent with an email)
                                                        created_level: this.sessionUserLevel,
                                                        brand_type_id: model.brand_type_id,
                                                        subject_com_type_id: model.subject_com_type_id,
                                                        subject_template_doc_id: model.doc_id,
                                                        log_name: log_name,
                                                        file_id: this.returned_created_file_id,
                                                        invoice_id: model.invoice_id,
                                                        brand_id: model.brand_id,
                                                        note_id: this.get_latest_subject_note_id, // from above loop
                                                      };
                                                      this.createSystemLog(create_sys_log);


                                      },
                                      err => console.error(err),
                                      // () => console.log('done loading Trace Types')
                                    );
                              
                                // end nested loop.


                                },
                                (error) => {
                                  // console.log(error(error));
                                  //return console.log(error);
                                  this.toastr.error('Note NOT Added  ' +  this.allRecipients[i].recipient_name);

                                }
                              );
                  // } // end if  open


          }else{ // if NO NOTES on
          // we still need to insert the comms log with no note ID
           // TODO
          //  this.createSubjectCommunicationHistory_with_vars(model);
                      const subject_communication_history = {
                        job_id: model.job_id,
                        subject_id: model.subject_id,
                        subject_com_type_id: model.subject_com_type_id,
                        doc_id: model.doc_id,
                        change_dates: model.change_dates,
                        additional_message: model.additional_message,
                        brand_type_id: model.brand_type_id,
                        brand_id: model.brand_id,
                        all_attached_file_names: JSON.stringify(model.all_attached_file_names),
                        send_to_invoice: model.send_to_invoice,
                        send_to_report: model.send_to_report,
                        send_to_logins: model.send_to_logins,
                        send_to_primary: model.send_to_primary,
                        allAttachments: JSON.stringify(model.allAttachments),
                        allRecipients: JSON.stringify(model.allRecipients),
                        allAttachedFiles: JSON.stringify(model.allAttachedFiles),
                        brand_report_id: model.brand_report_id,
                        brand_invoice_id: model.brand_invoice_id,
                        job_type_name: model.job_type_name,
                        job_type_location_name: model.job_type_location_name,
                        brand_report_user_id: model.brand_report_user_id,
                        
                        email_message_subject: this.allRecipients[i].email_message_subject,
                        email_message_recipeints: JSON.stringify(model.email_message_recipeints),
                        message_subject: this.allRecipients[i].message_subject,
                        // recipient_name: model.recipient_name,
                        // recipient_type_name: model.recipient_type_name,
                        // recipient_email_address: JSON.stringify(model.recipient_email_address),
                        recipient_name: this.allRecipients[i].recipient_name,
                        recipient_type_name: this.allRecipients[i].recipient_type_name,
                        recipient_email_address: this.allRecipients[i].recipient_email_address,
                  
                        email_template_HTML: this.allRecipients[i].email_template_HTML,
                        subject_number: this.allRecipients[i].subject_number,
                        created_by: this.sessionUserId,
                        created_date: this.today,
                        attached_file_names: JSON.stringify(model.attached_file_names),
                        attached_job_file_names: JSON.stringify(model.attached_job_file_names),
                        subject_com_type_name: model.subject_com_type_name,
                        // New Nov 2023 Fields. Captured
                        email_template_primary_HTML_rendered: this.allRecipients[i].email_template_primary_HTML_rendered,
                        email_subject_primary_rendered: this.allRecipients[i].email_subject_primary_rendered,
                        note_template_HTML_rendered: this.allRecipients[i].note_template_HTML_rendered,
                        email_template_private_HTML_rendered: this.allRecipients[i].email_template_private_HTML_rendered,
                        email_subject_private_rendered: this.allRecipients[i].email_subject_private_rendered,
                        note_template_private_HTML_rendered: this.allRecipients[i].note_template_private_HTML_rendered,
                        is_privacy_emails: this.allRecipients[i].is_privacy_emails,
                        is_privacy_notes: this.allRecipients[i].is_privacy_notes,
                        is_privacy_no_docs: this.allRecipients[i].is_privacy_no_docs,
                        is_privacy_no_emails: this.allRecipients[i].is_privacy_no_emails,
                        is_privacy_no_notes: this.allRecipients[i].is_privacy_no_notes,
                        created_note_id: this.get_latest_subject_note_id, // from above loop
                        created_file_id: this.returned_created_file_id,
                        email_bcc: this.allRecipients[i].email_bcc,
                        email_cc: this.allRecipients[i].email_cc,

                        job_type_id: model.job_type_id,
                        job_type_location_id: model.job_type_location_id,
                       job_type_court_id: model.job_type_court_id,
                       job_type_document_type_id: model.job_type_document_type_id,
                       job_type_affidavit_type_id: model.job_type_affidavit_type_id,
                       log_content: JSON.stringify(model)
                  
                        // 
                        // email_cc
                        
                    /*
                     */
                    
                      };
                       this.gfunc.createSubjectCommunicationHistory(subject_communication_history); // run the original Function Here if NO NOTES ON. (single NOt looped as contained in loop.)
          } // en dif no notes on
            // end if send note privacy checker

    } // end loop

    
   

  }

  RemoveElementOthersFromAllRecipients(key: number) {
    // test! -- load again an then filter and create the array again.
    // this.getSubjectAgentBrandsAssigned2(this.subject_id); // load first then remove. safest option.
  
    // delay load slightly so I can refresh the allRecpientList first.
    setTimeout(function() {   
  }, 2000);
      console.log("Ready to clean array!")
  
    let array = this.allRecipients;
    // removes all not matching
      // :: Specifcally removes the array item without there being
      // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array
      this.allRecipients.forEach((value, index) => {
      if (value.recipient_brand_id !== key) {
        this.allRecipients.splice(index, 1);
      }
    });
    console.log('allRecipients after Removal Others: ', JSON.stringify(this.allRecipients));
  
  // ::@https://stackoverflow.com/questions/5310304/remove-json-element
  // let json = this.allRecipients
  // let id_key = "recipient_brand_id";
  // delete json[id_key]; // Removes json.foo from the dictionary.
  
  
  
  };




  // BOF SHARMANS CALLS
  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
      (data) => {
        this.job_types = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  getJobSubjectTypes() {
    this._demoService.getJobSubjectTypes().subscribe(
      (data) => {
        this.job_subject_types = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  getJobPlaintiffTypes() {
    this._demoService.getJobPlaintiffTypes().subscribe(
      (data) => {
        this.job_plaintiff_types = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
      (data) => {
        this.job_type_locations = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....

    console.log('sending Count:' + this.count2);
  }

  getJobTypeCourts(job_type_location_id) {
    this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
      (data) => {
        this.job_type_courts = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  sendJobTypeCourtsID(job_type_location_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_location_id = job_type_location_id;
    this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....

    console.log('sending Location:' + this.sent_job_type_location_id);
  }

  getJobTypeDocumentTypes(job_type_court_id) {
    this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
      (data) => {
        this.job_type_document_types = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  sendJobTypeDocumentTypesID(job_type_court_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_court_id = job_type_court_id;
    this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....

    console.log('sending Court Type:' + this.sent_job_type_court_id);
  }

  getJobTypeAffidavitTypes(job_type_document_type_id) {
    this._demoService
      .getJobTypeAffidavitTypes(job_type_document_type_id)
      .subscribe(
        (data) => {
          this.job_type_affidavit_types = data;
        },
        (err) => console.error(err)
        // () => console.log('done loading Trace Types')
      );
  }

  sendJobTypeAffidavitTypesID(job_type_document_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_document_type_id = job_type_document_type_id;
    this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....

    console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
  }

  getSubjectTemplateDocsCheck(model) {
    this.smtp_error = 0; // reset the error warning

    this._demoService.getSubjectTemplateDocsCheck(model).subscribe(
      (data) => {
        {
          this.doc_check = data;
          const res = data[0];
          // set the model document id to the new one affidavits.
          model.doc_id = res.doc_id; // does this need to be this.???
          // set the recipeint type for display
          model.brand_type_id = res.brand_type_id;

          this.email_template_name = res.email_template;
          this.email_template_HTML = res.email_template_HTML;
          model.email_template_HTML = res.email_template_HTML;
          model.send_to_invoice = res.send_to_invoice;
          model.send_to_report = res.send_to_report;
          model.send_to_logins = res.send_to_logins;
          model.send_to_primary = res.send_to_primary;
          model.brand_type_id = res.brand_type_id;
          model.send_to_report_user = res.send_to_report_user;

       // advanced_options 2024
       model.is_theme = res.is_theme;
       model.encrypt_file = res.encrypt_file;
       model.render_images = res.render_images;
       model.render_images_empties = res.render_images_empties;


          // load the recipients into an array
          this.getSubjectAgentBrandsAssigned(this.subject_id);
          // load brands - clients into array
          this.getBrand(this.recipient_report_id);
          this.getBrandUsers(this.recipient_report_id);
          this.getBrandAccount(this.accounts_brand_id);

          model.brand_report_id = this.brand_report_id;
          model.brand_invoice_id = this.brand_invoice_id;
          model.brand_report_user_id = this.brand_report_user_id;

          // had to set here to sho
          model.subject_id = this.subject_id;

          model.change_dates = '1'; // set to default to system dates changes
          this.created_file_name = null; // reset the file to be recreated on change
            

          // :: Set the Message Subject Default Title
          // tslint:disable-next-line:max-line-length

          // TODO: Make so that only client communications have this . - subject_com_type_id?

          // this.message_subject = 'Subject: ' +  res.email_subject_header + ' ' + this.subjectFullNameOrBusiness + ' Our Reference: '  + this.subject_number;
          this.message_subject = 'Subject: ' +  res.email_subject_header + ' Our Reference: '  + this.subject_number;
         
          if(model.subject_com_type_id == 3){
            // this.message_subject = 'Reference: ' + this.client_reference + ', ' + 'Subject: ' +  res.email_subject_header + ' ' + this.subjectFullNameOrBusiness + ' Our Reference: '  + this.subject_number;
            this.message_subject = 'Reference: ' + this.client_reference + ', ' +  res.email_subject_header + ' Our Reference: '  + this.subject_number;
          }


         
          model.message_subject = this.message_subject;

          this.url =
          this.gfunc.baseUploadURLEmailTemplatesSSL +
            this.email_template_name;
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.url
          );


      // upgrade for attempts paragraphs checker == if 1 then accept. otherwise warn
      // 2.3.1.1
      model.attempt_paragraph_template = res.attempt_paragraph_template;

      model.email_template_primary_HTML = res.email_template_primary_HTML; // load the template
      model.email_template_primary_HTML_rendered = '';
      model.email_subject_primary_rendered = '';
      model.email_subject_primary = res.email_subject_primary;
      model.note_template_HTML = res.note_template_HTML;
      model.note_template_HTML_rendered = '';
          // private templates
      model.email_template_private_HTML = res.email_template_private_HTML; // load the template
      model.email_template_private_HTML_rendered = '';
      model.email_subject_private_rendered = '';
      model.email_subject_private = res.email_subject_private;
      model.note_template_private_HTML = res.note_template_private_HTML;
      model.note_template_private_HTML_rendered = '';



          // Setup Recipients :: New 2022 Model allRecipients
          const set_model = model
          // this.getJob_and_brands_Q(set_model.job_id, set_model); // loads the current job varables for the model.
          this.setAllRecipients(model);

        }
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  // to router navigate back
  public goBack() {
    this._location.back();
  }

  docView(doc_id) {
    this.router.navigate([
      '/admin/communication/com_type_template_doc_view/' + doc_id + '',
    ]);
  }

  docEdit(doc_id) {
    this.router.navigate([
      '/admin/communication/com_type_template_doc_edit/' + doc_id + '',
    ]);
  }


  docEditSubjectFile(file_id) {
    this.router.navigate(['/admin/jobs/subject/communication/docx-view/' + file_id + '']);
  }

  docViewSubjectFile(file_id) {
    this.router.navigate(['/admin/jobs/subject/communication/docx-view/' + file_id + '']);
  }

  viewSystemFile(file_id) {
    this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
  }

  editSystemFile(file_id) {
    this.router.navigate(['/admin/system-file-manager/system-file-edit/' + file_id + '']);
  }

  editDocFile(file_id) {
    this.router.navigate(['/admin/system-file-manager/system-doc-edit/' + file_id + '']);
  }


  editDocxSystemFile(file_id) {
    this.gfunc.globalEditDocxSystemFile(file_id);
    // this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']);
  }

  

  viewDocxSystemFile(file_id) {
    this.gfunc.globalViewDocxSystemFile(file_id);
    // this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-view/' + file_id + '']);
  }



  // testing some jquery
  Testing() {
    const name = (
      document.getElementById('subject_com_type_id') as HTMLTextAreaElement
    ).value;
    alert(name);

    // get the option name of the select Works so can use when adding as a fix.
    const conceptName = $('#subject_com_type_id').find(':selected').text();
    const conceptNameID = $('#subject_com_type_id').find(':selected').val();
    alert(conceptNameID + ':-  ' + conceptName);
  }

  // lookup and then set the doc_check array with the data.
  getSubjectTemplateDoc(model) {
    this._demoService.getSubjectTemplateDoc(model.doc_id).subscribe(
      (data) => {
        this.doc_check = data;
        const res = data[0];
        // load the drop downs res.doc_ii
        // set the model document id to the new one affidavits.
        model.doc_id = res.doc_id;
        // set the recipeint type for display
        model.brand_type_id = res.brand_type_id;
        this.email_template_name = res.email_template;
        this.email_template_HTML = res.email_template_HTML;
        model.email_template_HTML = res.email_template_HTML;
        model.send_to_invoice = res.send_to_invoice;
        model.send_to_report = res.send_to_report;
        model.send_to_logins = res.send_to_logins;
        model.send_to_primary = res.send_to_primary;
        model.brand_type_id = res.brand_type_id;
        model.send_to_report_user = res.send_to_report_user;

        model.brand_report_id = this.brand_report_id;
        model.brand_invoice_id = this.brand_invoice_id;
        model.brand_report_user_id = this.brand_report_user_id;
        model.subject_id = this.subject_id;

        // load the recipents into an array
        this.getSubjectAgentBrandsAssigned(this.subject_id);
        // load brands - clients into array
        this.getBrand(this.recipient_report_id);
        this.getBrandUsers(this.recipient_report_id);
        this.getBrandAccount(this.accounts_brand_id);


          // advanced_options 2024
          model.is_theme = res.is_theme;
          model.encrypt_file = res.encrypt_file;
          model.render_images = res.render_images;
          model.render_images_empties = res.render_images_empties;

        model.change_dates = '1'; // set to default to system dates changes -- Auust Users must now use dates!
        this.created_file_name = null; // reset the file to be recreated on change
        // iframe

 

         // tslint:disable-next-line:max-line-length

          // this.message_subject = 'Subject: ' +  res.email_subject_header + ' ' + this.subjectFullNameOrBusiness + ' Our Reference: '  + this.subject_number;
          this.message_subject = 'Subject: ' +  res.email_subject_header + ' Our Reference: '  + this.subject_number;
         
          if(model.subject_com_type_id == 3){
            // this.message_subject = 'Reference: ' + this.client_reference + ', ' + 'Subject: ' +  res.email_subject_header + ' ' + this.subjectFullNameOrBusiness + ' Our Reference: '  + this.subject_number;
            this.message_subject = 'Reference: ' + this.client_reference + ', ' +  res.email_subject_header + ' Our Reference: '  + this.subject_number;
          }


         

         model.message_subject = this.message_subject;

        this.url =
        this.gfunc.baseUploadURLEmailTemplatesSSL +
          this.email_template_name;
        this.url_non_ssl =
        this.gfunc.baseUploadURLEmailTemplates +
          this.email_template_name;
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);

              // upgrade for attempts paragraphs checker == if 1 then accept. otherwise warn
      // 2.3.1.1
      model.attempt_paragraph_template = res.attempt_paragraph_template;

      model.email_template_primary_HTML = res.email_template_primary_HTML; // load the template
      model.email_template_primary_HTML_rendered = '';
      model.email_subject_primary_rendered = '';
      model.email_subject_primary = res.email_subject_primary;
      model.note_template_HTML = res.note_template_HTML;
      model.note_template_HTML_rendered = '';
          // private templates
      model.email_template_private_HTML = res.email_template_private_HTML; // load the template
      model.email_template_private_HTML_rendered = '';
      model.email_subject_private_rendered = '';
      model.email_subject_private = res.email_subject_private;
      model.note_template_private_HTML = res.note_template_private_HTML;
      model.note_template_private_HTML_rendered = '';


             // Setup Recipients :: New 2022 Model allRecipients
             this.setAllRecipients(model);

        //   This DID NOT WORK!  CORS ACCESS ISSUES (will only work online? no cors)
        // HAD TO SETUP SERVER TO ALLOW ACCESS PLESK
        // see:  https://support.plesk.com/hc/en-us/articles/115001338265-How-to-set-up-CORS-cross-origin-resource-sharing-in-Plesk-for-Linux-

        //   if(this.email_template_name != null) {
        //   // get email temlate file as a variable TESTING
        //   fetch(this.url)
        //   .then(response => response.text())
        //   .then(html_data => {
        //   	// Do something with your data
        //     this.html_data = html_data;
        //   	console.log(html_data);
        //   });
        //   // end fetch
        // } // end if no template set
      },
      (err) => console.error(err),
      () => console.log('')
    );
  }



  // :: Method to all default recipients
  setAllRecipients(model) {
      this.prepareTemplateRenderLookups(model);
      this.allRecipients = [];
      this.selected_tab = 0;

    if (model.send_to_report == 1) {
      // 



      // THIS IS wrong as it sets the replacement varaiables without the all_repciepeints ----- As variables>???
      // NEED TO FIX this




            // :: Impliments automatic recipients based on chosen com template options
            // :: Subract Method / Filter
            // :: DEMOSERVICE look up client brand details.
            this._demoService.getBrandById(model.brand_report_id).subscribe(
              (data) => {


               let newArr = data;
               let  count_of_items = Object.keys(newArr).length;
                 // need to do a loop of subject_billing items (.length)
                 for(let i=0;i < count_of_items; i++) {
                 let res = newArr[i];

                  // if a company
            let is_privacy_emails = res.is_privacy_emails
            let is_privacy_notes = res.is_privacy_notes
            let is_privacy_no_docs = res.is_privacy_no_docs
            let is_privacy_no_emails = res.is_privacy_no_emails
            let is_privacy_no_notes = res.is_privacy_no_notes
            /*
 `is_privacy_emails` varchar(11) DEFAULT NULL,
  `is_privacy_notes` varchar(11) DEFAULT NULL,
  `is_privacy_no_docs` varchar(11) DEFAULT NULL,
  `is_privacy_no_emails` varchar(11) DEFAULT NULL,
  `is_privacy_no_notes
            */


            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
            let email_template_primary_HTML = model.email_template_primary_HTML;
            let email_subject_primary = model.email_subject_primary;
            let note_template_HTML = model.note_template_HTML

            let email_template_private_HTML = model.email_template_private_HTML;
            let email_subject_private = model.email_subject_private;
            let note_template_private_HTML = model.note_template_private_HTML
                  // set the recipent variables in the model first so I have them
            // model.recipient_name = res.name + ' - Client Report'
            model.recipient_name = res.name
            model.recipient_email_address = res.email
            model.recipient_brand_id = res.brand_id
            model.recipient_brand_type_id = res.brand_type_id
            model.recipient_user_id  = null
            model.recipient_user_level_id = null
            model.recipient_type_name ='Client Report'
          
          
            let rendered_email;
            let rendered_subject;
            let rendered_note;
            let rendered_email_private;
            let rendered_subject_private;
            let rendered_note_private;

            if(is_privacy_emails == 1){
             rendered_email = this.runReplaceAllVariables(email_template_private_HTML, model)
             rendered_subject = this.runReplaceAllVariables(email_subject_private, model)
           }else{
           rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
           rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
           }

           if(is_privacy_notes == 1){
             rendered_note = this.runReplaceAllVariables(note_template_private_HTML, model)
           }else{
           rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
           }
       
          
          
            // let rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
            // let rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
            // let rendered_note = this.runReplaceAllVariables(note_template_HTML, model)

            // let rendered_email_private = this.runReplaceAllVariables(email_template_private_HTML, model)
            // let rendered_subject_private = this.runReplaceAllVariables(email_subject_private, model)
            // let rendered_note_private = this.runReplaceAllVariables(note_template_private_HTML, model)

                 this.allRecipients.push({
                   recipient_name: res.name + ' - Client Report',
                   recipient_email_address: res.email,
                   recipient_brand_id: res.brand_id,
                   recipient_brand_type_id: res.brand_type_id,
                   recipient_user_id: null,
                   recipient_user_level_id: null,
                   recipient_type_name: 'Client Report',
                   ...model,
                   email_subject_primary_rendered: rendered_subject,
                   email_template_primary_HTML_rendered: rendered_email,
                   note_template_HTML_rendered: rendered_note,

                  //  email_subject_private_rendered: rendered_subject_private,
                  //  email_template_private_HTML_rendered: rendered_email_private,
                  //  note_template_private_HTML_rendered: rendered_note_private,

                   is_privacy_emails: is_privacy_emails,
                   is_privacy_notes: is_privacy_notes,
                   is_privacy_no_docs: is_privacy_no_docs,
                   is_privacy_no_emails: is_privacy_no_emails,
                   is_privacy_no_notes: is_privacy_no_notes,

                 });
                 } // end for loop
               this.allRecipients = this.allRecipients; // ?? this may be causing errors.

    

              },
              (err) => console.error(err),
              () => console.log('Client Report Recipient Added.')
            );

        } // end if send_to_report
          
        // AGENT
        if ( model.brand_type_id == 3) { 
          this._demoService.getSubjectAgentBrandsAssigned(model.subject_id).subscribe(
            (data) => {
              // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
             let newArr = data;
             let  count_of_items = Object.keys(newArr).length;
               // need to do a loop of subject_billing items (.length)
               for(let i=0;i < count_of_items; i++) {
               let res = newArr[i];

               let email_template_primary_HTML = model.email_template_primary_HTML;
               let email_subject_primary = model.email_subject_primary;
            let note_template_HTML = model.note_template_HTML

            

                     // set the recipent variables in the model first so I have them
              //  model.recipient_name = res.name + ' - Agent'
               model.recipient_name = res.name
               model.recipient_email_address = res.email
               model.recipient_brand_id = res.brand_id
               model.recipient_brand_type_id = res.brand_type_id
               model.recipient_user_id  = null
               model.recipient_user_level_id = null
               model.recipient_type_name = 'Agent'

               let is_privacy_emails = res.is_privacy_emails
               let is_privacy_notes = res.is_privacy_notes
               let is_privacy_no_docs = res.is_privacy_no_docs
               let is_privacy_no_emails = res.is_privacy_no_emails
               let is_privacy_no_notes = res.is_privacy_no_notes

               let email_template_private_HTML = model.email_template_private_HTML;
               let email_subject_private = model.email_subject_private;
               let note_template_private_HTML = model.note_template_private_HTML

               let rendered_email;
               let rendered_subject;
               let rendered_note;
               let rendered_email_private;
               let rendered_subject_private;
               let rendered_note_private;
   
               if(is_privacy_emails == 1){
                rendered_email = this.runReplaceAllVariables(email_template_private_HTML, model)
                rendered_subject = this.runReplaceAllVariables(email_subject_private, model)
              }else{
              rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
              rendered_subject = this.runReplaceAllVariables(email_subject_primary, model) // WHY IS THIS CREATING ERRORS??? -- THERE MUST BE A SUBJECT!!!!
              }
   
              if(is_privacy_notes == 1){
                rendered_note = this.runReplaceAllVariables(note_template_private_HTML, model)
              }else{
              rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
              }
          



            //    let rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
            //    let rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
            // let rendered_note = this.runReplaceAllVariables(note_template_HTML, model)

               this.allRecipients.push({
                 recipient_name: res.name + ' - Agent',
                 recipient_email_address: res.email,
                 recipient_brand_id: res.brand_id,
                 recipient_brand_type_id: res.brand_type_id,
                 recipient_user_id: null,
                 recipient_user_level_id: null,
                 recipient_type_name: 'Agent',
                 ...model,
                 email_subject_primary_rendered: rendered_subject,
                 email_template_primary_HTML_rendered: rendered_email,
                 note_template_HTML_rendered: rendered_note,

                 is_privacy_emails: is_privacy_emails,
                 is_privacy_notes: is_privacy_notes,
                 is_privacy_no_docs: is_privacy_no_docs,
                 is_privacy_no_emails: is_privacy_no_emails,
                 is_privacy_no_notes: is_privacy_no_notes,

               });
               } // end for loop
             this.allRecipients = this.allRecipients; // ?? this may be causing errors.

            },
            (err) => console.error(err),
            () => console.log('Agent Recipients Added.')
          );
          // const key = 'Agent';
          // this.allRecipients.forEach((value, index) => {
          //   if (value.recipient_type_name === key) {
          //     this.allRecipients.splice(index, 1);
          //     console.log('Removed Agent Recipients');
          //   }
          // });
        };

        if (model.send_to_report_user == 1) {

          this._demoService.getUsersById(model.brand_report_user_id).subscribe(
            (data) => {
              // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
             let newArr = data;
             let  count_of_items = Object.keys(newArr).length;
               // need to do a loop of subject_billing items (.length)
               for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];

            //  console.log('Respones: ' + JSON.stringify(res))

            let email_template_primary_HTML = model.email_template_primary_HTML
            let email_subject_primary = model.email_subject_primary;
            let note_template_HTML = model.note_template_HTML


            let email_template_private_HTML = model.email_template_private_HTML;
            let email_subject_private = model.email_subject_private;
            let note_template_private_HTML = model.note_template_private_HTML
            
            // these are different for the user as I have to lookup brand first
            let user_brand_id = res.brand_id;
            //get brand ---
            // this.getUserBrand_Q(user_brand_id); -- Instead Loop these up in the API data and send back with the user details - is_privacy_email (that way its set at a brand level for all users and I have access to these variables without another lookup here.)
                      // added to user API not actual user data.
            let is_privacy_emails = res.is_privacy_emails
            let is_privacy_notes = res.is_privacy_notes
            let is_privacy_no_docs = res.is_privacy_no_docs
            let is_privacy_no_emails = res.is_privacy_no_emails
            let is_privacy_no_notes = res.is_privacy_no_notes
            
            // model.recipient_name = res.first_name +  ' ' + res.surname + ' - Client Report User',
            model.recipient_name = res.first_name +  ' ' + res.surname,
            model.recipient_email_address = res.email_address,
            model.recipient_brand_id = null
            model.recipient_brand_type_id = null
            model.recipient_user_id  = res.user_id,
            model.recipient_user_level_id = null
            model.recipient_type_name = 'Client Report User'
          
            let rendered_email;
            let rendered_subject;
            let rendered_note;
            let rendered_email_private;
            let rendered_subject_private;
            let rendered_note_private;

            if(is_privacy_emails == 1){
              rendered_email = this.runReplaceAllVariables(email_template_private_HTML, model)
              rendered_subject = this.runReplaceAllVariables(email_subject_private, model)
            }else{
            rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
            rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
            }

            if(is_privacy_notes == 1){
              rendered_note = this.runReplaceAllVariables(note_template_private_HTML, model)
            }else{
            rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
            }

            // rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
            // rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
            // rendered_note = this.runReplaceAllVariables(note_template_HTML, model)


            // TOO MANY CONNECTIONS --- Breaks scripts with many errors so need to limit the replacements.
            // let rendered_email_private = this.runReplaceAllVariables(email_template_private_HTML, model)
            // let rendered_subject_private = this.runReplaceAllVariables(email_subject_private, model)
            // let rendered_note_private = this.runReplaceAllVariables(note_template_private_HTML, model)
            
               this.allRecipients.push({
              recipient_name: res.first_name +  ' ' + res.surname + ' - Client Report User',
              recipient_email_address: res.email_address,
              recipient_brand_id: null,
              recipient_brand_type_id: null,
              recipient_user_id: res.user_id,
              recipient_user_level_id: res.access_level,
              recipient_type_name: 'Client Report User',
              ...model,
              email_subject_primary_rendered: rendered_subject,
              email_template_primary_HTML_rendered: rendered_email,
              note_template_HTML_rendered: rendered_note,

              // email_subject_private_rendered: rendered_subject_private,
              // email_template_private_HTML_rendered: rendered_email_private,
              // note_template_private_HTML_rendered: rendered_note_private,

              is_privacy_emails: is_privacy_emails,
              is_privacy_notes: is_privacy_notes,
              is_privacy_no_docs: is_privacy_no_docs,
              is_privacy_no_emails: is_privacy_no_emails,
              is_privacy_no_notes: is_privacy_no_notes,

               });
               } // end for loop
             this.allRecipients = this.allRecipients; // ?? this may be causing errors.

            },
            (err) => console.error(err),
            () => console.log('Client Report User Recipient Added.')
          );
          // const key = 'Client Report User';
          // this.allRecipients.forEach((value, index) => {
          //   if (value.recipient_type_name === key) {
          //     this.allRecipients.splice(index, 1);
          //     console.log('Removed Report User Recipient');
          //   }
          // });
        };

        if (model.send_to_invoice == 1) {
            this._demoService.getBrandById(model.brand_invoice_id).subscribe(
              (data) => {
                // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
               let newArr = data;
               let  count_of_items = Object.keys(newArr).length;
                 // need to do a loop of subject_billing items (.length)
                 for(let i=0;i < count_of_items; i++) {
                 let res = newArr[i];

                 let email_template_primary_HTML = model.email_template_primary_HTML;
                 let email_subject_primary = model.email_subject_primary;
            let note_template_HTML = model.note_template_HTML


            let email_template_private_HTML = model.email_template_private_HTML;
            let email_subject_private = model.email_subject_private;
            let note_template_private_HTML = model.note_template_private_HTML

            let is_privacy_emails = res.is_privacy_emails
            let is_privacy_notes = res.is_privacy_notes
            let is_privacy_no_docs = res.is_privacy_no_docs
            let is_privacy_no_emails = res.is_privacy_no_emails
            let is_privacy_no_notes = res.is_privacy_no_notes

                       // set the recipent variables in the model first so I have them
                //  model.recipient_name = res.name + ' - Client Accounts'
                 model.recipient_name = res.name
                 model.recipient_email_address = res.accounts_email_address // WROMG EMAIL ADDRESSS NOW CORRECTED
                 model.recipient_brand_id = res.brand_id
                 model.recipient_brand_type_id = res.brand_type_id
                 model.recipient_user_id  = null
                 model.recipient_user_level_id = null
                 model.recipient_type_name = 'Client Accounts'


                 let rendered_email;
                 let rendered_subject;
                 let rendered_note;
                 let rendered_email_private;
                 let rendered_subject_private;
                 let rendered_note_private;

                 if(is_privacy_emails == 1){
                  rendered_email = this.runReplaceAllVariables(email_template_private_HTML, model)
                  rendered_subject = this.runReplaceAllVariables(email_subject_private, model)
                }else{
                rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
                rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
                }
    
                if(is_privacy_notes == 1){
                  rendered_note = this.runReplaceAllVariables(note_template_private_HTML, model)
                }else{
                rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
                }
            
                 
            // let rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
            // let rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
            // let rendered_note = this.runReplaceAllVariables(note_template_HTML, model)

            // To many quieries... instead change the above on an if staement and replace the rendered content instead!!!!!!!!!!
            // let rendered_email_private = this.runReplaceAllVariables(email_template_private_HTML, model)
            // let rendered_subject_private = this.runReplaceAllVariables(email_subject_private, model)
            // let rendered_note_private = this.runReplaceAllVariables(note_template_private_HTML, model)

// Updated for wrong accounts email address being inserted....

                 this.allRecipients.push({
                   recipient_name: res.name + ' - Client Accounts',
                   recipient_email_address: res.accounts_email_address,
                   recipient_brand_id: res.brand_id,
                   recipient_brand_type_id: res.brand_type_id,
                   recipient_user_id: null,
                   recipient_user_level_id: null,
                   recipient_type_name: 'Client Accounts',
                   ...model,
                   email_subject_primary_rendered: rendered_subject,
                   email_template_primary_HTML_rendered: rendered_email,
                   note_template_HTML_rendered: rendered_note,

                  //  email_subject_private_rendered: rendered_subject_private,
                  //  email_template_private_HTML_rendered: rendered_email_private,
                  //  note_template_private_HTML_rendered: rendered_note_private,
                   
                   is_privacy_emails: is_privacy_emails,
                   is_privacy_notes: is_privacy_notes,
                   is_privacy_no_docs: is_privacy_no_docs,
                   is_privacy_no_emails: is_privacy_no_emails,
                   is_privacy_no_notes: is_privacy_no_notes,

                 });
                 } // end for loop
               this.allRecipients = this.allRecipients; // ?? this may be causing errors.

              },
              (err) => console.error(err),
              () => console.log('Client Accounts Recipient Added.')
            );
        }

        if (model.send_to_logins == 1) {
          this._demoService.getBrandUsers(model.brand_report_id).subscribe(
            (data) => {
              // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
             let newArr = data;
             let  count_of_items = Object.keys(newArr).length;
               // need to do a loop of subject_billing items (.length)
               for(let i=0;i < count_of_items; i++) {
               let res = newArr[i];

               let email_template_primary_HTML = model.email_template_primary_HTML;
               let email_subject_primary = model.email_subject_primary;
            let note_template_HTML = model.note_template_HTML

                     // set the recipent variables in the model first so I have them
              //  model.recipient_name = res.first_name +  ' ' + res.surname + ' - Client User'
               model.recipient_name = res.first_name +  ' ' + res.surname
               model.recipient_email_address = res.email_address
               model.recipient_brand_id = null
               model.recipient_brand_type_id = null
               model.recipient_user_id  = res.user_id
               model.recipient_user_level_id = res.access_level
               model.recipient_type_name = 'Client User'


               let is_privacy_emails = res.is_privacy_emails
               let is_privacy_notes = res.is_privacy_notes
               let is_privacy_no_docs = res.is_privacy_no_docs
               let is_privacy_no_emails = res.is_privacy_no_emails
               let is_privacy_no_notes = res.is_privacy_no_notes

               let email_template_private_HTML = model.email_template_private_HTML;
               let email_subject_private = model.email_subject_private;
               let note_template_private_HTML = model.note_template_private_HTML

               let rendered_email;
               let rendered_subject;
               let rendered_note;
               let rendered_email_private;
               let rendered_subject_private;
               let rendered_note_private;
   
               if(is_privacy_emails == 1){
                rendered_email = this.runReplaceAllVariables(email_template_private_HTML, model)
                rendered_subject = this.runReplaceAllVariables(email_subject_private, model)
              }else{
              rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
              rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
              }
   
              if(is_privacy_notes == 1){
                rendered_note = this.runReplaceAllVariables(note_template_private_HTML, model)
              }else{
              rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
              }
          
            //    let rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
            //    let rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
            // let rendered_note = this.runReplaceAllVariables(note_template_HTML, model)


               this.allRecipients.push({
              recipient_name: res.first_name +  ' ' + res.surname + ' - Client User',
              recipient_email_address: res.email_address,
              recipient_brand_id: null,
              recipient_brand_type_id: null,
              recipient_user_id: res.user_id,
              recipient_user_level_id: res.access_level,
              recipient_type_name: 'Client User',
              ...model,
              email_subject_primary_rendered: rendered_subject,
              email_template_primary_HTML_rendered: rendered_email,
              note_template_HTML_rendered: rendered_note,

              is_privacy_emails: is_privacy_emails,
              is_privacy_notes: is_privacy_notes,
              is_privacy_no_docs: is_privacy_no_docs,
              is_privacy_no_emails: is_privacy_no_emails,
              is_privacy_no_notes: is_privacy_no_notes,

               });
               } // end for loop
             this.allRecipients = this.allRecipients; // ?? this may be causing errors.

            },
            (err) => console.error(err),
            () => console.log('Client User Recipient Added.')
          );
          // const key = 'Client User';
          // this.allRecipients.forEach((value, index) => {
          //   if (value.recipient_type_name === key) {
          //     this.allRecipients.splice(index, 1);
          //     console.log('Removed Client User Recipients');
          //   }
          // });
        }

        if (model.send_to_primary == 1) {
          this._demoService.getBrandPrimaryContact(model.brand_report_id).subscribe(
            (data) => {
              // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
             let newArr = data;
             let  count_of_items = Object.keys(newArr).length;
               // need to do a loop of subject_billing items (.length)
               for(let i=0;i < count_of_items; i++) {
               let res = newArr[i];

               let email_template_primary_HTML = model.email_template_primary_HTML;
               let email_subject_primary = model.email_subject_primary;
            let note_template_HTML = model.note_template_HTML

                     // set the recipent variables in the model first so I have them
              //  model.recipient_name = res.first_name +  ' ' + res.surname + ' - Client Primary Contact'
               model.recipient_name = res.first_name +  ' ' + res.surname
               model.recipient_email_address = res.email_address
               model.recipient_brand_id = null
               model.recipient_brand_type_id = null
               model.recipient_user_id  = res.user_id
               model.recipient_user_level_id = res.access_level
               model.recipient_type_name = 'Client Primary Contact'

               let is_privacy_emails = res.is_privacy_emails
               let is_privacy_notes = res.is_privacy_notes
               let is_privacy_no_docs = res.is_privacy_no_docs
               let is_privacy_no_emails = res.is_privacy_no_emails
               let is_privacy_no_notes = res.is_privacy_no_notes

               let email_template_private_HTML = model.email_template_private_HTML;
               let email_subject_private = model.email_subject_private;
               let note_template_private_HTML = model.note_template_private_HTML

               let rendered_email;
               let rendered_subject;
               let rendered_note;
               let rendered_email_private;
               let rendered_subject_private;
               let rendered_note_private;
   
               if(is_privacy_emails == 1){
                rendered_email = this.runReplaceAllVariables(email_template_private_HTML, model)
                rendered_subject = this.runReplaceAllVariables(email_subject_private, model)
              }else{
              rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
              rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
              }
   
              if(is_privacy_notes == 1){
                rendered_note = this.runReplaceAllVariables(note_template_private_HTML, model)
              }else{
              rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
              }
          

            //    let rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
            //    let rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
            // let rendered_note = this.runReplaceAllVariables(note_template_HTML, model)


               this.allRecipients.push({
              recipient_name: res.first_name +  ' ' + res.surname + ' - Client Primary Contact',
              recipient_email_address: res.email_address,
              recipient_brand_id: null,
              recipient_brand_type_id: null,
              recipient_user_id: res.user_id,
              recipient_user_level_id: res.access_level,
              recipient_type_name: 'Client Primary Contact',
              ...model,
              email_subject_primary_rendered: rendered_subject,
              email_template_primary_HTML_rendered: rendered_email,
              note_template_HTML_rendered: rendered_note,

              is_privacy_emails: is_privacy_emails,
              is_privacy_notes: is_privacy_notes,
              is_privacy_no_docs: is_privacy_no_docs,
              is_privacy_no_emails: is_privacy_no_emails,
              is_privacy_no_notes: is_privacy_no_notes,

               });
               } // end for loop
             this.allRecipients = this.allRecipients; // ?? this may be causing errors.

            },
            (err) => console.error(err),
            () => console.log('Client Primary Contact Added.')
          );
         
         
          // const key = 'Primary Contact';
          // this.allRecipients.forEach((value, index) => {
          //   if (value.recipient_type_name === key) {
          //     this.allRecipients.splice(index, 1);
          //     console.log('Removed Primary Contact Recipient');
          //   }
          // });
        }

  } // end function



  render_basic(str, model){
    // console.log('Passed Model: ' + JSON.stringify(model))


    // this.getJob_and_brands_Q(model.job_id, model); // loads the current job varables for the model.
    // console.log('this.job_data_paragraphs: ' + JSON.stringify(this.job_data_paragraphs))

        // this.getJobType_Q(model.job_type_id)

          // this.getJobTypeLocation_Q(model.job_type_location_id); // 
          // this.getJobTypeCourt_Q(model.job_type_court_id);       // 

          // this.getJobTypeDocumentType_Q(model.job_type_document_type_id)
          // this.getJobTypeAffidavitType_Q(model.job_type_affidavit_type_id);
          
          // this.getBrand_invoice_Q(model.brand_invoice_id) 
          // this.getBrand_owner_Q('94'); // sharmans id in the database as the app owner SO.
          // this.getJobReportUserContact_Q(model.brand_report_user_id)

          // this.getCurrentUser_Q(this.gfunc.sessionUserId);
          
          //   // Get Subject Agent - F_agent
          //   this.getSubjectAgentBrandsAssigned_Q(this.subject_id) // get the first agent ID.????
          //   this.getJobServiceRule_Q(model.job_service_rule_id) //? -- from the send comms model
          //   this.getJobServiceTimeframe_Q(model.job_service_timeframe_id)
          //   this.getSubjectServiceType_model_Q(model.subject_service_type_id);

          //   this.getSubjectContactNumbers_Q(model.subject_id)
          //   this.getSubjectContactEmails_Q(model.subject_id)



      let content = this.runReplaceAllVariables(str, model);  
      return content;

  }


  // Job and Subject Focus
  runReplaceAllVariables(str, model){
  
    // console.log('Brand invoice ID: ' + this.brand_invoice_id);

    // Moved to getJob() -- this worked
          // this.getBrand_invoice_Q(model.brand_invoice_id) 
          // this.getBrand_owner_Q('94'); // sharmans id in the database as the app owner SO.
          // this.getJobReportUserContact_Q(model.brand_report_user_id)
          //  this.getCurrentUser_Q(this.gfunc.sessionUserId);
    
  


      // moved to get()Subject --
          // Get Subject Agent - F_agent
          // this.getSubjectAgentBrandsAssigned_Q(this.subject_id) // get the first agent ID.????
      // this.getJobServiceRule_Q(model.job_service_rule_id) //? -- from the send comms model
      // this.getJobServiceTimeframe_Q(model.job_service_timeframe_id)
      // this.getSubjectServiceType_model_Q(model.subject_service_type_id);

      // this.getSubjectContactNumbers_Q(model.subject_id)
      // this.getSubjectContactEmails_Q(model.subject_id)

    // console.log('this.job_data_paragraphs: ' + JSON.stringify(this.job_data_paragraphs))


      if(model.job_id != ''){ 

        // Uppercese
        if ( this.job_data_paragraphs  && this.job_data_paragraphs != ''  ){
          this.registry_name = this.job_data_paragraphs[0].registry_name;
        let var_job_registry_name = this.job_data_paragraphs[0].registry_name;
        if(var_job_registry_name != null){
        this.job_registry_name_Upper = var_job_registry_name.toUpperCase();
        }
       }
        // Uppercese
        if ( this.job_type_paragraphs && this.job_type_paragraphs != '' ){
          this.job_type_name = this.job_type_paragraphs[0].job_type_name;
        let var_job_type_name = this.job_type_paragraphs[0].job_type_name;
        if(var_job_type_name != null){
        this.job_type_name_Upper = var_job_type_name.toUpperCase();
        }
         }
        // Uppercese
        // console.log('job_type_location_paragraphs: ' + this.job_type_location_paragraphs);
        if ( this.job_type_location_paragraphs && this.job_type_location_paragraphs != '' ){
          this.job_type_location_name = this.job_type_location_paragraphs[0].job_type_location_name;
        let var_job_type_location_name = this.job_type_location_paragraphs[0].job_type_location_name;
        if(var_job_type_location_name != null){
        this.job_type_location_name_Upper = var_job_type_location_name.toUpperCase();
        }
      }
        // Uppercese
        if ( this.job_type_court_paragraphs && this.job_type_court_paragraphs != '' ){
          this.job_type_court_name = this.job_type_court_paragraphs[0].job_type_court_name;
        let var_job_type_court_name = this.job_type_court_paragraphs[0].job_type_court_name;
        if(var_job_type_court_name != null){
        this.job_type_court_name_Upper = var_job_type_court_name.toUpperCase();
        }
      }
        // Uppercese
        if ( this.job_type_document_type_paragraphs && this.job_type_document_type_paragraphs != '' ){
          this.job_type_document_type_name = this.job_type_document_type_paragraphs[0].job_type_document_type_name
          // console.log(this.job_type_document_type_paragraphs)
        let var_job_type_document_type_name = this.job_type_document_type_paragraphs[0].job_type_document_type_name;
        if(var_job_type_document_type_name != null){
        this.job_type_document_type_name_Upper = var_job_type_document_type_name.toUpperCase();
        }
        }

        //model.job_subject_type_name.toUpperCase() 
                       
   }     
       


    
   // just if emtpies.
   if ( this.job_service_rule_paragraphs && this.job_service_rule_paragraphs != '' ){
   this.job_service_rule_name = this.job_service_rule_paragraphs[0].job_service_rule_name 
   this.job_service_rule_description = this.job_service_rule_paragraphs[0].job_service_rule_description 
   }

   if ( this.job_service_timeframe_paragraphs && this.job_service_timeframe_paragraphs != '' ){
   this.job_service_timeframe_name = this.job_service_timeframe_paragraphs[0].job_service_timeframe_name
   this.job_service_timeframe_text = this.job_service_timeframe_paragraphs[0].job_service_timeframe_text
   }

   if ( this.subject_service_type_model_paragraphs && this.subject_service_type_model_paragraphs != '' ){
   this.subject_service_type_name = this.subject_service_type_model_paragraphs[0].subject_service_type_name 
   this.subject_service_type_description =  this.subject_service_type_model_paragraphs[0].subject_service_type_description
   this.subject_service_type_staff_instructions = this.subject_service_type_model_paragraphs[0].subject_service_type_staff_instructions
   this.subject_service_type_agent_instructions = this.subject_service_type_model_paragraphs[0].subject_service_type_agent_instructions
   this.subject_service_type_instructions = this.subject_service_type_model_paragraphs[0].subject_service_type_instructions 
   }

  // Must check for nulls first and set as a variable.
  if(model.job_type_affidavit_type_paragraphs && model.job_type_affidavit_type_paragraphs != '' ){
    this.job_type_affidavit_type_name = this.job_type_affidavit_type_paragraphs[0].job_type_affidavit_type_name
    this.job_type_affidavit_type_name_Upper = this.job_type_affidavit_type_name.toUpperCase();
  }
  if(model.job_subject_type_name && model.job_subject_type_name  != '' ){
    this.job_subject_type_name = model.job_subject_type_name;
    this.job_subject_type_name_Upper = this.job_subject_type_name.toUpperCase();
  }
  
  
  // Subject Conversions from model
        // // Uppercese
        if(this.job_type_document_type_paragraphs && this.job_type_document_type_paragraphs != '' ){
        let var_job_type_document_type_name = this.job_type_document_type_paragraphs[0].job_type_document_type_name;
        if(var_job_type_document_type_name != null){
        this.job_type_document_type_name_Upper = var_job_type_document_type_name.toUpperCase();
        }
      }
  
  
  
  
       // Attempt Agent Details
        // if(model.who_service != ''){
        //   this.getBrand_Q(model.who_service);
        //  }
     
  // Set some variables
    // Do checks for subject name / Businesss Name of FUll SUbject Name fields
    let var_subject_name =  model.first_name + ' ' +  model.middlename + ' '+  model.surname;
    let var_subject_name_4_doc = model.first_name +'-'+  model.surname;
    let var_subject_business_name =  model.business_name;
    
    // Subject Name of Business
        if(var_subject_business_name != null){
            let var_trim_subject_business_name = var_subject_business_name.replaceAll(' ', ''); // need javscipt version of trim (all spaces removed)
            // $subject_name = $trim_subject_business_name;
             var_subject_name = var_subject_business_name; // changed here feb 2023 as subject busines name was printing stripped as variable in affidavid // Not trimmed
              var_subject_name_4_doc= var_trim_subject_business_name;
            
        }
    
  // Subject Genders -- based on passed model.
  if (model.sex == 'femail' || model.sex  == 'female'){
  this.subject_gender_descriptor = "Female";
  }
  if (model.sex == 'mail'){
  this.subject_gender_descriptor = "Male";
  }
  if (model.sex == '' || model.sex == null){
    this.subject_gender_descriptor = "The Person";
    }

  const jobReportClientUser: any = this.job_report_client_user_paragraphs?.[0] ?? {};
  const currentUser: any = this.current_user_paragraphs?.[0] ?? {};
  const assignedSubjectAgent: any = this.assignedBrandList_paragraphs?.[0] ?? {};
  const assignedSubjectAgentName = [assignedSubjectAgent.first_name, assignedSubjectAgent.middle_name, assignedSubjectAgent.surname]
    .filter(Boolean)
    .join(' ');
  const assignedSubjectAgentNameUpper = assignedSubjectAgent.name || assignedSubjectAgentName;
  const assignedSubjectAgentAddressFull = [
    assignedSubjectAgent.address_1,
    assignedSubjectAgent.address_2,
    assignedSubjectAgent.suburb,
    assignedSubjectAgent.state
  ]
    .filter(Boolean)
    .join(' ');
  const assignedSubjectAgentAddressFullWithPostcode = assignedSubjectAgentAddressFull
    ? `${assignedSubjectAgentAddressFull}${assignedSubjectAgent.postcode ? ', ' + assignedSubjectAgent.postcode : ''}`
    : (assignedSubjectAgent.postcode || '');
  const assignedSubjectAgentQualificationRenewalDate = assignedSubjectAgent.qualification_renewal_date
    ? moment(assignedSubjectAgent.qualification_renewal_date).format('D/M/YYYY')
    : '';
  const assignedSubjectAgentQualificationRenewalDateFullWords = assignedSubjectAgent.qualification_renewal_date
    ? moment(assignedSubjectAgent.qualification_renewal_date).format('dddd MMMM Do, YYYY h:mma')
    : '';
  

    
// this.message_subject = 'Subject: ' +  res.email_subject_header + ' ' + this.subjectFullNameOrBusiness + ' Our Reference: '  + this.subject_number;
this.message_subject_var = 'Subject: ' +  model.email_subject + ' Our Reference: '  + this.subject_number;

if(model.subject_com_type_id == 3){
  // this.message_subject = 'Reference: ' + this.client_reference + ', ' + 'Subject: ' +  res.email_subject_header + ' ' + this.subjectFullNameOrBusiness + ' Our Reference: '  + this.subject_number;
  this.message_subject_var = 'Reference: ' + this.client_reference + ', ' +  model.email_subject + ' Our Reference: '  + this.subject_number;
}
  
// Subject Com Document - Template Variables - if {model.doc_id}
if(model.doc_id != null){
  // need to set the communication template vars.
  // console.log(JSON.stringify(this.doc_check))

  this.doc_name_var = this.doc_check[0].doc_name 
}
  
  /*   
  // :: Gender Descriptor
  PHP code below.  
  if ($sbj->sex == 'femail' || $sbj->sex  == 'female'){
        $templateProcessor->setValue("subject_" .$sbjx. "_gender_descriptor", "She");
        $templateProcessor->setValue($f_starter. "_gender_descriptor", "She"); // focus
    }
    if ($sbj->sex  == 'male'){
        $templateProcessor->setValue("subject_" .$sbjx. "_gender_descriptor", "He");
        $templateProcessor->setValue($f_starter. "_gender_descriptor", "He"); // focus
    }
  */
  
  
  // Convert HTML
      // if(model.special_instructions_HTML == null){
      //   this.job_special_instructions_HTML = model.special_instructions_HTML;
      //   }else{
      //    this.job_special_instructions_HTML = unescape(this.transform2(this.job_data_paragraphs[0].special_instructions_HTML))
      //   }



// Where are all my time Conversions??????



  const rendered_result = str
  .replaceAll('${f_subject_name}', model.subject_name)
  .replaceAll('${f_subject_number}', model.subject_number)
  .replaceAll('${subject_number}', model.subject_number)

      // Job Merge Variables.
      .replaceAll('${job_id}', model.job_id)
      .replaceAll('${job_number}', model.job_id)
      .replaceAll('${job_status_code}', this.job_data_paragraphs[0].job_status_code)
      .replaceAll('${owner_trace_code}', this.job_data_paragraphs[0].owner_trace_code)
      .replaceAll('${client_ref}', this.client_reference)
      // .replaceAll('${client_ref}', this.job_data_paragraphs[0].owner_trace_code + '_ TEST APPEND')
      
      .replaceAll('${client_reference}', this.job_data_paragraphs[0].owner_trace_code)
      .replaceAll('${your_reference}', this.job_data_paragraphs[0].owner_trace_code)
      .replaceAll('${job_document_number}', this.job_data_paragraphs[0].document_number)
      // .replaceAll('${job_registry_name}', this.job_data_paragraphs[0].registry_name)
      .replaceAll('${job_registry_name}', this.registry_name)
      .replaceAll('${job_registry_name_upper}', this.job_registry_name_Upper) // capitalise
      .replaceAll('${job_special_instrucitons}', this.job_special_instructions_HTML)


      .replaceAll('${job_type_id}', model.job_type_id)

      // .replaceAll('${job_type_name}', this.job_type_paragraphs[0].job_type_name)
      .replaceAll('${job_type_name}', this.job_type_name)
      .replaceAll('${job_type_name_upper}', this.job_type_name_Upper)

      // .replaceAll('${job_type_location_name}', this.job_type_location_paragraphs[0].job_type_location_name)
      .replaceAll('${job_type_location_name}', this.job_type_location_name)
      .replaceAll('${job_type_location_name_upper}', this.job_type_location_name_Upper)
      // .replaceAll('${job_type_court_name}', this.job_type_court_paragraphs[0].job_type_court_name)
      .replaceAll('${job_type_court_name}', this.job_type_court_name)
      .replaceAll('${job_type_court_name_upper}', this.job_type_court_name_Upper)

      // .replaceAll('${job_type_document_type_name}', this.job_type_document_type_paragraphs[0].job_type_document_type_name)
      .replaceAll('${job_type_document_type_name}', this.job_type_document_type_name)

      .replaceAll('${job_type_document_type_name_upper}', this.job_type_document_type_name_Upper)
      .replaceAll('${job_type_affidavit_type_name}', this.job_type_affidavit_type_name )
      .replaceAll('${job_type_affidavit_type_name_upper}', this.job_type_affidavit_type_name_Upper )


      // .replaceAll('${job_type_location_name}', this.job_type_location_paragraphs[0].job_type_location_name)
      .replaceAll('${job_type_location_name}', this.job_type_location_name)
      .replaceAll('${job_type_location_name_upper}', this.job_type_location_name_Upper)

      .replaceAll('${job_type_court_name}', this.job_type_court_name)
      .replaceAll('${job_type_court_name_upper}', this.job_type_court_name_Upper)
      .replaceAll('${job_type_document_type_name}', this.job_type_document_type_name)
      .replaceAll('${job_type_document_type_name_upper}', this.job_type_document_type_name_Upper)
      .replaceAll('${job_type_affidavit_type_name}', this.job_type_affidavit_type_name )
      .replaceAll('${job_type_affidavit_type_name_upper}', this.job_type_affidavit_type_name_Upper )

      // JoB Dates - Need to Lookup Job. and use the details.


      .replaceAll('${job_hearing_date}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'D/M/YYYY'))
      .replaceAll('${job_hearing_date_and_time_full_words_time_first}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'h:mma dddd MMMM Do, YYYY') ) // equivilent to in PHP :: date("g:ia l jS F Y", strtotime($job_hearing_date))
      .replaceAll('${job_hearing_date_and_time_full_words}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'dddd MMMM Do, YYYY h:mma') )
      .replaceAll('${job_hearing_date}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'D/M/YYYY'))
      .replaceAll('${job_hearing_day}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'dddd'))
      .replaceAll('${job_hearing_day_number}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'Do'))
      .replaceAll('${job_hearing_month}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'MMMM'))
      .replaceAll('${job_hearing_month_number}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'Mo'))
      .replaceAll('${job_hearing_month_number_simple}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'M'))
      .replaceAll('${job_hearing_year}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'YYYY'))
      .replaceAll('${job_hearing_time}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'h:mma'))

      .replaceAll('${job_judgement_date}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'D/M/YYYY'))
      .replaceAll('${job_judgement_date_and_time_full_words_time_first}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'h:mma dddd MMMM Do, YYYY') ) 
      .replaceAll('${job_judgement_date_and_time_full_words}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'dddd MMMM Do, YYYY h:mma') ) 
      .replaceAll('${job_judgement_date}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'D/M/YYYY'))
      .replaceAll('${job_judgement_day}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'dddd'))
      .replaceAll('${job_judgement_day_number}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'Do'))
      .replaceAll('${job_judgement_month}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'MMMM'))
      .replaceAll('${job_judgement_month_number}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'Mo'))
      .replaceAll('${job_judgement_month_number_simple}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'M'))
      .replaceAll('${job_judgement_year}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'YYYY'))
      .replaceAll('${job_judgement_time}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'h:mma'))

      .replaceAll('${job_filing_date}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'D/M/YYYY'))
      .replaceAll('${job_filing_date_and_time_full_words_time_first}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'h:mma dddd MMMM Do, YYYY') ) 
      .replaceAll('${job_filing_date_and_time_full_words}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'dddd MMMM Do, YYYY h:mma') ) 
      .replaceAll('${job_filing_date}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'D/M/YYYY'))
      .replaceAll('${job_filing_day}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'dddd'))
      .replaceAll('${job_filing_day_number}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'Do'))
      .replaceAll('${job_filing_month}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'MMMM'))
      .replaceAll('${job_filing_month_number}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'Mo'))
      .replaceAll('${job_filing_month_number_simple}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'M'))
      .replaceAll('${job_filing_year}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'YYYY'))
      .replaceAll('${job_filing_time}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'h:mma'))


      .replaceAll('${job_instructions_date}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'D/M/YYYY'))
      .replaceAll('${job_instructions_date_and_time_full_words_time_first}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'h:mma dddd MMMM Do, YYYY') ) 
      .replaceAll('${job_instructions_date_and_time_full_words}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'dddd MMMM Do, YYYY h:mma') ) 
      .replaceAll('${job_instructions_date}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'D/M/YYYY'))
      .replaceAll('${job_instructions_day}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'dddd'))
      .replaceAll('${job_instructions_day_number}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'Do'))
      .replaceAll('${job_instructions_month}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'MMMM'))
      .replaceAll('${job_instructions_month_number}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'Mo'))
      .replaceAll('${job_instructions_month_number_simple}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'M'))
      .replaceAll('${job_instructions_year}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'YYYY'))
      .replaceAll('${job_instructions_time}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'h:mma'))

      .replaceAll('${job_aos_date}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'D/M/YYYY'))
      .replaceAll('${job_aos_date_and_time_full_words_time_first}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'h:mma dddd MMMM Do, YYYY') ) 
      .replaceAll('${job_aos_date_and_time_full_words}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'dddd MMMM Do, YYYY h:mma') ) 
      .replaceAll('${job_aos_date}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'D/M/YYYY'))
      .replaceAll('${job_aos_day}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'dddd'))
      .replaceAll('${job_aos_day_number}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'Do'))
      .replaceAll('${job_aos_month}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'MMMM'))
      .replaceAll('${job_aos_month_number}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'Mo'))
      .replaceAll('${job_aos_month_number_simple}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'M'))
      .replaceAll('${job_aos_year}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'YYYY'))
      .replaceAll('${job_aos_time}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'h:mma'))

      // Missing Report Client Name - And Report Client Details for the paragraph
           .replaceAll('${job_report_client_name}', this.brand_data[0].name)
           .replaceAll('${job_client_report_name}', this.brand_data[0].name)
           .replaceAll('${job_report_client_client_code}', this.brand_data[0].client_code)

           .replaceAll('${job_client_report_client_code}', this.brand_data[0].client_code)
           .replaceAll('${job_client_report_subject_number_client_code}', model.subject_number + '.' + this.brand_data[0].client_code)
           .replaceAll('${job_client_report_subject_number_client_code_brac}', model.subject_number + '[' + this.brand_data[0].client_code + ']' )


           .replaceAll('${job_client_report_name_upper}', this.brand_data[0].name)

           .replaceAll('${job_client_report_phone}', this.brand_data[0].phone)
           .replaceAll('${job_client_report_address_1}', this.brand_data[0].address_1)
           .replaceAll('${job_client_report_address_2}', this.brand_data[0].address_2)
           .replaceAll('${job_client_report_suburb}', this.brand_data[0].suburb)
           .replaceAll('${job_client_report_state}', this.brand_data[0].state)
           .replaceAll('${job_client_report_postcode}', this.brand_data[0].postcode)
           .replaceAll('${job_client_report_country}', this.brand_data[0].country)
           .replaceAll('${job_client_report_brand_type_id}', this.brand_data[0].brand_type_id)
           .replaceAll('${job_client_report_notes}', this.brand_data[0].brand_notes)
           .replaceAll('${job_client_report_fax}', this.brand_data[0].fax)
           .replaceAll('${job_client_report_email}', this.brand_data[0].email)
           .replaceAll('${job_client_report_website}', this.brand_data[0].website)
           .replaceAll('${job_client_report_postal_address_1}', this.brand_data[0].postal_address_1)
           .replaceAll('${job_client_report_postal_address_2}', this.brand_data[0].postal_address_2)
           .replaceAll('${job_client_report_postal_suburb}', this.brand_data[0].postal_suburb)
           .replaceAll('${job_client_report_postal_state}', this.brand_data[0].postal_state)
           .replaceAll('${job_client_report_postal_postcode}', this.brand_data[0].postal_postcode)
           .replaceAll('${job_client_report_postal_country}', this.brand_data[0].postal_country)
           .replaceAll('${job_client_report_myob_id}', this.brand_data[0].myob_id)
           .replaceAll('${job_client_report_accounts_email_address}', this.brand_data[0].accounts_email_address)
           .replaceAll('${job_client_report_brand_type}', this.brand_data[0].brand_type_id)

           .replaceAll('${job_invoice_client_name}', this.job_invoice_client_paragraphs[0].name)
           .replaceAll('${job_client_invoice_name}', this.job_invoice_client_paragraphs[0].name)
           
           .replaceAll('${job_client_invoice_client_code}', this.job_invoice_client_paragraphs[0].client_code)
           .replaceAll('${job_client_invoice_subject_number_client_code}', model.subject_number + '.' + this.brand_data[0].client_code)
           .replaceAll('${job_client_invoice_subject_number_client_code_brac}', model.subject_number + '[' + this.brand_data[0].client_code + ']' )


           .replaceAll('${job_client_invoice_name_upper}', this.job_invoice_client_paragraphs[0].name)

           .replaceAll('${job_client_invoice_phone}', this.job_invoice_client_paragraphs[0].phone)
           .replaceAll('${job_client_invoice_address_1}', this.job_invoice_client_paragraphs[0].address_1)
           .replaceAll('${job_client_invoice_address_2}', this.job_invoice_client_paragraphs[0].address_2)
           .replaceAll('${job_client_invoice_suburb}', this.job_invoice_client_paragraphs[0].suburb)
           .replaceAll('${job_client_invoice_state}', this.job_invoice_client_paragraphs[0].state)
           .replaceAll('${job_client_invoice_postcode}', this.job_invoice_client_paragraphs[0].postcode)
           .replaceAll('${job_client_invoice_country}', this.job_invoice_client_paragraphs[0].country)
           .replaceAll('${job_client_invoice_brand_type_id}', this.job_invoice_client_paragraphs[0].brand_type_id)
           .replaceAll('${job_client_invoice_notes}', this.job_invoice_client_paragraphs[0].brand_notes)
           .replaceAll('${job_client_invoice_fax}', this.job_invoice_client_paragraphs[0].fax)
           .replaceAll('${job_client_invoice_email}', this.job_invoice_client_paragraphs[0].email)
           .replaceAll('${job_client_invoice_website}', this.job_invoice_client_paragraphs[0].website)
           .replaceAll('${job_client_invoice_postal_address_1}', this.job_invoice_client_paragraphs[0].postal_address_1)
           .replaceAll('${job_client_invoice_postal_address_2}', this.job_invoice_client_paragraphs[0].postal_address_2)
           .replaceAll('${job_client_invoice_postal_suburb}', this.job_invoice_client_paragraphs[0].postal_suburb)
           .replaceAll('${job_client_invoice_postal_state}', this.job_invoice_client_paragraphs[0].postal_state)
           .replaceAll('${job_client_invoice_postal_postcode}', this.job_invoice_client_paragraphs[0].postal_postcode)
           .replaceAll('${job_client_invoice_postal_country}', this.job_invoice_client_paragraphs[0].postal_country)
           .replaceAll('${job_client_invoice_myob_id}', this.job_invoice_client_paragraphs[0].myob_id)
           .replaceAll('${job_client_invoice_accounts_email_address}', this.job_invoice_client_paragraphs[0].accounts_email_address)
           .replaceAll('${job_client_invoice_brand_type}', this.job_invoice_client_paragraphs[0].brand_type_id)


           .replaceAll('${job_owner_name}', this.job_owner_client_paragraphs[0].name)
           .replaceAll('${job_owner_name}', this.job_owner_client_paragraphs[0].name)
       
           .replaceAll('${job_owner_client_code}', this.job_owner_client_paragraphs[0].client_code)
           .replaceAll('${job_owner_subject_number_client_code}', model.subject_number + '.' + this.brand_data[0].client_code)
           .replaceAll('${job_owner_subject_number_client_code_brac}', model.subject_number + '[' + this.brand_data[0].client_code + ']' )



           .replaceAll('${job_owner_name_upper}', this.job_owner_client_paragraphs[0].name)

           .replaceAll('${job_owner_phone}', this.job_owner_client_paragraphs[0].phone)
           .replaceAll('${job_owner_address_1}', this.job_owner_client_paragraphs[0].address_1)
           .replaceAll('${job_owner_address_2}', this.job_owner_client_paragraphs[0].address_2)
           .replaceAll('${job_owner_suburb}', this.job_owner_client_paragraphs[0].suburb)
           .replaceAll('${job_owner_state}', this.job_owner_client_paragraphs[0].state)
           .replaceAll('${job_owner_postcode}', this.job_owner_client_paragraphs[0].postcode)
           .replaceAll('${job_owner_country}', this.job_owner_client_paragraphs[0].country)
           .replaceAll('${job_owner_brand_type_id}', this.job_owner_client_paragraphs[0].brand_type_id)
           .replaceAll('${job_owner_notes}', this.job_owner_client_paragraphs[0].brand_notes)
           .replaceAll('${job_owner_fax}', this.job_owner_client_paragraphs[0].fax)
           .replaceAll('${job_owner_email}', this.job_owner_client_paragraphs[0].email)
           .replaceAll('${job_owner_website}', this.job_owner_client_paragraphs[0].website)
           .replaceAll('${job_owner_postal_address_1}', this.job_owner_client_paragraphs[0].postal_address_1)
           .replaceAll('${job_owner_postal_address_2}', this.job_owner_client_paragraphs[0].postal_address_2)
           .replaceAll('${job_owner_postal_suburb}', this.job_owner_client_paragraphs[0].postal_suburb)
           .replaceAll('${job_owner_postal_state}', this.job_owner_client_paragraphs[0].postal_state)
           .replaceAll('${job_owner_postal_postcode}', this.job_owner_client_paragraphs[0].postal_postcode)
           .replaceAll('${job_owner_postal_country}', this.job_owner_client_paragraphs[0].postal_country)
           .replaceAll('${job_owner_myob_id}', this.job_owner_client_paragraphs[0].myob_id)
           .replaceAll('${job_owner_accounts_email_address}', this.job_owner_client_paragraphs[0].accounts_email_address)
           .replaceAll('${job_owner_brand_type}', this.job_owner_client_paragraphs[0].brand_type_id)

          


           .replaceAll('${job_client_report_user_first_name}',  jobReportClientUser.first_name)
           .replaceAll('${job_client_report_user_name_surname}', jobReportClientUser.surname)
           .replaceAll('${job_client_report_user_surname}', jobReportClientUser.surname)

           .replaceAll('${job_client_report_user_name}', jobReportClientUser.username)
           .replaceAll('${job_client_report_user_name_upper}', jobReportClientUser.username)
           .replaceAll('${job_client_report_user_phone}', jobReportClientUser.phone)
           .replaceAll('${job_client_report_user_address_1}', jobReportClientUser.address_1)
           .replaceAll('${job_client_report_user_address_2}', jobReportClientUser.address_2)
           .replaceAll('${job_client_report_user_suburb}', jobReportClientUser.suburb)
           .replaceAll('${job_client_report_user_state}', jobReportClientUser.state)
           .replaceAll('${job_client_report_user_postcode}', jobReportClientUser.postcode)
           .replaceAll('${job_client_report_user_country}', jobReportClientUser.country)
           .replaceAll('${job_client_report_user_brand_type_id}', jobReportClientUser.brand_type_id)
           .replaceAll('${job_client_report_user_notes}', jobReportClientUser.brand_notes)
           .replaceAll('${job_client_report_user_fax}', jobReportClientUser.fax)
           .replaceAll('${job_client_report_user_email}', jobReportClientUser.email_address)
           .replaceAll('${job_client_report_user_website}', jobReportClientUser.website)
           .replaceAll('${job_client_report_user_postal_address_1}', jobReportClientUser.postal_address_1)
           .replaceAll('${job_client_report_user_postal_address_2}', jobReportClientUser.postal_address_2)
           .replaceAll('${job_client_report_user_postal_suburb}', jobReportClientUser.postal_suburb)
           .replaceAll('${job_client_report_user_postal_state}', jobReportClientUser.postal_state)
           .replaceAll('${job_client_report_user_postal_postcode}', jobReportClientUser.postal_postcode)
           .replaceAll('${job_client_report_user_postal_country}', jobReportClientUser.postal_country)


           .replaceAll('${f_user_first_name}',  currentUser.first_name)
           .replaceAll('${f_user_name_surname}', currentUser.surname)
           .replaceAll('${f_user_surname}', currentUser.surname)

           .replaceAll('${f_user_name}', currentUser.username)
           .replaceAll('${f_user_name_upper}', currentUser.username)
           .replaceAll('${f_user_phone}', currentUser.phone)
           .replaceAll('${f_user_address_1}', currentUser.address_1)
           .replaceAll('${f_user_address_2}', currentUser.address_2)
           .replaceAll('${f_user_suburb}', currentUser.suburb)
           .replaceAll('${f_user_state}', currentUser.state)
           .replaceAll('${f_user_postcode}', currentUser.postcode)
           .replaceAll('${f_user_country}', currentUser.country)
           .replaceAll('${f_user_brand_type_id}', currentUser.brand_type_id)
           .replaceAll('${f_user_notes}', currentUser.brand_notes)
           .replaceAll('${f_user_fax}', currentUser.fax)
           .replaceAll('${f_user_email}', currentUser.email_address)
           .replaceAll('${f_user_website}', currentUser.website)
           .replaceAll('${f_user_postal_address_1}', currentUser.postal_address_1)
           .replaceAll('${f_user_postal_address_2}', currentUser.postal_address_2)
           .replaceAll('${f_user_postal_suburb}', currentUser.postal_suburb)
           .replaceAll('${f_user_postal_state}', currentUser.postal_state)
           .replaceAll('${f_user_postal_postcode}', currentUser.postal_postcode)
           .replaceAll('${f_user_postal_country}', currentUser.postal_country)

           .replaceAll('${f_user_email_signature}', currentUser.email_signature_HTML_rendered) // plain and not encoded.


// Current Subjcet as a passed commnunication model.
.replaceAll('${f_subject_subject_id}', model.subject_id )
.replaceAll('${f_subject_job_id}', model.job_id )
.replaceAll('${f_subject_first_name}', model.first_name )
.replaceAll('${f_subject_surname}', model.surname )
.replaceAll('${f_subject_title}', model.title )
.replaceAll('${f_subject_is_active}', model.is_active )

.replaceAll('${f_subject_next_date}', this.legalDate.format(model.next_date, 'D/M/YYYY'))
// .replaceAll('${f_subject_next_date}', model.next_date )

.replaceAll('${f_subject_next_date_and_time_full_words_time_first}', this.legalDate.format(model.next_date, 'h:mma dddd MMMM Do, YYYY') ) 
.replaceAll('${f_subject_next_date_and_time_full_words}', this.legalDate.format(model.next_date, 'dddd MMMM Do, YYYY h:mma') ) 
.replaceAll('${f_subject_next_date_full_words_time_first}', this.legalDate.format(model.next_date, 'h:mma dddd MMMM Do, YYYY') ) 
.replaceAll('${f_subject_next_date}', this.legalDate.format(model.next_date, 'D/M/YYYY'))
.replaceAll('${f_subject_next_day}', this.legalDate.format(model.next_date, 'dddd'))
.replaceAll('${f_subject_next_day_number}', this.legalDate.format(model.next_date, 'Do'))
.replaceAll('${f_subject_next_month}', this.legalDate.format(model.next_date, 'MMMM'))
.replaceAll('${f_subject_next_month_number}', this.legalDate.format(model.next_date, 'Mo'))
.replaceAll('${f_subject_next_month_number_simple}', this.legalDate.format(model.next_date, 'M'))
.replaceAll('${f_subject_next_year}', this.legalDate.format(model.next_date, 'YYYY'))
.replaceAll('${f_subject_next_time}', this.legalDate.format(model.next_date, 'h:mma'))

.replaceAll('${f_subject_final_date}', this.legalDate.format(model.final_date, 'D/M/YYYY'))
.replaceAll('${f_subject_final_date_and_time_full_words_time_first}', this.legalDate.format(model.final_date, 'h:mma dddd MMMM Do, YYYY') ) 
.replaceAll('${f_subject_final_date_and_time_full_words}', this.legalDate.format(model.final_date, 'dddd MMMM Do, YYYY h:mma') ) 
.replaceAll('${f_subject_final_date_full_words_time_first}', this.legalDate.format(model.final_date, 'h:mma dddd MMMM Do, YYYY') ) 
.replaceAll('${f_subject_final_date}', this.legalDate.format(model.final_date, 'D/M/YYYY'))
.replaceAll('${f_subject_final_day}', this.legalDate.format(model.final_date, 'dddd'))
.replaceAll('${f_subject_final_day_number}', this.legalDate.format(model.final_date, 'Do'))
.replaceAll('${f_subject_final_month}', this.legalDate.format(model.final_date, 'MMMM'))
.replaceAll('${f_subject_final_month_number}', this.legalDate.format(model.final_date, 'Mo'))
.replaceAll('${f_subject_final_month_number_simple}', this.legalDate.format(model.final_date, 'M'))
.replaceAll('${f_subject_final_year}', this.legalDate.format(model.final_date, 'YYYY'))
.replaceAll('${f_subject_final_time}', this.legalDate.format(model.final_date, 'h:mma'))

.replaceAll('${f_subject_job_status_id}', model.job_status_id )
.replaceAll('${f_subject_street_address}', model.street_address )
.replaceAll('${f_subject_suburb}', model.suburb )
.replaceAll('${f_subject_state}', model.state )
.replaceAll('${f_subject_postcode}', model.postcode )
.replaceAll('${f_subjectphone_h}', model.f_subjectphone_h )
.replaceAll('${f_subject_email}', model.email )

.replaceAll('${f_subject_dob}', moment(model.dob).format('D/M/YYYY'))
.replaceAll('${f_subject_dob_and_time_full_words_time_first}', moment(model.dob).format('h:mma dddd MMMM Do, YYYY') ) 
.replaceAll('${f_subject_dob_and_time_full_words}', moment(model.dob).format('dddd MMMM Do, YYYY h:mma') ) 
.replaceAll('${f_subject_dob_full_words}', moment(model.dob).format('dddd MMMM Do, YYYY') ) 
.replaceAll('${f_subject_dob_full_words_time_first}', moment(model.dob).format('dddd MMMM Do, YYYY h:mma') ) 
.replaceAll('${f_subject_dob}', moment(model.dob).format('D/M/YYYY'))
.replaceAll('${f_subject_dob_day}', moment(model.dob).format('dddd'))
.replaceAll('${f_subject_dob_day_number}', moment(model.dob).format('Do'))
.replaceAll('${f_subject_dob_month}', moment(model.dob).format('MMMM'))
.replaceAll('${f_subject_dob_month_number}', moment(model.dob).format('Mo'))
.replaceAll('${f_subject_dob_month_number_simple}', moment(model.dob).format('M'))
.replaceAll('${f_subject_dob_year}', moment(model.dob).format('YYYY'))
.replaceAll('${f_subject_dob_time}', moment(model.dob).format('h:mma'))

.replaceAll('${f_subject_phone_m}', model.phone_m )
.replaceAll('${f_subject_subject_type_id}', model.subject_type_id )

// .replaceAll('${f_subject_file_number}', model.file_number )
.replaceAll('${f_subject_file_number}', this.ordinalInWord(model.file_number) ) // Ordinal eg First... need to capitasie.

.replaceAll('${f_subject_special_instructions}', model.special_instructions )
.replaceAll('${f_subject_job_status}', model.job_status )
.replaceAll('${f_subject_reference_number}', model.reference_number )
.replaceAll('${f_subject_job_reference_number}', model.job_reference_number )
.replaceAll('${f_subject_subject_number}', model.subject_number )
.replaceAll('${f_subject_created_by}', model.created_by )
.replaceAll('${f_subject_created_date}', this.legalDate.format(model.next_date, 'D/M/YYYY'))
.replaceAll('${f_subject_updated_date}', this.legalDate.format(model.next_date, 'D/M/YYYY'))
.replaceAll('${f_subject_updated_by}', model.updated_by )
.replaceAll('${f_subject_completed_date}', this.legalDate.format(model.next_date, 'D/M/YYYY'))
.replaceAll('${f_subject_completed_by}', model.completed_by )
.replaceAll('${f_subject_start_date}', this.legalDate.format(model.next_date, 'D/M/YYYY'))
.replaceAll('${f_subject_started_by}', model.started_by )
.replaceAll('${f_subject_time_taken}', model.time_taken )
.replaceAll('${f_subject_sex}', model.sex )

// .replaceAll('${f_subject_gender_descriptor}', model.sex )
.replaceAll('${f_subject_gender_descriptor}', this.subject_gender_descriptor )


.replaceAll('${f_subject_finalised}', model.finalised )
.replaceAll('${f_subject_subject_reference_created}', model.subject_reference_created )
.replaceAll('${f_subject_brand_report_user_id}', model.brand_report_user_id )
.replaceAll('${f_subject_job_type_id}', model.job_type_id )
.replaceAll('${f_subject_job_type_location_id}', model.job_type_location_id )
.replaceAll('${f_subject_job_type_court_id}', model.job_type_court_id )
.replaceAll('${f_subject_job_type_document_type_id}', model.job_type_document_type_id )
.replaceAll('${f_subject_job_type_affidavit_type_id}', model.job_type_affidavit_type_id )
.replaceAll('${f_subject_business_name}', model.business_name )
.replaceAll('${f_subject_prev_subject_id}', model.prev_subject_id )
.replaceAll('${f_subject_next_subject_id}', model.next_subject_id )
.replaceAll('${f_subject_job_subject_type_id}', model.job_subject_type_id )
.replaceAll('${f_subject_subject_report_order_number}', model.subject_report_order_number )
.replaceAll('${f_subject_job_service_rule_id}', model.job_service_rule_id )

      .replaceAll('${f_subject_job_service_rule_name}', this.job_service_rule_name )
      .replaceAll('${f_subject_job_service_rule_description}', this.job_service_rule_description )


      .replaceAll('${f_subject_job_service_timeframe_id}', model.job_service_timeframe_id )
      .replaceAll('${f_subject_job_service_timeframe_name}', this.job_service_timeframe_name )
      .replaceAll('${f_subject_job_service_timeframe_text}', this.job_service_timeframe_text )

      .replaceAll('${f_subject_subject_service_type_id}', model.subject_service_type_id )
      .replaceAll('${f_subject_subject_service_type_name}', this.subject_service_type_name )
      .replaceAll('${f_subject_subject_service_type_description}', this.subject_service_type_description )
      .replaceAll('${f_subject_subject_service_type_staff_instructions}', this.subject_service_type_staff_instructions )
      .replaceAll('${f_subject_subject_service_type_agent_instructions}', this.subject_service_type_agent_instructions )
      .replaceAll('${f_subject_subject_service_type_instructions}', this.subject_service_type_instructions )


.replaceAll('${f_subject_service_company_name}', model.service_company_name )
.replaceAll('${f_subject_service_directors_name}', model.service_directors_name )
.replaceAll('${f_subject_service_prison_name}', model.service_prison_name )
.replaceAll('${f_subject_service_law_firm_name}', model.service_law_firm_name )
.replaceAll('${f_subject_service_solicitor_name}', model.service_solicitor_name )
.replaceAll('${f_subject_middle_name}', model.middle_name )
.replaceAll('${f_subject_special_instructions_HTML}', model.special_instructions_HTML )

// .replaceAll('${f_subject_job_subject_type_name}', model.job_subject_type_name )
.replaceAll('${f_subject_subject_type_name}', this.job_subject_type_name )
.replaceAll('${f_subject_subject_type_name_upper}', this.job_subject_type_name_Upper)

// .replaceAll('${f_subject_job__type}', model.job_type )
.replaceAll('${f_subject_subject_type}', model.job_type )

.replaceAll('${f_subject_brand_invoice_id}', model.brand_invoice_id )
.replaceAll('${f_subject_brand_report_id}', model.brand_report_id )
.replaceAll('${f_subject_instructions_date}', model.instructions_date )
.replaceAll('${f_subject_hearing_date}', model.hearing_date )
.replaceAll('${f_subject_judgement_date}', model.judgement_date )
.replaceAll('${f_subject_filing_date}', model.filing_date )
.replaceAll('${f_subject_client_reference}', model.client_reference )
.replaceAll('${f_subject_brand_report_name}', model.brand_report_name )
.replaceAll('${f_subject_brand_invoice_name}', model.brand_invoice_name )

.replaceAll('${f_subject_subject_name}', model.subject_name )
.replaceAll('${f_subject_name_upper}', model.subject_name.toUpperCase() )
.replaceAll('${subject_name}', model.subject_name )
.replaceAll('${subject_name_upper}', model.subject_name.toUpperCase() )

.replaceAll('${f_subject_contact_numbers}', this.subject_contact_numbers)
.replaceAll('${f_subject_contact_emails}', this.subject_contact_emails)




// BREAKS EMAIL TEMPLATES IF NO AGENT SELECTED AT PRESENT>
// Subject Focus Agent
            .replaceAll('${f_subject_agent_name}', assignedSubjectAgentName)
            .replaceAll('${f_subject_agent_name_upper}', assignedSubjectAgentNameUpper)
            .replaceAll('${f_subject_agent_first_name}', assignedSubjectAgent.first_name)
            .replaceAll('${f_subject_agent_middle_name}', assignedSubjectAgent.middle_name)
            .replaceAll('${f_subject_agent_surname}', assignedSubjectAgent.surname)

            .replaceAll('${f_subject_agent_address_1}', assignedSubjectAgent.address_1)
            .replaceAll('${f_subject_agent_address_2}', assignedSubjectAgent.address_2)
            .replaceAll('${f_subject_agent_suburb}', assignedSubjectAgent.suburb)
            .replaceAll('${f_subject_agent_state}', assignedSubjectAgent.state)
            .replaceAll('${f_subject_agent_postcode}', assignedSubjectAgent.postcode)
            .replaceAll('${f_subject_agent_country}', assignedSubjectAgent.country)


            .replaceAll('${f_subject_agent_postal_address_1}', assignedSubjectAgent.address_1)
            .replaceAll('${f_subject_agent_postal_address_2}', assignedSubjectAgent.address_2)
            .replaceAll('${f_subject_agent_postal_suburb}', assignedSubjectAgent.suburb)
            .replaceAll('${f_subject_agent_postal_state}', assignedSubjectAgent.state)
            .replaceAll('${f_subject_agent_postal_postcode}', assignedSubjectAgent.postcode)
            .replaceAll('${f_subject_agent_postal_country}', assignedSubjectAgent.country)

            .replaceAll('${f_subject_agent_adddress_full}', assignedSubjectAgentAddressFullWithPostcode)
            .replaceAll('${f_subject_agent_qualification}', assignedSubjectAgent.qualification)
            .replaceAll('${f_subject_agent_qualification_number}', assignedSubjectAgent.qualification_number)

            .replaceAll('${f_subject_agent_myob_id}', assignedSubjectAgent.myob_id)
            .replaceAll('${f_subject_agent_brand_type}', assignedSubjectAgent.brand_type_id)

            .replaceAll('${f_subject_agent_phone}', assignedSubjectAgent.phone)
            .replaceAll('${f_subject_agent_fax}', assignedSubjectAgent.fax)
            .replaceAll('${f_subject_agent_website}', assignedSubjectAgent.website)
            .replaceAll('${f_subject_agent_accounts_email_address}', assignedSubjectAgent.accounts_email_address)

            .replaceAll('${f_subject_agent_qualification_renewal_date}', assignedSubjectAgentQualificationRenewalDate)
            .replaceAll('${f_subject_agent_qualification_renewal_date_full_words}', assignedSubjectAgentQualificationRenewalDateFullWords)


// Sent from the allRecipeints Atray Function when adding recipeints
        .replaceAll('${recipient_name}', model.recipient_name )
        .replaceAll('${recipient_email_address}', model.recipient_email_address )
        .replaceAll('${recipient_brand_id}', model.recipient_brand_id )
        .replaceAll('${recipient_brand_type_id}', model.recipient_brand_type_id )
        .replaceAll('${recipient_user_id}', model.recipient_user_id )
        .replaceAll('${recipient_user_level_id}', model.recipient_user_level_id )
        .replaceAll('${recipient_type_name}', model.recipient_type_name )
       
        // .replaceAll('${message_subject}', this.message_subject_var )
        .replaceAll('${message_subject}', this.message_subject ) // set from the old system
        .replaceAll('${doc_name}', this.doc_name_var  ) // set from the old system
     



// hide anything null or undefined.
.replaceAll('${undefined}', '')
.replaceAll('${null}', '')
.replaceAll('undefined', '') // makes all undefined print empty
.replaceAll('null', '') // makes all undefined print empty
.replaceAll('Invalid date', '') // makes all undefined print empty


// model.email_template_primary_HTML_rendered
// email_subject_primary_rendered

// Convert the results to a form field value.
// model.email_template_primary_HTML_rendered = rendered_result;




// return rendered_result;
if(this.attempts_paragraphs_model != undefined && this.attempts_paragraphs_model != '[]' && this.attempts_paragraphs_model != null){
 return this.runReplaceAllVariables_AttemptsOnly(rendered_result, model) // returns after running all the attempts.
// return rendered_result; // just return without rendering the attempts

}else{
  return rendered_result; // just return without rendering the attempts
}


}


// Attempt f_attempt focus variables for all templates -- Only run if a service acualty exisits to save time and pervent errors.
// THIS TRIGGERS ALL OTHER ATTEMPT VARIABELS AT THE END.
runReplaceAllVariables_AttemptsOnly(str, model){



  // Already loaded in the job/subject lookup
  // if(this.attempts_paragraphs_model.job_subject_type_id){
  //   this.getJobSubjectType_Q(this.attempts_paragraphs_model.job_subject_type_id) ;
  // }
  // let var_subject_type_name;
  // if(this.subject_job_subject_type != null){
  // var_subject_type_name = this.subject_job_subject_type.job_subject_type_name
  // } else{
  // var_subject_type_name = '';
  // }



// ATTEMPS
  // Current Attempt Variables Setups
  // Uppercase.
  if(this.attempts_paragraphs_model){

    let var_subject_attempt_type_name = this.attempts_paragraphs_model.subject_attempt_type_name
    if(var_subject_attempt_type_name != null){ // uppercase must be validated if not null
     this.var_subject_attempt_type_name_Upper = var_subject_attempt_type_name.toUpperCase();
    }
  
  } // end if attemps paragraphs model.

  this.person_spoken_with_advised_HTML = '';

if(this.attempts_paragraphs_model.person_spoken_with_advised_HTML == null){this.person_spoken_with_advised_HTML = this.attempts_paragraphs_model.person_spoken_with_advised; }else{this.person_spoken_with_advised_HTML = this.transform2(this.attempts_paragraphs_model.person_spoken_with_advised_HTML);}
if(this.attempts_paragraphs_model.vehicles_notes_HTML == null){this.vehicles_notes_HTML = this.attempts_paragraphs_model.vehicles_notes; }else{this.vehicles_notes_HTML = this.transform2(this.attempts_paragraphs_model.vehicles_notes_HTML);}
if(this.attempts_paragraphs_model.neighbours_notes_HTML == null){this.neighbours_notes_HTML = this.attempts_paragraphs_model.neighbours_notes; }else{this.neighbours_notes_HTML = this.transform2(this.attempts_paragraphs_model.neighbours_notes_HTML);}
if(this.attempts_paragraphs_model.calling_card_notes_HTML == null){this.calling_card_notes_HTML = this.attempts_paragraphs_model.calling_card_notes; }else{this.calling_card_notes_HTML = this.transform2(this.attempts_paragraphs_model.calling_card_notes_HTML);}
if(this.attempts_paragraphs_model.postal_mail_notes_HTML == null){this.postal_mail_notes_HTML = this.attempts_paragraphs_model.postal_mail_notes; }else{this.postal_mail_notes_HTML = this.transform2(this.attempts_paragraphs_model.postal_mail_notes_HTML);}
if(this.attempts_paragraphs_model.phone_call_notes_HTML == null){this.phone_call_notes_HTML = this.attempts_paragraphs_model.phone_call_notes; }else{this.phone_call_notes_HTML = this.transform2(this.attempts_paragraphs_model.phone_call_notes_HTML);}
if(this.attempts_paragraphs_model.attempts_notes_HTML == null){this.attempts_notes_HTML = this.attempts_paragraphs_model.attempts_notes; }else{this.attempts_notes_HTML = this.transform2(this.attempts_paragraphs_model.attempts_notes_HTML);}
if(this.attempts_paragraphs_model.email_contents_HTML == null){this.email_contents_HTML = this.attempts_paragraphs_model.email_contents; }else{this.email_contents_HTML = this.transform2(this.attempts_paragraphs_model.email_contents_HTML);}
if(this.attempts_paragraphs_model.general_notes_HTML == null){
  this.set_general_notes = this.attempts_paragraphs_model.general_notes;
  }else{
   this.set_general_notes = this.transform2(this.attempts_paragraphs_model.general_notes_HTML)
  }
  if(this.attempts_paragraphs_model.property_forsale_or_lease_sign_details_HTML == null){this.property_forsale_or_lease_sign_details_HTML = this.attempts_paragraphs_model.property_forsale_or_lease_sign_details; }else{this.property_forsale_or_lease_sign_details_HTML = this.transform2(this.attempts_paragraphs_model.property_forsale_or_lease_sign_details_HTML);}  
  if(this.attempts_paragraphs_model.property_mail_details_HTML == null){this.property_mail_details_HTML = this.attempts_paragraphs_model.property_mail_details; }else{this.property_mail_details_HTML = this.transform2(this.attempts_paragraphs_model.property_mail_details_HTML);}
  if(this.attempts_paragraphs_model.property_vehicles_sighted_details_HTML == null){this.property_vehicles_sighted_details_HTML = this.attempts_paragraphs_model.property_vehicles_sighted_details; }else{this.property_vehicles_sighted_details_HTML = this.transform2(this.attempts_paragraphs_model.property_vehicles_sighted_details_HTML);}  
  if(this.attempts_paragraphs_model.property_pets_details_HTML == null){this.property_pets_details_HTML = this.attempts_paragraphs_model.property_pets_details; }else{this.property_pets_details_HTML = this.transform2(this.attempts_paragraphs_model.property_pets_details_HTML);}

  if(this.attempts_paragraphs_model.property_occupancy_details_HTML == null){this.property_occupancy_details_HTML = this.attempts_paragraphs_model.property_occupancy_details; }else{this.property_occupancy_details_HTML = this.transform2(this.attempts_paragraphs_model.property_occupancy_details_HTML);}
  
  if(this.attempts_paragraphs_model.property_condition_HTML == null){this.property_condition_HTML = this.attempts_paragraphs_model.property_condition; }else{this.property_condition_HTML = this.transform2(this.attempts_paragraphs_model.property_condition_HTML);}
if(this.attempts_paragraphs_model.property_occupied_details_HTML == null){this.property_occupied_details_HTML = this.attempts_paragraphs_model.property_occupied_details; }else{this.property_occupied_details_HTML = this.transform2(this.attempts_paragraphs_model.property_occupied_details_HTML);}
if(this.attempts_paragraphs_model.property_type_details_HTML == null){this.set_property_type_details_HTML = this.attempts_paragraphs_model.property_type_details; }else{this.set_property_type_details_HTML = this.transform2(this.attempts_paragraphs_model.property_type_details_HTML);}

if(this.attempts_paragraphs_model.service_under_order_HTML == null){this.service_under_order_HTML = this.attempts_paragraphs_model.service_under_order; }else{this.service_under_order_HTML = this.transform2(this.attempts_paragraphs_model.service_under_order_HTML);}


 // Do checks for subject name / Businesss Name of FUll SUbject Name fields
 let var_subject_name =  this.attempts_paragraphs_model.first_name + ' ' +  this.attempts_paragraphs_model.middlename + ' '+  this.attempts_paragraphs_model.surname;
 let var_subject_name_4_doc = this.attempts_paragraphs_model.first_name +'-'+  this.attempts_paragraphs_model.surname;
 let var_subject_business_name =  this.attempts_paragraphs_model.business_name;
 
 // Subject Name of Business
     if(var_subject_business_name != null){
         let var_trim_subject_business_name = var_subject_business_name.replaceAll(' ', ''); // need javscipt version of trim (all spaces removed)
         // $subject_name = $trim_subject_business_name;
          var_subject_name = var_subject_business_name; // changed here feb 2023 as subject busines name was printing stripped as variable in affidavid // Not trimmed
           var_subject_name_4_doc= var_trim_subject_business_name;
         
     }



if(this.attempts_paragraphs_model.service_paragraph_rendered == null){
  this.set_service_paragraph_rendered = '';
 }else{
  this.set_service_paragraph_rendered = this.attempts_paragraphs_model.service_paragraph_rendered; // does not require encodeing
}

// Property Images
if(this.attempts_paragraphs_model.property_images != '[]' || this.attempts_paragraphs_model.property_images != null){
  this.property_images = JSON.parse(this.attempts_paragraphs_model.property_images)



  let newArr = this.property_images;
  let  count_of_items = Object.keys(newArr).length;

  // let  count_of_items = 25;
  //   let  count_of_items = Object.keys(newArr).length;
  // //     for(let i=0;i < count_of_items; i++) { 
  // //     let res = newArr[i];
  // // }
 
  if(count_of_items >= 1){this.propery_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[0].file_server_location +  '/' + this.property_images[0].file_name + '"></img>'}else{this.propery_image_0=''}
  if(count_of_items >= 2){this.propery_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[1].file_server_location +  '/' + this.property_images[1].file_name + '"></img>'}else{this.propery_image_1=''}
  if(count_of_items >= 3){this.propery_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[2].file_server_location +  '/' + this.property_images[2].file_name + '"></img>'}else{this.propery_image_2=''}
  if(count_of_items >= 4){this.propery_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[3].file_server_location +  '/' + this.property_images[3].file_name + '"></img>'}else{this.propery_image_3=''}
  if(count_of_items >= 5){this.propery_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[4].file_server_location +  '/' + this.property_images[4].file_name + '"></img>'}else{this.propery_image_4=''}
  if(count_of_items >= 6){this.propery_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[5].file_server_location +  '/' + this.property_images[5].file_name + '"></img>'}else{this.propery_image_5=''}
  if(count_of_items >= 7){this.propery_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[6].file_server_location +  '/' + this.property_images[6].file_name + '"></img>'}else{this.propery_image_6=''}
  if(count_of_items >= 8){this.propery_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[7].file_server_location +  '/' + this.property_images[7].file_name + '"></img>'}else{this.propery_image_7=''}
  if(count_of_items >= 9){this.propery_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[8].file_server_location +  '/' + this.property_images[8].file_name + '"></img>'}else{this.propery_image_8=''}
  if(count_of_items >= 10){this.propery_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[9].file_server_location +  '/' + this.property_images[9].file_name + '"></img>'}else{this.propery_image_9=''}
  if(count_of_items >= 11){this.propery_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[10].file_server_location +  '/' + this.property_images[10].file_name + '"></img>'}else{this.propery_image_10=''}
  if(count_of_items >= 11){this.propery_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[11].file_server_location +  '/' + this.property_images[11].file_name + '"></img>'}else{this.propery_image_11=''}
  if(count_of_items >= 11){this.propery_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[12].file_server_location +  '/' + this.property_images[12].file_name + '"></img>'}else{this.propery_image_12=''}
  if(count_of_items >= 11){this.propery_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[13].file_server_location +  '/' + this.property_images[13].file_name + '"></img>'}else{this.propery_image_13=''}
  if(count_of_items >= 11){this.propery_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[14].file_server_location +  '/' + this.property_images[14].file_name + '"></img>'}else{this.propery_image_14=''}
  if(count_of_items >= 11){this.propery_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[15].file_server_location +  '/' + this.property_images[15].file_name + '"></img>'}else{this.propery_image_15=''}
  if(count_of_items >= 11){this.propery_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[16].file_server_location +  '/' + this.property_images[16].file_name + '"></img>'}else{this.propery_image_16=''}
  if(count_of_items >= 11){this.propery_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[17].file_server_location +  '/' + this.property_images[17].file_name + '"></img>'}else{this.propery_image_17=''}
  if(count_of_items >= 11){this.propery_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[18].file_server_location +  '/' + this.property_images[18].file_name + '"></img>'}else{this.propery_image_18=''}
  if(count_of_items >= 11){this.propery_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[19].file_server_location +  '/' + this.property_images[19].file_name + '"></img>'}else{this.propery_image_19=''}
  if(count_of_items >= 11){this.propery_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[20].file_server_location +  '/' + this.property_images[20].file_name + '"></img>'}else{this.propery_image_20=''}
  if(count_of_items >= 11){this.propery_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[21].file_server_location +  '/' + this.property_images[21].file_name + '"></img>'}else{this.propery_image_21=''}
  if(count_of_items >= 11){this.propery_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[22].file_server_location +  '/' + this.property_images[22].file_name + '"></img>'}else{this.propery_image_22=''}
  if(count_of_items >= 11){this.propery_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[23].file_server_location +  '/' + this.property_images[23].file_name + '"></img>'}else{this.propery_image_23=''}
  if(count_of_items >= 11){this.propery_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[24].file_server_location +  '/' + this.property_images[24].file_name + '"></img>'}else{this.propery_image_24=''}
  if(count_of_items >= 11){this.propery_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[25].file_server_location +  '/' + this.property_images[25].file_name + '"></img>'}else{this.propery_image_25=''}
   


  

  // Loop function to set the images set the ones that exist and then set nulls to the ones that dont. -- similar to the php function in the doucment imaee replacement function 
  // loop 0 - 25 and only set if exisis or '' if not.


}

if(this.attempts_paragraphs_model.property_sign_images != '[]' && this.attempts_paragraphs_model.property_sign_images != null){
  this.property_sign_images = JSON.parse(this.attempts_paragraphs_model.property_sign_images)
  let newArr = this.property_sign_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_sign_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[0].file_server_location +  '/' + this.property_sign_images[0].file_name + '"></img>'}else{this.property_sign_image_0=''}
  if(count_of_items >= 2){this.property_sign_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[1].file_server_location +  '/' + this.property_sign_images[1].file_name + '"></img>'}else{this.property_sign_image_1=''}
  if(count_of_items >= 3){this.property_sign_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[2].file_server_location +  '/' + this.property_sign_images[2].file_name + '"></img>'}else{this.property_sign_image_2=''}
  if(count_of_items >= 4){this.property_sign_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[3].file_server_location +  '/' + this.property_sign_images[3].file_name + '"></img>'}else{this.property_sign_image_3=''}
  if(count_of_items >= 5){this.property_sign_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[4].file_server_location +  '/' + this.property_sign_images[4].file_name + '"></img>'}else{this.property_sign_image_4=''}
  if(count_of_items >= 6){this.property_sign_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[5].file_server_location +  '/' + this.property_sign_images[5].file_name + '"></img>'}else{this.property_sign_image_5=''}
  if(count_of_items >= 7){this.property_sign_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[6].file_server_location +  '/' + this.property_sign_images[6].file_name + '"></img>'}else{this.property_sign_image_6=''}
  if(count_of_items >= 8){this.property_sign_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[7].file_server_location +  '/' + this.property_sign_images[7].file_name + '"></img>'}else{this.property_sign_image_7=''}
  if(count_of_items >= 9){this.property_sign_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[8].file_server_location +  '/' + this.property_sign_images[8].file_name + '"></img>'}else{this.property_sign_image_8=''}
  if(count_of_items >= 10){this.property_sign_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[9].file_server_location +  '/' + this.property_sign_images[9].file_name + '"></img>'}else{this.property_sign_image_9=''}
  if(count_of_items >= 11){this.property_sign_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[10].file_server_location +  '/' + this.property_sign_images[10].file_name + '"></img>'}else{this.property_sign_image_10=''}
  if(count_of_items >= 11){this.property_sign_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[11].file_server_location +  '/' + this.property_sign_images[11].file_name + '"></img>'}else{this.property_sign_image_11=''}
  if(count_of_items >= 11){this.property_sign_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[12].file_server_location +  '/' + this.property_sign_images[12].file_name + '"></img>'}else{this.property_sign_image_12=''}
  if(count_of_items >= 11){this.property_sign_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[13].file_server_location +  '/' + this.property_sign_images[13].file_name + '"></img>'}else{this.property_sign_image_13=''}
  if(count_of_items >= 11){this.property_sign_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[14].file_server_location +  '/' + this.property_sign_images[14].file_name + '"></img>'}else{this.property_sign_image_14=''}
  if(count_of_items >= 11){this.property_sign_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[15].file_server_location +  '/' + this.property_sign_images[15].file_name + '"></img>'}else{this.property_sign_image_15=''}
  if(count_of_items >= 11){this.property_sign_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[16].file_server_location +  '/' + this.property_sign_images[16].file_name + '"></img>'}else{this.property_sign_image_16=''}
  if(count_of_items >= 11){this.property_sign_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[17].file_server_location +  '/' + this.property_sign_images[17].file_name + '"></img>'}else{this.property_sign_image_17=''}
  if(count_of_items >= 11){this.property_sign_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[18].file_server_location +  '/' + this.property_sign_images[18].file_name + '"></img>'}else{this.property_sign_image_18=''}
  if(count_of_items >= 11){this.property_sign_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[19].file_server_location +  '/' + this.property_sign_images[19].file_name + '"></img>'}else{this.property_sign_image_19=''}
  if(count_of_items >= 11){this.property_sign_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[20].file_server_location +  '/' + this.property_sign_images[20].file_name + '"></img>'}else{this.property_sign_image_20=''}
  if(count_of_items >= 11){this.property_sign_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[21].file_server_location +  '/' + this.property_sign_images[21].file_name + '"></img>'}else{this.property_sign_image_21=''}
  if(count_of_items >= 11){this.property_sign_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[22].file_server_location +  '/' + this.property_sign_images[22].file_name + '"></img>'}else{this.property_sign_image_22=''}
  if(count_of_items >= 11){this.property_sign_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[23].file_server_location +  '/' + this.property_sign_images[23].file_name + '"></img>'}else{this.property_sign_image_23=''}
  if(count_of_items >= 11){this.property_sign_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[24].file_server_location +  '/' + this.property_sign_images[24].file_name + '"></img>'}else{this.property_sign_image_24=''}
  if(count_of_items >= 11){this.property_sign_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[25].file_server_location +  '/' + this.property_sign_images[25].file_name + '"></img>'}else{this.property_sign_image_25=''}
}
  
if(this.attempts_paragraphs_model.property_mail_images != '[]' && this.attempts_paragraphs_model.property_mail_images != null ){
  this.property_mail_images = JSON.parse(this.attempts_paragraphs_model.property_mail_images)
  let newArr = this.property_mail_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_mail_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[0].file_server_location +  '/' + this.property_mail_images[0].file_name + '"></img>'}else{this.property_mail_image_0=''}
  if(count_of_items >= 2){this.property_mail_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[1].file_server_location +  '/' + this.property_mail_images[1].file_name + '"></img>'}else{this.property_mail_image_1=''}
  if(count_of_items >= 3){this.property_mail_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[2].file_server_location +  '/' + this.property_mail_images[2].file_name + '"></img>'}else{this.property_mail_image_2=''}
  if(count_of_items >= 4){this.property_mail_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[3].file_server_location +  '/' + this.property_mail_images[3].file_name + '"></img>'}else{this.property_mail_image_3=''}
  if(count_of_items >= 5){this.property_mail_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[4].file_server_location +  '/' + this.property_mail_images[4].file_name + '"></img>'}else{this.property_mail_image_4=''}
  if(count_of_items >= 6){this.property_mail_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[5].file_server_location +  '/' + this.property_mail_images[5].file_name + '"></img>'}else{this.property_mail_image_5=''}
  if(count_of_items >= 7){this.property_mail_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[6].file_server_location +  '/' + this.property_mail_images[6].file_name + '"></img>'}else{this.property_mail_image_6=''}
  if(count_of_items >= 8){this.property_mail_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[7].file_server_location +  '/' + this.property_mail_images[7].file_name + '"></img>'}else{this.property_mail_image_7=''}
  if(count_of_items >= 9){this.property_mail_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[8].file_server_location +  '/' + this.property_mail_images[8].file_name + '"></img>'}else{this.property_mail_image_8=''}
  if(count_of_items >= 10){this.property_mail_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[9].file_server_location +  '/' + this.property_mail_images[9].file_name + '"></img>'}else{this.property_mail_image_9=''}
  if(count_of_items >= 11){this.property_mail_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[10].file_server_location +  '/' + this.property_mail_images[10].file_name + '"></img>'}else{this.property_mail_image_10=''}
  if(count_of_items >= 11){this.property_mail_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[11].file_server_location +  '/' + this.property_mail_images[11].file_name + '"></img>'}else{this.property_mail_image_11=''}
  if(count_of_items >= 11){this.property_mail_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[12].file_server_location +  '/' + this.property_mail_images[12].file_name + '"></img>'}else{this.property_mail_image_12=''}
  if(count_of_items >= 11){this.property_mail_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[13].file_server_location +  '/' + this.property_mail_images[13].file_name + '"></img>'}else{this.property_mail_image_13=''}
  if(count_of_items >= 11){this.property_mail_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[14].file_server_location +  '/' + this.property_mail_images[14].file_name + '"></img>'}else{this.property_mail_image_14=''}
  if(count_of_items >= 11){this.property_mail_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[15].file_server_location +  '/' + this.property_mail_images[15].file_name + '"></img>'}else{this.property_mail_image_15=''}
  if(count_of_items >= 11){this.property_mail_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[16].file_server_location +  '/' + this.property_mail_images[16].file_name + '"></img>'}else{this.property_mail_image_16=''}
  if(count_of_items >= 11){this.property_mail_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[17].file_server_location +  '/' + this.property_mail_images[17].file_name + '"></img>'}else{this.property_mail_image_17=''}
  if(count_of_items >= 11){this.property_mail_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[18].file_server_location +  '/' + this.property_mail_images[18].file_name + '"></img>'}else{this.property_mail_image_18=''}
  if(count_of_items >= 11){this.property_mail_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[19].file_server_location +  '/' + this.property_mail_images[19].file_name + '"></img>'}else{this.property_mail_image_19=''}
  if(count_of_items >= 11){this.property_mail_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[20].file_server_location +  '/' + this.property_mail_images[20].file_name + '"></img>'}else{this.property_mail_image_20=''}
  if(count_of_items >= 11){this.property_mail_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[21].file_server_location +  '/' + this.property_mail_images[21].file_name + '"></img>'}else{this.property_mail_image_21=''}
  if(count_of_items >= 11){this.property_mail_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[22].file_server_location +  '/' + this.property_mail_images[22].file_name + '"></img>'}else{this.property_mail_image_22=''}
  if(count_of_items >= 11){this.property_mail_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[23].file_server_location +  '/' + this.property_mail_images[23].file_name + '"></img>'}else{this.property_mail_image_23=''}
  if(count_of_items >= 11){this.property_mail_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[24].file_server_location +  '/' + this.property_mail_images[24].file_name + '"></img>'}else{this.property_mail_image_24=''}
  if(count_of_items >= 11){this.property_mail_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[25].file_server_location +  '/' + this.property_mail_images[25].file_name + '"></img>'}else{this.property_mail_image_25=''}
}
  
if(this.attempts_paragraphs_model.property_vehicles_images != '[]' && this.attempts_paragraphs_model.property_vehicles_images != null){
  this.property_vehicles_images = JSON.parse(this.attempts_paragraphs_model.property_vehicles_images)
  let newArr = this.property_vehicles_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_vehicles_image_0  = '<img src="' + this.gfunc.fileURL + '/' + this.property_vehicles_images[0].file_server_location +  '/' + this.property_vehicles_images[0].file_name + '"></img>'}else{this.property_vehicles_image_0=''}
  if(count_of_items >= 2){this.property_vehicles_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[1].file_server_location +  '/' + this.property_vehicles_images[1].file_name + '"></img>'}else{this.property_vehicles_image_1=''}
  if(count_of_items >= 3){this.property_vehicles_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[2].file_server_location +  '/' + this.property_vehicles_images[2].file_name + '"></img>'}else{this.property_vehicles_image_2=''}
  if(count_of_items >= 4){this.property_vehicles_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[3].file_server_location +  '/' + this.property_vehicles_images[3].file_name + '"></img>'}else{this.property_vehicles_image_3=''}
  if(count_of_items >= 5){this.property_vehicles_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[4].file_server_location +  '/' + this.property_vehicles_images[4].file_name + '"></img>'}else{this.property_vehicles_image_4=''}
  if(count_of_items >= 6){this.property_vehicles_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[5].file_server_location +  '/' + this.property_vehicles_images[5].file_name + '"></img>'}else{this.property_vehicles_image_5=''}
  if(count_of_items >= 7){this.property_vehicles_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[6].file_server_location +  '/' + this.property_vehicles_images[6].file_name + '"></img>'}else{this.property_vehicles_image_6=''}
  if(count_of_items >= 8){this.property_vehicles_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[7].file_server_location +  '/' + this.property_vehicles_images[7].file_name + '"></img>'}else{this.property_vehicles_image_7=''}
  if(count_of_items >= 9){this.property_vehicles_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[8].file_server_location +  '/' + this.property_vehicles_images[8].file_name + '"></img>'}else{this.property_vehicles_image_8=''}
  if(count_of_items >= 10){this.property_vehicles_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[9].file_server_location +  '/' + this.property_vehicles_images[9].file_name + '"></img>'}else{this.property_vehicles_image_9=''}
  if(count_of_items >= 11){this.property_vehicles_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[10].file_server_location +  '/' + this.property_vehicles_images[10].file_name + '"></img>'}else{this.property_vehicles_image_10=''}
  if(count_of_items >= 11){this.property_vehicles_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[11].file_server_location +  '/' + this.property_vehicles_images[11].file_name + '"></img>'}else{this.property_vehicles_image_11=''}
  if(count_of_items >= 11){this.property_vehicles_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[12].file_server_location +  '/' + this.property_vehicles_images[12].file_name + '"></img>'}else{this.property_vehicles_image_12=''}
  if(count_of_items >= 11){this.property_vehicles_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[13].file_server_location +  '/' + this.property_vehicles_images[13].file_name + '"></img>'}else{this.property_vehicles_image_13=''}
  if(count_of_items >= 11){this.property_vehicles_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[14].file_server_location +  '/' + this.property_vehicles_images[14].file_name + '"></img>'}else{this.property_vehicles_image_14=''}
  if(count_of_items >= 11){this.property_vehicles_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[15].file_server_location +  '/' + this.property_vehicles_images[15].file_name + '"></img>'}else{this.property_vehicles_image_15=''}
  if(count_of_items >= 11){this.property_vehicles_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[16].file_server_location +  '/' + this.property_vehicles_images[16].file_name + '"></img>'}else{this.property_vehicles_image_16=''}
  if(count_of_items >= 11){this.property_vehicles_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[17].file_server_location +  '/' + this.property_vehicles_images[17].file_name + '"></img>'}else{this.property_vehicles_image_17=''}
  if(count_of_items >= 11){this.property_vehicles_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[18].file_server_location +  '/' + this.property_vehicles_images[18].file_name + '"></img>'}else{this.property_vehicles_image_18=''}
  if(count_of_items >= 11){this.property_vehicles_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[19].file_server_location +  '/' + this.property_vehicles_images[19].file_name + '"></img>'}else{this.property_vehicles_image_19=''}
  if(count_of_items >= 11){this.property_vehicles_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[20].file_server_location +  '/' + this.property_vehicles_images[20].file_name + '"></img>'}else{this.property_vehicles_image_20=''}
  if(count_of_items >= 11){this.property_vehicles_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[21].file_server_location +  '/' + this.property_vehicles_images[21].file_name + '"></img>'}else{this.property_vehicles_image_21=''}
  if(count_of_items >= 11){this.property_vehicles_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[22].file_server_location +  '/' + this.property_vehicles_images[22].file_name + '"></img>'}else{this.property_vehicles_image_22=''}
  if(count_of_items >= 11){this.property_vehicles_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[23].file_server_location +  '/' + this.property_vehicles_images[23].file_name + '"></img>'}else{this.property_vehicles_image_23=''}
  if(count_of_items >= 11){this.property_vehicles_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[24].file_server_location +  '/' + this.property_vehicles_images[24].file_name + '"></img>'}else{this.property_vehicles_image_24=''}
  if(count_of_items >= 11){this.property_vehicles_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[25].file_server_location +  '/' + this.property_vehicles_images[25].file_name + '"></img>'}else{this.property_vehicles_image_25=''}
}


if(this.attempts_paragraphs_model.property_pets_images != '[]' && this.attempts_paragraphs_model.property_pets_images != null){
  this.property_pets_images = JSON.parse(this.attempts_paragraphs_model.property_pets_images)
  let newArr = this.property_pets_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_pets_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[0].file_server_location +  '/' + this.property_pets_images[0].file_name + '"></img>'}else{this.property_pets_image_0=''}
  if(count_of_items >= 2){this.property_pets_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[1].file_server_location +  '/' + this.property_pets_images[1].file_name + '"></img>'}else{this.property_pets_image_1=''}
  if(count_of_items >= 3){this.property_pets_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[2].file_server_location +  '/' + this.property_pets_images[2].file_name + '"></img>'}else{this.property_pets_image_2=''}
  if(count_of_items >= 4){this.property_pets_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[3].file_server_location +  '/' + this.property_pets_images[3].file_name + '"></img>'}else{this.property_pets_image_3=''}
  if(count_of_items >= 5){this.property_pets_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[4].file_server_location +  '/' + this.property_pets_images[4].file_name + '"></img>'}else{this.property_pets_image_4=''}
  if(count_of_items >= 6){this.property_pets_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[5].file_server_location +  '/' + this.property_pets_images[5].file_name + '"></img>'}else{this.property_pets_image_5=''}
  if(count_of_items >= 7){this.property_pets_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[6].file_server_location +  '/' + this.property_pets_images[6].file_name + '"></img>'}else{this.property_pets_image_6=''}
  if(count_of_items >= 8){this.property_pets_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[7].file_server_location +  '/' + this.property_pets_images[7].file_name + '"></img>'}else{this.property_pets_image_7=''}
  if(count_of_items >= 9){this.property_pets_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[8].file_server_location +  '/' + this.property_pets_images[8].file_name + '"></img>'}else{this.property_pets_image_8=''}
  if(count_of_items >= 10){this.property_pets_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[9].file_server_location +  '/' + this.property_pets_images[9].file_name + '"></img>'}else{this.property_pets_image_9=''}
  if(count_of_items >= 11){this.property_pets_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[10].file_server_location +  '/' + this.property_pets_images[10].file_name + '"></img>'}else{this.property_pets_image_10=''}
  if(count_of_items >= 11){this.property_pets_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[11].file_server_location +  '/' + this.property_pets_images[11].file_name + '"></img>'}else{this.property_pets_image_11=''}
  if(count_of_items >= 11){this.property_pets_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[12].file_server_location +  '/' + this.property_pets_images[12].file_name + '"></img>'}else{this.property_pets_image_12=''}
  if(count_of_items >= 11){this.property_pets_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[13].file_server_location +  '/' + this.property_pets_images[13].file_name + '"></img>'}else{this.property_pets_image_13=''}
  if(count_of_items >= 11){this.property_pets_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[14].file_server_location +  '/' + this.property_pets_images[14].file_name + '"></img>'}else{this.property_pets_image_14=''}
  if(count_of_items >= 11){this.property_pets_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[15].file_server_location +  '/' + this.property_pets_images[15].file_name + '"></img>'}else{this.property_pets_image_15=''}
  if(count_of_items >= 11){this.property_pets_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[16].file_server_location +  '/' + this.property_pets_images[16].file_name + '"></img>'}else{this.property_pets_image_16=''}
  if(count_of_items >= 11){this.property_pets_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[17].file_server_location +  '/' + this.property_pets_images[17].file_name + '"></img>'}else{this.property_pets_image_17=''}
  if(count_of_items >= 11){this.property_pets_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[18].file_server_location +  '/' + this.property_pets_images[18].file_name + '"></img>'}else{this.property_pets_image_18=''}
  if(count_of_items >= 11){this.property_pets_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[19].file_server_location +  '/' + this.property_pets_images[19].file_name + '"></img>'}else{this.property_pets_image_19=''}
  if(count_of_items >= 11){this.property_pets_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[20].file_server_location +  '/' + this.property_pets_images[20].file_name + '"></img>'}else{this.property_pets_image_20=''}
  if(count_of_items >= 11){this.property_pets_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[21].file_server_location +  '/' + this.property_pets_images[21].file_name + '"></img>'}else{this.property_pets_image_21=''}
  if(count_of_items >= 11){this.property_pets_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[22].file_server_location +  '/' + this.property_pets_images[22].file_name + '"></img>'}else{this.property_pets_image_22=''}
  if(count_of_items >= 11){this.property_pets_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[23].file_server_location +  '/' + this.property_pets_images[23].file_name + '"></img>'}else{this.property_pets_image_23=''}
  if(count_of_items >= 11){this.property_pets_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[24].file_server_location +  '/' + this.property_pets_images[24].file_name + '"></img>'}else{this.property_pets_image_24=''}
  if(count_of_items >= 11){this.property_pets_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[25].file_server_location +  '/' + this.property_pets_images[25].file_name + '"></img>'}else{this.property_pets_image_25=''}
}


if(this.attempts_paragraphs_model.property_occupancy_images != '[]' && this.attempts_paragraphs_model.property_occupancy_images != null){
  this.property_occupancy_images = JSON.parse(this.attempts_paragraphs_model.property_occupancy_images)
  let newArr = this.property_occupancy_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_occupancy_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[0].file_server_location +  '/' + this.property_occupancy_images[0].file_name + '"></img>'}else{this.property_occupancy_image_0=''}
  if(count_of_items >= 2){this.property_occupancy_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[1].file_server_location +  '/' + this.property_occupancy_images[1].file_name + '"></img>'}else{this.property_occupancy_image_1=''}
  if(count_of_items >= 3){this.property_occupancy_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[2].file_server_location +  '/' + this.property_occupancy_images[2].file_name + '"></img>'}else{this.property_occupancy_image_2=''}
  if(count_of_items >= 4){this.property_occupancy_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[3].file_server_location +  '/' + this.property_occupancy_images[3].file_name + '"></img>'}else{this.property_occupancy_image_3=''}
  if(count_of_items >= 5){this.property_occupancy_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[4].file_server_location +  '/' + this.property_occupancy_images[4].file_name + '"></img>'}else{this.property_occupancy_image_4=''}
  if(count_of_items >= 6){this.property_occupancy_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[5].file_server_location +  '/' + this.property_occupancy_images[5].file_name + '"></img>'}else{this.property_occupancy_image_5=''}
  if(count_of_items >= 7){this.property_occupancy_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[6].file_server_location +  '/' + this.property_occupancy_images[6].file_name + '"></img>'}else{this.property_occupancy_image_6=''}
  if(count_of_items >= 8){this.property_occupancy_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[7].file_server_location +  '/' + this.property_occupancy_images[7].file_name + '"></img>'}else{this.property_occupancy_image_7=''}
  if(count_of_items >= 9){this.property_occupancy_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[8].file_server_location +  '/' + this.property_occupancy_images[8].file_name + '"></img>'}else{this.property_occupancy_image_8=''}
  if(count_of_items >= 10){this.property_occupancy_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[9].file_server_location +  '/' + this.property_occupancy_images[9].file_name + '"></img>'}else{this.property_occupancy_image_9=''}
  if(count_of_items >= 11){this.property_occupancy_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[10].file_server_location +  '/' + this.property_occupancy_images[10].file_name + '"></img>'}else{this.property_occupancy_image_10=''}
  if(count_of_items >= 11){this.property_occupancy_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[11].file_server_location +  '/' + this.property_occupancy_images[11].file_name + '"></img>'}else{this.property_occupancy_image_11=''}
  if(count_of_items >= 11){this.property_occupancy_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[12].file_server_location +  '/' + this.property_occupancy_images[12].file_name + '"></img>'}else{this.property_occupancy_image_12=''}
  if(count_of_items >= 11){this.property_occupancy_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[13].file_server_location +  '/' + this.property_occupancy_images[13].file_name + '"></img>'}else{this.property_occupancy_image_13=''}
  if(count_of_items >= 11){this.property_occupancy_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[14].file_server_location +  '/' + this.property_occupancy_images[14].file_name + '"></img>'}else{this.property_occupancy_image_14=''}
  if(count_of_items >= 11){this.property_occupancy_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[15].file_server_location +  '/' + this.property_occupancy_images[15].file_name + '"></img>'}else{this.property_occupancy_image_15=''}
  if(count_of_items >= 11){this.property_occupancy_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[16].file_server_location +  '/' + this.property_occupancy_images[16].file_name + '"></img>'}else{this.property_occupancy_image_16=''}
  if(count_of_items >= 11){this.property_occupancy_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[17].file_server_location +  '/' + this.property_occupancy_images[17].file_name + '"></img>'}else{this.property_occupancy_image_17=''}
  if(count_of_items >= 11){this.property_occupancy_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[18].file_server_location +  '/' + this.property_occupancy_images[18].file_name + '"></img>'}else{this.property_occupancy_image_18=''}
  if(count_of_items >= 11){this.property_occupancy_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[19].file_server_location +  '/' + this.property_occupancy_images[19].file_name + '"></img>'}else{this.property_occupancy_image_19=''}
  if(count_of_items >= 11){this.property_occupancy_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[20].file_server_location +  '/' + this.property_occupancy_images[20].file_name + '"></img>'}else{this.property_occupancy_image_20=''}
  if(count_of_items >= 11){this.property_occupancy_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[21].file_server_location +  '/' + this.property_occupancy_images[21].file_name + '"></img>'}else{this.property_occupancy_image_21=''}
  if(count_of_items >= 11){this.property_occupancy_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[22].file_server_location +  '/' + this.property_occupancy_images[22].file_name + '"></img>'}else{this.property_occupancy_image_22=''}
  if(count_of_items >= 11){this.property_occupancy_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[23].file_server_location +  '/' + this.property_occupancy_images[23].file_name + '"></img>'}else{this.property_occupancy_image_23=''}
  if(count_of_items >= 11){this.property_occupancy_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[24].file_server_location +  '/' + this.property_occupancy_images[24].file_name + '"></img>'}else{this.property_occupancy_image_24=''}
  if(count_of_items >= 11){this.property_occupancy_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[25].file_server_location +  '/' + this.property_occupancy_images[25].file_name + '"></img>'}else{this.property_occupancy_image_25=''}
}

if(this.attempts_paragraphs_model.property_condition_images != '[]' && this.attempts_paragraphs_model.property_condition_images != null ){
  this.property_condition_images = JSON.parse(this.attempts_paragraphs_model.property_condition_images)
  let newArr = this.property_condition_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_condition_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[0].file_server_location +  '/' + this.property_condition_images[0].file_name + '"></img>'}else{this.property_condition_image_0=''}
  if(count_of_items >= 2){this.property_condition_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[1].file_server_location +  '/' + this.property_condition_images[1].file_name + '"></img>'}else{this.property_condition_image_1=''}
  if(count_of_items >= 3){this.property_condition_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[2].file_server_location +  '/' + this.property_condition_images[2].file_name + '"></img>'}else{this.property_condition_image_2=''}
  if(count_of_items >= 4){this.property_condition_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[3].file_server_location +  '/' + this.property_condition_images[3].file_name + '"></img>'}else{this.property_condition_image_3=''}
  if(count_of_items >= 5){this.property_condition_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[4].file_server_location +  '/' + this.property_condition_images[4].file_name + '"></img>'}else{this.property_condition_image_4=''}
  if(count_of_items >= 6){this.property_condition_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[5].file_server_location +  '/' + this.property_condition_images[5].file_name + '"></img>'}else{this.property_condition_image_5=''}
  if(count_of_items >= 7){this.property_condition_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[6].file_server_location +  '/' + this.property_condition_images[6].file_name + '"></img>'}else{this.property_condition_image_6=''}
  if(count_of_items >= 8){this.property_condition_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[7].file_server_location +  '/' + this.property_condition_images[7].file_name + '"></img>'}else{this.property_condition_image_7=''}
  if(count_of_items >= 9){this.property_condition_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[8].file_server_location +  '/' + this.property_condition_images[8].file_name + '"></img>'}else{this.property_condition_image_8=''}
  if(count_of_items >= 10){this.property_condition_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[9].file_server_location +  '/' + this.property_condition_images[9].file_name + '"></img>'}else{this.property_condition_image_9=''}
  if(count_of_items >= 11){this.property_condition_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[10].file_server_location +  '/' + this.property_condition_images[10].file_name + '"></img>'}else{this.property_condition_image_10=''}
  if(count_of_items >= 11){this.property_condition_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[11].file_server_location +  '/' + this.property_condition_images[11].file_name + '"></img>'}else{this.property_condition_image_11=''}
  if(count_of_items >= 11){this.property_condition_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[12].file_server_location +  '/' + this.property_condition_images[12].file_name + '"></img>'}else{this.property_condition_image_12=''}
  if(count_of_items >= 11){this.property_condition_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[13].file_server_location +  '/' + this.property_condition_images[13].file_name + '"></img>'}else{this.property_condition_image_13=''}
  if(count_of_items >= 11){this.property_condition_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[14].file_server_location +  '/' + this.property_condition_images[14].file_name + '"></img>'}else{this.property_condition_image_14=''}
  if(count_of_items >= 11){this.property_condition_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[15].file_server_location +  '/' + this.property_condition_images[15].file_name + '"></img>'}else{this.property_condition_image_15=''}
  if(count_of_items >= 11){this.property_condition_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[16].file_server_location +  '/' + this.property_condition_images[16].file_name + '"></img>'}else{this.property_condition_image_16=''}
  if(count_of_items >= 11){this.property_condition_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[17].file_server_location +  '/' + this.property_condition_images[17].file_name + '"></img>'}else{this.property_condition_image_17=''}
  if(count_of_items >= 11){this.property_condition_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[18].file_server_location +  '/' + this.property_condition_images[18].file_name + '"></img>'}else{this.property_condition_image_18=''}
  if(count_of_items >= 11){this.property_condition_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[19].file_server_location +  '/' + this.property_condition_images[19].file_name + '"></img>'}else{this.property_condition_image_19=''}
  if(count_of_items >= 11){this.property_condition_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[20].file_server_location +  '/' + this.property_condition_images[20].file_name + '"></img>'}else{this.property_condition_image_20=''}
  if(count_of_items >= 11){this.property_condition_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[21].file_server_location +  '/' + this.property_condition_images[21].file_name + '"></img>'}else{this.property_condition_image_21=''}
  if(count_of_items >= 11){this.property_condition_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[22].file_server_location +  '/' + this.property_condition_images[22].file_name + '"></img>'}else{this.property_condition_image_22=''}
  if(count_of_items >= 11){this.property_condition_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[23].file_server_location +  '/' + this.property_condition_images[23].file_name + '"></img>'}else{this.property_condition_image_23=''}
  if(count_of_items >= 11){this.property_condition_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[24].file_server_location +  '/' + this.property_condition_images[24].file_name + '"></img>'}else{this.property_condition_image_24=''}
  if(count_of_items >= 11){this.property_condition_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[25].file_server_location +  '/' + this.property_condition_images[25].file_name + '"></img>'}else{this.property_condition_image_25=''}
}


if(this.attempts_paragraphs_model.property_type_images != '[]' && this.attempts_paragraphs_model.property_type_images != null){
  this.property_type_images = JSON.parse(this.attempts_paragraphs_model.property_type_images)
  let newArr = this.property_type_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_type_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[0].file_server_location +  '/' + this.property_type_images[0].file_name + '"></img>'}else{this.property_type_image_0=''}
  if(count_of_items >= 2){this.property_type_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[1].file_server_location +  '/' + this.property_type_images[1].file_name + '"></img>'}else{this.property_type_image_1=''}
  if(count_of_items >= 3){this.property_type_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[2].file_server_location +  '/' + this.property_type_images[2].file_name + '"></img>'}else{this.property_type_image_2=''}
  if(count_of_items >= 4){this.property_type_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[3].file_server_location +  '/' + this.property_type_images[3].file_name + '"></img>'}else{this.property_type_image_3=''}
  if(count_of_items >= 5){this.property_type_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[4].file_server_location +  '/' + this.property_type_images[4].file_name + '"></img>'}else{this.property_type_image_4=''}
  if(count_of_items >= 6){this.property_type_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[5].file_server_location +  '/' + this.property_type_images[5].file_name + '"></img>'}else{this.property_type_image_5=''}
  if(count_of_items >= 7){this.property_type_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[6].file_server_location +  '/' + this.property_type_images[6].file_name + '"></img>'}else{this.property_type_image_6=''}
  if(count_of_items >= 8){this.property_type_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[7].file_server_location +  '/' + this.property_type_images[7].file_name + '"></img>'}else{this.property_type_image_7=''}
  if(count_of_items >= 9){this.property_type_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[8].file_server_location +  '/' + this.property_type_images[8].file_name + '"></img>'}else{this.property_type_image_8=''}
  if(count_of_items >= 10){this.property_type_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[9].file_server_location +  '/' + this.property_type_images[9].file_name + '"></img>'}else{this.property_type_image_9=''}
  if(count_of_items >= 11){this.property_type_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[10].file_server_location +  '/' + this.property_type_images[10].file_name + '"></img>'}else{this.property_type_image_10=''}
  if(count_of_items >= 11){this.property_type_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[11].file_server_location +  '/' + this.property_type_images[11].file_name + '"></img>'}else{this.property_type_image_11=''}
  if(count_of_items >= 11){this.property_type_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[12].file_server_location +  '/' + this.property_type_images[12].file_name + '"></img>'}else{this.property_type_image_12=''}
  if(count_of_items >= 11){this.property_type_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[13].file_server_location +  '/' + this.property_type_images[13].file_name + '"></img>'}else{this.property_type_image_13=''}
  if(count_of_items >= 11){this.property_type_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[14].file_server_location +  '/' + this.property_type_images[14].file_name + '"></img>'}else{this.property_type_image_14=''}
  if(count_of_items >= 11){this.property_type_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[15].file_server_location +  '/' + this.property_type_images[15].file_name + '"></img>'}else{this.property_type_image_15=''}
  if(count_of_items >= 11){this.property_type_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[16].file_server_location +  '/' + this.property_type_images[16].file_name + '"></img>'}else{this.property_type_image_16=''}
  if(count_of_items >= 11){this.property_type_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[17].file_server_location +  '/' + this.property_type_images[17].file_name + '"></img>'}else{this.property_type_image_17=''}
  if(count_of_items >= 11){this.property_type_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[18].file_server_location +  '/' + this.property_type_images[18].file_name + '"></img>'}else{this.property_type_image_18=''}
  if(count_of_items >= 11){this.property_type_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[19].file_server_location +  '/' + this.property_type_images[19].file_name + '"></img>'}else{this.property_type_image_19=''}
  if(count_of_items >= 11){this.property_type_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[20].file_server_location +  '/' + this.property_type_images[20].file_name + '"></img>'}else{this.property_type_image_20=''}
  if(count_of_items >= 11){this.property_type_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[21].file_server_location +  '/' + this.property_type_images[21].file_name + '"></img>'}else{this.property_type_image_21=''}
  if(count_of_items >= 11){this.property_type_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[22].file_server_location +  '/' + this.property_type_images[22].file_name + '"></img>'}else{this.property_type_image_22=''}
  if(count_of_items >= 11){this.property_type_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[23].file_server_location +  '/' + this.property_type_images[23].file_name + '"></img>'}else{this.property_type_image_23=''}
  if(count_of_items >= 11){this.property_type_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[24].file_server_location +  '/' + this.property_type_images[24].file_name + '"></img>'}else{this.property_type_image_24=''}
  if(count_of_items >= 11){this.property_type_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[25].file_server_location +  '/' + this.property_type_images[25].file_name + '"></img>'}else{this.property_type_image_25=''}
}




if(this.attempts_paragraphs_model.service_file_array != '[]' && this.attempts_paragraphs_model.service_file_array != null){
  this.service_file_array_images = JSON.parse(this.attempts_paragraphs_model.service_file_array)
  let newArr = this.service_file_array_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.service_file_array_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[0].file_server_location +  '/' + this.service_file_array_images[0].file_name + '"></img>'}else{this.service_file_array_image_0=''}
  if(count_of_items >= 2){this.service_file_array_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[1].file_server_location +  '/' + this.service_file_array_images[1].file_name + '"></img>'}else{this.service_file_array_image_1=''}
  if(count_of_items >= 3){this.service_file_array_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[2].file_server_location +  '/' + this.service_file_array_images[2].file_name + '"></img>'}else{this.service_file_array_image_2=''}
  if(count_of_items >= 4){this.service_file_array_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[3].file_server_location +  '/' + this.service_file_array_images[3].file_name + '"></img>'}else{this.service_file_array_image_3=''}
  if(count_of_items >= 5){this.service_file_array_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[4].file_server_location +  '/' + this.service_file_array_images[4].file_name + '"></img>'}else{this.service_file_array_image_4=''}
  if(count_of_items >= 6){this.service_file_array_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[5].file_server_location +  '/' + this.service_file_array_images[5].file_name + '"></img>'}else{this.service_file_array_image_5=''}
  if(count_of_items >= 7){this.service_file_array_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[6].file_server_location +  '/' + this.service_file_array_images[6].file_name + '"></img>'}else{this.service_file_array_image_6=''}
  if(count_of_items >= 8){this.service_file_array_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[7].file_server_location +  '/' + this.service_file_array_images[7].file_name + '"></img>'}else{this.service_file_array_image_7=''}
  if(count_of_items >= 9){this.service_file_array_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[8].file_server_location +  '/' + this.service_file_array_images[8].file_name + '"></img>'}else{this.service_file_array_image_8=''}
  if(count_of_items >= 10){this.service_file_array_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[9].file_server_location +  '/' + this.service_file_array_images[9].file_name + '"></img>'}else{this.service_file_array_image_9=''}
  if(count_of_items >= 11){this.service_file_array_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[10].file_server_location +  '/' + this.service_file_array_images[10].file_name + '"></img>'}else{this.service_file_array_image_10=''}
  if(count_of_items >= 11){this.service_file_array_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[11].file_server_location +  '/' + this.service_file_array_images[11].file_name + '"></img>'}else{this.service_file_array_image_11=''}
  if(count_of_items >= 11){this.service_file_array_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[12].file_server_location +  '/' + this.service_file_array_images[12].file_name + '"></img>'}else{this.service_file_array_image_12=''}
  if(count_of_items >= 11){this.service_file_array_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[13].file_server_location +  '/' + this.service_file_array_images[13].file_name + '"></img>'}else{this.service_file_array_image_13=''}
  if(count_of_items >= 11){this.service_file_array_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[14].file_server_location +  '/' + this.service_file_array_images[14].file_name + '"></img>'}else{this.service_file_array_image_14=''}
  if(count_of_items >= 11){this.service_file_array_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[15].file_server_location +  '/' + this.service_file_array_images[15].file_name + '"></img>'}else{this.service_file_array_image_15=''}
  if(count_of_items >= 11){this.service_file_array_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[16].file_server_location +  '/' + this.service_file_array_images[16].file_name + '"></img>'}else{this.service_file_array_image_16=''}
  if(count_of_items >= 11){this.service_file_array_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[17].file_server_location +  '/' + this.service_file_array_images[17].file_name + '"></img>'}else{this.service_file_array_image_17=''}
  if(count_of_items >= 11){this.service_file_array_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[18].file_server_location +  '/' + this.service_file_array_images[18].file_name + '"></img>'}else{this.service_file_array_image_18=''}
  if(count_of_items >= 11){this.service_file_array_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[19].file_server_location +  '/' + this.service_file_array_images[19].file_name + '"></img>'}else{this.service_file_array_image_19=''}
  if(count_of_items >= 11){this.service_file_array_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[20].file_server_location +  '/' + this.service_file_array_images[20].file_name + '"></img>'}else{this.service_file_array_image_20=''}
  if(count_of_items >= 11){this.service_file_array_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[21].file_server_location +  '/' + this.service_file_array_images[21].file_name + '"></img>'}else{this.service_file_array_image_21=''}
  if(count_of_items >= 11){this.service_file_array_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[22].file_server_location +  '/' + this.service_file_array_images[22].file_name + '"></img>'}else{this.service_file_array_image_22=''}
  if(count_of_items >= 11){this.service_file_array_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[23].file_server_location +  '/' + this.service_file_array_images[23].file_name + '"></img>'}else{this.service_file_array_image_23=''}
  if(count_of_items >= 11){this.service_file_array_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[24].file_server_location +  '/' + this.service_file_array_images[24].file_name + '"></img>'}else{this.service_file_array_image_24=''}
  if(count_of_items >= 11){this.service_file_array_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[25].file_server_location +  '/' + this.service_file_array_images[25].file_name + '"></img>'}else{this.service_file_array_image_25=''}
}

  let rendered_result = str



      .replaceAll('${f_attempt_type_id}', this.attempts_paragraphs_model.subject_attempt_type_id)
      .replaceAll('${f_attempt_type_name}', this.attempts_paragraphs_model.subject_attempt_type_name ) // run a function with return;
      .replaceAll('${f_attempt_subject_attempt_type_name}', this.attempts_paragraphs_model.subject_attempt_type_name ) // run a function with return;
      .replaceAll('${f_attempt_type_name_upper}', this.var_subject_attempt_type_name_Upper) // all if statments set a this/g/ varaibales

      .replaceAll('${f_attempt_subject_service_method_id}', this.attempts_paragraphs_model.subject_service_method_id)
      .replaceAll('${f_attempt_subject_service_method_name}', this.attempts_paragraphs_model.subject_service_method_name ) // tested above.
      .replaceAll('${f_attempt_service_method}', this.attempts_paragraphs_model.subject_service_method_name ) // tested above.
      .replaceAll('${f_attempt_service_method_id}', this.attempts_paragraphs_model.subject_service_method_id) // tested above.


      .replaceAll('${f_attempt_date_service}', moment(this.attempts_paragraphs_model.date_service).format('D/M/YYYY'))
      .replaceAll('${f_attempt_date_service_full_words_time_first}', this.attempts_paragraphs_model.time_service_text + ' ' + moment(this.attempts_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') ) 
      .replaceAll('${f_attempt_date_service_and_time_full_words}', moment(this.attempts_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') + ' ' + this.attempts_paragraphs_model.time_service_text ) 
      .replaceAll('${f_attempt_date_service_full_words}', moment(this.attempts_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') + ' ' + model.time_service_text ) 

      .replaceAll('${f_attempt_day}', moment(this.attempts_paragraphs_model.date_service).format('dddd'))
      .replaceAll('${f_attempt_day_number}', moment(this.attempts_paragraphs_model.date_service).format('Do'))
      .replaceAll('${f_attempt_day_number_simple}', moment(this.attempts_paragraphs_model.date_service).format('D'))
      .replaceAll('${f_attempt_month}', moment(this.attempts_paragraphs_model.date_service).format('MMMM'))
      .replaceAll('${f_attempt_month_number}', moment(this.attempts_paragraphs_model.date_service).format('Mo'))
      .replaceAll('${f_attempt_month_number_simple}', moment(this.attempts_paragraphs_model.date_service).format('M'))
      .replaceAll('${f_attempt_year}', moment(this.attempts_paragraphs_model.date_service).format('YYYY'))

      .replaceAll('${f_attempt_service_local}', this.attempts_paragraphs_model.service_local) // region Australia/Perth of service undertaken
      .replaceAll('${f_attempt_time}', this.attempts_paragraphs_model.time_service_text) //$_set_service_time - Fixed and set time of attempt and service

      .replaceAll('${f_attempt_paragraph_rendered}',  this.set_service_paragraph_rendered) //$_set_service_time - Fixed and set time of attempt and service

      .replaceAll('${f_attempt_subject_name}', var_subject_name)
      .replaceAll('${f_attempt_subject_number}', this.attempts_paragraphs_model.subject_number)
      .replaceAll('${f_attempt_subject_name_4_doc}', var_subject_name_4_doc)
      .replaceAll('${f_attempt_subject_business_name}', var_subject_business_name)
      .replaceAll('${f_attempt_business_name}', var_subject_business_name)

  // Subject Attempt Address
  .replaceAll('${f_attempt_address_1}', this.attempts_paragraphs_model.address_1)
  .replaceAll('${f_attempt_address_2}', this.attempts_paragraphs_model.address_2)
  .replaceAll('${f_attempt_suburb}', this.attempts_paragraphs_model.suburb)
  .replaceAll('${f_attempt_state}', this.attempts_paragraphs_model.state)
  .replaceAll('${f_attempt_postcode}', this.attempts_paragraphs_model.postcode)
  .replaceAll('${f_attempt_address_full}', this.attempts_paragraphs_model.address_1 +  ' ' + this.attempts_paragraphs_model.address_2 +  ' ' + this.attempts_paragraphs_model.suburb +  ' ' + this.attempts_paragraphs_model.state +  ',  ' + this.attempts_paragraphs_model.postcode )
  // Sav
  .replaceAll('${f_attempt_sav_address_full}', this.attempts_paragraphs_model.address_1 +  ' ' + this.attempts_paragraphs_model.address_2 +  ' ' + this.attempts_paragraphs_model.suburb +  ' ' + this.attempts_paragraphs_model.state +  ',  ' + this.attempts_paragraphs_model.postcode )
  // New address
  .replaceAll('${f_attempt_new_business_name}', this.attempts_paragraphs_model.new_business_name)
  .replaceAll('${f_attempt_new_address_1}', this.attempts_paragraphs_model.new_address_1)
  .replaceAll('${f_attempt_new_address_2}', this.attempts_paragraphs_model.new_address_2)
  .replaceAll('${f_attempt_new_suburb}', this.attempts_paragraphs_model.new_suburb)
  .replaceAll('${f_attempt_new_state}', this.attempts_paragraphs_model.new_state)
  .replaceAll('${f_attempt_new_postcode}', this.attempts_paragraphs_model.new_postcode)
  .replaceAll('${f_attempt_new_address_full}', this.attempts_paragraphs_model.new_address_1 +  ' ' + this.attempts_paragraphs_model.new_address_2 +  ' ' + this.attempts_paragraphs_model.new_suburb +  ' ' + this.attempts_paragraphs_model.new_state +  ',  ' + this.attempts_paragraphs_model.new_postcode )
  
  .replaceAll('${f_attempt_service_number}', this.attempts_paragraphs_model.service_number)

  .replaceAll('${f_attempt_service_outcome_name}', this.attempts_paragraphs_model.subject_service_outcome_name)
  .replaceAll('${f_attempt_exact_service_method_name}', this.attempts_paragraphs_model.exact_service_method_name) //
  .replaceAll('${f_attempt_subject_type_name}', this.job_subject_type_name) // set in the job lookup.
  .replaceAll('${f_attempt_subject_type_name_upper}', this.job_subject_type_name_Upper) // set in the job lookup.
  .replaceAll('${f_attempt_location_status_name}', this.attempts_paragraphs_model.subject_location_status_name)
  .replaceAll('${f_attempt_location_status_found_name}', this.attempts_paragraphs_model.subject_location_status_found_name)

  .replaceAll('${f_attempt_fellow_occupants_name}', this.attempts_paragraphs_model.fellow_occupants_name)
  .replaceAll('${f_attempt_fellow_occupants_sex}', this.attempts_paragraphs_model.fellow_occupants_sex)
  .replaceAll('${f_attempt_fellow_occupants_name_label}', 'Fellow Occupants Name: ' +  this.attempts_paragraphs_model.fellow_occupants_name)
  .replaceAll('${f_attempt_subject_relationship_name}', this.attempts_paragraphs_model.subject_service_fellow_relationship)

  .replaceAll('${f_attempt_person_spoken_with}', this.attempts_paragraphs_model.person_spoken_with)
  .replaceAll('${f_attempt_person_type}', this.attempts_paragraphs_model.person_type)
  .replaceAll('${f_attempt_person_spoken_with_advised}',   this.person_spoken_with_advised_HTML ) 

  .replaceAll('${f_attempt_vehicles}', this.attempts_paragraphs_model.vehicles)
.replaceAll('${f_attempt_vehicles_notes}',   this.vehicles_notes_HTML ) // replace original only use this for create.

.replaceAll('${f_attempt_neighbours}', this.attempts_paragraphs_model.neighbours)
.replaceAll('${f_attempt_neighbours_notes}',   this.neighbours_notes_HTML ) // replace original only use this for create.

.replaceAll('${f_attempt_calling_card}', this.attempts_paragraphs_model.calling_card)
.replaceAll('${f_attempt_calling_card_notes}',   this.calling_card_notes_HTML ) // replace original only use this for create.

.replaceAll('${f_attempt_postal_mail}', this.attempts_paragraphs_model.postal_mail)
.replaceAll('${f_attempt_postal_mail_notes}',   this.postal_mail_notes_HTML ) // replace original only use this for create.

.replaceAll('${f_attempt_phone_call}', this.attempts_paragraphs_model.phone_call)
.replaceAll('${f_attempt_phone_call_notes}',   this.phone_call_notes_HTML ) // replace original only use this for create.

.replaceAll('${f_attempt_attempts}', this.attempts_paragraphs_model.attempts)
.replaceAll('${f_attempt_attempts_notes}',   this.attempts_notes_HTML ) // replace original only use this for create.

.replaceAll('${f_attempt_authorised_employee_name}', this.attempts_paragraphs_model.authorised_employee_name)
.replaceAll('${f_attempt_authorised_employee_job_title}', this.attempts_paragraphs_model.authorised_employee_job_title)
.replaceAll('${f_attempt_authorised_employee_sex}', this.attempts_paragraphs_model.authorised_employee_sex)
.replaceAll('${f_attempt_office_business_name}', this.attempts_paragraphs_model.office_business_name)

.replaceAll('${f_attempt_witness_name}', this.attempts_paragraphs_model.witness_name)
.replaceAll('${f_attempt_witness_business_name}', this.attempts_paragraphs_model.witness_business_name)
.replaceAll('${f_attempt_witness_address}', this.attempts_paragraphs_model.witness_address_1 + ' ' + this.attempts_paragraphs_model.witness_address_2 + ' ' +  this.attempts_paragraphs_model.witness_suburb + ' ' + this.attempts_paragraphs_model.witness_state + ', ' + this.attempts_paragraphs_model.witness_postcode  ) // 
.replaceAll('${f_attempt_witness_address_1}', this.attempts_paragraphs_model.witness_address_1)
.replaceAll('${f_attempt_witness_address_2}', this.attempts_paragraphs_model.witness_address_2)
.replaceAll('${f_attempt_witness_state}', this.attempts_paragraphs_model.witness_state)
.replaceAll('${f_attempt_witness_suburb}', this.attempts_paragraphs_model.witness_suburb)
.replaceAll('${f_attempt_witness_country}', this.attempts_paragraphs_model.witness_country)
.replaceAll('${f_attempt_witness_postcode}', this.attempts_paragraphs_model.witness_postcode)

.replaceAll('${f_attempt_person_in_charge_of_prison_name}', this.attempts_paragraphs_model.person_in_charge_of_prison_name)
.replaceAll('${f_attempt_person_in_charge_of_prison_occupation}', this.attempts_paragraphs_model.person_in_charge_of_prison_occupation)

.replaceAll('${f_attempt_ubject_contact_email_id}', this.attempts_paragraphs_model.subject_contact_email_id)
.replaceAll('${f_attempt_email_address_served}', this.attempts_paragraphs_model.email_address_served)
.replaceAll('${f_attempt_email_contents}', this.email_contents_HTML ) // replace original only use this for create.

.replaceAll('${f_attempt_director_name}', this.attempts_paragraphs_model.director_name)
// .replaceAll('${f_attempt_service_under_order}', this.attempts_paragraphs_model.service_under_order)
.replaceAll('${f_attempt_service_under_order}', this.service_under_order_HTML)

.replaceAll('${f_attempt_phone_number}', this.attempts_paragraphs_model.phone_number)



  // Agent Details
  .replaceAll('${f_attempt_agent_name}', this.subject_service_agent.first_name + ' ' + this.subject_service_agent.middle_name + ' ' + this.subject_service_agent.surname )
  .replaceAll('${f_attempt_agent_first_name}', this.subject_service_agent.first_name)
  .replaceAll('${f_attempt_agent_middle_name}', this.subject_service_agent.middle_name)
  .replaceAll('${f_attempt_agent_surname}', this.subject_service_agent.surname)
  
  .replaceAll('${f_attempt_agent_address_1}', this.subject_service_agent.address_1)
  .replaceAll('${f_attempt_agent_address_2}', this.subject_service_agent.address_2)
  .replaceAll('${f_attempt_agent_suburb}', this.subject_service_agent.suburb)
  .replaceAll('${f_attempt_agent_state}', this.subject_service_agent.state)
  .replaceAll('${f_attempt_agent_postcode}', this.subject_service_agent.postcode)
  .replaceAll('${f_attempt_agent_address_full}', this.subject_service_agent.address_1 + ' ' + this.subject_service_agent.address_2 + ' ' + this.subject_service_agent.suburb + ' ' + this.subject_service_agent.state + ', ' + this.subject_service_agent.postcode )
  .replaceAll('${f_attempt_agent_qualification}', this.subject_service_agent.qualification)
  .replaceAll('${f_attempt_agent_qualification_number}', this.subject_service_agent.qualification_number)
  
  .replaceAll('${f_attempt_agent_qualification_renewal_date}', moment(this.subject_service_agent.qualification_renewal_date).format('D/M/YYYY') )
  .replaceAll('${f_attempt_agent_qualification_renewal_date_full_words}', moment(this.subject_service_agent.qualification_renewal_date).format('dddd MMMM Do, YYYY h:mma') )

  .replaceAll('${f_attempt_general_notes}',  this.set_general_notes ) // replace original only use this for create.

  .replaceAll('${f_attempt_is_count}', this.attempts_paragraphs_model.is_count)
  .replaceAll('${f_attempt_property_images}', this.attempts_paragraphs_model.property_images)
  .replaceAll('${f_attempt_attach_file_array_name}', this.attempts_paragraphs_model.attach_file_array_name)
  .replaceAll('${f_attempt_property_occupied}', this.attempts_paragraphs_model.property_occupied)

  .replaceAll('${f_attempt_property_forsale_or_lease_sign}', this.attempts_paragraphs_model.property_forsale_or_lease_sign)
  .replaceAll('${f_attempt_property_sign_images}', this.attempts_paragraphs_model.property_sign_images)
.replaceAll('${f_attempt_property_forsale_or_lease_sign_details}',   this.property_forsale_or_lease_sign_details_HTML) // replace original only use this for create.
.replaceAll('${f_attempt_property_agent_name}', this.attempts_paragraphs_model.property_agent_name)
.replaceAll('${f_attempt_property_agency_name}', this.attempts_paragraphs_model.property_agency_name)
.replaceAll('${f_attempt_property_agency_contact_numbers}', this.attempts_paragraphs_model.property_agency_contact_numbers)


.replaceAll('${f_attempt_property_mail}', this.attempts_paragraphs_model.property_mail)
.replaceAll('${f_attempt_property_mail_images}', this.attempts_paragraphs_model.property_mail_images)
.replaceAll('${f_attempt_property_mail_details}', this.property_mail_details_HTML ) // replace original only use this for create.

.replaceAll('${f_attempt_property_vehicles_sighted}', this.attempts_paragraphs_model.property_vehicles_sighted)
.replaceAll('${f_attempt_property_vehicles_sighted_details}', this.property_vehicles_sighted_details_HTML ) // replace original only use this for create.
  .replaceAll('${f_attempt_property_vehicles_images}', this.attempts_paragraphs_model.property_vehicles_images)
  .replaceAll('${f_attempt_property_v_make}', this.attempts_paragraphs_model.property_v_make)
  .replaceAll('${f_attempt_property_v_model}', this.attempts_paragraphs_model.property_v_model)
  .replaceAll('${f_attempt_property_v_plate}', this.attempts_paragraphs_model.property_v_plate)
  .replaceAll('${f_attempt_property_v_rego_state}', this.attempts_paragraphs_model.property_v_rego_state)

  .replaceAll('${f_attempt_property_pets}', this.attempts_paragraphs_model.property_pets)
.replaceAll('${f_attempt_property_pets_details}', this.property_pets_details_HTML ) // replace original only use this for create.
  .replaceAll('${f_attempt_property_pets_images}', this.attempts_paragraphs_model.property_pets_images)

.replaceAll('${f_attempt_property_occupancy}', this.attempts_paragraphs_model.property_occupancy)
.replaceAll('${f_attempt_property_occupancy_details}', this.property_occupancy_details_HTML ) // replace original only use this for create.
.replaceAll('${f_attempt_property_occupancy_images}', this.attempts_paragraphs_model.property_occupancy_images)
.replaceAll('${f_attempt_property_o_name}', this.attempts_paragraphs_model.property_o_name)
.replaceAll('${f_attempt_property_o_contact_numbers}', this.attempts_paragraphs_model.property_o_contact_numbers)
.replaceAll('${f_attempt_property_o_lease_details}', this.attempts_paragraphs_model.property_o_lease_details)
.replaceAll('${f_attempt_property_o_lease_date}', this.attempts_paragraphs_model.property_o_lease_date)
.replaceAll('${f_attempt_property_o_landlord_contacts}', this.attempts_paragraphs_model.property_o_landlord_contacts)

.replaceAll('${f_attempt_property_condition}', this.property_condition_HTML ) // replace original only use this for create.
  .replaceAll('${f_attempt_property_condition_images}', this.attempts_paragraphs_model.property_condition_images)

.replaceAll('${f_attempt_property_occupied_details}', this.property_occupied_details_HTML) // replace original only use this for create.

.replaceAll('${f_attempt_property_type_id}', this.attempts_paragraphs_model.property_type_id)
.replaceAll('${f_attempt_property_type_details}', this.set_property_type_details_HTML) // replace original only use this for create.
.replaceAll('${f_attempt_property_type_images}', this.attempts_paragraphs_model.property_type_images)

.replaceAll('${f_attempt_property_type_name}', this.attempts_paragraphs_model.property_type_name)

.replaceAll('${f_attempt_service_file_array}', this.attempts_paragraphs_model.service_file_array)


// Images // <img src="pic_trulli.jpg" alt="Italian Trulli">
// this.attempts_paragraphs_model.property_images - runs a loop functino above to set image variables
.replaceAll('${f_attempt_property_image_0}',  this.propery_image_0 )
.replaceAll('${f_attempt_property_image_1}',  this.propery_image_1 )
.replaceAll('${f_attempt_property_image_2}',  this.propery_image_2 )
.replaceAll('${f_attempt_property_image_3}',  this.propery_image_3 )
.replaceAll('${f_attempt_property_image_4}',  this.propery_image_4 )
.replaceAll('${f_attempt_property_image_5}',  this.propery_image_5 )
.replaceAll('${f_attempt_property_image_6}',  this.propery_image_6 )
.replaceAll('${f_attempt_property_image_7}',  this.propery_image_7 )
.replaceAll('${f_attempt_property_image_8}',  this.propery_image_8 )
.replaceAll('${f_attempt_property_image_9}',  this.propery_image_9 )
.replaceAll('${f_attempt_property_image_10}',  this.propery_image_10 )
.replaceAll('${f_attempt_property_image_11}',  this.propery_image_11 )
.replaceAll('${f_attempt_property_image_12}',  this.propery_image_12 )
.replaceAll('${f_attempt_property_image_13}',  this.propery_image_13 )
.replaceAll('${f_attempt_property_image_14}',  this.propery_image_14 )
.replaceAll('${f_attempt_property_image_15}',  this.propery_image_15 )
.replaceAll('${f_attempt_property_image_16}',  this.propery_image_16 )
.replaceAll('${f_attempt_property_image_17}',  this.propery_image_17 )
.replaceAll('${f_attempt_property_image_18}',  this.propery_image_18 )
.replaceAll('${f_attempt_property_image_19}',  this.propery_image_19 )
.replaceAll('${f_attempt_property_image_20}',  this.propery_image_20 )
.replaceAll('${f_attempt_property_image_21}',  this.propery_image_21 )
.replaceAll('${f_attempt_property_image_22}',  this.propery_image_22 )
.replaceAll('${f_attempt_property_image_23}',  this.propery_image_23 )
.replaceAll('${f_attempt_property_image_24}',  this.propery_image_24 )
.replaceAll('${f_attempt_property_image_25}',  this.propery_image_25 )


.replaceAll('${f_attempt_property_sign_image_0}',  this.property_sign_image_0 )
.replaceAll('${f_attempt_property_sign_image_1}',  this.property_sign_image_1 )
.replaceAll('${f_attempt_property_sign_image_2}',  this.property_sign_image_2 )
.replaceAll('${f_attempt_property_sign_image_3}',  this.property_sign_image_3 )
.replaceAll('${f_attempt_property_sign_image_4}',  this.property_sign_image_4 )
.replaceAll('${f_attempt_property_sign_image_5}',  this.property_sign_image_5 )
.replaceAll('${f_attempt_property_sign_image_6}',  this.property_sign_image_6 )
.replaceAll('${f_attempt_property_sign_image_7}',  this.property_sign_image_7 )
.replaceAll('${f_attempt_property_sign_image_8}',  this.property_sign_image_8 )
.replaceAll('${f_attempt_property_sign_image_9}',  this.property_sign_image_9 )
.replaceAll('${f_attempt_property_sign_image_10}',  this.property_sign_image_10 )
.replaceAll('${f_attempt_property_sign_image_11}',  this.property_sign_image_11 )
.replaceAll('${f_attempt_property_sign_image_12}',  this.property_sign_image_12 )
.replaceAll('${f_attempt_property_sign_image_13}',  this.property_sign_image_13 )
.replaceAll('${f_attempt_property_sign_image_14}',  this.property_sign_image_14 )
.replaceAll('${f_attempt_property_sign_image_15}',  this.property_sign_image_15 )
.replaceAll('${f_attempt_property_sign_image_16}',  this.property_sign_image_16 )
.replaceAll('${f_attempt_property_sign_image_17}',  this.property_sign_image_17 )
.replaceAll('${f_attempt_property_sign_image_18}',  this.property_sign_image_18 )
.replaceAll('${f_attempt_property_sign_image_19}',  this.property_sign_image_19 )
.replaceAll('${f_attempt_property_sign_image_20}',  this.property_sign_image_20 )
.replaceAll('${f_attempt_property_sign_image_21}',  this.property_sign_image_21 )
.replaceAll('${f_attempt_property_sign_image_22}',  this.property_sign_image_22 )
.replaceAll('${f_attempt_property_sign_image_23}',  this.property_sign_image_23 )
.replaceAll('${f_attempt_property_sign_image_24}',  this.property_sign_image_24 )
.replaceAll('${f_attempt_property_sign_image_25}',  this.property_sign_image_25 )


.replaceAll('${f_attempt_property_mail_image_0}',  this.property_mail_image_0 )
.replaceAll('${f_attempt_property_mail_image_1}',  this.property_mail_image_1 )
.replaceAll('${f_attempt_property_mail_image_2}',  this.property_mail_image_2 )
.replaceAll('${f_attempt_property_mail_image_3}',  this.property_mail_image_3 )
.replaceAll('${f_attempt_property_mail_image_4}',  this.property_mail_image_4 )
.replaceAll('${f_attempt_property_mail_image_5}',  this.property_mail_image_5 )
.replaceAll('${f_attempt_property_mail_image_6}',  this.property_mail_image_6 )
.replaceAll('${f_attempt_property_mail_image_7}',  this.property_mail_image_7 )
.replaceAll('${f_attempt_property_mail_image_8}',  this.property_mail_image_8 )
.replaceAll('${f_attempt_property_mail_image_9}',  this.property_mail_image_9 )
.replaceAll('${f_attempt_property_mail_image_10}',  this.property_mail_image_10 )
.replaceAll('${f_attempt_property_mail_image_11}',  this.property_mail_image_11 )
.replaceAll('${f_attempt_property_mail_image_12}',  this.property_mail_image_12 )
.replaceAll('${f_attempt_property_mail_image_13}',  this.property_mail_image_13 )
.replaceAll('${f_attempt_property_mail_image_14}',  this.property_mail_image_14 )
.replaceAll('${f_attempt_property_mail_image_15}',  this.property_mail_image_15 )
.replaceAll('${f_attempt_property_mail_image_16}',  this.property_mail_image_16 )
.replaceAll('${f_attempt_property_mail_image_17}',  this.property_mail_image_17 )
.replaceAll('${f_attempt_property_mail_image_18}',  this.property_mail_image_18 )
.replaceAll('${f_attempt_property_mail_image_19}',  this.property_mail_image_19 )
.replaceAll('${f_attempt_property_mail_image_20}',  this.property_mail_image_20 )
.replaceAll('${f_attempt_property_mail_image_21}',  this.property_mail_image_21 )
.replaceAll('${f_attempt_property_mail_image_22}',  this.property_mail_image_22 )
.replaceAll('${f_attempt_property_mail_image_23}',  this.property_mail_image_23 )
.replaceAll('${f_attempt_property_mail_image_24}',  this.property_mail_image_24 )
.replaceAll('${f_attempt_property_mail_image_25}',  this.property_mail_image_25 )


.replaceAll('${f_attempt_property_vehicles_image_0}',  this.property_vehicles_image_0 )
.replaceAll('${f_attempt_property_vehicles_image_1}',  this.property_vehicles_image_1 )
.replaceAll('${f_attempt_property_vehicles_image_2}',  this.property_vehicles_image_2 )
.replaceAll('${f_attempt_property_vehicles_image_3}',  this.property_vehicles_image_3 )
.replaceAll('${f_attempt_property_vehicles_image_4}',  this.property_vehicles_image_4 )
.replaceAll('${f_attempt_property_vehicles_image_5}',  this.property_vehicles_image_5 )
.replaceAll('${f_attempt_property_vehicles_image_6}',  this.property_vehicles_image_6 )
.replaceAll('${f_attempt_property_vehicles_image_7}',  this.property_vehicles_image_7 )
.replaceAll('${f_attempt_property_vehicles_image_8}',  this.property_vehicles_image_8 )
.replaceAll('${f_attempt_property_vehicles_image_9}',  this.property_vehicles_image_9 )
.replaceAll('${f_attempt_property_vehicles_image_10}',  this.property_vehicles_image_10 )
.replaceAll('${f_attempt_property_vehicles_image_11}',  this.property_vehicles_image_11 )
.replaceAll('${f_attempt_property_vehicles_image_12}',  this.property_vehicles_image_12 )
.replaceAll('${f_attempt_property_vehicles_image_13}',  this.property_vehicles_image_13 )
.replaceAll('${f_attempt_property_vehicles_image_14}',  this.property_vehicles_image_14 )
.replaceAll('${f_attempt_property_vehicles_image_15}',  this.property_vehicles_image_15 )
.replaceAll('${f_attempt_property_vehicles_image_16}',  this.property_vehicles_image_16 )
.replaceAll('${f_attempt_property_vehicles_image_17}',  this.property_vehicles_image_17 )
.replaceAll('${f_attempt_property_vehicles_image_18}',  this.property_vehicles_image_18 )
.replaceAll('${f_attempt_property_vehicles_image_19}',  this.property_vehicles_image_19 )
.replaceAll('${f_attempt_property_vehicles_image_20}',  this.property_vehicles_image_20 )
.replaceAll('${f_attempt_property_vehicles_image_21}',  this.property_vehicles_image_21 )
.replaceAll('${f_attempt_property_vehicles_image_22}',  this.property_vehicles_image_22 )
.replaceAll('${f_attempt_property_vehicles_image_23}',  this.property_vehicles_image_23 )
.replaceAll('${f_attempt_property_vehicles_image_24}',  this.property_vehicles_image_24 )
.replaceAll('${f_attempt_property_vehicles_image_25}',  this.property_vehicles_image_25 )


.replaceAll('${f_attempt_property_pets_image_0}',  this.property_pets_image_0 )
.replaceAll('${f_attempt_property_pets_image_1}',  this.property_pets_image_1 )
.replaceAll('${f_attempt_property_pets_image_2}',  this.property_pets_image_2 )
.replaceAll('${f_attempt_property_pets_image_3}',  this.property_pets_image_3 )
.replaceAll('${f_attempt_property_pets_image_4}',  this.property_pets_image_4 )
.replaceAll('${f_attempt_property_pets_image_5}',  this.property_pets_image_5 )
.replaceAll('${f_attempt_property_pets_image_6}',  this.property_pets_image_6 )
.replaceAll('${f_attempt_property_pets_image_7}',  this.property_pets_image_7 )
.replaceAll('${f_attempt_property_pets_image_8}',  this.property_pets_image_8 )
.replaceAll('${f_attempt_property_pets_image_9}',  this.property_pets_image_9 )
.replaceAll('${f_attempt_property_pets_image_10}',  this.property_pets_image_10 )
.replaceAll('${f_attempt_property_pets_image_11}',  this.property_pets_image_11 )
.replaceAll('${f_attempt_property_pets_image_12}',  this.property_pets_image_12 )
.replaceAll('${f_attempt_property_pets_image_13}',  this.property_pets_image_13 )
.replaceAll('${f_attempt_property_pets_image_14}',  this.property_pets_image_14 )
.replaceAll('${f_attempt_property_pets_image_15}',  this.property_pets_image_15 )
.replaceAll('${f_attempt_property_pets_image_16}',  this.property_pets_image_16 )
.replaceAll('${f_attempt_property_pets_image_17}',  this.property_pets_image_17 )
.replaceAll('${f_attempt_property_pets_image_18}',  this.property_pets_image_18 )
.replaceAll('${f_attempt_property_pets_image_19}',  this.property_pets_image_19 )
.replaceAll('${f_attempt_property_pets_image_20}',  this.property_pets_image_20 )
.replaceAll('${f_attempt_property_pets_image_21}',  this.property_pets_image_21 )
.replaceAll('${f_attempt_property_pets_image_22}',  this.property_pets_image_22 )
.replaceAll('${f_attempt_property_pets_image_23}',  this.property_pets_image_23 )
.replaceAll('${f_attempt_property_pets_image_24}',  this.property_pets_image_24 )
.replaceAll('${f_attempt_property_pets_image_25}',  this.property_pets_image_25 )

.replaceAll('${f_attempt_property_occupancy_image_0}',  this.property_occupancy_image_0 )
.replaceAll('${f_attempt_property_occupancy_image_1}',  this.property_occupancy_image_1 )
.replaceAll('${f_attempt_property_occupancy_image_2}',  this.property_occupancy_image_2 )
.replaceAll('${f_attempt_property_occupancy_image_3}',  this.property_occupancy_image_3 )
.replaceAll('${f_attempt_property_occupancy_image_4}',  this.property_occupancy_image_4 )
.replaceAll('${f_attempt_property_occupancy_image_5}',  this.property_occupancy_image_5 )
.replaceAll('${f_attempt_property_occupancy_image_6}',  this.property_occupancy_image_6 )
.replaceAll('${f_attempt_property_occupancy_image_7}',  this.property_occupancy_image_7 )
.replaceAll('${f_attempt_property_occupancy_image_8}',  this.property_occupancy_image_8 )
.replaceAll('${f_attempt_property_occupancy_image_9}',  this.property_occupancy_image_9 )
.replaceAll('${f_attempt_property_occupancy_image_10}',  this.property_occupancy_image_10 )
.replaceAll('${f_attempt_property_occupancy_image_11}',  this.property_occupancy_image_11 )
.replaceAll('${f_attempt_property_occupancy_image_12}',  this.property_occupancy_image_12 )
.replaceAll('${f_attempt_property_occupancy_image_13}',  this.property_occupancy_image_13 )
.replaceAll('${f_attempt_property_occupancy_image_14}',  this.property_occupancy_image_14 )
.replaceAll('${f_attempt_property_occupancy_image_15}',  this.property_occupancy_image_15 )
.replaceAll('${f_attempt_property_occupancy_image_16}',  this.property_occupancy_image_16 )
.replaceAll('${f_attempt_property_occupancy_image_17}',  this.property_occupancy_image_17 )
.replaceAll('${f_attempt_property_occupancy_image_18}',  this.property_occupancy_image_18 )
.replaceAll('${f_attempt_property_occupancy_image_19}',  this.property_occupancy_image_19 )
.replaceAll('${f_attempt_property_occupancy_image_20}',  this.property_occupancy_image_20 )
.replaceAll('${f_attempt_property_occupancy_image_21}',  this.property_occupancy_image_21 )
.replaceAll('${f_attempt_property_occupancy_image_22}',  this.property_occupancy_image_22 )
.replaceAll('${f_attempt_property_occupancy_image_23}',  this.property_occupancy_image_23 )
.replaceAll('${f_attempt_property_occupancy_image_24}',  this.property_occupancy_image_24 )
.replaceAll('${f_attempt_property_occupancy_image_25}',  this.property_occupancy_image_25 )

.replaceAll('${f_attempt_property_condition_image_0}',  this.property_condition_image_0 )
.replaceAll('${f_attempt_property_condition_image_1}',  this.property_condition_image_1 )
.replaceAll('${f_attempt_property_condition_image_2}',  this.property_condition_image_2 )
.replaceAll('${f_attempt_property_condition_image_3}',  this.property_condition_image_3 )
.replaceAll('${f_attempt_property_condition_image_4}',  this.property_condition_image_4 )
.replaceAll('${f_attempt_property_condition_image_5}',  this.property_condition_image_5 )
.replaceAll('${f_attempt_property_condition_image_6}',  this.property_condition_image_6 )
.replaceAll('${f_attempt_property_condition_image_7}',  this.property_condition_image_7 )
.replaceAll('${f_attempt_property_condition_image_8}',  this.property_condition_image_8 )
.replaceAll('${f_attempt_property_condition_image_9}',  this.property_condition_image_9 )
.replaceAll('${f_attempt_property_condition_image_10}',  this.property_condition_image_10 )
.replaceAll('${f_attempt_property_condition_image_11}',  this.property_condition_image_11 )
.replaceAll('${f_attempt_property_condition_image_12}',  this.property_condition_image_12 )
.replaceAll('${f_attempt_property_condition_image_13}',  this.property_condition_image_13 )
.replaceAll('${f_attempt_property_condition_image_14}',  this.property_condition_image_14 )
.replaceAll('${f_attempt_property_condition_image_15}',  this.property_condition_image_15 )
.replaceAll('${f_attempt_property_condition_image_16}',  this.property_condition_image_16 )
.replaceAll('${f_attempt_property_condition_image_17}',  this.property_condition_image_17 )
.replaceAll('${f_attempt_property_condition_image_18}',  this.property_condition_image_18 )
.replaceAll('${f_attempt_property_condition_image_19}',  this.property_condition_image_19 )
.replaceAll('${f_attempt_property_condition_image_20}',  this.property_condition_image_20 )
.replaceAll('${f_attempt_property_condition_image_21}',  this.property_condition_image_21 )
.replaceAll('${f_attempt_property_condition_image_22}',  this.property_condition_image_22 )
.replaceAll('${f_attempt_property_condition_image_23}',  this.property_condition_image_23 )
.replaceAll('${f_attempt_property_condition_image_24}',  this.property_condition_image_24 )
.replaceAll('${f_attempt_property_condition_image_25}',  this.property_condition_image_25 )

.replaceAll('${f_attempt_property_type_image_0}',  this.property_type_image_0 )
.replaceAll('${f_attempt_property_type_image_1}',  this.property_type_image_1 )
.replaceAll('${f_attempt_property_type_image_2}',  this.property_type_image_2 )
.replaceAll('${f_attempt_property_type_image_3}',  this.property_type_image_3 )
.replaceAll('${f_attempt_property_type_image_4}',  this.property_type_image_4 )
.replaceAll('${f_attempt_property_type_image_5}',  this.property_type_image_5 )
.replaceAll('${f_attempt_property_type_image_6}',  this.property_type_image_6 )
.replaceAll('${f_attempt_property_type_image_7}',  this.property_type_image_7 )
.replaceAll('${f_attempt_property_type_image_8}',  this.property_type_image_8 )
.replaceAll('${f_attempt_property_type_image_9}',  this.property_type_image_9 )
.replaceAll('${f_attempt_property_type_image_10}',  this.property_type_image_10 )
.replaceAll('${f_attempt_property_type_image_11}',  this.property_type_image_11 )
.replaceAll('${f_attempt_property_type_image_12}',  this.property_type_image_12 )
.replaceAll('${f_attempt_property_type_image_13}',  this.property_type_image_13 )
.replaceAll('${f_attempt_property_type_image_14}',  this.property_type_image_14 )
.replaceAll('${f_attempt_property_type_image_15}',  this.property_type_image_15 )
.replaceAll('${f_attempt_property_type_image_16}',  this.property_type_image_16 )
.replaceAll('${f_attempt_property_type_image_17}',  this.property_type_image_17 )
.replaceAll('${f_attempt_property_type_image_18}',  this.property_type_image_18 )
.replaceAll('${f_attempt_property_type_image_19}',  this.property_type_image_19 )
.replaceAll('${f_attempt_property_type_image_20}',  this.property_type_image_20 )
.replaceAll('${f_attempt_property_type_image_21}',  this.property_type_image_21 )
.replaceAll('${f_attempt_property_type_image_22}',  this.property_type_image_22 )
.replaceAll('${f_attempt_property_type_image_23}',  this.property_type_image_23 )
.replaceAll('${f_attempt_property_type_image_24}',  this.property_type_image_24 )
.replaceAll('${f_attempt_property_type_image_25}',  this.property_type_image_25 )

.replaceAll('${f_attempt_service_file_array_image_0}',  this.service_file_array_image_0 )
.replaceAll('${f_attempt_service_file_array_image_1}',  this.service_file_array_image_1 )
.replaceAll('${f_attempt_service_file_array_image_2}',  this.service_file_array_image_2 )
.replaceAll('${f_attempt_service_file_array_image_3}',  this.service_file_array_image_3 )
.replaceAll('${f_attempt_service_file_array_image_4}',  this.service_file_array_image_4 )
.replaceAll('${f_attempt_service_file_array_image_5}',  this.service_file_array_image_5 )
.replaceAll('${f_attempt_service_file_array_image_6}',  this.service_file_array_image_6 )
.replaceAll('${f_attempt_service_file_array_image_7}',  this.service_file_array_image_7 )
.replaceAll('${f_attempt_service_file_array_image_8}',  this.service_file_array_image_8 )
.replaceAll('${f_attempt_service_file_array_image_9}',  this.service_file_array_image_9 )
.replaceAll('${f_attempt_service_file_array_image_10}',  this.service_file_array_image_10 )
.replaceAll('${f_attempt_service_file_array_image_11}',  this.service_file_array_image_11 )
.replaceAll('${f_attempt_service_file_array_image_12}',  this.service_file_array_image_12 )
.replaceAll('${f_attempt_service_file_array_image_13}',  this.service_file_array_image_13 )
.replaceAll('${f_attempt_service_file_array_image_14}',  this.service_file_array_image_14 )
.replaceAll('${f_attempt_service_file_array_image_15}',  this.service_file_array_image_15 )
.replaceAll('${f_attempt_service_file_array_image_16}',  this.service_file_array_image_16 )
.replaceAll('${f_attempt_service_file_array_image_17}',  this.service_file_array_image_17 )
.replaceAll('${f_attempt_service_file_array_image_18}',  this.service_file_array_image_18 )
.replaceAll('${f_attempt_service_file_array_image_19}',  this.service_file_array_image_19 )
.replaceAll('${f_attempt_service_file_array_image_20}',  this.service_file_array_image_20 )
.replaceAll('${f_attempt_service_file_array_image_21}',  this.service_file_array_image_21 )
.replaceAll('${f_attempt_service_file_array_image_22}',  this.service_file_array_image_22 )
.replaceAll('${f_attempt_service_file_array_image_23}',  this.service_file_array_image_23 )
.replaceAll('${f_attempt_service_file_array_image_24}',  this.service_file_array_image_24 )
.replaceAll('${f_attempt_service_file_array_image_25}',  this.service_file_array_image_25 )



// hide anything null or undefined.
.replaceAll('${undefined}', '')
.replaceAll('${null}', '')
.replaceAll('undefined', '') // makes all undefined print empty
.replaceAll('null', '') // makes all undefined print empty
.replaceAll('Invalid date', '') // makes all undefined print empty


// model.email_template_primary_HTML_rendered
// email_subject_primary_rendered
// return rendered_result f_service;
// might need if statements here....

if(this.attempts_paragraphs_model != undefined && this.attempts_paragraphs_model != '[]' && this.attempts_paragraphs_model != null){
rendered_result = this.runReplaceAllVariables_AttemptsOnly_keystarter(rendered_result, model, 'f_attend', 2) // returns after running all the attempts.
}

if(this.service_paragraphs_model != undefined && this.service_paragraphs_model != '[]' && this.service_paragraphs_model != null){
rendered_result = this.runReplaceAllVariables_ServicesOnly_keystarter(rendered_result, model, 'f_service', 1)  // returns after running all the attempts.
}

// Convert the results to a form field value.
// model.email_template_primary_HTML_rendered = rendered_result;
return rendered_result;

}




runReplaceAllVariables_AttemptsOnly_keystarter(str, model, keystarter, subject_attempt_type_id){


      // // Filters objects for nul and undefined values.
      // const obj = this.attempts_paragraphs_model;
      // const filteredObject = _.pickBy(obj, v =>  v.subject_attempt_type_id === subject_attempt_type_id);
      // // console.log = (obj) => document.write(JSON.stringify(filteredObject, null, 2));
      // console.log('FilteredObject', JSON.stringify(filteredObject));



// Filter the array for attempt_type_id = 1 or 2 service or attemdamce -- Do a filter on the final RESULTS IF F SERVICE!!!!! 
// Do a simple loadash filter on attempts_paragraphs model.'

// change the data for a service
if (subject_attempt_type_id = 1)
{


}


  // Already loaded in the job/subject lookup
  // if(this.attempts_paragraphs_model.job_subject_type_id){
  //   this.getJobSubjectType_Q(this.attempts_paragraphs_model.job_subject_type_id) ;
  // }
  // let var_subject_type_name;
  // if(this.subject_job_subject_type != null){
  // var_subject_type_name = this.subject_job_subject_type.job_subject_type_name
  // } else{
  // var_subject_type_name = '';
  // }


// NEED TO DETERMINE THE attempt_type === data

    // FIX THIS AND WE CAN USE FOR ALL. -- By getting   if(this.attempts_paragraphs_model){ to refresh or reset the data lookip as it needs to ne differemt for a service or attedance

// ATTEMPS
  // Current Attempt Variables Setups
  // Uppercase.
  if(this.attempts_paragraphs_model){

    let var_subject_attempt_type_name = this.attempts_paragraphs_model.subject_attempt_type_name
    if(var_subject_attempt_type_name != null){ // uppercase must be validated if not null
     this.var_subject_attempt_type_name_Upper = var_subject_attempt_type_name.toUpperCase();
    }
  
  } // end if attemps paragraphs model.

  this.person_spoken_with_advised_HTML = '';

if(this.attempts_paragraphs_model.person_spoken_with_advised_HTML == null){this.person_spoken_with_advised_HTML = this.attempts_paragraphs_model.person_spoken_with_advised; }else{this.person_spoken_with_advised_HTML = this.transform2(this.attempts_paragraphs_model.person_spoken_with_advised_HTML);}
if(this.attempts_paragraphs_model.vehicles_notes_HTML == null){this.vehicles_notes_HTML = this.attempts_paragraphs_model.vehicles_notes; }else{this.vehicles_notes_HTML = this.transform2(this.attempts_paragraphs_model.vehicles_notes_HTML);}
if(this.attempts_paragraphs_model.neighbours_notes_HTML == null){this.neighbours_notes_HTML = this.attempts_paragraphs_model.neighbours_notes; }else{this.neighbours_notes_HTML = this.transform2(this.attempts_paragraphs_model.neighbours_notes_HTML);}
if(this.attempts_paragraphs_model.calling_card_notes_HTML == null){this.calling_card_notes_HTML = this.attempts_paragraphs_model.calling_card_notes; }else{this.calling_card_notes_HTML = this.transform2(this.attempts_paragraphs_model.calling_card_notes_HTML);}
if(this.attempts_paragraphs_model.postal_mail_notes_HTML == null){this.postal_mail_notes_HTML = this.attempts_paragraphs_model.postal_mail_notes; }else{this.postal_mail_notes_HTML = this.transform2(this.attempts_paragraphs_model.postal_mail_notes_HTML);}
if(this.attempts_paragraphs_model.phone_call_notes_HTML == null){this.phone_call_notes_HTML = this.attempts_paragraphs_model.phone_call_notes; }else{this.phone_call_notes_HTML = this.transform2(this.attempts_paragraphs_model.phone_call_notes_HTML);}
if(this.attempts_paragraphs_model.attempts_notes_HTML == null){this.attempts_notes_HTML = this.attempts_paragraphs_model.attempts_notes; }else{this.attempts_notes_HTML = this.transform2(this.attempts_paragraphs_model.attempts_notes_HTML);}
if(this.attempts_paragraphs_model.email_contents_HTML == null){this.email_contents_HTML = this.attempts_paragraphs_model.email_contents; }else{this.email_contents_HTML = this.transform2(this.attempts_paragraphs_model.email_contents_HTML);}
if(this.attempts_paragraphs_model.general_notes_HTML == null){
  this.set_general_notes = this.attempts_paragraphs_model.general_notes;
  }else{
   this.set_general_notes = this.transform2(this.attempts_paragraphs_model.general_notes_HTML)
  }
  if(this.attempts_paragraphs_model.property_forsale_or_lease_sign_details_HTML == null){this.property_forsale_or_lease_sign_details_HTML = this.attempts_paragraphs_model.property_forsale_or_lease_sign_details; }else{this.property_forsale_or_lease_sign_details_HTML = this.transform2(this.attempts_paragraphs_model.property_forsale_or_lease_sign_details_HTML);}  
  if(this.attempts_paragraphs_model.property_mail_details_HTML == null){this.property_mail_details_HTML = this.attempts_paragraphs_model.property_mail_details; }else{this.property_mail_details_HTML = this.transform2(this.attempts_paragraphs_model.property_mail_details_HTML);}
  if(this.attempts_paragraphs_model.property_vehicles_sighted_details_HTML == null){this.property_vehicles_sighted_details_HTML = this.attempts_paragraphs_model.property_vehicles_sighted_details; }else{this.property_vehicles_sighted_details_HTML = this.transform2(this.attempts_paragraphs_model.property_vehicles_sighted_details_HTML);}  
  if(this.attempts_paragraphs_model.property_pets_details_HTML == null){this.property_pets_details_HTML = this.attempts_paragraphs_model.property_pets_details; }else{this.property_pets_details_HTML = this.transform2(this.attempts_paragraphs_model.property_pets_details_HTML);}

  if(this.attempts_paragraphs_model.property_occupancy_details_HTML == null){this.property_occupancy_details_HTML = this.attempts_paragraphs_model.property_occupancy_details; }else{this.property_occupancy_details_HTML = this.transform2(this.attempts_paragraphs_model.property_occupancy_details_HTML);}
  
  if(this.attempts_paragraphs_model.property_condition_HTML == null){this.property_condition_HTML = this.attempts_paragraphs_model.property_condition; }else{this.property_condition_HTML = this.transform2(this.attempts_paragraphs_model.property_condition_HTML);}
if(this.attempts_paragraphs_model.property_occupied_details_HTML == null){this.property_occupied_details_HTML = this.attempts_paragraphs_model.property_occupied_details; }else{this.property_occupied_details_HTML = this.transform2(this.attempts_paragraphs_model.property_occupied_details_HTML);}
if(this.attempts_paragraphs_model.property_type_details_HTML == null){this.set_property_type_details_HTML = this.attempts_paragraphs_model.property_type_details; }else{this.set_property_type_details_HTML = this.transform2(this.attempts_paragraphs_model.property_type_details_HTML);}
if(this.attempts_paragraphs_model.service_under_order_HTML == null){this.service_under_order_HTML = this.attempts_paragraphs_model.service_under_order; }else{this.service_under_order_HTML = this.transform2(this.attempts_paragraphs_model.service_under_order_HTML);}



 // Do checks for subject name / Businesss Name of FUll SUbject Name fields
 let var_subject_name =  this.attempts_paragraphs_model.first_name + ' ' +  this.attempts_paragraphs_model.middlename + ' '+  this.attempts_paragraphs_model.surname;
 let var_subject_name_4_doc = this.attempts_paragraphs_model.first_name +'-'+  this.attempts_paragraphs_model.surname;
 let var_subject_business_name =  this.attempts_paragraphs_model.business_name;
 
 // Subject Name of Business
     if(var_subject_business_name != null){
         let var_trim_subject_business_name = var_subject_business_name.replaceAll(' ', ''); // need javscipt version of trim (all spaces removed)
         // $subject_name = $trim_subject_business_name;
          var_subject_name = var_subject_business_name; // changed here feb 2023 as subject busines name was printing stripped as variable in affidavid // Not trimmed
           var_subject_name_4_doc= var_trim_subject_business_name;
         
     }



if(this.attempts_paragraphs_model.service_paragraph_rendered == null){
  this.set_service_paragraph_rendered = '';
 }else{
  this.set_service_paragraph_rendered = this.attempts_paragraphs_model.service_paragraph_rendered; // does not require encodeing
}

// Property Images
if(this.attempts_paragraphs_model.property_images != '[]' || this.attempts_paragraphs_model.property_images != null){
  this.property_images = JSON.parse(this.attempts_paragraphs_model.property_images)



  let newArr = this.property_images;
  let  count_of_items = Object.keys(newArr).length;

  // let  count_of_items = 25;
  //   let  count_of_items = Object.keys(newArr).length;
  // //     for(let i=0;i < count_of_items; i++) { 
  // //     let res = newArr[i];
  // // }
 
  if(count_of_items >= 1){this.propery_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[0].file_server_location +  '/' + this.property_images[0].file_name + '"></img>'}else{this.propery_image_0=''}
  if(count_of_items >= 2){this.propery_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[1].file_server_location +  '/' + this.property_images[1].file_name + '"></img>'}else{this.propery_image_1=''}
  if(count_of_items >= 3){this.propery_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[2].file_server_location +  '/' + this.property_images[2].file_name + '"></img>'}else{this.propery_image_2=''}
  if(count_of_items >= 4){this.propery_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[3].file_server_location +  '/' + this.property_images[3].file_name + '"></img>'}else{this.propery_image_3=''}
  if(count_of_items >= 5){this.propery_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[4].file_server_location +  '/' + this.property_images[4].file_name + '"></img>'}else{this.propery_image_4=''}
  if(count_of_items >= 6){this.propery_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[5].file_server_location +  '/' + this.property_images[5].file_name + '"></img>'}else{this.propery_image_5=''}
  if(count_of_items >= 7){this.propery_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[6].file_server_location +  '/' + this.property_images[6].file_name + '"></img>'}else{this.propery_image_6=''}
  if(count_of_items >= 8){this.propery_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[7].file_server_location +  '/' + this.property_images[7].file_name + '"></img>'}else{this.propery_image_7=''}
  if(count_of_items >= 9){this.propery_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[8].file_server_location +  '/' + this.property_images[8].file_name + '"></img>'}else{this.propery_image_8=''}
  if(count_of_items >= 10){this.propery_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[9].file_server_location +  '/' + this.property_images[9].file_name + '"></img>'}else{this.propery_image_9=''}
  if(count_of_items >= 11){this.propery_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[10].file_server_location +  '/' + this.property_images[10].file_name + '"></img>'}else{this.propery_image_10=''}
  if(count_of_items >= 11){this.propery_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[11].file_server_location +  '/' + this.property_images[11].file_name + '"></img>'}else{this.propery_image_11=''}
  if(count_of_items >= 11){this.propery_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[12].file_server_location +  '/' + this.property_images[12].file_name + '"></img>'}else{this.propery_image_12=''}
  if(count_of_items >= 11){this.propery_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[13].file_server_location +  '/' + this.property_images[13].file_name + '"></img>'}else{this.propery_image_13=''}
  if(count_of_items >= 11){this.propery_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[14].file_server_location +  '/' + this.property_images[14].file_name + '"></img>'}else{this.propery_image_14=''}
  if(count_of_items >= 11){this.propery_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[15].file_server_location +  '/' + this.property_images[15].file_name + '"></img>'}else{this.propery_image_15=''}
  if(count_of_items >= 11){this.propery_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[16].file_server_location +  '/' + this.property_images[16].file_name + '"></img>'}else{this.propery_image_16=''}
  if(count_of_items >= 11){this.propery_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[17].file_server_location +  '/' + this.property_images[17].file_name + '"></img>'}else{this.propery_image_17=''}
  if(count_of_items >= 11){this.propery_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[18].file_server_location +  '/' + this.property_images[18].file_name + '"></img>'}else{this.propery_image_18=''}
  if(count_of_items >= 11){this.propery_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[19].file_server_location +  '/' + this.property_images[19].file_name + '"></img>'}else{this.propery_image_19=''}
  if(count_of_items >= 11){this.propery_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[20].file_server_location +  '/' + this.property_images[20].file_name + '"></img>'}else{this.propery_image_20=''}
  if(count_of_items >= 11){this.propery_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[21].file_server_location +  '/' + this.property_images[21].file_name + '"></img>'}else{this.propery_image_21=''}
  if(count_of_items >= 11){this.propery_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[22].file_server_location +  '/' + this.property_images[22].file_name + '"></img>'}else{this.propery_image_22=''}
  if(count_of_items >= 11){this.propery_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[23].file_server_location +  '/' + this.property_images[23].file_name + '"></img>'}else{this.propery_image_23=''}
  if(count_of_items >= 11){this.propery_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[24].file_server_location +  '/' + this.property_images[24].file_name + '"></img>'}else{this.propery_image_24=''}
  if(count_of_items >= 11){this.propery_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[25].file_server_location +  '/' + this.property_images[25].file_name + '"></img>'}else{this.propery_image_25=''}
   


  

  // Loop function to set the images set the ones that exist and then set nulls to the ones that dont. -- similar to the php function in the doucment imaee replacement function 
  // loop 0 - 25 and only set if exisis or '' if not.


}

if(this.attempts_paragraphs_model.property_sign_images != '[]' && this.attempts_paragraphs_model.property_sign_images != null){
  this.property_sign_images = JSON.parse(this.attempts_paragraphs_model.property_sign_images)
  let newArr = this.property_sign_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_sign_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[0].file_server_location +  '/' + this.property_sign_images[0].file_name + '"></img>'}else{this.property_sign_image_0=''}
  if(count_of_items >= 2){this.property_sign_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[1].file_server_location +  '/' + this.property_sign_images[1].file_name + '"></img>'}else{this.property_sign_image_1=''}
  if(count_of_items >= 3){this.property_sign_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[2].file_server_location +  '/' + this.property_sign_images[2].file_name + '"></img>'}else{this.property_sign_image_2=''}
  if(count_of_items >= 4){this.property_sign_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[3].file_server_location +  '/' + this.property_sign_images[3].file_name + '"></img>'}else{this.property_sign_image_3=''}
  if(count_of_items >= 5){this.property_sign_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[4].file_server_location +  '/' + this.property_sign_images[4].file_name + '"></img>'}else{this.property_sign_image_4=''}
  if(count_of_items >= 6){this.property_sign_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[5].file_server_location +  '/' + this.property_sign_images[5].file_name + '"></img>'}else{this.property_sign_image_5=''}
  if(count_of_items >= 7){this.property_sign_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[6].file_server_location +  '/' + this.property_sign_images[6].file_name + '"></img>'}else{this.property_sign_image_6=''}
  if(count_of_items >= 8){this.property_sign_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[7].file_server_location +  '/' + this.property_sign_images[7].file_name + '"></img>'}else{this.property_sign_image_7=''}
  if(count_of_items >= 9){this.property_sign_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[8].file_server_location +  '/' + this.property_sign_images[8].file_name + '"></img>'}else{this.property_sign_image_8=''}
  if(count_of_items >= 10){this.property_sign_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[9].file_server_location +  '/' + this.property_sign_images[9].file_name + '"></img>'}else{this.property_sign_image_9=''}
  if(count_of_items >= 11){this.property_sign_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[10].file_server_location +  '/' + this.property_sign_images[10].file_name + '"></img>'}else{this.property_sign_image_10=''}
  if(count_of_items >= 11){this.property_sign_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[11].file_server_location +  '/' + this.property_sign_images[11].file_name + '"></img>'}else{this.property_sign_image_11=''}
  if(count_of_items >= 11){this.property_sign_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[12].file_server_location +  '/' + this.property_sign_images[12].file_name + '"></img>'}else{this.property_sign_image_12=''}
  if(count_of_items >= 11){this.property_sign_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[13].file_server_location +  '/' + this.property_sign_images[13].file_name + '"></img>'}else{this.property_sign_image_13=''}
  if(count_of_items >= 11){this.property_sign_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[14].file_server_location +  '/' + this.property_sign_images[14].file_name + '"></img>'}else{this.property_sign_image_14=''}
  if(count_of_items >= 11){this.property_sign_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[15].file_server_location +  '/' + this.property_sign_images[15].file_name + '"></img>'}else{this.property_sign_image_15=''}
  if(count_of_items >= 11){this.property_sign_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[16].file_server_location +  '/' + this.property_sign_images[16].file_name + '"></img>'}else{this.property_sign_image_16=''}
  if(count_of_items >= 11){this.property_sign_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[17].file_server_location +  '/' + this.property_sign_images[17].file_name + '"></img>'}else{this.property_sign_image_17=''}
  if(count_of_items >= 11){this.property_sign_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[18].file_server_location +  '/' + this.property_sign_images[18].file_name + '"></img>'}else{this.property_sign_image_18=''}
  if(count_of_items >= 11){this.property_sign_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[19].file_server_location +  '/' + this.property_sign_images[19].file_name + '"></img>'}else{this.property_sign_image_19=''}
  if(count_of_items >= 11){this.property_sign_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[20].file_server_location +  '/' + this.property_sign_images[20].file_name + '"></img>'}else{this.property_sign_image_20=''}
  if(count_of_items >= 11){this.property_sign_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[21].file_server_location +  '/' + this.property_sign_images[21].file_name + '"></img>'}else{this.property_sign_image_21=''}
  if(count_of_items >= 11){this.property_sign_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[22].file_server_location +  '/' + this.property_sign_images[22].file_name + '"></img>'}else{this.property_sign_image_22=''}
  if(count_of_items >= 11){this.property_sign_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[23].file_server_location +  '/' + this.property_sign_images[23].file_name + '"></img>'}else{this.property_sign_image_23=''}
  if(count_of_items >= 11){this.property_sign_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[24].file_server_location +  '/' + this.property_sign_images[24].file_name + '"></img>'}else{this.property_sign_image_24=''}
  if(count_of_items >= 11){this.property_sign_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[25].file_server_location +  '/' + this.property_sign_images[25].file_name + '"></img>'}else{this.property_sign_image_25=''}
}
  
if(this.attempts_paragraphs_model.property_mail_images != '[]' && this.attempts_paragraphs_model.property_mail_images != null ){
  this.property_mail_images = JSON.parse(this.attempts_paragraphs_model.property_mail_images)
  let newArr = this.property_mail_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_mail_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[0].file_server_location +  '/' + this.property_mail_images[0].file_name + '"></img>'}else{this.property_mail_image_0=''}
  if(count_of_items >= 2){this.property_mail_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[1].file_server_location +  '/' + this.property_mail_images[1].file_name + '"></img>'}else{this.property_mail_image_1=''}
  if(count_of_items >= 3){this.property_mail_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[2].file_server_location +  '/' + this.property_mail_images[2].file_name + '"></img>'}else{this.property_mail_image_2=''}
  if(count_of_items >= 4){this.property_mail_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[3].file_server_location +  '/' + this.property_mail_images[3].file_name + '"></img>'}else{this.property_mail_image_3=''}
  if(count_of_items >= 5){this.property_mail_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[4].file_server_location +  '/' + this.property_mail_images[4].file_name + '"></img>'}else{this.property_mail_image_4=''}
  if(count_of_items >= 6){this.property_mail_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[5].file_server_location +  '/' + this.property_mail_images[5].file_name + '"></img>'}else{this.property_mail_image_5=''}
  if(count_of_items >= 7){this.property_mail_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[6].file_server_location +  '/' + this.property_mail_images[6].file_name + '"></img>'}else{this.property_mail_image_6=''}
  if(count_of_items >= 8){this.property_mail_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[7].file_server_location +  '/' + this.property_mail_images[7].file_name + '"></img>'}else{this.property_mail_image_7=''}
  if(count_of_items >= 9){this.property_mail_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[8].file_server_location +  '/' + this.property_mail_images[8].file_name + '"></img>'}else{this.property_mail_image_8=''}
  if(count_of_items >= 10){this.property_mail_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[9].file_server_location +  '/' + this.property_mail_images[9].file_name + '"></img>'}else{this.property_mail_image_9=''}
  if(count_of_items >= 11){this.property_mail_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[10].file_server_location +  '/' + this.property_mail_images[10].file_name + '"></img>'}else{this.property_mail_image_10=''}
  if(count_of_items >= 11){this.property_mail_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[11].file_server_location +  '/' + this.property_mail_images[11].file_name + '"></img>'}else{this.property_mail_image_11=''}
  if(count_of_items >= 11){this.property_mail_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[12].file_server_location +  '/' + this.property_mail_images[12].file_name + '"></img>'}else{this.property_mail_image_12=''}
  if(count_of_items >= 11){this.property_mail_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[13].file_server_location +  '/' + this.property_mail_images[13].file_name + '"></img>'}else{this.property_mail_image_13=''}
  if(count_of_items >= 11){this.property_mail_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[14].file_server_location +  '/' + this.property_mail_images[14].file_name + '"></img>'}else{this.property_mail_image_14=''}
  if(count_of_items >= 11){this.property_mail_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[15].file_server_location +  '/' + this.property_mail_images[15].file_name + '"></img>'}else{this.property_mail_image_15=''}
  if(count_of_items >= 11){this.property_mail_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[16].file_server_location +  '/' + this.property_mail_images[16].file_name + '"></img>'}else{this.property_mail_image_16=''}
  if(count_of_items >= 11){this.property_mail_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[17].file_server_location +  '/' + this.property_mail_images[17].file_name + '"></img>'}else{this.property_mail_image_17=''}
  if(count_of_items >= 11){this.property_mail_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[18].file_server_location +  '/' + this.property_mail_images[18].file_name + '"></img>'}else{this.property_mail_image_18=''}
  if(count_of_items >= 11){this.property_mail_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[19].file_server_location +  '/' + this.property_mail_images[19].file_name + '"></img>'}else{this.property_mail_image_19=''}
  if(count_of_items >= 11){this.property_mail_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[20].file_server_location +  '/' + this.property_mail_images[20].file_name + '"></img>'}else{this.property_mail_image_20=''}
  if(count_of_items >= 11){this.property_mail_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[21].file_server_location +  '/' + this.property_mail_images[21].file_name + '"></img>'}else{this.property_mail_image_21=''}
  if(count_of_items >= 11){this.property_mail_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[22].file_server_location +  '/' + this.property_mail_images[22].file_name + '"></img>'}else{this.property_mail_image_22=''}
  if(count_of_items >= 11){this.property_mail_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[23].file_server_location +  '/' + this.property_mail_images[23].file_name + '"></img>'}else{this.property_mail_image_23=''}
  if(count_of_items >= 11){this.property_mail_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[24].file_server_location +  '/' + this.property_mail_images[24].file_name + '"></img>'}else{this.property_mail_image_24=''}
  if(count_of_items >= 11){this.property_mail_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[25].file_server_location +  '/' + this.property_mail_images[25].file_name + '"></img>'}else{this.property_mail_image_25=''}
}
  
if(this.attempts_paragraphs_model.property_vehicles_images != '[]' && this.attempts_paragraphs_model.property_vehicles_images != null){
  this.property_vehicles_images = JSON.parse(this.attempts_paragraphs_model.property_vehicles_images)
  let newArr = this.property_vehicles_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_vehicles_image_0  = '<img src="' + this.gfunc.fileURL + '/' + this.property_vehicles_images[0].file_server_location +  '/' + this.property_vehicles_images[0].file_name + '"></img>'}else{this.property_vehicles_image_0=''}
  if(count_of_items >= 2){this.property_vehicles_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[1].file_server_location +  '/' + this.property_vehicles_images[1].file_name + '"></img>'}else{this.property_vehicles_image_1=''}
  if(count_of_items >= 3){this.property_vehicles_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[2].file_server_location +  '/' + this.property_vehicles_images[2].file_name + '"></img>'}else{this.property_vehicles_image_2=''}
  if(count_of_items >= 4){this.property_vehicles_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[3].file_server_location +  '/' + this.property_vehicles_images[3].file_name + '"></img>'}else{this.property_vehicles_image_3=''}
  if(count_of_items >= 5){this.property_vehicles_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[4].file_server_location +  '/' + this.property_vehicles_images[4].file_name + '"></img>'}else{this.property_vehicles_image_4=''}
  if(count_of_items >= 6){this.property_vehicles_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[5].file_server_location +  '/' + this.property_vehicles_images[5].file_name + '"></img>'}else{this.property_vehicles_image_5=''}
  if(count_of_items >= 7){this.property_vehicles_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[6].file_server_location +  '/' + this.property_vehicles_images[6].file_name + '"></img>'}else{this.property_vehicles_image_6=''}
  if(count_of_items >= 8){this.property_vehicles_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[7].file_server_location +  '/' + this.property_vehicles_images[7].file_name + '"></img>'}else{this.property_vehicles_image_7=''}
  if(count_of_items >= 9){this.property_vehicles_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[8].file_server_location +  '/' + this.property_vehicles_images[8].file_name + '"></img>'}else{this.property_vehicles_image_8=''}
  if(count_of_items >= 10){this.property_vehicles_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[9].file_server_location +  '/' + this.property_vehicles_images[9].file_name + '"></img>'}else{this.property_vehicles_image_9=''}
  if(count_of_items >= 11){this.property_vehicles_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[10].file_server_location +  '/' + this.property_vehicles_images[10].file_name + '"></img>'}else{this.property_vehicles_image_10=''}
  if(count_of_items >= 11){this.property_vehicles_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[11].file_server_location +  '/' + this.property_vehicles_images[11].file_name + '"></img>'}else{this.property_vehicles_image_11=''}
  if(count_of_items >= 11){this.property_vehicles_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[12].file_server_location +  '/' + this.property_vehicles_images[12].file_name + '"></img>'}else{this.property_vehicles_image_12=''}
  if(count_of_items >= 11){this.property_vehicles_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[13].file_server_location +  '/' + this.property_vehicles_images[13].file_name + '"></img>'}else{this.property_vehicles_image_13=''}
  if(count_of_items >= 11){this.property_vehicles_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[14].file_server_location +  '/' + this.property_vehicles_images[14].file_name + '"></img>'}else{this.property_vehicles_image_14=''}
  if(count_of_items >= 11){this.property_vehicles_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[15].file_server_location +  '/' + this.property_vehicles_images[15].file_name + '"></img>'}else{this.property_vehicles_image_15=''}
  if(count_of_items >= 11){this.property_vehicles_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[16].file_server_location +  '/' + this.property_vehicles_images[16].file_name + '"></img>'}else{this.property_vehicles_image_16=''}
  if(count_of_items >= 11){this.property_vehicles_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[17].file_server_location +  '/' + this.property_vehicles_images[17].file_name + '"></img>'}else{this.property_vehicles_image_17=''}
  if(count_of_items >= 11){this.property_vehicles_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[18].file_server_location +  '/' + this.property_vehicles_images[18].file_name + '"></img>'}else{this.property_vehicles_image_18=''}
  if(count_of_items >= 11){this.property_vehicles_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[19].file_server_location +  '/' + this.property_vehicles_images[19].file_name + '"></img>'}else{this.property_vehicles_image_19=''}
  if(count_of_items >= 11){this.property_vehicles_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[20].file_server_location +  '/' + this.property_vehicles_images[20].file_name + '"></img>'}else{this.property_vehicles_image_20=''}
  if(count_of_items >= 11){this.property_vehicles_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[21].file_server_location +  '/' + this.property_vehicles_images[21].file_name + '"></img>'}else{this.property_vehicles_image_21=''}
  if(count_of_items >= 11){this.property_vehicles_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[22].file_server_location +  '/' + this.property_vehicles_images[22].file_name + '"></img>'}else{this.property_vehicles_image_22=''}
  if(count_of_items >= 11){this.property_vehicles_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[23].file_server_location +  '/' + this.property_vehicles_images[23].file_name + '"></img>'}else{this.property_vehicles_image_23=''}
  if(count_of_items >= 11){this.property_vehicles_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[24].file_server_location +  '/' + this.property_vehicles_images[24].file_name + '"></img>'}else{this.property_vehicles_image_24=''}
  if(count_of_items >= 11){this.property_vehicles_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[25].file_server_location +  '/' + this.property_vehicles_images[25].file_name + '"></img>'}else{this.property_vehicles_image_25=''}
}


if(this.attempts_paragraphs_model.property_pets_images != '[]' && this.attempts_paragraphs_model.property_pets_images != null){
  this.property_pets_images = JSON.parse(this.attempts_paragraphs_model.property_pets_images)
  let newArr = this.property_pets_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_pets_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[0].file_server_location +  '/' + this.property_pets_images[0].file_name + '"></img>'}else{this.property_pets_image_0=''}
  if(count_of_items >= 2){this.property_pets_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[1].file_server_location +  '/' + this.property_pets_images[1].file_name + '"></img>'}else{this.property_pets_image_1=''}
  if(count_of_items >= 3){this.property_pets_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[2].file_server_location +  '/' + this.property_pets_images[2].file_name + '"></img>'}else{this.property_pets_image_2=''}
  if(count_of_items >= 4){this.property_pets_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[3].file_server_location +  '/' + this.property_pets_images[3].file_name + '"></img>'}else{this.property_pets_image_3=''}
  if(count_of_items >= 5){this.property_pets_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[4].file_server_location +  '/' + this.property_pets_images[4].file_name + '"></img>'}else{this.property_pets_image_4=''}
  if(count_of_items >= 6){this.property_pets_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[5].file_server_location +  '/' + this.property_pets_images[5].file_name + '"></img>'}else{this.property_pets_image_5=''}
  if(count_of_items >= 7){this.property_pets_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[6].file_server_location +  '/' + this.property_pets_images[6].file_name + '"></img>'}else{this.property_pets_image_6=''}
  if(count_of_items >= 8){this.property_pets_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[7].file_server_location +  '/' + this.property_pets_images[7].file_name + '"></img>'}else{this.property_pets_image_7=''}
  if(count_of_items >= 9){this.property_pets_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[8].file_server_location +  '/' + this.property_pets_images[8].file_name + '"></img>'}else{this.property_pets_image_8=''}
  if(count_of_items >= 10){this.property_pets_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[9].file_server_location +  '/' + this.property_pets_images[9].file_name + '"></img>'}else{this.property_pets_image_9=''}
  if(count_of_items >= 11){this.property_pets_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[10].file_server_location +  '/' + this.property_pets_images[10].file_name + '"></img>'}else{this.property_pets_image_10=''}
  if(count_of_items >= 11){this.property_pets_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[11].file_server_location +  '/' + this.property_pets_images[11].file_name + '"></img>'}else{this.property_pets_image_11=''}
  if(count_of_items >= 11){this.property_pets_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[12].file_server_location +  '/' + this.property_pets_images[12].file_name + '"></img>'}else{this.property_pets_image_12=''}
  if(count_of_items >= 11){this.property_pets_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[13].file_server_location +  '/' + this.property_pets_images[13].file_name + '"></img>'}else{this.property_pets_image_13=''}
  if(count_of_items >= 11){this.property_pets_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[14].file_server_location +  '/' + this.property_pets_images[14].file_name + '"></img>'}else{this.property_pets_image_14=''}
  if(count_of_items >= 11){this.property_pets_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[15].file_server_location +  '/' + this.property_pets_images[15].file_name + '"></img>'}else{this.property_pets_image_15=''}
  if(count_of_items >= 11){this.property_pets_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[16].file_server_location +  '/' + this.property_pets_images[16].file_name + '"></img>'}else{this.property_pets_image_16=''}
  if(count_of_items >= 11){this.property_pets_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[17].file_server_location +  '/' + this.property_pets_images[17].file_name + '"></img>'}else{this.property_pets_image_17=''}
  if(count_of_items >= 11){this.property_pets_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[18].file_server_location +  '/' + this.property_pets_images[18].file_name + '"></img>'}else{this.property_pets_image_18=''}
  if(count_of_items >= 11){this.property_pets_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[19].file_server_location +  '/' + this.property_pets_images[19].file_name + '"></img>'}else{this.property_pets_image_19=''}
  if(count_of_items >= 11){this.property_pets_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[20].file_server_location +  '/' + this.property_pets_images[20].file_name + '"></img>'}else{this.property_pets_image_20=''}
  if(count_of_items >= 11){this.property_pets_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[21].file_server_location +  '/' + this.property_pets_images[21].file_name + '"></img>'}else{this.property_pets_image_21=''}
  if(count_of_items >= 11){this.property_pets_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[22].file_server_location +  '/' + this.property_pets_images[22].file_name + '"></img>'}else{this.property_pets_image_22=''}
  if(count_of_items >= 11){this.property_pets_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[23].file_server_location +  '/' + this.property_pets_images[23].file_name + '"></img>'}else{this.property_pets_image_23=''}
  if(count_of_items >= 11){this.property_pets_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[24].file_server_location +  '/' + this.property_pets_images[24].file_name + '"></img>'}else{this.property_pets_image_24=''}
  if(count_of_items >= 11){this.property_pets_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[25].file_server_location +  '/' + this.property_pets_images[25].file_name + '"></img>'}else{this.property_pets_image_25=''}
}


if(this.attempts_paragraphs_model.property_occupancy_images != '[]' && this.attempts_paragraphs_model.property_occupancy_images != null){
  this.property_occupancy_images = JSON.parse(this.attempts_paragraphs_model.property_occupancy_images)
  let newArr = this.property_occupancy_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_occupancy_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[0].file_server_location +  '/' + this.property_occupancy_images[0].file_name + '"></img>'}else{this.property_occupancy_image_0=''}
  if(count_of_items >= 2){this.property_occupancy_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[1].file_server_location +  '/' + this.property_occupancy_images[1].file_name + '"></img>'}else{this.property_occupancy_image_1=''}
  if(count_of_items >= 3){this.property_occupancy_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[2].file_server_location +  '/' + this.property_occupancy_images[2].file_name + '"></img>'}else{this.property_occupancy_image_2=''}
  if(count_of_items >= 4){this.property_occupancy_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[3].file_server_location +  '/' + this.property_occupancy_images[3].file_name + '"></img>'}else{this.property_occupancy_image_3=''}
  if(count_of_items >= 5){this.property_occupancy_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[4].file_server_location +  '/' + this.property_occupancy_images[4].file_name + '"></img>'}else{this.property_occupancy_image_4=''}
  if(count_of_items >= 6){this.property_occupancy_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[5].file_server_location +  '/' + this.property_occupancy_images[5].file_name + '"></img>'}else{this.property_occupancy_image_5=''}
  if(count_of_items >= 7){this.property_occupancy_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[6].file_server_location +  '/' + this.property_occupancy_images[6].file_name + '"></img>'}else{this.property_occupancy_image_6=''}
  if(count_of_items >= 8){this.property_occupancy_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[7].file_server_location +  '/' + this.property_occupancy_images[7].file_name + '"></img>'}else{this.property_occupancy_image_7=''}
  if(count_of_items >= 9){this.property_occupancy_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[8].file_server_location +  '/' + this.property_occupancy_images[8].file_name + '"></img>'}else{this.property_occupancy_image_8=''}
  if(count_of_items >= 10){this.property_occupancy_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[9].file_server_location +  '/' + this.property_occupancy_images[9].file_name + '"></img>'}else{this.property_occupancy_image_9=''}
  if(count_of_items >= 11){this.property_occupancy_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[10].file_server_location +  '/' + this.property_occupancy_images[10].file_name + '"></img>'}else{this.property_occupancy_image_10=''}
  if(count_of_items >= 11){this.property_occupancy_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[11].file_server_location +  '/' + this.property_occupancy_images[11].file_name + '"></img>'}else{this.property_occupancy_image_11=''}
  if(count_of_items >= 11){this.property_occupancy_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[12].file_server_location +  '/' + this.property_occupancy_images[12].file_name + '"></img>'}else{this.property_occupancy_image_12=''}
  if(count_of_items >= 11){this.property_occupancy_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[13].file_server_location +  '/' + this.property_occupancy_images[13].file_name + '"></img>'}else{this.property_occupancy_image_13=''}
  if(count_of_items >= 11){this.property_occupancy_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[14].file_server_location +  '/' + this.property_occupancy_images[14].file_name + '"></img>'}else{this.property_occupancy_image_14=''}
  if(count_of_items >= 11){this.property_occupancy_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[15].file_server_location +  '/' + this.property_occupancy_images[15].file_name + '"></img>'}else{this.property_occupancy_image_15=''}
  if(count_of_items >= 11){this.property_occupancy_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[16].file_server_location +  '/' + this.property_occupancy_images[16].file_name + '"></img>'}else{this.property_occupancy_image_16=''}
  if(count_of_items >= 11){this.property_occupancy_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[17].file_server_location +  '/' + this.property_occupancy_images[17].file_name + '"></img>'}else{this.property_occupancy_image_17=''}
  if(count_of_items >= 11){this.property_occupancy_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[18].file_server_location +  '/' + this.property_occupancy_images[18].file_name + '"></img>'}else{this.property_occupancy_image_18=''}
  if(count_of_items >= 11){this.property_occupancy_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[19].file_server_location +  '/' + this.property_occupancy_images[19].file_name + '"></img>'}else{this.property_occupancy_image_19=''}
  if(count_of_items >= 11){this.property_occupancy_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[20].file_server_location +  '/' + this.property_occupancy_images[20].file_name + '"></img>'}else{this.property_occupancy_image_20=''}
  if(count_of_items >= 11){this.property_occupancy_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[21].file_server_location +  '/' + this.property_occupancy_images[21].file_name + '"></img>'}else{this.property_occupancy_image_21=''}
  if(count_of_items >= 11){this.property_occupancy_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[22].file_server_location +  '/' + this.property_occupancy_images[22].file_name + '"></img>'}else{this.property_occupancy_image_22=''}
  if(count_of_items >= 11){this.property_occupancy_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[23].file_server_location +  '/' + this.property_occupancy_images[23].file_name + '"></img>'}else{this.property_occupancy_image_23=''}
  if(count_of_items >= 11){this.property_occupancy_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[24].file_server_location +  '/' + this.property_occupancy_images[24].file_name + '"></img>'}else{this.property_occupancy_image_24=''}
  if(count_of_items >= 11){this.property_occupancy_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[25].file_server_location +  '/' + this.property_occupancy_images[25].file_name + '"></img>'}else{this.property_occupancy_image_25=''}
}

if(this.attempts_paragraphs_model.property_condition_images != '[]' && this.attempts_paragraphs_model.property_condition_images != null ){
  this.property_condition_images = JSON.parse(this.attempts_paragraphs_model.property_condition_images)
  let newArr = this.property_condition_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_condition_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[0].file_server_location +  '/' + this.property_condition_images[0].file_name + '"></img>'}else{this.property_condition_image_0=''}
  if(count_of_items >= 2){this.property_condition_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[1].file_server_location +  '/' + this.property_condition_images[1].file_name + '"></img>'}else{this.property_condition_image_1=''}
  if(count_of_items >= 3){this.property_condition_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[2].file_server_location +  '/' + this.property_condition_images[2].file_name + '"></img>'}else{this.property_condition_image_2=''}
  if(count_of_items >= 4){this.property_condition_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[3].file_server_location +  '/' + this.property_condition_images[3].file_name + '"></img>'}else{this.property_condition_image_3=''}
  if(count_of_items >= 5){this.property_condition_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[4].file_server_location +  '/' + this.property_condition_images[4].file_name + '"></img>'}else{this.property_condition_image_4=''}
  if(count_of_items >= 6){this.property_condition_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[5].file_server_location +  '/' + this.property_condition_images[5].file_name + '"></img>'}else{this.property_condition_image_5=''}
  if(count_of_items >= 7){this.property_condition_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[6].file_server_location +  '/' + this.property_condition_images[6].file_name + '"></img>'}else{this.property_condition_image_6=''}
  if(count_of_items >= 8){this.property_condition_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[7].file_server_location +  '/' + this.property_condition_images[7].file_name + '"></img>'}else{this.property_condition_image_7=''}
  if(count_of_items >= 9){this.property_condition_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[8].file_server_location +  '/' + this.property_condition_images[8].file_name + '"></img>'}else{this.property_condition_image_8=''}
  if(count_of_items >= 10){this.property_condition_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[9].file_server_location +  '/' + this.property_condition_images[9].file_name + '"></img>'}else{this.property_condition_image_9=''}
  if(count_of_items >= 11){this.property_condition_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[10].file_server_location +  '/' + this.property_condition_images[10].file_name + '"></img>'}else{this.property_condition_image_10=''}
  if(count_of_items >= 11){this.property_condition_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[11].file_server_location +  '/' + this.property_condition_images[11].file_name + '"></img>'}else{this.property_condition_image_11=''}
  if(count_of_items >= 11){this.property_condition_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[12].file_server_location +  '/' + this.property_condition_images[12].file_name + '"></img>'}else{this.property_condition_image_12=''}
  if(count_of_items >= 11){this.property_condition_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[13].file_server_location +  '/' + this.property_condition_images[13].file_name + '"></img>'}else{this.property_condition_image_13=''}
  if(count_of_items >= 11){this.property_condition_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[14].file_server_location +  '/' + this.property_condition_images[14].file_name + '"></img>'}else{this.property_condition_image_14=''}
  if(count_of_items >= 11){this.property_condition_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[15].file_server_location +  '/' + this.property_condition_images[15].file_name + '"></img>'}else{this.property_condition_image_15=''}
  if(count_of_items >= 11){this.property_condition_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[16].file_server_location +  '/' + this.property_condition_images[16].file_name + '"></img>'}else{this.property_condition_image_16=''}
  if(count_of_items >= 11){this.property_condition_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[17].file_server_location +  '/' + this.property_condition_images[17].file_name + '"></img>'}else{this.property_condition_image_17=''}
  if(count_of_items >= 11){this.property_condition_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[18].file_server_location +  '/' + this.property_condition_images[18].file_name + '"></img>'}else{this.property_condition_image_18=''}
  if(count_of_items >= 11){this.property_condition_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[19].file_server_location +  '/' + this.property_condition_images[19].file_name + '"></img>'}else{this.property_condition_image_19=''}
  if(count_of_items >= 11){this.property_condition_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[20].file_server_location +  '/' + this.property_condition_images[20].file_name + '"></img>'}else{this.property_condition_image_20=''}
  if(count_of_items >= 11){this.property_condition_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[21].file_server_location +  '/' + this.property_condition_images[21].file_name + '"></img>'}else{this.property_condition_image_21=''}
  if(count_of_items >= 11){this.property_condition_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[22].file_server_location +  '/' + this.property_condition_images[22].file_name + '"></img>'}else{this.property_condition_image_22=''}
  if(count_of_items >= 11){this.property_condition_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[23].file_server_location +  '/' + this.property_condition_images[23].file_name + '"></img>'}else{this.property_condition_image_23=''}
  if(count_of_items >= 11){this.property_condition_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[24].file_server_location +  '/' + this.property_condition_images[24].file_name + '"></img>'}else{this.property_condition_image_24=''}
  if(count_of_items >= 11){this.property_condition_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[25].file_server_location +  '/' + this.property_condition_images[25].file_name + '"></img>'}else{this.property_condition_image_25=''}
}


if(this.attempts_paragraphs_model.property_type_images != '[]' && this.attempts_paragraphs_model.property_type_images != null){
  this.property_type_images = JSON.parse(this.attempts_paragraphs_model.property_type_images)
  let newArr = this.property_type_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_type_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[0].file_server_location +  '/' + this.property_type_images[0].file_name + '"></img>'}else{this.property_type_image_0=''}
  if(count_of_items >= 2){this.property_type_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[1].file_server_location +  '/' + this.property_type_images[1].file_name + '"></img>'}else{this.property_type_image_1=''}
  if(count_of_items >= 3){this.property_type_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[2].file_server_location +  '/' + this.property_type_images[2].file_name + '"></img>'}else{this.property_type_image_2=''}
  if(count_of_items >= 4){this.property_type_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[3].file_server_location +  '/' + this.property_type_images[3].file_name + '"></img>'}else{this.property_type_image_3=''}
  if(count_of_items >= 5){this.property_type_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[4].file_server_location +  '/' + this.property_type_images[4].file_name + '"></img>'}else{this.property_type_image_4=''}
  if(count_of_items >= 6){this.property_type_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[5].file_server_location +  '/' + this.property_type_images[5].file_name + '"></img>'}else{this.property_type_image_5=''}
  if(count_of_items >= 7){this.property_type_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[6].file_server_location +  '/' + this.property_type_images[6].file_name + '"></img>'}else{this.property_type_image_6=''}
  if(count_of_items >= 8){this.property_type_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[7].file_server_location +  '/' + this.property_type_images[7].file_name + '"></img>'}else{this.property_type_image_7=''}
  if(count_of_items >= 9){this.property_type_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[8].file_server_location +  '/' + this.property_type_images[8].file_name + '"></img>'}else{this.property_type_image_8=''}
  if(count_of_items >= 10){this.property_type_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[9].file_server_location +  '/' + this.property_type_images[9].file_name + '"></img>'}else{this.property_type_image_9=''}
  if(count_of_items >= 11){this.property_type_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[10].file_server_location +  '/' + this.property_type_images[10].file_name + '"></img>'}else{this.property_type_image_10=''}
  if(count_of_items >= 11){this.property_type_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[11].file_server_location +  '/' + this.property_type_images[11].file_name + '"></img>'}else{this.property_type_image_11=''}
  if(count_of_items >= 11){this.property_type_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[12].file_server_location +  '/' + this.property_type_images[12].file_name + '"></img>'}else{this.property_type_image_12=''}
  if(count_of_items >= 11){this.property_type_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[13].file_server_location +  '/' + this.property_type_images[13].file_name + '"></img>'}else{this.property_type_image_13=''}
  if(count_of_items >= 11){this.property_type_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[14].file_server_location +  '/' + this.property_type_images[14].file_name + '"></img>'}else{this.property_type_image_14=''}
  if(count_of_items >= 11){this.property_type_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[15].file_server_location +  '/' + this.property_type_images[15].file_name + '"></img>'}else{this.property_type_image_15=''}
  if(count_of_items >= 11){this.property_type_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[16].file_server_location +  '/' + this.property_type_images[16].file_name + '"></img>'}else{this.property_type_image_16=''}
  if(count_of_items >= 11){this.property_type_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[17].file_server_location +  '/' + this.property_type_images[17].file_name + '"></img>'}else{this.property_type_image_17=''}
  if(count_of_items >= 11){this.property_type_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[18].file_server_location +  '/' + this.property_type_images[18].file_name + '"></img>'}else{this.property_type_image_18=''}
  if(count_of_items >= 11){this.property_type_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[19].file_server_location +  '/' + this.property_type_images[19].file_name + '"></img>'}else{this.property_type_image_19=''}
  if(count_of_items >= 11){this.property_type_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[20].file_server_location +  '/' + this.property_type_images[20].file_name + '"></img>'}else{this.property_type_image_20=''}
  if(count_of_items >= 11){this.property_type_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[21].file_server_location +  '/' + this.property_type_images[21].file_name + '"></img>'}else{this.property_type_image_21=''}
  if(count_of_items >= 11){this.property_type_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[22].file_server_location +  '/' + this.property_type_images[22].file_name + '"></img>'}else{this.property_type_image_22=''}
  if(count_of_items >= 11){this.property_type_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[23].file_server_location +  '/' + this.property_type_images[23].file_name + '"></img>'}else{this.property_type_image_23=''}
  if(count_of_items >= 11){this.property_type_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[24].file_server_location +  '/' + this.property_type_images[24].file_name + '"></img>'}else{this.property_type_image_24=''}
  if(count_of_items >= 11){this.property_type_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[25].file_server_location +  '/' + this.property_type_images[25].file_name + '"></img>'}else{this.property_type_image_25=''}
}




if(this.attempts_paragraphs_model.service_file_array != '[]' && this.attempts_paragraphs_model.service_file_array != null){
  this.service_file_array_images = JSON.parse(this.attempts_paragraphs_model.service_file_array)
  let newArr = this.service_file_array_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.service_file_array_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[0].file_server_location +  '/' + this.service_file_array_images[0].file_name + '"></img>'}else{this.service_file_array_image_0=''}
  if(count_of_items >= 2){this.service_file_array_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[1].file_server_location +  '/' + this.service_file_array_images[1].file_name + '"></img>'}else{this.service_file_array_image_1=''}
  if(count_of_items >= 3){this.service_file_array_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[2].file_server_location +  '/' + this.service_file_array_images[2].file_name + '"></img>'}else{this.service_file_array_image_2=''}
  if(count_of_items >= 4){this.service_file_array_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[3].file_server_location +  '/' + this.service_file_array_images[3].file_name + '"></img>'}else{this.service_file_array_image_3=''}
  if(count_of_items >= 5){this.service_file_array_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[4].file_server_location +  '/' + this.service_file_array_images[4].file_name + '"></img>'}else{this.service_file_array_image_4=''}
  if(count_of_items >= 6){this.service_file_array_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[5].file_server_location +  '/' + this.service_file_array_images[5].file_name + '"></img>'}else{this.service_file_array_image_5=''}
  if(count_of_items >= 7){this.service_file_array_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[6].file_server_location +  '/' + this.service_file_array_images[6].file_name + '"></img>'}else{this.service_file_array_image_6=''}
  if(count_of_items >= 8){this.service_file_array_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[7].file_server_location +  '/' + this.service_file_array_images[7].file_name + '"></img>'}else{this.service_file_array_image_7=''}
  if(count_of_items >= 9){this.service_file_array_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[8].file_server_location +  '/' + this.service_file_array_images[8].file_name + '"></img>'}else{this.service_file_array_image_8=''}
  if(count_of_items >= 10){this.service_file_array_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[9].file_server_location +  '/' + this.service_file_array_images[9].file_name + '"></img>'}else{this.service_file_array_image_9=''}
  if(count_of_items >= 11){this.service_file_array_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[10].file_server_location +  '/' + this.service_file_array_images[10].file_name + '"></img>'}else{this.service_file_array_image_10=''}
  if(count_of_items >= 11){this.service_file_array_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[11].file_server_location +  '/' + this.service_file_array_images[11].file_name + '"></img>'}else{this.service_file_array_image_11=''}
  if(count_of_items >= 11){this.service_file_array_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[12].file_server_location +  '/' + this.service_file_array_images[12].file_name + '"></img>'}else{this.service_file_array_image_12=''}
  if(count_of_items >= 11){this.service_file_array_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[13].file_server_location +  '/' + this.service_file_array_images[13].file_name + '"></img>'}else{this.service_file_array_image_13=''}
  if(count_of_items >= 11){this.service_file_array_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[14].file_server_location +  '/' + this.service_file_array_images[14].file_name + '"></img>'}else{this.service_file_array_image_14=''}
  if(count_of_items >= 11){this.service_file_array_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[15].file_server_location +  '/' + this.service_file_array_images[15].file_name + '"></img>'}else{this.service_file_array_image_15=''}
  if(count_of_items >= 11){this.service_file_array_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[16].file_server_location +  '/' + this.service_file_array_images[16].file_name + '"></img>'}else{this.service_file_array_image_16=''}
  if(count_of_items >= 11){this.service_file_array_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[17].file_server_location +  '/' + this.service_file_array_images[17].file_name + '"></img>'}else{this.service_file_array_image_17=''}
  if(count_of_items >= 11){this.service_file_array_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[18].file_server_location +  '/' + this.service_file_array_images[18].file_name + '"></img>'}else{this.service_file_array_image_18=''}
  if(count_of_items >= 11){this.service_file_array_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[19].file_server_location +  '/' + this.service_file_array_images[19].file_name + '"></img>'}else{this.service_file_array_image_19=''}
  if(count_of_items >= 11){this.service_file_array_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[20].file_server_location +  '/' + this.service_file_array_images[20].file_name + '"></img>'}else{this.service_file_array_image_20=''}
  if(count_of_items >= 11){this.service_file_array_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[21].file_server_location +  '/' + this.service_file_array_images[21].file_name + '"></img>'}else{this.service_file_array_image_21=''}
  if(count_of_items >= 11){this.service_file_array_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[22].file_server_location +  '/' + this.service_file_array_images[22].file_name + '"></img>'}else{this.service_file_array_image_22=''}
  if(count_of_items >= 11){this.service_file_array_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[23].file_server_location +  '/' + this.service_file_array_images[23].file_name + '"></img>'}else{this.service_file_array_image_23=''}
  if(count_of_items >= 11){this.service_file_array_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[24].file_server_location +  '/' + this.service_file_array_images[24].file_name + '"></img>'}else{this.service_file_array_image_24=''}
  if(count_of_items >= 11){this.service_file_array_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[25].file_server_location +  '/' + this.service_file_array_images[25].file_name + '"></img>'}else{this.service_file_array_image_25=''}
}

  const rendered_result = str



      .replaceAll( '${' + keystarter + '_type_id}', this.attempts_paragraphs_model.subject_attempt_type_id)
      .replaceAll( '${' + keystarter + '_type_name}', this.attempts_paragraphs_model.subject_attempt_type_name ) // run a function with return;
      .replaceAll( '${' + keystarter + '_subject_attempt_type_name}', this.attempts_paragraphs_model.subject_attempt_type_name ) // run a function with return;
      .replaceAll( '${' + keystarter + '_type_name_upper}', this.var_subject_attempt_type_name_Upper) // all if statments set a this/g/ varaibales

      .replaceAll( '${' + keystarter + '_subject_service_method_id}', this.attempts_paragraphs_model.subject_service_method_id)
      .replaceAll( '${' + keystarter + '_subject_service_method_name}', this.attempts_paragraphs_model.subject_service_method_name ) // tested above.
      .replaceAll( '${' + keystarter + '_service_method}', this.attempts_paragraphs_model.subject_service_method_name ) // tested above.
      .replaceAll( '${' + keystarter + '_service_method_id}', this.attempts_paragraphs_model.subject_service_method_id) // tested above.


      .replaceAll( '${' + keystarter + '_date_service}', moment(this.attempts_paragraphs_model.date_service).format('D/M/YYYY'))
      .replaceAll( '${' + keystarter + '_date_service_full_words_time_first}', this.attempts_paragraphs_model.time_service_text + ' ' + moment(this.attempts_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') ) 
      .replaceAll( '${' + keystarter + '_date_service_and_time_full_words}', moment(this.attempts_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') + ' ' + this.attempts_paragraphs_model.time_service_text ) 
      .replaceAll( '${' + keystarter + '_date_service_full_words}', moment(this.attempts_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') + ' ' + model.time_service_text ) 

      .replaceAll( '${' + keystarter + '_day}', moment(this.attempts_paragraphs_model.date_service).format('dddd'))
      .replaceAll( '${' + keystarter + '_day_number}', moment(this.attempts_paragraphs_model.date_service).format('Do'))
      .replaceAll( '${' + keystarter + '_day_number_simple}', moment(this.attempts_paragraphs_model.date_service).format('D'))
      .replaceAll( '${' + keystarter + '_month}', moment(this.attempts_paragraphs_model.date_service).format('MMMM'))
      .replaceAll( '${' + keystarter + '_month_number}', moment(this.attempts_paragraphs_model.date_service).format('Mo'))
      .replaceAll( '${' + keystarter + '_month_number_simple}', moment(this.attempts_paragraphs_model.date_service).format('M'))
      .replaceAll( '${' + keystarter + '_year}', moment(this.attempts_paragraphs_model.date_service).format('YYYY'))

      .replaceAll( '${' + keystarter + '_service_local}', this.attempts_paragraphs_model.service_local) // region Australia/Perth of service undertaken
      .replaceAll( '${' + keystarter + '_time}', this.attempts_paragraphs_model.time_service_text) //$_set_service_time - Fixed and set time of attempt and service

      .replaceAll( '${' + keystarter + '_paragraph_rendered}',  this.set_service_paragraph_rendered) //$_set_service_time - Fixed and set time of attempt and service

      .replaceAll( '${' + keystarter + '_subject_name}', var_subject_name)
      .replaceAll( '${' + keystarter + '_subject_number}', this.attempts_paragraphs_model.subject_number)
      .replaceAll( '${' + keystarter + '_subject_name_4_doc}', var_subject_name_4_doc)
      .replaceAll( '${' + keystarter + '_subject_business_name}', var_subject_business_name)
      .replaceAll( '${' + keystarter + '_business_name}', var_subject_business_name)

  // Subject Attempt Address
  .replaceAll( '${' + keystarter + '_address_1}', this.attempts_paragraphs_model.address_1)
  .replaceAll( '${' + keystarter + '_address_2}', this.attempts_paragraphs_model.address_2)
  .replaceAll( '${' + keystarter + '_suburb}', this.attempts_paragraphs_model.suburb)
  .replaceAll( '${' + keystarter + '_state}', this.attempts_paragraphs_model.state)
  .replaceAll( '${' + keystarter + '_postcode}', this.attempts_paragraphs_model.postcode)
  .replaceAll( '${' + keystarter + '_address_full}', this.attempts_paragraphs_model.address_1 +  ' ' + this.attempts_paragraphs_model.address_2 +  ' ' + this.attempts_paragraphs_model.suburb +  ' ' + this.attempts_paragraphs_model.state +  ',  ' + this.attempts_paragraphs_model.postcode )
  // Sav
  .replaceAll( '${' + keystarter + '_sav_address_full}', this.attempts_paragraphs_model.address_1 +  ' ' + this.attempts_paragraphs_model.address_2 +  ' ' + this.attempts_paragraphs_model.suburb +  ' ' + this.attempts_paragraphs_model.state +  ',  ' + this.attempts_paragraphs_model.postcode )
  // New address
  .replaceAll( '${' + keystarter + '_new_business_name}', this.attempts_paragraphs_model.new_business_name)
  .replaceAll( '${' + keystarter + '_new_address_1}', this.attempts_paragraphs_model.new_address_1)
  .replaceAll( '${' + keystarter + '_new_address_2}', this.attempts_paragraphs_model.new_address_2)
  .replaceAll( '${' + keystarter + '_new_suburb}', this.attempts_paragraphs_model.new_suburb)
  .replaceAll( '${' + keystarter + '_new_state}', this.attempts_paragraphs_model.new_state)
  .replaceAll( '${' + keystarter + '_new_postcode}', this.attempts_paragraphs_model.new_postcode)
  .replaceAll( '${' + keystarter + '_new_address_full}', this.attempts_paragraphs_model.new_address_1 +  ' ' + this.attempts_paragraphs_model.new_address_2 +  ' ' + this.attempts_paragraphs_model.new_suburb +  ' ' + this.attempts_paragraphs_model.new_state +  ',  ' + this.attempts_paragraphs_model.new_postcode )
  
  .replaceAll( '${' + keystarter + '_service_number}', this.attempts_paragraphs_model.service_number)

  .replaceAll( '${' + keystarter + '_service_outcome_name}', this.attempts_paragraphs_model.subject_service_outcome_name)
  .replaceAll( '${' + keystarter + '_exact_service_method_name}', this.attempts_paragraphs_model.exact_service_method_name) //
  .replaceAll( '${' + keystarter + '_subject_type_name}', this.job_subject_type_name) // set in the job lookup.
  .replaceAll( '${' + keystarter + '_subject_type_name_upper}', this.job_subject_type_name_Upper) // set in the job lookup.
  .replaceAll( '${' + keystarter + '_location_status_name}', this.attempts_paragraphs_model.subject_location_status_name)
  .replaceAll( '${' + keystarter + '_location_status_found_name}', this.attempts_paragraphs_model.subject_location_status_found_name)

  .replaceAll( '${' + keystarter + '_fellow_occupants_name}', this.attempts_paragraphs_model.fellow_occupants_name)
  .replaceAll( '${' + keystarter + '_fellow_occupants_sex}', this.attempts_paragraphs_model.fellow_occupants_sex)
  .replaceAll( '${' + keystarter + '_fellow_occupants_name_label}', 'Fellow Occupants Name: ' +  this.attempts_paragraphs_model.fellow_occupants_name)
  .replaceAll( '${' + keystarter + '_subject_relationship_name}', this.attempts_paragraphs_model.subject_service_fellow_relationship)

  .replaceAll( '${' + keystarter + '_person_spoken_with}', this.attempts_paragraphs_model.person_spoken_with)
  .replaceAll( '${' + keystarter + '_person_type}', this.attempts_paragraphs_model.person_type)
  .replaceAll( '${' + keystarter + '_person_spoken_with_advised}',   this.person_spoken_with_advised_HTML ) 

  .replaceAll( '${' + keystarter + '_vehicles}', this.attempts_paragraphs_model.vehicles)
.replaceAll( '${' + keystarter + '_vehicles_notes}',   this.vehicles_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_neighbours}', this.attempts_paragraphs_model.neighbours)
.replaceAll( '${' + keystarter + '_neighbours_notes}',   this.neighbours_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_calling_card}', this.attempts_paragraphs_model.calling_card)
.replaceAll( '${' + keystarter + '_calling_card_notes}',   this.calling_card_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_postal_mail}', this.attempts_paragraphs_model.postal_mail)
.replaceAll( '${' + keystarter + '_postal_mail_notes}',   this.postal_mail_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_phone_call}', this.attempts_paragraphs_model.phone_call)
.replaceAll( '${' + keystarter + '_phone_call_notes}',   this.phone_call_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_attempts}', this.attempts_paragraphs_model.attempts)
.replaceAll( '${' + keystarter + '_attempts_notes}',   this.attempts_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_authorised_employee_name}', this.attempts_paragraphs_model.authorised_employee_name)
.replaceAll( '${' + keystarter + '_authorised_employee_job_title}', this.attempts_paragraphs_model.authorised_employee_job_title)
.replaceAll( '${' + keystarter + '_authorised_employee_sex}', this.attempts_paragraphs_model.authorised_employee_sex)
.replaceAll( '${' + keystarter + '_office_business_name}', this.attempts_paragraphs_model.office_business_name)

.replaceAll( '${' + keystarter + '_witness_name}', this.attempts_paragraphs_model.witness_name)
.replaceAll( '${' + keystarter + '_witness_business_name}', this.attempts_paragraphs_model.witness_business_name)
.replaceAll( '${' + keystarter + '_witness_address}', this.attempts_paragraphs_model.witness_address_1 + ' ' + this.attempts_paragraphs_model.witness_address_2 + ' ' +  this.attempts_paragraphs_model.witness_suburb + ' ' + this.attempts_paragraphs_model.witness_state + ', ' + this.attempts_paragraphs_model.witness_postcode  ) // 
.replaceAll( '${' + keystarter + '_witness_address_1}', this.attempts_paragraphs_model.witness_address_1)
.replaceAll( '${' + keystarter + '_witness_address_2}', this.attempts_paragraphs_model.witness_address_2)
.replaceAll( '${' + keystarter + '_witness_state}', this.attempts_paragraphs_model.witness_state)
.replaceAll( '${' + keystarter + '_witness_suburb}', this.attempts_paragraphs_model.witness_suburb)
.replaceAll( '${' + keystarter + '_witness_country}', this.attempts_paragraphs_model.witness_country)
.replaceAll( '${' + keystarter + '_witness_postcode}', this.attempts_paragraphs_model.witness_postcode)

.replaceAll( '${' + keystarter + '_person_in_charge_of_prison_name}', this.attempts_paragraphs_model.person_in_charge_of_prison_name)
.replaceAll( '${' + keystarter + '_person_in_charge_of_prison_occupation}', this.attempts_paragraphs_model.person_in_charge_of_prison_occupation)

.replaceAll( '${' + keystarter + '_ubject_contact_email_id}', this.attempts_paragraphs_model.subject_contact_email_id)
.replaceAll( '${' + keystarter + '_email_address_served}', this.attempts_paragraphs_model.email_address_served)
.replaceAll( '${' + keystarter + '_email_contents}', this.email_contents_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_director_name}', this.attempts_paragraphs_model.director_name)
// .replaceAll( '${' + keystarter + '_service_under_order}', this.attempts_paragraphs_model.service_under_order)
.replaceAll( '${' + keystarter + '_service_under_order}', this.service_under_order_HTML)

.replaceAll( '${' + keystarter + '_phone_number}', this.attempts_paragraphs_model.phone_number)



  // Agent Details
  .replaceAll( '${' + keystarter + '_agent_name}', this.subject_service_agent.first_name + ' ' + this.subject_service_agent.middle_name + ' ' + this.subject_service_agent.surname )
  .replaceAll( '${' + keystarter + '_agent_first_name}', this.subject_service_agent.first_name)
  .replaceAll( '${' + keystarter + '_agent_middle_name}', this.subject_service_agent.middle_name)
  .replaceAll( '${' + keystarter + '_agent_surname}', this.subject_service_agent.surname)
  
  .replaceAll( '${' + keystarter + '_agent_address_1}', this.subject_service_agent.address_1)
  .replaceAll( '${' + keystarter + '_agent_address_2}', this.subject_service_agent.address_2)
  .replaceAll( '${' + keystarter + '_agent_suburb}', this.subject_service_agent.suburb)
  .replaceAll( '${' + keystarter + '_agent_state}', this.subject_service_agent.state)
  .replaceAll( '${' + keystarter + '_agent_postcode}', this.subject_service_agent.postcode)
  .replaceAll( '${' + keystarter + '_agent_address_full}', this.subject_service_agent.address_1 + ' ' + this.subject_service_agent.address_2 + ' ' + this.subject_service_agent.suburb + ' ' + this.subject_service_agent.state + ', ' + this.subject_service_agent.postcode )
  .replaceAll( '${' + keystarter + '_agent_qualification}', this.subject_service_agent.qualification)
  .replaceAll( '${' + keystarter + '_agent_qualification_number}', this.subject_service_agent.qualification_number)
  
  .replaceAll( '${' + keystarter + '_agent_qualification_renewal_date}', moment(this.subject_service_agent.qualification_renewal_date).format('D/M/YYYY') )
  .replaceAll( '${' + keystarter + '_agent_qualification_renewal_date_full_words}', moment(this.subject_service_agent.qualification_renewal_date).format('dddd MMMM Do, YYYY h:mma') )

  .replaceAll( '${' + keystarter + '_general_notes}',  this.set_general_notes ) // replace original only use this for create.

  .replaceAll( '${' + keystarter + '_is_count}', this.attempts_paragraphs_model.is_count)
  .replaceAll( '${' + keystarter + '_property_images}', this.attempts_paragraphs_model.property_images)
  .replaceAll( '${' + keystarter + '_attach_file_array_name}', this.attempts_paragraphs_model.attach_file_array_name)
  .replaceAll( '${' + keystarter + '_property_occupied}', this.attempts_paragraphs_model.property_occupied)

  .replaceAll( '${' + keystarter + '_property_forsale_or_lease_sign}', this.attempts_paragraphs_model.property_forsale_or_lease_sign)
  .replaceAll( '${' + keystarter + '_property_sign_images}', this.attempts_paragraphs_model.property_sign_images)
.replaceAll( '${' + keystarter + '_property_forsale_or_lease_sign_details}',   this.property_forsale_or_lease_sign_details_HTML) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_agent_name}', this.attempts_paragraphs_model.property_agent_name)
.replaceAll( '${' + keystarter + '_property_agency_name}', this.attempts_paragraphs_model.property_agency_name)
.replaceAll( '${' + keystarter + '_property_agency_contact_numbers}', this.attempts_paragraphs_model.property_agency_contact_numbers)


.replaceAll( '${' + keystarter + '_property_mail}', this.attempts_paragraphs_model.property_mail)
.replaceAll( '${' + keystarter + '_property_mail_images}', this.attempts_paragraphs_model.property_mail_images)
.replaceAll( '${' + keystarter + '_property_mail_details}', this.property_mail_details_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_property_vehicles_sighted}', this.attempts_paragraphs_model.property_vehicles_sighted)
.replaceAll( '${' + keystarter + '_property_vehicles_sighted_details}', this.property_vehicles_sighted_details_HTML ) // replace original only use this for create.
  .replaceAll( '${' + keystarter + '_property_vehicles_images}', this.attempts_paragraphs_model.property_vehicles_images)
  .replaceAll( '${' + keystarter + '_property_v_make}', this.attempts_paragraphs_model.property_v_make)
  .replaceAll( '${' + keystarter + '_property_v_model}', this.attempts_paragraphs_model.property_v_model)
  .replaceAll( '${' + keystarter + '_property_v_plate}', this.attempts_paragraphs_model.property_v_plate)
  .replaceAll( '${' + keystarter + '_property_v_rego_state}', this.attempts_paragraphs_model.property_v_rego_state)

  .replaceAll( '${' + keystarter + '_property_pets}', this.attempts_paragraphs_model.property_pets)
.replaceAll( '${' + keystarter + '_property_pets_details}', this.property_pets_details_HTML ) // replace original only use this for create.
  .replaceAll( '${' + keystarter + '_property_pets_images}', this.attempts_paragraphs_model.property_pets_images)

.replaceAll( '${' + keystarter + '_property_occupancy}', this.attempts_paragraphs_model.property_occupancy)
.replaceAll( '${' + keystarter + '_property_occupancy_details}', this.property_occupancy_details_HTML ) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_occupancy_images}', this.attempts_paragraphs_model.property_occupancy_images)
.replaceAll( '${' + keystarter + '_property_o_name}', this.attempts_paragraphs_model.property_o_name)
.replaceAll( '${' + keystarter + '_property_o_contact_numbers}', this.attempts_paragraphs_model.property_o_contact_numbers)
.replaceAll( '${' + keystarter + '_property_o_lease_details}', this.attempts_paragraphs_model.property_o_lease_details)
.replaceAll( '${' + keystarter + '_property_o_lease_date}', this.attempts_paragraphs_model.property_o_lease_date)
.replaceAll( '${' + keystarter + '_property_o_landlord_contacts}', this.attempts_paragraphs_model.property_o_landlord_contacts)

.replaceAll( '${' + keystarter + '_property_condition}', this.property_condition_HTML ) // replace original only use this for create.
  .replaceAll( '${' + keystarter + '_property_condition_images}', this.attempts_paragraphs_model.property_condition_images)

.replaceAll( '${' + keystarter + '_property_occupied_details}', this.property_occupied_details_HTML) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_property_type_id}', this.attempts_paragraphs_model.property_type_id)
.replaceAll( '${' + keystarter + '_property_type_details}', this.set_property_type_details_HTML) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_type_images}', this.attempts_paragraphs_model.property_type_images)

.replaceAll( '${' + keystarter + '_property_type_name}', this.attempts_paragraphs_model.property_type_name)

.replaceAll( '${' + keystarter + '_service_file_array}', this.attempts_paragraphs_model.service_file_array)


// Images // <img src="pic_trulli.jpg" alt="Italian Trulli">
// this.attempts_paragraphs_model.property_images - runs a loop functino above to set image variables
.replaceAll( '${' + keystarter + '_property_image_0}',  this.propery_image_0 )
.replaceAll( '${' + keystarter + '_property_image_1}',  this.propery_image_1 )
.replaceAll( '${' + keystarter + '_property_image_2}',  this.propery_image_2 )
.replaceAll( '${' + keystarter + '_property_image_3}',  this.propery_image_3 )
.replaceAll( '${' + keystarter + '_property_image_4}',  this.propery_image_4 )
.replaceAll( '${' + keystarter + '_property_image_5}',  this.propery_image_5 )
.replaceAll( '${' + keystarter + '_property_image_6}',  this.propery_image_6 )
.replaceAll( '${' + keystarter + '_property_image_7}',  this.propery_image_7 )
.replaceAll( '${' + keystarter + '_property_image_8}',  this.propery_image_8 )
.replaceAll( '${' + keystarter + '_property_image_9}',  this.propery_image_9 )
.replaceAll( '${' + keystarter + '_property_image_10}',  this.propery_image_10 )
.replaceAll( '${' + keystarter + '_property_image_11}',  this.propery_image_11 )
.replaceAll( '${' + keystarter + '_property_image_12}',  this.propery_image_12 )
.replaceAll( '${' + keystarter + '_property_image_13}',  this.propery_image_13 )
.replaceAll( '${' + keystarter + '_property_image_14}',  this.propery_image_14 )
.replaceAll( '${' + keystarter + '_property_image_15}',  this.propery_image_15 )
.replaceAll( '${' + keystarter + '_property_image_16}',  this.propery_image_16 )
.replaceAll( '${' + keystarter + '_property_image_17}',  this.propery_image_17 )
.replaceAll( '${' + keystarter + '_property_image_18}',  this.propery_image_18 )
.replaceAll( '${' + keystarter + '_property_image_19}',  this.propery_image_19 )
.replaceAll( '${' + keystarter + '_property_image_20}',  this.propery_image_20 )
.replaceAll( '${' + keystarter + '_property_image_21}',  this.propery_image_21 )
.replaceAll( '${' + keystarter + '_property_image_22}',  this.propery_image_22 )
.replaceAll( '${' + keystarter + '_property_image_23}',  this.propery_image_23 )
.replaceAll( '${' + keystarter + '_property_image_24}',  this.propery_image_24 )
.replaceAll( '${' + keystarter + '_property_image_25}',  this.propery_image_25 )


.replaceAll( '${' + keystarter + '_property_sign_image_0}',  this.property_sign_image_0 )
.replaceAll( '${' + keystarter + '_property_sign_image_1}',  this.property_sign_image_1 )
.replaceAll( '${' + keystarter + '_property_sign_image_2}',  this.property_sign_image_2 )
.replaceAll( '${' + keystarter + '_property_sign_image_3}',  this.property_sign_image_3 )
.replaceAll( '${' + keystarter + '_property_sign_image_4}',  this.property_sign_image_4 )
.replaceAll( '${' + keystarter + '_property_sign_image_5}',  this.property_sign_image_5 )
.replaceAll( '${' + keystarter + '_property_sign_image_6}',  this.property_sign_image_6 )
.replaceAll( '${' + keystarter + '_property_sign_image_7}',  this.property_sign_image_7 )
.replaceAll( '${' + keystarter + '_property_sign_image_8}',  this.property_sign_image_8 )
.replaceAll( '${' + keystarter + '_property_sign_image_9}',  this.property_sign_image_9 )
.replaceAll( '${' + keystarter + '_property_sign_image_10}',  this.property_sign_image_10 )
.replaceAll( '${' + keystarter + '_property_sign_image_11}',  this.property_sign_image_11 )
.replaceAll( '${' + keystarter + '_property_sign_image_12}',  this.property_sign_image_12 )
.replaceAll( '${' + keystarter + '_property_sign_image_13}',  this.property_sign_image_13 )
.replaceAll( '${' + keystarter + '_property_sign_image_14}',  this.property_sign_image_14 )
.replaceAll( '${' + keystarter + '_property_sign_image_15}',  this.property_sign_image_15 )
.replaceAll( '${' + keystarter + '_property_sign_image_16}',  this.property_sign_image_16 )
.replaceAll( '${' + keystarter + '_property_sign_image_17}',  this.property_sign_image_17 )
.replaceAll( '${' + keystarter + '_property_sign_image_18}',  this.property_sign_image_18 )
.replaceAll( '${' + keystarter + '_property_sign_image_19}',  this.property_sign_image_19 )
.replaceAll( '${' + keystarter + '_property_sign_image_20}',  this.property_sign_image_20 )
.replaceAll( '${' + keystarter + '_property_sign_image_21}',  this.property_sign_image_21 )
.replaceAll( '${' + keystarter + '_property_sign_image_22}',  this.property_sign_image_22 )
.replaceAll( '${' + keystarter + '_property_sign_image_23}',  this.property_sign_image_23 )
.replaceAll( '${' + keystarter + '_property_sign_image_24}',  this.property_sign_image_24 )
.replaceAll( '${' + keystarter + '_property_sign_image_25}',  this.property_sign_image_25 )


.replaceAll( '${' + keystarter + '_property_mail_image_0}',  this.property_mail_image_0 )
.replaceAll( '${' + keystarter + '_property_mail_image_1}',  this.property_mail_image_1 )
.replaceAll( '${' + keystarter + '_property_mail_image_2}',  this.property_mail_image_2 )
.replaceAll( '${' + keystarter + '_property_mail_image_3}',  this.property_mail_image_3 )
.replaceAll( '${' + keystarter + '_property_mail_image_4}',  this.property_mail_image_4 )
.replaceAll( '${' + keystarter + '_property_mail_image_5}',  this.property_mail_image_5 )
.replaceAll( '${' + keystarter + '_property_mail_image_6}',  this.property_mail_image_6 )
.replaceAll( '${' + keystarter + '_property_mail_image_7}',  this.property_mail_image_7 )
.replaceAll( '${' + keystarter + '_property_mail_image_8}',  this.property_mail_image_8 )
.replaceAll( '${' + keystarter + '_property_mail_image_9}',  this.property_mail_image_9 )
.replaceAll( '${' + keystarter + '_property_mail_image_10}',  this.property_mail_image_10 )
.replaceAll( '${' + keystarter + '_property_mail_image_11}',  this.property_mail_image_11 )
.replaceAll( '${' + keystarter + '_property_mail_image_12}',  this.property_mail_image_12 )
.replaceAll( '${' + keystarter + '_property_mail_image_13}',  this.property_mail_image_13 )
.replaceAll( '${' + keystarter + '_property_mail_image_14}',  this.property_mail_image_14 )
.replaceAll( '${' + keystarter + '_property_mail_image_15}',  this.property_mail_image_15 )
.replaceAll( '${' + keystarter + '_property_mail_image_16}',  this.property_mail_image_16 )
.replaceAll( '${' + keystarter + '_property_mail_image_17}',  this.property_mail_image_17 )
.replaceAll( '${' + keystarter + '_property_mail_image_18}',  this.property_mail_image_18 )
.replaceAll( '${' + keystarter + '_property_mail_image_19}',  this.property_mail_image_19 )
.replaceAll( '${' + keystarter + '_property_mail_image_20}',  this.property_mail_image_20 )
.replaceAll( '${' + keystarter + '_property_mail_image_21}',  this.property_mail_image_21 )
.replaceAll( '${' + keystarter + '_property_mail_image_22}',  this.property_mail_image_22 )
.replaceAll( '${' + keystarter + '_property_mail_image_23}',  this.property_mail_image_23 )
.replaceAll( '${' + keystarter + '_property_mail_image_24}',  this.property_mail_image_24 )
.replaceAll( '${' + keystarter + '_property_mail_image_25}',  this.property_mail_image_25 )


.replaceAll( '${' + keystarter + '_property_vehicles_image_0}',  this.property_vehicles_image_0 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_1}',  this.property_vehicles_image_1 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_2}',  this.property_vehicles_image_2 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_3}',  this.property_vehicles_image_3 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_4}',  this.property_vehicles_image_4 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_5}',  this.property_vehicles_image_5 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_6}',  this.property_vehicles_image_6 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_7}',  this.property_vehicles_image_7 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_8}',  this.property_vehicles_image_8 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_9}',  this.property_vehicles_image_9 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_10}',  this.property_vehicles_image_10 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_11}',  this.property_vehicles_image_11 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_12}',  this.property_vehicles_image_12 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_13}',  this.property_vehicles_image_13 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_14}',  this.property_vehicles_image_14 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_15}',  this.property_vehicles_image_15 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_16}',  this.property_vehicles_image_16 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_17}',  this.property_vehicles_image_17 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_18}',  this.property_vehicles_image_18 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_19}',  this.property_vehicles_image_19 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_20}',  this.property_vehicles_image_20 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_21}',  this.property_vehicles_image_21 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_22}',  this.property_vehicles_image_22 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_23}',  this.property_vehicles_image_23 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_24}',  this.property_vehicles_image_24 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_25}',  this.property_vehicles_image_25 )


.replaceAll( '${' + keystarter + '_property_pets_image_0}',  this.property_pets_image_0 )
.replaceAll( '${' + keystarter + '_property_pets_image_1}',  this.property_pets_image_1 )
.replaceAll( '${' + keystarter + '_property_pets_image_2}',  this.property_pets_image_2 )
.replaceAll( '${' + keystarter + '_property_pets_image_3}',  this.property_pets_image_3 )
.replaceAll( '${' + keystarter + '_property_pets_image_4}',  this.property_pets_image_4 )
.replaceAll( '${' + keystarter + '_property_pets_image_5}',  this.property_pets_image_5 )
.replaceAll( '${' + keystarter + '_property_pets_image_6}',  this.property_pets_image_6 )
.replaceAll( '${' + keystarter + '_property_pets_image_7}',  this.property_pets_image_7 )
.replaceAll( '${' + keystarter + '_property_pets_image_8}',  this.property_pets_image_8 )
.replaceAll( '${' + keystarter + '_property_pets_image_9}',  this.property_pets_image_9 )
.replaceAll( '${' + keystarter + '_property_pets_image_10}',  this.property_pets_image_10 )
.replaceAll( '${' + keystarter + '_property_pets_image_11}',  this.property_pets_image_11 )
.replaceAll( '${' + keystarter + '_property_pets_image_12}',  this.property_pets_image_12 )
.replaceAll( '${' + keystarter + '_property_pets_image_13}',  this.property_pets_image_13 )
.replaceAll( '${' + keystarter + '_property_pets_image_14}',  this.property_pets_image_14 )
.replaceAll( '${' + keystarter + '_property_pets_image_15}',  this.property_pets_image_15 )
.replaceAll( '${' + keystarter + '_property_pets_image_16}',  this.property_pets_image_16 )
.replaceAll( '${' + keystarter + '_property_pets_image_17}',  this.property_pets_image_17 )
.replaceAll( '${' + keystarter + '_property_pets_image_18}',  this.property_pets_image_18 )
.replaceAll( '${' + keystarter + '_property_pets_image_19}',  this.property_pets_image_19 )
.replaceAll( '${' + keystarter + '_property_pets_image_20}',  this.property_pets_image_20 )
.replaceAll( '${' + keystarter + '_property_pets_image_21}',  this.property_pets_image_21 )
.replaceAll( '${' + keystarter + '_property_pets_image_22}',  this.property_pets_image_22 )
.replaceAll( '${' + keystarter + '_property_pets_image_23}',  this.property_pets_image_23 )
.replaceAll( '${' + keystarter + '_property_pets_image_24}',  this.property_pets_image_24 )
.replaceAll( '${' + keystarter + '_property_pets_image_25}',  this.property_pets_image_25 )

.replaceAll( '${' + keystarter + '_property_occupancy_image_0}',  this.property_occupancy_image_0 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_1}',  this.property_occupancy_image_1 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_2}',  this.property_occupancy_image_2 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_3}',  this.property_occupancy_image_3 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_4}',  this.property_occupancy_image_4 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_5}',  this.property_occupancy_image_5 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_6}',  this.property_occupancy_image_6 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_7}',  this.property_occupancy_image_7 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_8}',  this.property_occupancy_image_8 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_9}',  this.property_occupancy_image_9 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_10}',  this.property_occupancy_image_10 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_11}',  this.property_occupancy_image_11 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_12}',  this.property_occupancy_image_12 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_13}',  this.property_occupancy_image_13 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_14}',  this.property_occupancy_image_14 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_15}',  this.property_occupancy_image_15 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_16}',  this.property_occupancy_image_16 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_17}',  this.property_occupancy_image_17 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_18}',  this.property_occupancy_image_18 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_19}',  this.property_occupancy_image_19 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_20}',  this.property_occupancy_image_20 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_21}',  this.property_occupancy_image_21 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_22}',  this.property_occupancy_image_22 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_23}',  this.property_occupancy_image_23 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_24}',  this.property_occupancy_image_24 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_25}',  this.property_occupancy_image_25 )

.replaceAll( '${' + keystarter + '_property_condition_image_0}',  this.property_condition_image_0 )
.replaceAll( '${' + keystarter + '_property_condition_image_1}',  this.property_condition_image_1 )
.replaceAll( '${' + keystarter + '_property_condition_image_2}',  this.property_condition_image_2 )
.replaceAll( '${' + keystarter + '_property_condition_image_3}',  this.property_condition_image_3 )
.replaceAll( '${' + keystarter + '_property_condition_image_4}',  this.property_condition_image_4 )
.replaceAll( '${' + keystarter + '_property_condition_image_5}',  this.property_condition_image_5 )
.replaceAll( '${' + keystarter + '_property_condition_image_6}',  this.property_condition_image_6 )
.replaceAll( '${' + keystarter + '_property_condition_image_7}',  this.property_condition_image_7 )
.replaceAll( '${' + keystarter + '_property_condition_image_8}',  this.property_condition_image_8 )
.replaceAll( '${' + keystarter + '_property_condition_image_9}',  this.property_condition_image_9 )
.replaceAll( '${' + keystarter + '_property_condition_image_10}',  this.property_condition_image_10 )
.replaceAll( '${' + keystarter + '_property_condition_image_11}',  this.property_condition_image_11 )
.replaceAll( '${' + keystarter + '_property_condition_image_12}',  this.property_condition_image_12 )
.replaceAll( '${' + keystarter + '_property_condition_image_13}',  this.property_condition_image_13 )
.replaceAll( '${' + keystarter + '_property_condition_image_14}',  this.property_condition_image_14 )
.replaceAll( '${' + keystarter + '_property_condition_image_15}',  this.property_condition_image_15 )
.replaceAll( '${' + keystarter + '_property_condition_image_16}',  this.property_condition_image_16 )
.replaceAll( '${' + keystarter + '_property_condition_image_17}',  this.property_condition_image_17 )
.replaceAll( '${' + keystarter + '_property_condition_image_18}',  this.property_condition_image_18 )
.replaceAll( '${' + keystarter + '_property_condition_image_19}',  this.property_condition_image_19 )
.replaceAll( '${' + keystarter + '_property_condition_image_20}',  this.property_condition_image_20 )
.replaceAll( '${' + keystarter + '_property_condition_image_21}',  this.property_condition_image_21 )
.replaceAll( '${' + keystarter + '_property_condition_image_22}',  this.property_condition_image_22 )
.replaceAll( '${' + keystarter + '_property_condition_image_23}',  this.property_condition_image_23 )
.replaceAll( '${' + keystarter + '_property_condition_image_24}',  this.property_condition_image_24 )
.replaceAll( '${' + keystarter + '_property_condition_image_25}',  this.property_condition_image_25 )

.replaceAll( '${' + keystarter + '_property_type_image_0}',  this.property_type_image_0 )
.replaceAll( '${' + keystarter + '_property_type_image_1}',  this.property_type_image_1 )
.replaceAll( '${' + keystarter + '_property_type_image_2}',  this.property_type_image_2 )
.replaceAll( '${' + keystarter + '_property_type_image_3}',  this.property_type_image_3 )
.replaceAll( '${' + keystarter + '_property_type_image_4}',  this.property_type_image_4 )
.replaceAll( '${' + keystarter + '_property_type_image_5}',  this.property_type_image_5 )
.replaceAll( '${' + keystarter + '_property_type_image_6}',  this.property_type_image_6 )
.replaceAll( '${' + keystarter + '_property_type_image_7}',  this.property_type_image_7 )
.replaceAll( '${' + keystarter + '_property_type_image_8}',  this.property_type_image_8 )
.replaceAll( '${' + keystarter + '_property_type_image_9}',  this.property_type_image_9 )
.replaceAll( '${' + keystarter + '_property_type_image_10}',  this.property_type_image_10 )
.replaceAll( '${' + keystarter + '_property_type_image_11}',  this.property_type_image_11 )
.replaceAll( '${' + keystarter + '_property_type_image_12}',  this.property_type_image_12 )
.replaceAll( '${' + keystarter + '_property_type_image_13}',  this.property_type_image_13 )
.replaceAll( '${' + keystarter + '_property_type_image_14}',  this.property_type_image_14 )
.replaceAll( '${' + keystarter + '_property_type_image_15}',  this.property_type_image_15 )
.replaceAll( '${' + keystarter + '_property_type_image_16}',  this.property_type_image_16 )
.replaceAll( '${' + keystarter + '_property_type_image_17}',  this.property_type_image_17 )
.replaceAll( '${' + keystarter + '_property_type_image_18}',  this.property_type_image_18 )
.replaceAll( '${' + keystarter + '_property_type_image_19}',  this.property_type_image_19 )
.replaceAll( '${' + keystarter + '_property_type_image_20}',  this.property_type_image_20 )
.replaceAll( '${' + keystarter + '_property_type_image_21}',  this.property_type_image_21 )
.replaceAll( '${' + keystarter + '_property_type_image_22}',  this.property_type_image_22 )
.replaceAll( '${' + keystarter + '_property_type_image_23}',  this.property_type_image_23 )
.replaceAll( '${' + keystarter + '_property_type_image_24}',  this.property_type_image_24 )
.replaceAll( '${' + keystarter + '_property_type_image_25}',  this.property_type_image_25 )

.replaceAll( '${' + keystarter + '_service_file_array_image_0}',  this.service_file_array_image_0 )
.replaceAll( '${' + keystarter + '_service_file_array_image_1}',  this.service_file_array_image_1 )
.replaceAll( '${' + keystarter + '_service_file_array_image_2}',  this.service_file_array_image_2 )
.replaceAll( '${' + keystarter + '_service_file_array_image_3}',  this.service_file_array_image_3 )
.replaceAll( '${' + keystarter + '_service_file_array_image_4}',  this.service_file_array_image_4 )
.replaceAll( '${' + keystarter + '_service_file_array_image_5}',  this.service_file_array_image_5 )
.replaceAll( '${' + keystarter + '_service_file_array_image_6}',  this.service_file_array_image_6 )
.replaceAll( '${' + keystarter + '_service_file_array_image_7}',  this.service_file_array_image_7 )
.replaceAll( '${' + keystarter + '_service_file_array_image_8}',  this.service_file_array_image_8 )
.replaceAll( '${' + keystarter + '_service_file_array_image_9}',  this.service_file_array_image_9 )
.replaceAll( '${' + keystarter + '_service_file_array_image_10}',  this.service_file_array_image_10 )
.replaceAll( '${' + keystarter + '_service_file_array_image_11}',  this.service_file_array_image_11 )
.replaceAll( '${' + keystarter + '_service_file_array_image_12}',  this.service_file_array_image_12 )
.replaceAll( '${' + keystarter + '_service_file_array_image_13}',  this.service_file_array_image_13 )
.replaceAll( '${' + keystarter + '_service_file_array_image_14}',  this.service_file_array_image_14 )
.replaceAll( '${' + keystarter + '_service_file_array_image_15}',  this.service_file_array_image_15 )
.replaceAll( '${' + keystarter + '_service_file_array_image_16}',  this.service_file_array_image_16 )
.replaceAll( '${' + keystarter + '_service_file_array_image_17}',  this.service_file_array_image_17 )
.replaceAll( '${' + keystarter + '_service_file_array_image_18}',  this.service_file_array_image_18 )
.replaceAll( '${' + keystarter + '_service_file_array_image_19}',  this.service_file_array_image_19 )
.replaceAll( '${' + keystarter + '_service_file_array_image_20}',  this.service_file_array_image_20 )
.replaceAll( '${' + keystarter + '_service_file_array_image_21}',  this.service_file_array_image_21 )
.replaceAll( '${' + keystarter + '_service_file_array_image_22}',  this.service_file_array_image_22 )
.replaceAll( '${' + keystarter + '_service_file_array_image_23}',  this.service_file_array_image_23 )
.replaceAll( '${' + keystarter + '_service_file_array_image_24}',  this.service_file_array_image_24 )
.replaceAll( '${' + keystarter + '_service_file_array_image_25}',  this.service_file_array_image_25 )



// hide anything null or undefined.
.replaceAll('${undefined}', '')
.replaceAll('${null}', '')
.replaceAll('undefined', '') // makes all undefined print empty
.replaceAll('null', '') // makes all undefined print empty
.replaceAll('Invalid date', '') // makes all undefined print empty


// model.email_template_primary_HTML_rendered
// email_subject_primary_rendered


// Convert the results to a form field value.
// model.email_template_primary_HTML_rendered = rendered_result;
return rendered_result;

}

// different data model.
runReplaceAllVariables_ServicesOnly_keystarter(str, model, keystarter, subject_attempt_type_id){


  // // Filters objects for nul and undefined values.
  // const obj = this.attempts_paragraphs_model;
  // const filteredObject = _.pickBy(obj, v =>  v.subject_attempt_type_id === subject_attempt_type_id);
  // // console.log = (obj) => document.write(JSON.stringify(filteredObject, null, 2));
  // console.log('FilteredObject', JSON.stringify(filteredObject));



// Filter the array for attempt_type_id = 1 or 2 service or attemdamce -- Do a filter on the final RESULTS IF F SERVICE!!!!! 
// Do a simple loadash filter on attempts_paragraphs model.'

// change the data for a service
if (subject_attempt_type_id = 1)
{


}


// Already loaded in the job/subject lookup
// if(this.attempts_paragraphs_model.job_subject_type_id){
//   this.getJobSubjectType_Q(this.attempts_paragraphs_model.job_subject_type_id) ;
// }
// let var_subject_type_name;
// if(this.subject_job_subject_type != null){
// var_subject_type_name = this.subject_job_subject_type.job_subject_type_name
// } else{
// var_subject_type_name = '';
// }


// NEED TO DETERMINE THE attempt_type === data

// FIX THIS AND WE CAN USE FOR ALL. -- By getting   if(this.attempts_paragraphs_model){ to refresh or reset the data lookip as it needs to ne differemt for a service or attedance

// ATTEMPS
// Current Attempt Variables Setups
// Uppercase.
if(this.service_paragraphs_model){

let var_subject_attempt_type_name = this.service_paragraphs_model.subject_attempt_type_name
if(var_subject_attempt_type_name != null){ // uppercase must be validated if not null
 this.var_subject_attempt_type_name_Upper = var_subject_attempt_type_name.toUpperCase();
}

} // end if attemps paragraphs model.

  this.person_spoken_with_advised_HTML = '';

if(this.service_paragraphs_model.person_spoken_with_advised_HTML == null){this.person_spoken_with_advised_HTML = this.service_paragraphs_model.person_spoken_with_advised; }else{this.person_spoken_with_advised_HTML = this.transform2(this.service_paragraphs_model.person_spoken_with_advised_HTML);}
if(this.service_paragraphs_model.vehicles_notes_HTML == null){this.vehicles_notes_HTML = this.service_paragraphs_model.vehicles_notes; }else{this.vehicles_notes_HTML = this.transform2(this.service_paragraphs_model.vehicles_notes_HTML);}
if(this.service_paragraphs_model.neighbours_notes_HTML == null){this.neighbours_notes_HTML = this.service_paragraphs_model.neighbours_notes; }else{this.neighbours_notes_HTML = this.transform2(this.service_paragraphs_model.neighbours_notes_HTML);}
if(this.service_paragraphs_model.calling_card_notes_HTML == null){this.calling_card_notes_HTML = this.service_paragraphs_model.calling_card_notes; }else{this.calling_card_notes_HTML = this.transform2(this.service_paragraphs_model.calling_card_notes_HTML);}
if(this.service_paragraphs_model.postal_mail_notes_HTML == null){this.postal_mail_notes_HTML = this.service_paragraphs_model.postal_mail_notes; }else{this.postal_mail_notes_HTML = this.transform2(this.service_paragraphs_model.postal_mail_notes_HTML);}
if(this.service_paragraphs_model.phone_call_notes_HTML == null){this.phone_call_notes_HTML = this.service_paragraphs_model.phone_call_notes; }else{this.phone_call_notes_HTML = this.transform2(this.service_paragraphs_model.phone_call_notes_HTML);}
if(this.service_paragraphs_model.attempts_notes_HTML == null){this.attempts_notes_HTML = this.service_paragraphs_model.attempts_notes; }else{this.attempts_notes_HTML = this.transform2(this.service_paragraphs_model.attempts_notes_HTML);}
if(this.service_paragraphs_model.email_contents_HTML == null){this.email_contents_HTML = this.service_paragraphs_model.email_contents; }else{this.email_contents_HTML = this.transform2(this.service_paragraphs_model.email_contents_HTML);}
if(this.service_paragraphs_model.general_notes_HTML == null){
this.set_general_notes = this.service_paragraphs_model.general_notes;
}else{
this.set_general_notes = this.transform2(this.service_paragraphs_model.general_notes_HTML)
}
if(this.service_paragraphs_model.property_forsale_or_lease_sign_details_HTML == null){this.property_forsale_or_lease_sign_details_HTML = this.service_paragraphs_model.property_forsale_or_lease_sign_details; }else{this.property_forsale_or_lease_sign_details_HTML = this.transform2(this.service_paragraphs_model.property_forsale_or_lease_sign_details_HTML);}  
if(this.service_paragraphs_model.property_mail_details_HTML == null){this.property_mail_details_HTML = this.service_paragraphs_model.property_mail_details; }else{this.property_mail_details_HTML = this.transform2(this.service_paragraphs_model.property_mail_details_HTML);}
if(this.service_paragraphs_model.property_vehicles_sighted_details_HTML == null){this.property_vehicles_sighted_details_HTML = this.service_paragraphs_model.property_vehicles_sighted_details; }else{this.property_vehicles_sighted_details_HTML = this.transform2(this.service_paragraphs_model.property_vehicles_sighted_details_HTML);}  
if(this.service_paragraphs_model.property_pets_details_HTML == null){this.property_pets_details_HTML = this.service_paragraphs_model.property_pets_details; }else{this.property_pets_details_HTML = this.transform2(this.service_paragraphs_model.property_pets_details_HTML);}

if(this.service_paragraphs_model.property_occupancy_details_HTML == null){this.property_occupancy_details_HTML = this.service_paragraphs_model.property_occupancy_details; }else{this.property_occupancy_details_HTML = this.transform2(this.service_paragraphs_model.property_occupancy_details_HTML);}

if(this.service_paragraphs_model.property_condition_HTML == null){this.property_condition_HTML = this.service_paragraphs_model.property_condition; }else{this.property_condition_HTML = this.transform2(this.service_paragraphs_model.property_condition_HTML);}
if(this.service_paragraphs_model.property_occupied_details_HTML == null){this.property_occupied_details_HTML = this.service_paragraphs_model.property_occupied_details; }else{this.property_occupied_details_HTML = this.transform2(this.service_paragraphs_model.property_occupied_details_HTML);}
if(this.service_paragraphs_model.property_type_details_HTML == null){this.set_property_type_details_HTML = this.service_paragraphs_model.property_type_details; }else{this.set_property_type_details_HTML = this.transform2(this.service_paragraphs_model.property_type_details_HTML);}
if(this.attempts_paragraphs_model.service_under_order_HTML == null){this.service_under_order_HTML = this.attempts_paragraphs_model.service_under_order; }else{this.service_under_order_HTML = this.transform2(this.attempts_paragraphs_model.service_under_order_HTML);}



// Do checks for subject name / Businesss Name of FUll SUbject Name fields
let var_subject_name =  this.service_paragraphs_model.first_name + ' ' +  this.service_paragraphs_model.middlename + ' '+  this.service_paragraphs_model.surname;
let var_subject_name_4_doc = this.service_paragraphs_model.first_name +'-'+  this.service_paragraphs_model.surname;
let var_subject_business_name =  this.service_paragraphs_model.business_name;

// Subject Name of Business
 if(var_subject_business_name != null){
     let var_trim_subject_business_name = var_subject_business_name.replaceAll(' ', ''); // need javscipt version of trim (all spaces removed)
     // $subject_name = $trim_subject_business_name;
      var_subject_name = var_subject_business_name; // changed here feb 2023 as subject busines name was printing stripped as variable in affidavid // Not trimmed
       var_subject_name_4_doc= var_trim_subject_business_name;
     
 }



if(this.service_paragraphs_model.service_paragraph_rendered == null){
this.set_service_paragraph_rendered = '';
}else{
this.set_service_paragraph_rendered = this.service_paragraphs_model.service_paragraph_rendered; // does not require encodeing
}

// Property Images
if(this.service_paragraphs_model.property_images != '[]' || this.service_paragraphs_model.property_images != null){
this.property_images = JSON.parse(this.service_paragraphs_model.property_images)



let newArr = this.property_images;
let  count_of_items = Object.keys(newArr).length;

// let  count_of_items = 25;
//   let  count_of_items = Object.keys(newArr).length;
// //     for(let i=0;i < count_of_items; i++) { 
// //     let res = newArr[i];
// // }

if(count_of_items >= 1){this.propery_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[0].file_server_location +  '/' + this.property_images[0].file_name + '"></img>'}else{this.propery_image_0=''}
if(count_of_items >= 2){this.propery_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[1].file_server_location +  '/' + this.property_images[1].file_name + '"></img>'}else{this.propery_image_1=''}
if(count_of_items >= 3){this.propery_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[2].file_server_location +  '/' + this.property_images[2].file_name + '"></img>'}else{this.propery_image_2=''}
if(count_of_items >= 4){this.propery_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[3].file_server_location +  '/' + this.property_images[3].file_name + '"></img>'}else{this.propery_image_3=''}
if(count_of_items >= 5){this.propery_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[4].file_server_location +  '/' + this.property_images[4].file_name + '"></img>'}else{this.propery_image_4=''}
if(count_of_items >= 6){this.propery_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[5].file_server_location +  '/' + this.property_images[5].file_name + '"></img>'}else{this.propery_image_5=''}
if(count_of_items >= 7){this.propery_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[6].file_server_location +  '/' + this.property_images[6].file_name + '"></img>'}else{this.propery_image_6=''}
if(count_of_items >= 8){this.propery_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[7].file_server_location +  '/' + this.property_images[7].file_name + '"></img>'}else{this.propery_image_7=''}
if(count_of_items >= 9){this.propery_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[8].file_server_location +  '/' + this.property_images[8].file_name + '"></img>'}else{this.propery_image_8=''}
if(count_of_items >= 10){this.propery_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[9].file_server_location +  '/' + this.property_images[9].file_name + '"></img>'}else{this.propery_image_9=''}
if(count_of_items >= 11){this.propery_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[10].file_server_location +  '/' + this.property_images[10].file_name + '"></img>'}else{this.propery_image_10=''}
if(count_of_items >= 11){this.propery_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[11].file_server_location +  '/' + this.property_images[11].file_name + '"></img>'}else{this.propery_image_11=''}
if(count_of_items >= 11){this.propery_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[12].file_server_location +  '/' + this.property_images[12].file_name + '"></img>'}else{this.propery_image_12=''}
if(count_of_items >= 11){this.propery_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[13].file_server_location +  '/' + this.property_images[13].file_name + '"></img>'}else{this.propery_image_13=''}
if(count_of_items >= 11){this.propery_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[14].file_server_location +  '/' + this.property_images[14].file_name + '"></img>'}else{this.propery_image_14=''}
if(count_of_items >= 11){this.propery_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[15].file_server_location +  '/' + this.property_images[15].file_name + '"></img>'}else{this.propery_image_15=''}
if(count_of_items >= 11){this.propery_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[16].file_server_location +  '/' + this.property_images[16].file_name + '"></img>'}else{this.propery_image_16=''}
if(count_of_items >= 11){this.propery_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[17].file_server_location +  '/' + this.property_images[17].file_name + '"></img>'}else{this.propery_image_17=''}
if(count_of_items >= 11){this.propery_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[18].file_server_location +  '/' + this.property_images[18].file_name + '"></img>'}else{this.propery_image_18=''}
if(count_of_items >= 11){this.propery_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[19].file_server_location +  '/' + this.property_images[19].file_name + '"></img>'}else{this.propery_image_19=''}
if(count_of_items >= 11){this.propery_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[20].file_server_location +  '/' + this.property_images[20].file_name + '"></img>'}else{this.propery_image_20=''}
if(count_of_items >= 11){this.propery_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[21].file_server_location +  '/' + this.property_images[21].file_name + '"></img>'}else{this.propery_image_21=''}
if(count_of_items >= 11){this.propery_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[22].file_server_location +  '/' + this.property_images[22].file_name + '"></img>'}else{this.propery_image_22=''}
if(count_of_items >= 11){this.propery_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[23].file_server_location +  '/' + this.property_images[23].file_name + '"></img>'}else{this.propery_image_23=''}
if(count_of_items >= 11){this.propery_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[24].file_server_location +  '/' + this.property_images[24].file_name + '"></img>'}else{this.propery_image_24=''}
if(count_of_items >= 11){this.propery_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[25].file_server_location +  '/' + this.property_images[25].file_name + '"></img>'}else{this.propery_image_25=''}





// Loop function to set the images set the ones that exist and then set nulls to the ones that dont. -- similar to the php function in the doucment imaee replacement function 
// loop 0 - 25 and only set if exisis or '' if not.


}

if(this.service_paragraphs_model.property_sign_images != '[]' && this.service_paragraphs_model.property_sign_images != null){
this.property_sign_images = JSON.parse(this.service_paragraphs_model.property_sign_images)
let newArr = this.property_sign_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_sign_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[0].file_server_location +  '/' + this.property_sign_images[0].file_name + '"></img>'}else{this.property_sign_image_0=''}
if(count_of_items >= 2){this.property_sign_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[1].file_server_location +  '/' + this.property_sign_images[1].file_name + '"></img>'}else{this.property_sign_image_1=''}
if(count_of_items >= 3){this.property_sign_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[2].file_server_location +  '/' + this.property_sign_images[2].file_name + '"></img>'}else{this.property_sign_image_2=''}
if(count_of_items >= 4){this.property_sign_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[3].file_server_location +  '/' + this.property_sign_images[3].file_name + '"></img>'}else{this.property_sign_image_3=''}
if(count_of_items >= 5){this.property_sign_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[4].file_server_location +  '/' + this.property_sign_images[4].file_name + '"></img>'}else{this.property_sign_image_4=''}
if(count_of_items >= 6){this.property_sign_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[5].file_server_location +  '/' + this.property_sign_images[5].file_name + '"></img>'}else{this.property_sign_image_5=''}
if(count_of_items >= 7){this.property_sign_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[6].file_server_location +  '/' + this.property_sign_images[6].file_name + '"></img>'}else{this.property_sign_image_6=''}
if(count_of_items >= 8){this.property_sign_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[7].file_server_location +  '/' + this.property_sign_images[7].file_name + '"></img>'}else{this.property_sign_image_7=''}
if(count_of_items >= 9){this.property_sign_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[8].file_server_location +  '/' + this.property_sign_images[8].file_name + '"></img>'}else{this.property_sign_image_8=''}
if(count_of_items >= 10){this.property_sign_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[9].file_server_location +  '/' + this.property_sign_images[9].file_name + '"></img>'}else{this.property_sign_image_9=''}
if(count_of_items >= 11){this.property_sign_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[10].file_server_location +  '/' + this.property_sign_images[10].file_name + '"></img>'}else{this.property_sign_image_10=''}
if(count_of_items >= 11){this.property_sign_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[11].file_server_location +  '/' + this.property_sign_images[11].file_name + '"></img>'}else{this.property_sign_image_11=''}
if(count_of_items >= 11){this.property_sign_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[12].file_server_location +  '/' + this.property_sign_images[12].file_name + '"></img>'}else{this.property_sign_image_12=''}
if(count_of_items >= 11){this.property_sign_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[13].file_server_location +  '/' + this.property_sign_images[13].file_name + '"></img>'}else{this.property_sign_image_13=''}
if(count_of_items >= 11){this.property_sign_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[14].file_server_location +  '/' + this.property_sign_images[14].file_name + '"></img>'}else{this.property_sign_image_14=''}
if(count_of_items >= 11){this.property_sign_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[15].file_server_location +  '/' + this.property_sign_images[15].file_name + '"></img>'}else{this.property_sign_image_15=''}
if(count_of_items >= 11){this.property_sign_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[16].file_server_location +  '/' + this.property_sign_images[16].file_name + '"></img>'}else{this.property_sign_image_16=''}
if(count_of_items >= 11){this.property_sign_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[17].file_server_location +  '/' + this.property_sign_images[17].file_name + '"></img>'}else{this.property_sign_image_17=''}
if(count_of_items >= 11){this.property_sign_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[18].file_server_location +  '/' + this.property_sign_images[18].file_name + '"></img>'}else{this.property_sign_image_18=''}
if(count_of_items >= 11){this.property_sign_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[19].file_server_location +  '/' + this.property_sign_images[19].file_name + '"></img>'}else{this.property_sign_image_19=''}
if(count_of_items >= 11){this.property_sign_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[20].file_server_location +  '/' + this.property_sign_images[20].file_name + '"></img>'}else{this.property_sign_image_20=''}
if(count_of_items >= 11){this.property_sign_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[21].file_server_location +  '/' + this.property_sign_images[21].file_name + '"></img>'}else{this.property_sign_image_21=''}
if(count_of_items >= 11){this.property_sign_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[22].file_server_location +  '/' + this.property_sign_images[22].file_name + '"></img>'}else{this.property_sign_image_22=''}
if(count_of_items >= 11){this.property_sign_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[23].file_server_location +  '/' + this.property_sign_images[23].file_name + '"></img>'}else{this.property_sign_image_23=''}
if(count_of_items >= 11){this.property_sign_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[24].file_server_location +  '/' + this.property_sign_images[24].file_name + '"></img>'}else{this.property_sign_image_24=''}
if(count_of_items >= 11){this.property_sign_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[25].file_server_location +  '/' + this.property_sign_images[25].file_name + '"></img>'}else{this.property_sign_image_25=''}
}

if(this.service_paragraphs_model.property_mail_images != '[]' && this.service_paragraphs_model.property_mail_images != null ){
this.property_mail_images = JSON.parse(this.service_paragraphs_model.property_mail_images)
let newArr = this.property_mail_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_mail_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[0].file_server_location +  '/' + this.property_mail_images[0].file_name + '"></img>'}else{this.property_mail_image_0=''}
if(count_of_items >= 2){this.property_mail_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[1].file_server_location +  '/' + this.property_mail_images[1].file_name + '"></img>'}else{this.property_mail_image_1=''}
if(count_of_items >= 3){this.property_mail_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[2].file_server_location +  '/' + this.property_mail_images[2].file_name + '"></img>'}else{this.property_mail_image_2=''}
if(count_of_items >= 4){this.property_mail_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[3].file_server_location +  '/' + this.property_mail_images[3].file_name + '"></img>'}else{this.property_mail_image_3=''}
if(count_of_items >= 5){this.property_mail_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[4].file_server_location +  '/' + this.property_mail_images[4].file_name + '"></img>'}else{this.property_mail_image_4=''}
if(count_of_items >= 6){this.property_mail_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[5].file_server_location +  '/' + this.property_mail_images[5].file_name + '"></img>'}else{this.property_mail_image_5=''}
if(count_of_items >= 7){this.property_mail_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[6].file_server_location +  '/' + this.property_mail_images[6].file_name + '"></img>'}else{this.property_mail_image_6=''}
if(count_of_items >= 8){this.property_mail_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[7].file_server_location +  '/' + this.property_mail_images[7].file_name + '"></img>'}else{this.property_mail_image_7=''}
if(count_of_items >= 9){this.property_mail_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[8].file_server_location +  '/' + this.property_mail_images[8].file_name + '"></img>'}else{this.property_mail_image_8=''}
if(count_of_items >= 10){this.property_mail_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[9].file_server_location +  '/' + this.property_mail_images[9].file_name + '"></img>'}else{this.property_mail_image_9=''}
if(count_of_items >= 11){this.property_mail_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[10].file_server_location +  '/' + this.property_mail_images[10].file_name + '"></img>'}else{this.property_mail_image_10=''}
if(count_of_items >= 11){this.property_mail_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[11].file_server_location +  '/' + this.property_mail_images[11].file_name + '"></img>'}else{this.property_mail_image_11=''}
if(count_of_items >= 11){this.property_mail_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[12].file_server_location +  '/' + this.property_mail_images[12].file_name + '"></img>'}else{this.property_mail_image_12=''}
if(count_of_items >= 11){this.property_mail_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[13].file_server_location +  '/' + this.property_mail_images[13].file_name + '"></img>'}else{this.property_mail_image_13=''}
if(count_of_items >= 11){this.property_mail_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[14].file_server_location +  '/' + this.property_mail_images[14].file_name + '"></img>'}else{this.property_mail_image_14=''}
if(count_of_items >= 11){this.property_mail_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[15].file_server_location +  '/' + this.property_mail_images[15].file_name + '"></img>'}else{this.property_mail_image_15=''}
if(count_of_items >= 11){this.property_mail_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[16].file_server_location +  '/' + this.property_mail_images[16].file_name + '"></img>'}else{this.property_mail_image_16=''}
if(count_of_items >= 11){this.property_mail_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[17].file_server_location +  '/' + this.property_mail_images[17].file_name + '"></img>'}else{this.property_mail_image_17=''}
if(count_of_items >= 11){this.property_mail_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[18].file_server_location +  '/' + this.property_mail_images[18].file_name + '"></img>'}else{this.property_mail_image_18=''}
if(count_of_items >= 11){this.property_mail_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[19].file_server_location +  '/' + this.property_mail_images[19].file_name + '"></img>'}else{this.property_mail_image_19=''}
if(count_of_items >= 11){this.property_mail_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[20].file_server_location +  '/' + this.property_mail_images[20].file_name + '"></img>'}else{this.property_mail_image_20=''}
if(count_of_items >= 11){this.property_mail_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[21].file_server_location +  '/' + this.property_mail_images[21].file_name + '"></img>'}else{this.property_mail_image_21=''}
if(count_of_items >= 11){this.property_mail_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[22].file_server_location +  '/' + this.property_mail_images[22].file_name + '"></img>'}else{this.property_mail_image_22=''}
if(count_of_items >= 11){this.property_mail_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[23].file_server_location +  '/' + this.property_mail_images[23].file_name + '"></img>'}else{this.property_mail_image_23=''}
if(count_of_items >= 11){this.property_mail_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[24].file_server_location +  '/' + this.property_mail_images[24].file_name + '"></img>'}else{this.property_mail_image_24=''}
if(count_of_items >= 11){this.property_mail_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[25].file_server_location +  '/' + this.property_mail_images[25].file_name + '"></img>'}else{this.property_mail_image_25=''}
}

if(this.service_paragraphs_model.property_vehicles_images != '[]' && this.service_paragraphs_model.property_vehicles_images != null){
this.property_vehicles_images = JSON.parse(this.service_paragraphs_model.property_vehicles_images)
let newArr = this.property_vehicles_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_vehicles_image_0  = '<img src="' + this.gfunc.fileURL + '/' + this.property_vehicles_images[0].file_server_location +  '/' + this.property_vehicles_images[0].file_name + '"></img>'}else{this.property_vehicles_image_0=''}
if(count_of_items >= 2){this.property_vehicles_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[1].file_server_location +  '/' + this.property_vehicles_images[1].file_name + '"></img>'}else{this.property_vehicles_image_1=''}
if(count_of_items >= 3){this.property_vehicles_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[2].file_server_location +  '/' + this.property_vehicles_images[2].file_name + '"></img>'}else{this.property_vehicles_image_2=''}
if(count_of_items >= 4){this.property_vehicles_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[3].file_server_location +  '/' + this.property_vehicles_images[3].file_name + '"></img>'}else{this.property_vehicles_image_3=''}
if(count_of_items >= 5){this.property_vehicles_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[4].file_server_location +  '/' + this.property_vehicles_images[4].file_name + '"></img>'}else{this.property_vehicles_image_4=''}
if(count_of_items >= 6){this.property_vehicles_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[5].file_server_location +  '/' + this.property_vehicles_images[5].file_name + '"></img>'}else{this.property_vehicles_image_5=''}
if(count_of_items >= 7){this.property_vehicles_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[6].file_server_location +  '/' + this.property_vehicles_images[6].file_name + '"></img>'}else{this.property_vehicles_image_6=''}
if(count_of_items >= 8){this.property_vehicles_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[7].file_server_location +  '/' + this.property_vehicles_images[7].file_name + '"></img>'}else{this.property_vehicles_image_7=''}
if(count_of_items >= 9){this.property_vehicles_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[8].file_server_location +  '/' + this.property_vehicles_images[8].file_name + '"></img>'}else{this.property_vehicles_image_8=''}
if(count_of_items >= 10){this.property_vehicles_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[9].file_server_location +  '/' + this.property_vehicles_images[9].file_name + '"></img>'}else{this.property_vehicles_image_9=''}
if(count_of_items >= 11){this.property_vehicles_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[10].file_server_location +  '/' + this.property_vehicles_images[10].file_name + '"></img>'}else{this.property_vehicles_image_10=''}
if(count_of_items >= 11){this.property_vehicles_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[11].file_server_location +  '/' + this.property_vehicles_images[11].file_name + '"></img>'}else{this.property_vehicles_image_11=''}
if(count_of_items >= 11){this.property_vehicles_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[12].file_server_location +  '/' + this.property_vehicles_images[12].file_name + '"></img>'}else{this.property_vehicles_image_12=''}
if(count_of_items >= 11){this.property_vehicles_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[13].file_server_location +  '/' + this.property_vehicles_images[13].file_name + '"></img>'}else{this.property_vehicles_image_13=''}
if(count_of_items >= 11){this.property_vehicles_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[14].file_server_location +  '/' + this.property_vehicles_images[14].file_name + '"></img>'}else{this.property_vehicles_image_14=''}
if(count_of_items >= 11){this.property_vehicles_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[15].file_server_location +  '/' + this.property_vehicles_images[15].file_name + '"></img>'}else{this.property_vehicles_image_15=''}
if(count_of_items >= 11){this.property_vehicles_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[16].file_server_location +  '/' + this.property_vehicles_images[16].file_name + '"></img>'}else{this.property_vehicles_image_16=''}
if(count_of_items >= 11){this.property_vehicles_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[17].file_server_location +  '/' + this.property_vehicles_images[17].file_name + '"></img>'}else{this.property_vehicles_image_17=''}
if(count_of_items >= 11){this.property_vehicles_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[18].file_server_location +  '/' + this.property_vehicles_images[18].file_name + '"></img>'}else{this.property_vehicles_image_18=''}
if(count_of_items >= 11){this.property_vehicles_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[19].file_server_location +  '/' + this.property_vehicles_images[19].file_name + '"></img>'}else{this.property_vehicles_image_19=''}
if(count_of_items >= 11){this.property_vehicles_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[20].file_server_location +  '/' + this.property_vehicles_images[20].file_name + '"></img>'}else{this.property_vehicles_image_20=''}
if(count_of_items >= 11){this.property_vehicles_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[21].file_server_location +  '/' + this.property_vehicles_images[21].file_name + '"></img>'}else{this.property_vehicles_image_21=''}
if(count_of_items >= 11){this.property_vehicles_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[22].file_server_location +  '/' + this.property_vehicles_images[22].file_name + '"></img>'}else{this.property_vehicles_image_22=''}
if(count_of_items >= 11){this.property_vehicles_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[23].file_server_location +  '/' + this.property_vehicles_images[23].file_name + '"></img>'}else{this.property_vehicles_image_23=''}
if(count_of_items >= 11){this.property_vehicles_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[24].file_server_location +  '/' + this.property_vehicles_images[24].file_name + '"></img>'}else{this.property_vehicles_image_24=''}
if(count_of_items >= 11){this.property_vehicles_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[25].file_server_location +  '/' + this.property_vehicles_images[25].file_name + '"></img>'}else{this.property_vehicles_image_25=''}
}


if(this.service_paragraphs_model.property_pets_images != '[]' && this.service_paragraphs_model.property_pets_images != null){
this.property_pets_images = JSON.parse(this.service_paragraphs_model.property_pets_images)
let newArr = this.property_pets_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_pets_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[0].file_server_location +  '/' + this.property_pets_images[0].file_name + '"></img>'}else{this.property_pets_image_0=''}
if(count_of_items >= 2){this.property_pets_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[1].file_server_location +  '/' + this.property_pets_images[1].file_name + '"></img>'}else{this.property_pets_image_1=''}
if(count_of_items >= 3){this.property_pets_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[2].file_server_location +  '/' + this.property_pets_images[2].file_name + '"></img>'}else{this.property_pets_image_2=''}
if(count_of_items >= 4){this.property_pets_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[3].file_server_location +  '/' + this.property_pets_images[3].file_name + '"></img>'}else{this.property_pets_image_3=''}
if(count_of_items >= 5){this.property_pets_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[4].file_server_location +  '/' + this.property_pets_images[4].file_name + '"></img>'}else{this.property_pets_image_4=''}
if(count_of_items >= 6){this.property_pets_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[5].file_server_location +  '/' + this.property_pets_images[5].file_name + '"></img>'}else{this.property_pets_image_5=''}
if(count_of_items >= 7){this.property_pets_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[6].file_server_location +  '/' + this.property_pets_images[6].file_name + '"></img>'}else{this.property_pets_image_6=''}
if(count_of_items >= 8){this.property_pets_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[7].file_server_location +  '/' + this.property_pets_images[7].file_name + '"></img>'}else{this.property_pets_image_7=''}
if(count_of_items >= 9){this.property_pets_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[8].file_server_location +  '/' + this.property_pets_images[8].file_name + '"></img>'}else{this.property_pets_image_8=''}
if(count_of_items >= 10){this.property_pets_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[9].file_server_location +  '/' + this.property_pets_images[9].file_name + '"></img>'}else{this.property_pets_image_9=''}
if(count_of_items >= 11){this.property_pets_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[10].file_server_location +  '/' + this.property_pets_images[10].file_name + '"></img>'}else{this.property_pets_image_10=''}
if(count_of_items >= 11){this.property_pets_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[11].file_server_location +  '/' + this.property_pets_images[11].file_name + '"></img>'}else{this.property_pets_image_11=''}
if(count_of_items >= 11){this.property_pets_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[12].file_server_location +  '/' + this.property_pets_images[12].file_name + '"></img>'}else{this.property_pets_image_12=''}
if(count_of_items >= 11){this.property_pets_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[13].file_server_location +  '/' + this.property_pets_images[13].file_name + '"></img>'}else{this.property_pets_image_13=''}
if(count_of_items >= 11){this.property_pets_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[14].file_server_location +  '/' + this.property_pets_images[14].file_name + '"></img>'}else{this.property_pets_image_14=''}
if(count_of_items >= 11){this.property_pets_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[15].file_server_location +  '/' + this.property_pets_images[15].file_name + '"></img>'}else{this.property_pets_image_15=''}
if(count_of_items >= 11){this.property_pets_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[16].file_server_location +  '/' + this.property_pets_images[16].file_name + '"></img>'}else{this.property_pets_image_16=''}
if(count_of_items >= 11){this.property_pets_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[17].file_server_location +  '/' + this.property_pets_images[17].file_name + '"></img>'}else{this.property_pets_image_17=''}
if(count_of_items >= 11){this.property_pets_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[18].file_server_location +  '/' + this.property_pets_images[18].file_name + '"></img>'}else{this.property_pets_image_18=''}
if(count_of_items >= 11){this.property_pets_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[19].file_server_location +  '/' + this.property_pets_images[19].file_name + '"></img>'}else{this.property_pets_image_19=''}
if(count_of_items >= 11){this.property_pets_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[20].file_server_location +  '/' + this.property_pets_images[20].file_name + '"></img>'}else{this.property_pets_image_20=''}
if(count_of_items >= 11){this.property_pets_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[21].file_server_location +  '/' + this.property_pets_images[21].file_name + '"></img>'}else{this.property_pets_image_21=''}
if(count_of_items >= 11){this.property_pets_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[22].file_server_location +  '/' + this.property_pets_images[22].file_name + '"></img>'}else{this.property_pets_image_22=''}
if(count_of_items >= 11){this.property_pets_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[23].file_server_location +  '/' + this.property_pets_images[23].file_name + '"></img>'}else{this.property_pets_image_23=''}
if(count_of_items >= 11){this.property_pets_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[24].file_server_location +  '/' + this.property_pets_images[24].file_name + '"></img>'}else{this.property_pets_image_24=''}
if(count_of_items >= 11){this.property_pets_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[25].file_server_location +  '/' + this.property_pets_images[25].file_name + '"></img>'}else{this.property_pets_image_25=''}
}


if(this.service_paragraphs_model.property_occupancy_images != '[]' && this.service_paragraphs_model.property_occupancy_images != null){
this.property_occupancy_images = JSON.parse(this.service_paragraphs_model.property_occupancy_images)
let newArr = this.property_occupancy_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_occupancy_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[0].file_server_location +  '/' + this.property_occupancy_images[0].file_name + '"></img>'}else{this.property_occupancy_image_0=''}
if(count_of_items >= 2){this.property_occupancy_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[1].file_server_location +  '/' + this.property_occupancy_images[1].file_name + '"></img>'}else{this.property_occupancy_image_1=''}
if(count_of_items >= 3){this.property_occupancy_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[2].file_server_location +  '/' + this.property_occupancy_images[2].file_name + '"></img>'}else{this.property_occupancy_image_2=''}
if(count_of_items >= 4){this.property_occupancy_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[3].file_server_location +  '/' + this.property_occupancy_images[3].file_name + '"></img>'}else{this.property_occupancy_image_3=''}
if(count_of_items >= 5){this.property_occupancy_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[4].file_server_location +  '/' + this.property_occupancy_images[4].file_name + '"></img>'}else{this.property_occupancy_image_4=''}
if(count_of_items >= 6){this.property_occupancy_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[5].file_server_location +  '/' + this.property_occupancy_images[5].file_name + '"></img>'}else{this.property_occupancy_image_5=''}
if(count_of_items >= 7){this.property_occupancy_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[6].file_server_location +  '/' + this.property_occupancy_images[6].file_name + '"></img>'}else{this.property_occupancy_image_6=''}
if(count_of_items >= 8){this.property_occupancy_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[7].file_server_location +  '/' + this.property_occupancy_images[7].file_name + '"></img>'}else{this.property_occupancy_image_7=''}
if(count_of_items >= 9){this.property_occupancy_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[8].file_server_location +  '/' + this.property_occupancy_images[8].file_name + '"></img>'}else{this.property_occupancy_image_8=''}
if(count_of_items >= 10){this.property_occupancy_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[9].file_server_location +  '/' + this.property_occupancy_images[9].file_name + '"></img>'}else{this.property_occupancy_image_9=''}
if(count_of_items >= 11){this.property_occupancy_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[10].file_server_location +  '/' + this.property_occupancy_images[10].file_name + '"></img>'}else{this.property_occupancy_image_10=''}
if(count_of_items >= 11){this.property_occupancy_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[11].file_server_location +  '/' + this.property_occupancy_images[11].file_name + '"></img>'}else{this.property_occupancy_image_11=''}
if(count_of_items >= 11){this.property_occupancy_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[12].file_server_location +  '/' + this.property_occupancy_images[12].file_name + '"></img>'}else{this.property_occupancy_image_12=''}
if(count_of_items >= 11){this.property_occupancy_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[13].file_server_location +  '/' + this.property_occupancy_images[13].file_name + '"></img>'}else{this.property_occupancy_image_13=''}
if(count_of_items >= 11){this.property_occupancy_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[14].file_server_location +  '/' + this.property_occupancy_images[14].file_name + '"></img>'}else{this.property_occupancy_image_14=''}
if(count_of_items >= 11){this.property_occupancy_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[15].file_server_location +  '/' + this.property_occupancy_images[15].file_name + '"></img>'}else{this.property_occupancy_image_15=''}
if(count_of_items >= 11){this.property_occupancy_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[16].file_server_location +  '/' + this.property_occupancy_images[16].file_name + '"></img>'}else{this.property_occupancy_image_16=''}
if(count_of_items >= 11){this.property_occupancy_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[17].file_server_location +  '/' + this.property_occupancy_images[17].file_name + '"></img>'}else{this.property_occupancy_image_17=''}
if(count_of_items >= 11){this.property_occupancy_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[18].file_server_location +  '/' + this.property_occupancy_images[18].file_name + '"></img>'}else{this.property_occupancy_image_18=''}
if(count_of_items >= 11){this.property_occupancy_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[19].file_server_location +  '/' + this.property_occupancy_images[19].file_name + '"></img>'}else{this.property_occupancy_image_19=''}
if(count_of_items >= 11){this.property_occupancy_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[20].file_server_location +  '/' + this.property_occupancy_images[20].file_name + '"></img>'}else{this.property_occupancy_image_20=''}
if(count_of_items >= 11){this.property_occupancy_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[21].file_server_location +  '/' + this.property_occupancy_images[21].file_name + '"></img>'}else{this.property_occupancy_image_21=''}
if(count_of_items >= 11){this.property_occupancy_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[22].file_server_location +  '/' + this.property_occupancy_images[22].file_name + '"></img>'}else{this.property_occupancy_image_22=''}
if(count_of_items >= 11){this.property_occupancy_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[23].file_server_location +  '/' + this.property_occupancy_images[23].file_name + '"></img>'}else{this.property_occupancy_image_23=''}
if(count_of_items >= 11){this.property_occupancy_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[24].file_server_location +  '/' + this.property_occupancy_images[24].file_name + '"></img>'}else{this.property_occupancy_image_24=''}
if(count_of_items >= 11){this.property_occupancy_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[25].file_server_location +  '/' + this.property_occupancy_images[25].file_name + '"></img>'}else{this.property_occupancy_image_25=''}
}

if(this.service_paragraphs_model.property_condition_images != '[]' && this.service_paragraphs_model.property_condition_images != null ){
this.property_condition_images = JSON.parse(this.service_paragraphs_model.property_condition_images)
let newArr = this.property_condition_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_condition_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[0].file_server_location +  '/' + this.property_condition_images[0].file_name + '"></img>'}else{this.property_condition_image_0=''}
if(count_of_items >= 2){this.property_condition_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[1].file_server_location +  '/' + this.property_condition_images[1].file_name + '"></img>'}else{this.property_condition_image_1=''}
if(count_of_items >= 3){this.property_condition_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[2].file_server_location +  '/' + this.property_condition_images[2].file_name + '"></img>'}else{this.property_condition_image_2=''}
if(count_of_items >= 4){this.property_condition_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[3].file_server_location +  '/' + this.property_condition_images[3].file_name + '"></img>'}else{this.property_condition_image_3=''}
if(count_of_items >= 5){this.property_condition_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[4].file_server_location +  '/' + this.property_condition_images[4].file_name + '"></img>'}else{this.property_condition_image_4=''}
if(count_of_items >= 6){this.property_condition_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[5].file_server_location +  '/' + this.property_condition_images[5].file_name + '"></img>'}else{this.property_condition_image_5=''}
if(count_of_items >= 7){this.property_condition_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[6].file_server_location +  '/' + this.property_condition_images[6].file_name + '"></img>'}else{this.property_condition_image_6=''}
if(count_of_items >= 8){this.property_condition_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[7].file_server_location +  '/' + this.property_condition_images[7].file_name + '"></img>'}else{this.property_condition_image_7=''}
if(count_of_items >= 9){this.property_condition_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[8].file_server_location +  '/' + this.property_condition_images[8].file_name + '"></img>'}else{this.property_condition_image_8=''}
if(count_of_items >= 10){this.property_condition_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[9].file_server_location +  '/' + this.property_condition_images[9].file_name + '"></img>'}else{this.property_condition_image_9=''}
if(count_of_items >= 11){this.property_condition_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[10].file_server_location +  '/' + this.property_condition_images[10].file_name + '"></img>'}else{this.property_condition_image_10=''}
if(count_of_items >= 11){this.property_condition_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[11].file_server_location +  '/' + this.property_condition_images[11].file_name + '"></img>'}else{this.property_condition_image_11=''}
if(count_of_items >= 11){this.property_condition_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[12].file_server_location +  '/' + this.property_condition_images[12].file_name + '"></img>'}else{this.property_condition_image_12=''}
if(count_of_items >= 11){this.property_condition_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[13].file_server_location +  '/' + this.property_condition_images[13].file_name + '"></img>'}else{this.property_condition_image_13=''}
if(count_of_items >= 11){this.property_condition_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[14].file_server_location +  '/' + this.property_condition_images[14].file_name + '"></img>'}else{this.property_condition_image_14=''}
if(count_of_items >= 11){this.property_condition_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[15].file_server_location +  '/' + this.property_condition_images[15].file_name + '"></img>'}else{this.property_condition_image_15=''}
if(count_of_items >= 11){this.property_condition_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[16].file_server_location +  '/' + this.property_condition_images[16].file_name + '"></img>'}else{this.property_condition_image_16=''}
if(count_of_items >= 11){this.property_condition_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[17].file_server_location +  '/' + this.property_condition_images[17].file_name + '"></img>'}else{this.property_condition_image_17=''}
if(count_of_items >= 11){this.property_condition_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[18].file_server_location +  '/' + this.property_condition_images[18].file_name + '"></img>'}else{this.property_condition_image_18=''}
if(count_of_items >= 11){this.property_condition_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[19].file_server_location +  '/' + this.property_condition_images[19].file_name + '"></img>'}else{this.property_condition_image_19=''}
if(count_of_items >= 11){this.property_condition_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[20].file_server_location +  '/' + this.property_condition_images[20].file_name + '"></img>'}else{this.property_condition_image_20=''}
if(count_of_items >= 11){this.property_condition_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[21].file_server_location +  '/' + this.property_condition_images[21].file_name + '"></img>'}else{this.property_condition_image_21=''}
if(count_of_items >= 11){this.property_condition_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[22].file_server_location +  '/' + this.property_condition_images[22].file_name + '"></img>'}else{this.property_condition_image_22=''}
if(count_of_items >= 11){this.property_condition_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[23].file_server_location +  '/' + this.property_condition_images[23].file_name + '"></img>'}else{this.property_condition_image_23=''}
if(count_of_items >= 11){this.property_condition_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[24].file_server_location +  '/' + this.property_condition_images[24].file_name + '"></img>'}else{this.property_condition_image_24=''}
if(count_of_items >= 11){this.property_condition_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[25].file_server_location +  '/' + this.property_condition_images[25].file_name + '"></img>'}else{this.property_condition_image_25=''}
}


if(this.service_paragraphs_model.property_type_images != '[]' && this.service_paragraphs_model.property_type_images != null){
this.property_type_images = JSON.parse(this.service_paragraphs_model.property_type_images)
let newArr = this.property_type_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_type_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[0].file_server_location +  '/' + this.property_type_images[0].file_name + '"></img>'}else{this.property_type_image_0=''}
if(count_of_items >= 2){this.property_type_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[1].file_server_location +  '/' + this.property_type_images[1].file_name + '"></img>'}else{this.property_type_image_1=''}
if(count_of_items >= 3){this.property_type_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[2].file_server_location +  '/' + this.property_type_images[2].file_name + '"></img>'}else{this.property_type_image_2=''}
if(count_of_items >= 4){this.property_type_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[3].file_server_location +  '/' + this.property_type_images[3].file_name + '"></img>'}else{this.property_type_image_3=''}
if(count_of_items >= 5){this.property_type_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[4].file_server_location +  '/' + this.property_type_images[4].file_name + '"></img>'}else{this.property_type_image_4=''}
if(count_of_items >= 6){this.property_type_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[5].file_server_location +  '/' + this.property_type_images[5].file_name + '"></img>'}else{this.property_type_image_5=''}
if(count_of_items >= 7){this.property_type_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[6].file_server_location +  '/' + this.property_type_images[6].file_name + '"></img>'}else{this.property_type_image_6=''}
if(count_of_items >= 8){this.property_type_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[7].file_server_location +  '/' + this.property_type_images[7].file_name + '"></img>'}else{this.property_type_image_7=''}
if(count_of_items >= 9){this.property_type_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[8].file_server_location +  '/' + this.property_type_images[8].file_name + '"></img>'}else{this.property_type_image_8=''}
if(count_of_items >= 10){this.property_type_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[9].file_server_location +  '/' + this.property_type_images[9].file_name + '"></img>'}else{this.property_type_image_9=''}
if(count_of_items >= 11){this.property_type_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[10].file_server_location +  '/' + this.property_type_images[10].file_name + '"></img>'}else{this.property_type_image_10=''}
if(count_of_items >= 11){this.property_type_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[11].file_server_location +  '/' + this.property_type_images[11].file_name + '"></img>'}else{this.property_type_image_11=''}
if(count_of_items >= 11){this.property_type_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[12].file_server_location +  '/' + this.property_type_images[12].file_name + '"></img>'}else{this.property_type_image_12=''}
if(count_of_items >= 11){this.property_type_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[13].file_server_location +  '/' + this.property_type_images[13].file_name + '"></img>'}else{this.property_type_image_13=''}
if(count_of_items >= 11){this.property_type_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[14].file_server_location +  '/' + this.property_type_images[14].file_name + '"></img>'}else{this.property_type_image_14=''}
if(count_of_items >= 11){this.property_type_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[15].file_server_location +  '/' + this.property_type_images[15].file_name + '"></img>'}else{this.property_type_image_15=''}
if(count_of_items >= 11){this.property_type_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[16].file_server_location +  '/' + this.property_type_images[16].file_name + '"></img>'}else{this.property_type_image_16=''}
if(count_of_items >= 11){this.property_type_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[17].file_server_location +  '/' + this.property_type_images[17].file_name + '"></img>'}else{this.property_type_image_17=''}
if(count_of_items >= 11){this.property_type_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[18].file_server_location +  '/' + this.property_type_images[18].file_name + '"></img>'}else{this.property_type_image_18=''}
if(count_of_items >= 11){this.property_type_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[19].file_server_location +  '/' + this.property_type_images[19].file_name + '"></img>'}else{this.property_type_image_19=''}
if(count_of_items >= 11){this.property_type_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[20].file_server_location +  '/' + this.property_type_images[20].file_name + '"></img>'}else{this.property_type_image_20=''}
if(count_of_items >= 11){this.property_type_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[21].file_server_location +  '/' + this.property_type_images[21].file_name + '"></img>'}else{this.property_type_image_21=''}
if(count_of_items >= 11){this.property_type_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[22].file_server_location +  '/' + this.property_type_images[22].file_name + '"></img>'}else{this.property_type_image_22=''}
if(count_of_items >= 11){this.property_type_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[23].file_server_location +  '/' + this.property_type_images[23].file_name + '"></img>'}else{this.property_type_image_23=''}
if(count_of_items >= 11){this.property_type_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[24].file_server_location +  '/' + this.property_type_images[24].file_name + '"></img>'}else{this.property_type_image_24=''}
if(count_of_items >= 11){this.property_type_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[25].file_server_location +  '/' + this.property_type_images[25].file_name + '"></img>'}else{this.property_type_image_25=''}
}




if(this.service_paragraphs_model.service_file_array != '[]' && this.service_paragraphs_model.service_file_array != null){
this.service_file_array_images = JSON.parse(this.service_paragraphs_model.service_file_array)
let newArr = this.service_file_array_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.service_file_array_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[0].file_server_location +  '/' + this.service_file_array_images[0].file_name + '"></img>'}else{this.service_file_array_image_0=''}
if(count_of_items >= 2){this.service_file_array_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[1].file_server_location +  '/' + this.service_file_array_images[1].file_name + '"></img>'}else{this.service_file_array_image_1=''}
if(count_of_items >= 3){this.service_file_array_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[2].file_server_location +  '/' + this.service_file_array_images[2].file_name + '"></img>'}else{this.service_file_array_image_2=''}
if(count_of_items >= 4){this.service_file_array_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[3].file_server_location +  '/' + this.service_file_array_images[3].file_name + '"></img>'}else{this.service_file_array_image_3=''}
if(count_of_items >= 5){this.service_file_array_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[4].file_server_location +  '/' + this.service_file_array_images[4].file_name + '"></img>'}else{this.service_file_array_image_4=''}
if(count_of_items >= 6){this.service_file_array_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[5].file_server_location +  '/' + this.service_file_array_images[5].file_name + '"></img>'}else{this.service_file_array_image_5=''}
if(count_of_items >= 7){this.service_file_array_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[6].file_server_location +  '/' + this.service_file_array_images[6].file_name + '"></img>'}else{this.service_file_array_image_6=''}
if(count_of_items >= 8){this.service_file_array_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[7].file_server_location +  '/' + this.service_file_array_images[7].file_name + '"></img>'}else{this.service_file_array_image_7=''}
if(count_of_items >= 9){this.service_file_array_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[8].file_server_location +  '/' + this.service_file_array_images[8].file_name + '"></img>'}else{this.service_file_array_image_8=''}
if(count_of_items >= 10){this.service_file_array_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[9].file_server_location +  '/' + this.service_file_array_images[9].file_name + '"></img>'}else{this.service_file_array_image_9=''}
if(count_of_items >= 11){this.service_file_array_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[10].file_server_location +  '/' + this.service_file_array_images[10].file_name + '"></img>'}else{this.service_file_array_image_10=''}
if(count_of_items >= 11){this.service_file_array_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[11].file_server_location +  '/' + this.service_file_array_images[11].file_name + '"></img>'}else{this.service_file_array_image_11=''}
if(count_of_items >= 11){this.service_file_array_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[12].file_server_location +  '/' + this.service_file_array_images[12].file_name + '"></img>'}else{this.service_file_array_image_12=''}
if(count_of_items >= 11){this.service_file_array_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[13].file_server_location +  '/' + this.service_file_array_images[13].file_name + '"></img>'}else{this.service_file_array_image_13=''}
if(count_of_items >= 11){this.service_file_array_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[14].file_server_location +  '/' + this.service_file_array_images[14].file_name + '"></img>'}else{this.service_file_array_image_14=''}
if(count_of_items >= 11){this.service_file_array_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[15].file_server_location +  '/' + this.service_file_array_images[15].file_name + '"></img>'}else{this.service_file_array_image_15=''}
if(count_of_items >= 11){this.service_file_array_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[16].file_server_location +  '/' + this.service_file_array_images[16].file_name + '"></img>'}else{this.service_file_array_image_16=''}
if(count_of_items >= 11){this.service_file_array_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[17].file_server_location +  '/' + this.service_file_array_images[17].file_name + '"></img>'}else{this.service_file_array_image_17=''}
if(count_of_items >= 11){this.service_file_array_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[18].file_server_location +  '/' + this.service_file_array_images[18].file_name + '"></img>'}else{this.service_file_array_image_18=''}
if(count_of_items >= 11){this.service_file_array_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[19].file_server_location +  '/' + this.service_file_array_images[19].file_name + '"></img>'}else{this.service_file_array_image_19=''}
if(count_of_items >= 11){this.service_file_array_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[20].file_server_location +  '/' + this.service_file_array_images[20].file_name + '"></img>'}else{this.service_file_array_image_20=''}
if(count_of_items >= 11){this.service_file_array_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[21].file_server_location +  '/' + this.service_file_array_images[21].file_name + '"></img>'}else{this.service_file_array_image_21=''}
if(count_of_items >= 11){this.service_file_array_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[22].file_server_location +  '/' + this.service_file_array_images[22].file_name + '"></img>'}else{this.service_file_array_image_22=''}
if(count_of_items >= 11){this.service_file_array_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[23].file_server_location +  '/' + this.service_file_array_images[23].file_name + '"></img>'}else{this.service_file_array_image_23=''}
if(count_of_items >= 11){this.service_file_array_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[24].file_server_location +  '/' + this.service_file_array_images[24].file_name + '"></img>'}else{this.service_file_array_image_24=''}
if(count_of_items >= 11){this.service_file_array_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[25].file_server_location +  '/' + this.service_file_array_images[25].file_name + '"></img>'}else{this.service_file_array_image_25=''}
}

const rendered_result = str



  .replaceAll( '${' + keystarter + '_type_id}', this.service_paragraphs_model.subject_attempt_type_id)
  .replaceAll( '${' + keystarter + '_type_name}', this.service_paragraphs_model.subject_attempt_type_name ) // run a function with return;
  .replaceAll( '${' + keystarter + '_subject_attempt_type_name}', this.service_paragraphs_model.subject_attempt_type_name ) // run a function with return;
  .replaceAll( '${' + keystarter + '_type_name_upper}', this.var_subject_attempt_type_name_Upper) // all if statments set a this/g/ varaibales

  .replaceAll( '${' + keystarter + '_subject_service_method_id}', this.service_paragraphs_model.subject_service_method_id)
  .replaceAll( '${' + keystarter + '_subject_service_method_name}', this.service_paragraphs_model.subject_service_method_name ) // tested above.
  .replaceAll( '${' + keystarter + '_service_method}', this.service_paragraphs_model.subject_service_method_name ) // tested above.
  .replaceAll( '${' + keystarter + '_service_method_id}', this.service_paragraphs_model.subject_service_method_id) // tested above.


  .replaceAll( '${' + keystarter + '_date_service}', moment(this.service_paragraphs_model.date_service).format('D/M/YYYY'))
  .replaceAll( '${' + keystarter + '_date_service_full_words_time_first}', this.service_paragraphs_model.time_service_text + ' ' + moment(this.service_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') ) 
  .replaceAll( '${' + keystarter + '_date_service_and_time_full_words}', moment(this.service_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') + ' ' + this.service_paragraphs_model.time_service_text ) 
  .replaceAll( '${' + keystarter + '_date_service_full_words}', moment(this.service_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') + ' ' + model.time_service_text ) 

  .replaceAll( '${' + keystarter + '_day}', moment(this.service_paragraphs_model.date_service).format('dddd'))
  .replaceAll( '${' + keystarter + '_day_number}', moment(this.service_paragraphs_model.date_service).format('Do'))
  .replaceAll( '${' + keystarter + '_day_number_simple}', moment(this.service_paragraphs_model.date_service).format('D'))
  .replaceAll( '${' + keystarter + '_month}', moment(this.service_paragraphs_model.date_service).format('MMMM'))
  .replaceAll( '${' + keystarter + '_month_number}', moment(this.service_paragraphs_model.date_service).format('Mo'))
  .replaceAll( '${' + keystarter + '_month_number_simple}', moment(this.service_paragraphs_model.date_service).format('M'))
  .replaceAll( '${' + keystarter + '_year}', moment(this.service_paragraphs_model.date_service).format('YYYY'))

  .replaceAll( '${' + keystarter + '_service_local}', this.service_paragraphs_model.service_local) // region Australia/Perth of service undertaken
  .replaceAll( '${' + keystarter + '_time}', this.service_paragraphs_model.time_service_text) //$_set_service_time - Fixed and set time of attempt and service

  .replaceAll( '${' + keystarter + '_paragraph_rendered}',  this.set_service_paragraph_rendered) //$_set_service_time - Fixed and set time of attempt and service

  .replaceAll( '${' + keystarter + '_subject_name}', var_subject_name)
  .replaceAll( '${' + keystarter + '_subject_number}', this.service_paragraphs_model.subject_number)
  .replaceAll( '${' + keystarter + '_subject_name_4_doc}', var_subject_name_4_doc)
  .replaceAll( '${' + keystarter + '_subject_business_name}', var_subject_business_name)
  .replaceAll( '${' + keystarter + '_business_name}', var_subject_business_name)

// Subject Attempt Address
.replaceAll( '${' + keystarter + '_address_1}', this.service_paragraphs_model.address_1)
.replaceAll( '${' + keystarter + '_address_2}', this.service_paragraphs_model.address_2)
.replaceAll( '${' + keystarter + '_suburb}', this.service_paragraphs_model.suburb)
.replaceAll( '${' + keystarter + '_state}', this.service_paragraphs_model.state)
.replaceAll( '${' + keystarter + '_postcode}', this.service_paragraphs_model.postcode)
.replaceAll( '${' + keystarter + '_address_full}', this.service_paragraphs_model.address_1 +  ' ' + this.service_paragraphs_model.address_2 +  ' ' + this.service_paragraphs_model.suburb +  ' ' + this.service_paragraphs_model.state +  ',  ' + this.service_paragraphs_model.postcode )
// Sav
.replaceAll( '${' + keystarter + '_sav_address_full}', this.service_paragraphs_model.address_1 +  ' ' + this.service_paragraphs_model.address_2 +  ' ' + this.service_paragraphs_model.suburb +  ' ' + this.service_paragraphs_model.state +  ',  ' + this.service_paragraphs_model.postcode )
// New address
.replaceAll( '${' + keystarter + '_new_business_name}', this.service_paragraphs_model.new_business_name)
.replaceAll( '${' + keystarter + '_new_address_1}', this.service_paragraphs_model.new_address_1)
.replaceAll( '${' + keystarter + '_new_address_2}', this.service_paragraphs_model.new_address_2)
.replaceAll( '${' + keystarter + '_new_suburb}', this.service_paragraphs_model.new_suburb)
.replaceAll( '${' + keystarter + '_new_state}', this.service_paragraphs_model.new_state)
.replaceAll( '${' + keystarter + '_new_postcode}', this.service_paragraphs_model.new_postcode)
.replaceAll( '${' + keystarter + '_new_address_full}', this.service_paragraphs_model.new_address_1 +  ' ' + this.service_paragraphs_model.new_address_2 +  ' ' + this.service_paragraphs_model.new_suburb +  ' ' + this.service_paragraphs_model.new_state +  ',  ' + this.service_paragraphs_model.new_postcode )

.replaceAll( '${' + keystarter + '_service_number}', this.service_paragraphs_model.service_number)

.replaceAll( '${' + keystarter + '_service_outcome_name}', this.service_paragraphs_model.subject_service_outcome_name)
.replaceAll( '${' + keystarter + '_exact_service_method_name}', this.service_paragraphs_model.exact_service_method_name) //
.replaceAll( '${' + keystarter + '_subject_type_name}', this.job_subject_type_name) // set in the job lookup.
.replaceAll( '${' + keystarter + '_subject_type_name_upper}', this.job_subject_type_name_Upper) // set in the job lookup.
.replaceAll( '${' + keystarter + '_location_status_name}', this.service_paragraphs_model.subject_location_status_name)
.replaceAll( '${' + keystarter + '_location_status_found_name}', this.service_paragraphs_model.subject_location_status_found_name)

.replaceAll( '${' + keystarter + '_fellow_occupants_name}', this.service_paragraphs_model.fellow_occupants_name)
.replaceAll( '${' + keystarter + '_fellow_occupants_sex}', this.service_paragraphs_model.fellow_occupants_sex)
.replaceAll( '${' + keystarter + '_fellow_occupants_name_label}', 'Fellow Occupants Name: ' +  this.service_paragraphs_model.fellow_occupants_name)
.replaceAll( '${' + keystarter + '_subject_relationship_name}', this.service_paragraphs_model.subject_service_fellow_relationship)

.replaceAll( '${' + keystarter + '_person_spoken_with}', this.service_paragraphs_model.person_spoken_with)
.replaceAll( '${' + keystarter + '_person_type}', this.service_paragraphs_model.person_type)
.replaceAll( '${' + keystarter + '_person_spoken_with_advised}',   this.person_spoken_with_advised_HTML ) 

.replaceAll( '${' + keystarter + '_vehicles}', this.service_paragraphs_model.vehicles)
.replaceAll( '${' + keystarter + '_vehicles_notes}',   this.vehicles_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_neighbours}', this.service_paragraphs_model.neighbours)
.replaceAll( '${' + keystarter + '_neighbours_notes}',   this.neighbours_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_calling_card}', this.service_paragraphs_model.calling_card)
.replaceAll( '${' + keystarter + '_calling_card_notes}',   this.calling_card_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_postal_mail}', this.service_paragraphs_model.postal_mail)
.replaceAll( '${' + keystarter + '_postal_mail_notes}',   this.postal_mail_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_phone_call}', this.service_paragraphs_model.phone_call)
.replaceAll( '${' + keystarter + '_phone_call_notes}',   this.phone_call_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_attempts}', this.service_paragraphs_model.attempts)
.replaceAll( '${' + keystarter + '_attempts_notes}',   this.attempts_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_authorised_employee_name}', this.service_paragraphs_model.authorised_employee_name)
.replaceAll( '${' + keystarter + '_authorised_employee_job_title}', this.service_paragraphs_model.authorised_employee_job_title)
.replaceAll( '${' + keystarter + '_authorised_employee_sex}', this.service_paragraphs_model.authorised_employee_sex)
.replaceAll( '${' + keystarter + '_office_business_name}', this.service_paragraphs_model.office_business_name)

.replaceAll( '${' + keystarter + '_witness_name}', this.service_paragraphs_model.witness_name)
.replaceAll( '${' + keystarter + '_witness_business_name}', this.service_paragraphs_model.witness_business_name)
.replaceAll( '${' + keystarter + '_witness_address}', this.service_paragraphs_model.witness_address_1 + ' ' + this.service_paragraphs_model.witness_address_2 + ' ' +  this.service_paragraphs_model.witness_suburb + ' ' + this.service_paragraphs_model.witness_state + ', ' + this.service_paragraphs_model.witness_postcode  ) // 
.replaceAll( '${' + keystarter + '_witness_address_1}', this.service_paragraphs_model.witness_address_1)
.replaceAll( '${' + keystarter + '_witness_address_2}', this.service_paragraphs_model.witness_address_2)
.replaceAll( '${' + keystarter + '_witness_state}', this.service_paragraphs_model.witness_state)
.replaceAll( '${' + keystarter + '_witness_suburb}', this.service_paragraphs_model.witness_suburb)
.replaceAll( '${' + keystarter + '_witness_country}', this.service_paragraphs_model.witness_country)
.replaceAll( '${' + keystarter + '_witness_postcode}', this.service_paragraphs_model.witness_postcode)

.replaceAll( '${' + keystarter + '_person_in_charge_of_prison_name}', this.service_paragraphs_model.person_in_charge_of_prison_name)
.replaceAll( '${' + keystarter + '_person_in_charge_of_prison_occupation}', this.service_paragraphs_model.person_in_charge_of_prison_occupation)

.replaceAll( '${' + keystarter + '_ubject_contact_email_id}', this.service_paragraphs_model.subject_contact_email_id)
.replaceAll( '${' + keystarter + '_email_address_served}', this.service_paragraphs_model.email_address_served)
.replaceAll( '${' + keystarter + '_email_contents}', this.email_contents_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_director_name}', this.service_paragraphs_model.director_name)
// .replaceAll( '${' + keystarter + '_service_under_order}', this.service_paragraphs_model.service_under_order)
.replaceAll( '${' + keystarter + '_service_under_order}', this.service_under_order_HTML)


.replaceAll( '${' + keystarter + '_phone_number}', this.service_paragraphs_model.phone_number)



// Agent Details
.replaceAll( '${' + keystarter + '_agent_name}', this.subject_service_agent.first_name + ' ' + this.subject_service_agent.middle_name + ' ' + this.subject_service_agent.surname )
.replaceAll( '${' + keystarter + '_agent_first_name}', this.subject_service_agent.first_name)
.replaceAll( '${' + keystarter + '_agent_middle_name}', this.subject_service_agent.middle_name)
.replaceAll( '${' + keystarter + '_agent_surname}', this.subject_service_agent.surname)

.replaceAll( '${' + keystarter + '_agent_address_1}', this.subject_service_agent.address_1)
.replaceAll( '${' + keystarter + '_agent_address_2}', this.subject_service_agent.address_2)
.replaceAll( '${' + keystarter + '_agent_suburb}', this.subject_service_agent.suburb)
.replaceAll( '${' + keystarter + '_agent_state}', this.subject_service_agent.state)
.replaceAll( '${' + keystarter + '_agent_postcode}', this.subject_service_agent.postcode)
.replaceAll( '${' + keystarter + '_agent_address_full}', this.subject_service_agent.address_1 + ' ' + this.subject_service_agent.address_2 + ' ' + this.subject_service_agent.suburb + ' ' + this.subject_service_agent.state + ', ' + this.subject_service_agent.postcode )
.replaceAll( '${' + keystarter + '_agent_qualification}', this.subject_service_agent.qualification)
.replaceAll( '${' + keystarter + '_agent_qualification_number}', this.subject_service_agent.qualification_number)

.replaceAll( '${' + keystarter + '_agent_qualification_renewal_date}', moment(this.subject_service_agent.qualification_renewal_date).format('D/M/YYYY') )
.replaceAll( '${' + keystarter + '_agent_qualification_renewal_date_full_words}', moment(this.subject_service_agent.qualification_renewal_date).format('dddd MMMM Do, YYYY h:mma') )

.replaceAll( '${' + keystarter + '_general_notes}',  this.set_general_notes ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_is_count}', this.service_paragraphs_model.is_count)
.replaceAll( '${' + keystarter + '_property_images}', this.service_paragraphs_model.property_images)
.replaceAll( '${' + keystarter + '_attach_file_array_name}', this.service_paragraphs_model.attach_file_array_name)
.replaceAll( '${' + keystarter + '_property_occupied}', this.service_paragraphs_model.property_occupied)

.replaceAll( '${' + keystarter + '_property_forsale_or_lease_sign}', this.service_paragraphs_model.property_forsale_or_lease_sign)
.replaceAll( '${' + keystarter + '_property_sign_images}', this.service_paragraphs_model.property_sign_images)
.replaceAll( '${' + keystarter + '_property_forsale_or_lease_sign_details}',   this.property_forsale_or_lease_sign_details_HTML) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_agent_name}', this.service_paragraphs_model.property_agent_name)
.replaceAll( '${' + keystarter + '_property_agency_name}', this.service_paragraphs_model.property_agency_name)
.replaceAll( '${' + keystarter + '_property_agency_contact_numbers}', this.service_paragraphs_model.property_agency_contact_numbers)


.replaceAll( '${' + keystarter + '_property_mail}', this.service_paragraphs_model.property_mail)
.replaceAll( '${' + keystarter + '_property_mail_images}', this.service_paragraphs_model.property_mail_images)
.replaceAll( '${' + keystarter + '_property_mail_details}', this.property_mail_details_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_property_vehicles_sighted}', this.service_paragraphs_model.property_vehicles_sighted)
.replaceAll( '${' + keystarter + '_property_vehicles_sighted_details}', this.property_vehicles_sighted_details_HTML ) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_vehicles_images}', this.service_paragraphs_model.property_vehicles_images)
.replaceAll( '${' + keystarter + '_property_v_make}', this.service_paragraphs_model.property_v_make)
.replaceAll( '${' + keystarter + '_property_v_model}', this.service_paragraphs_model.property_v_model)
.replaceAll( '${' + keystarter + '_property_v_plate}', this.service_paragraphs_model.property_v_plate)
.replaceAll( '${' + keystarter + '_property_v_rego_state}', this.service_paragraphs_model.property_v_rego_state)

.replaceAll( '${' + keystarter + '_property_pets}', this.service_paragraphs_model.property_pets)
.replaceAll( '${' + keystarter + '_property_pets_details}', this.property_pets_details_HTML ) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_pets_images}', this.service_paragraphs_model.property_pets_images)

.replaceAll( '${' + keystarter + '_property_occupancy}', this.service_paragraphs_model.property_occupancy)
.replaceAll( '${' + keystarter + '_property_occupancy_details}', this.property_occupancy_details_HTML ) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_occupancy_images}', this.service_paragraphs_model.property_occupancy_images)
.replaceAll( '${' + keystarter + '_property_o_name}', this.service_paragraphs_model.property_o_name)
.replaceAll( '${' + keystarter + '_property_o_contact_numbers}', this.service_paragraphs_model.property_o_contact_numbers)
.replaceAll( '${' + keystarter + '_property_o_lease_details}', this.service_paragraphs_model.property_o_lease_details)
.replaceAll( '${' + keystarter + '_property_o_lease_date}', this.service_paragraphs_model.property_o_lease_date)
.replaceAll( '${' + keystarter + '_property_o_landlord_contacts}', this.service_paragraphs_model.property_o_landlord_contacts)

.replaceAll( '${' + keystarter + '_property_condition}', this.property_condition_HTML ) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_condition_images}', this.service_paragraphs_model.property_condition_images)

.replaceAll( '${' + keystarter + '_property_occupied_details}', this.property_occupied_details_HTML) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_property_type_id}', this.service_paragraphs_model.property_type_id)
.replaceAll( '${' + keystarter + '_property_type_details}', this.set_property_type_details_HTML) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_type_images}', this.service_paragraphs_model.property_type_images)

.replaceAll( '${' + keystarter + '_property_type_name}', this.service_paragraphs_model.property_type_name)

.replaceAll( '${' + keystarter + '_service_file_array}', this.service_paragraphs_model.service_file_array)


// Images // <img src="pic_trulli.jpg" alt="Italian Trulli">
// this.service_paragraphs_model.property_images - runs a loop functino above to set image variables
.replaceAll( '${' + keystarter + '_property_image_0}',  this.propery_image_0 )
.replaceAll( '${' + keystarter + '_property_image_1}',  this.propery_image_1 )
.replaceAll( '${' + keystarter + '_property_image_2}',  this.propery_image_2 )
.replaceAll( '${' + keystarter + '_property_image_3}',  this.propery_image_3 )
.replaceAll( '${' + keystarter + '_property_image_4}',  this.propery_image_4 )
.replaceAll( '${' + keystarter + '_property_image_5}',  this.propery_image_5 )
.replaceAll( '${' + keystarter + '_property_image_6}',  this.propery_image_6 )
.replaceAll( '${' + keystarter + '_property_image_7}',  this.propery_image_7 )
.replaceAll( '${' + keystarter + '_property_image_8}',  this.propery_image_8 )
.replaceAll( '${' + keystarter + '_property_image_9}',  this.propery_image_9 )
.replaceAll( '${' + keystarter + '_property_image_10}',  this.propery_image_10 )
.replaceAll( '${' + keystarter + '_property_image_11}',  this.propery_image_11 )
.replaceAll( '${' + keystarter + '_property_image_12}',  this.propery_image_12 )
.replaceAll( '${' + keystarter + '_property_image_13}',  this.propery_image_13 )
.replaceAll( '${' + keystarter + '_property_image_14}',  this.propery_image_14 )
.replaceAll( '${' + keystarter + '_property_image_15}',  this.propery_image_15 )
.replaceAll( '${' + keystarter + '_property_image_16}',  this.propery_image_16 )
.replaceAll( '${' + keystarter + '_property_image_17}',  this.propery_image_17 )
.replaceAll( '${' + keystarter + '_property_image_18}',  this.propery_image_18 )
.replaceAll( '${' + keystarter + '_property_image_19}',  this.propery_image_19 )
.replaceAll( '${' + keystarter + '_property_image_20}',  this.propery_image_20 )
.replaceAll( '${' + keystarter + '_property_image_21}',  this.propery_image_21 )
.replaceAll( '${' + keystarter + '_property_image_22}',  this.propery_image_22 )
.replaceAll( '${' + keystarter + '_property_image_23}',  this.propery_image_23 )
.replaceAll( '${' + keystarter + '_property_image_24}',  this.propery_image_24 )
.replaceAll( '${' + keystarter + '_property_image_25}',  this.propery_image_25 )


.replaceAll( '${' + keystarter + '_property_sign_image_0}',  this.property_sign_image_0 )
.replaceAll( '${' + keystarter + '_property_sign_image_1}',  this.property_sign_image_1 )
.replaceAll( '${' + keystarter + '_property_sign_image_2}',  this.property_sign_image_2 )
.replaceAll( '${' + keystarter + '_property_sign_image_3}',  this.property_sign_image_3 )
.replaceAll( '${' + keystarter + '_property_sign_image_4}',  this.property_sign_image_4 )
.replaceAll( '${' + keystarter + '_property_sign_image_5}',  this.property_sign_image_5 )
.replaceAll( '${' + keystarter + '_property_sign_image_6}',  this.property_sign_image_6 )
.replaceAll( '${' + keystarter + '_property_sign_image_7}',  this.property_sign_image_7 )
.replaceAll( '${' + keystarter + '_property_sign_image_8}',  this.property_sign_image_8 )
.replaceAll( '${' + keystarter + '_property_sign_image_9}',  this.property_sign_image_9 )
.replaceAll( '${' + keystarter + '_property_sign_image_10}',  this.property_sign_image_10 )
.replaceAll( '${' + keystarter + '_property_sign_image_11}',  this.property_sign_image_11 )
.replaceAll( '${' + keystarter + '_property_sign_image_12}',  this.property_sign_image_12 )
.replaceAll( '${' + keystarter + '_property_sign_image_13}',  this.property_sign_image_13 )
.replaceAll( '${' + keystarter + '_property_sign_image_14}',  this.property_sign_image_14 )
.replaceAll( '${' + keystarter + '_property_sign_image_15}',  this.property_sign_image_15 )
.replaceAll( '${' + keystarter + '_property_sign_image_16}',  this.property_sign_image_16 )
.replaceAll( '${' + keystarter + '_property_sign_image_17}',  this.property_sign_image_17 )
.replaceAll( '${' + keystarter + '_property_sign_image_18}',  this.property_sign_image_18 )
.replaceAll( '${' + keystarter + '_property_sign_image_19}',  this.property_sign_image_19 )
.replaceAll( '${' + keystarter + '_property_sign_image_20}',  this.property_sign_image_20 )
.replaceAll( '${' + keystarter + '_property_sign_image_21}',  this.property_sign_image_21 )
.replaceAll( '${' + keystarter + '_property_sign_image_22}',  this.property_sign_image_22 )
.replaceAll( '${' + keystarter + '_property_sign_image_23}',  this.property_sign_image_23 )
.replaceAll( '${' + keystarter + '_property_sign_image_24}',  this.property_sign_image_24 )
.replaceAll( '${' + keystarter + '_property_sign_image_25}',  this.property_sign_image_25 )


.replaceAll( '${' + keystarter + '_property_mail_image_0}',  this.property_mail_image_0 )
.replaceAll( '${' + keystarter + '_property_mail_image_1}',  this.property_mail_image_1 )
.replaceAll( '${' + keystarter + '_property_mail_image_2}',  this.property_mail_image_2 )
.replaceAll( '${' + keystarter + '_property_mail_image_3}',  this.property_mail_image_3 )
.replaceAll( '${' + keystarter + '_property_mail_image_4}',  this.property_mail_image_4 )
.replaceAll( '${' + keystarter + '_property_mail_image_5}',  this.property_mail_image_5 )
.replaceAll( '${' + keystarter + '_property_mail_image_6}',  this.property_mail_image_6 )
.replaceAll( '${' + keystarter + '_property_mail_image_7}',  this.property_mail_image_7 )
.replaceAll( '${' + keystarter + '_property_mail_image_8}',  this.property_mail_image_8 )
.replaceAll( '${' + keystarter + '_property_mail_image_9}',  this.property_mail_image_9 )
.replaceAll( '${' + keystarter + '_property_mail_image_10}',  this.property_mail_image_10 )
.replaceAll( '${' + keystarter + '_property_mail_image_11}',  this.property_mail_image_11 )
.replaceAll( '${' + keystarter + '_property_mail_image_12}',  this.property_mail_image_12 )
.replaceAll( '${' + keystarter + '_property_mail_image_13}',  this.property_mail_image_13 )
.replaceAll( '${' + keystarter + '_property_mail_image_14}',  this.property_mail_image_14 )
.replaceAll( '${' + keystarter + '_property_mail_image_15}',  this.property_mail_image_15 )
.replaceAll( '${' + keystarter + '_property_mail_image_16}',  this.property_mail_image_16 )
.replaceAll( '${' + keystarter + '_property_mail_image_17}',  this.property_mail_image_17 )
.replaceAll( '${' + keystarter + '_property_mail_image_18}',  this.property_mail_image_18 )
.replaceAll( '${' + keystarter + '_property_mail_image_19}',  this.property_mail_image_19 )
.replaceAll( '${' + keystarter + '_property_mail_image_20}',  this.property_mail_image_20 )
.replaceAll( '${' + keystarter + '_property_mail_image_21}',  this.property_mail_image_21 )
.replaceAll( '${' + keystarter + '_property_mail_image_22}',  this.property_mail_image_22 )
.replaceAll( '${' + keystarter + '_property_mail_image_23}',  this.property_mail_image_23 )
.replaceAll( '${' + keystarter + '_property_mail_image_24}',  this.property_mail_image_24 )
.replaceAll( '${' + keystarter + '_property_mail_image_25}',  this.property_mail_image_25 )


.replaceAll( '${' + keystarter + '_property_vehicles_image_0}',  this.property_vehicles_image_0 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_1}',  this.property_vehicles_image_1 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_2}',  this.property_vehicles_image_2 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_3}',  this.property_vehicles_image_3 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_4}',  this.property_vehicles_image_4 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_5}',  this.property_vehicles_image_5 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_6}',  this.property_vehicles_image_6 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_7}',  this.property_vehicles_image_7 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_8}',  this.property_vehicles_image_8 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_9}',  this.property_vehicles_image_9 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_10}',  this.property_vehicles_image_10 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_11}',  this.property_vehicles_image_11 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_12}',  this.property_vehicles_image_12 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_13}',  this.property_vehicles_image_13 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_14}',  this.property_vehicles_image_14 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_15}',  this.property_vehicles_image_15 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_16}',  this.property_vehicles_image_16 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_17}',  this.property_vehicles_image_17 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_18}',  this.property_vehicles_image_18 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_19}',  this.property_vehicles_image_19 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_20}',  this.property_vehicles_image_20 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_21}',  this.property_vehicles_image_21 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_22}',  this.property_vehicles_image_22 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_23}',  this.property_vehicles_image_23 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_24}',  this.property_vehicles_image_24 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_25}',  this.property_vehicles_image_25 )


.replaceAll( '${' + keystarter + '_property_pets_image_0}',  this.property_pets_image_0 )
.replaceAll( '${' + keystarter + '_property_pets_image_1}',  this.property_pets_image_1 )
.replaceAll( '${' + keystarter + '_property_pets_image_2}',  this.property_pets_image_2 )
.replaceAll( '${' + keystarter + '_property_pets_image_3}',  this.property_pets_image_3 )
.replaceAll( '${' + keystarter + '_property_pets_image_4}',  this.property_pets_image_4 )
.replaceAll( '${' + keystarter + '_property_pets_image_5}',  this.property_pets_image_5 )
.replaceAll( '${' + keystarter + '_property_pets_image_6}',  this.property_pets_image_6 )
.replaceAll( '${' + keystarter + '_property_pets_image_7}',  this.property_pets_image_7 )
.replaceAll( '${' + keystarter + '_property_pets_image_8}',  this.property_pets_image_8 )
.replaceAll( '${' + keystarter + '_property_pets_image_9}',  this.property_pets_image_9 )
.replaceAll( '${' + keystarter + '_property_pets_image_10}',  this.property_pets_image_10 )
.replaceAll( '${' + keystarter + '_property_pets_image_11}',  this.property_pets_image_11 )
.replaceAll( '${' + keystarter + '_property_pets_image_12}',  this.property_pets_image_12 )
.replaceAll( '${' + keystarter + '_property_pets_image_13}',  this.property_pets_image_13 )
.replaceAll( '${' + keystarter + '_property_pets_image_14}',  this.property_pets_image_14 )
.replaceAll( '${' + keystarter + '_property_pets_image_15}',  this.property_pets_image_15 )
.replaceAll( '${' + keystarter + '_property_pets_image_16}',  this.property_pets_image_16 )
.replaceAll( '${' + keystarter + '_property_pets_image_17}',  this.property_pets_image_17 )
.replaceAll( '${' + keystarter + '_property_pets_image_18}',  this.property_pets_image_18 )
.replaceAll( '${' + keystarter + '_property_pets_image_19}',  this.property_pets_image_19 )
.replaceAll( '${' + keystarter + '_property_pets_image_20}',  this.property_pets_image_20 )
.replaceAll( '${' + keystarter + '_property_pets_image_21}',  this.property_pets_image_21 )
.replaceAll( '${' + keystarter + '_property_pets_image_22}',  this.property_pets_image_22 )
.replaceAll( '${' + keystarter + '_property_pets_image_23}',  this.property_pets_image_23 )
.replaceAll( '${' + keystarter + '_property_pets_image_24}',  this.property_pets_image_24 )
.replaceAll( '${' + keystarter + '_property_pets_image_25}',  this.property_pets_image_25 )

.replaceAll( '${' + keystarter + '_property_occupancy_image_0}',  this.property_occupancy_image_0 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_1}',  this.property_occupancy_image_1 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_2}',  this.property_occupancy_image_2 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_3}',  this.property_occupancy_image_3 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_4}',  this.property_occupancy_image_4 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_5}',  this.property_occupancy_image_5 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_6}',  this.property_occupancy_image_6 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_7}',  this.property_occupancy_image_7 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_8}',  this.property_occupancy_image_8 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_9}',  this.property_occupancy_image_9 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_10}',  this.property_occupancy_image_10 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_11}',  this.property_occupancy_image_11 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_12}',  this.property_occupancy_image_12 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_13}',  this.property_occupancy_image_13 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_14}',  this.property_occupancy_image_14 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_15}',  this.property_occupancy_image_15 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_16}',  this.property_occupancy_image_16 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_17}',  this.property_occupancy_image_17 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_18}',  this.property_occupancy_image_18 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_19}',  this.property_occupancy_image_19 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_20}',  this.property_occupancy_image_20 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_21}',  this.property_occupancy_image_21 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_22}',  this.property_occupancy_image_22 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_23}',  this.property_occupancy_image_23 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_24}',  this.property_occupancy_image_24 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_25}',  this.property_occupancy_image_25 )

.replaceAll( '${' + keystarter + '_property_condition_image_0}',  this.property_condition_image_0 )
.replaceAll( '${' + keystarter + '_property_condition_image_1}',  this.property_condition_image_1 )
.replaceAll( '${' + keystarter + '_property_condition_image_2}',  this.property_condition_image_2 )
.replaceAll( '${' + keystarter + '_property_condition_image_3}',  this.property_condition_image_3 )
.replaceAll( '${' + keystarter + '_property_condition_image_4}',  this.property_condition_image_4 )
.replaceAll( '${' + keystarter + '_property_condition_image_5}',  this.property_condition_image_5 )
.replaceAll( '${' + keystarter + '_property_condition_image_6}',  this.property_condition_image_6 )
.replaceAll( '${' + keystarter + '_property_condition_image_7}',  this.property_condition_image_7 )
.replaceAll( '${' + keystarter + '_property_condition_image_8}',  this.property_condition_image_8 )
.replaceAll( '${' + keystarter + '_property_condition_image_9}',  this.property_condition_image_9 )
.replaceAll( '${' + keystarter + '_property_condition_image_10}',  this.property_condition_image_10 )
.replaceAll( '${' + keystarter + '_property_condition_image_11}',  this.property_condition_image_11 )
.replaceAll( '${' + keystarter + '_property_condition_image_12}',  this.property_condition_image_12 )
.replaceAll( '${' + keystarter + '_property_condition_image_13}',  this.property_condition_image_13 )
.replaceAll( '${' + keystarter + '_property_condition_image_14}',  this.property_condition_image_14 )
.replaceAll( '${' + keystarter + '_property_condition_image_15}',  this.property_condition_image_15 )
.replaceAll( '${' + keystarter + '_property_condition_image_16}',  this.property_condition_image_16 )
.replaceAll( '${' + keystarter + '_property_condition_image_17}',  this.property_condition_image_17 )
.replaceAll( '${' + keystarter + '_property_condition_image_18}',  this.property_condition_image_18 )
.replaceAll( '${' + keystarter + '_property_condition_image_19}',  this.property_condition_image_19 )
.replaceAll( '${' + keystarter + '_property_condition_image_20}',  this.property_condition_image_20 )
.replaceAll( '${' + keystarter + '_property_condition_image_21}',  this.property_condition_image_21 )
.replaceAll( '${' + keystarter + '_property_condition_image_22}',  this.property_condition_image_22 )
.replaceAll( '${' + keystarter + '_property_condition_image_23}',  this.property_condition_image_23 )
.replaceAll( '${' + keystarter + '_property_condition_image_24}',  this.property_condition_image_24 )
.replaceAll( '${' + keystarter + '_property_condition_image_25}',  this.property_condition_image_25 )

.replaceAll( '${' + keystarter + '_property_type_image_0}',  this.property_type_image_0 )
.replaceAll( '${' + keystarter + '_property_type_image_1}',  this.property_type_image_1 )
.replaceAll( '${' + keystarter + '_property_type_image_2}',  this.property_type_image_2 )
.replaceAll( '${' + keystarter + '_property_type_image_3}',  this.property_type_image_3 )
.replaceAll( '${' + keystarter + '_property_type_image_4}',  this.property_type_image_4 )
.replaceAll( '${' + keystarter + '_property_type_image_5}',  this.property_type_image_5 )
.replaceAll( '${' + keystarter + '_property_type_image_6}',  this.property_type_image_6 )
.replaceAll( '${' + keystarter + '_property_type_image_7}',  this.property_type_image_7 )
.replaceAll( '${' + keystarter + '_property_type_image_8}',  this.property_type_image_8 )
.replaceAll( '${' + keystarter + '_property_type_image_9}',  this.property_type_image_9 )
.replaceAll( '${' + keystarter + '_property_type_image_10}',  this.property_type_image_10 )
.replaceAll( '${' + keystarter + '_property_type_image_11}',  this.property_type_image_11 )
.replaceAll( '${' + keystarter + '_property_type_image_12}',  this.property_type_image_12 )
.replaceAll( '${' + keystarter + '_property_type_image_13}',  this.property_type_image_13 )
.replaceAll( '${' + keystarter + '_property_type_image_14}',  this.property_type_image_14 )
.replaceAll( '${' + keystarter + '_property_type_image_15}',  this.property_type_image_15 )
.replaceAll( '${' + keystarter + '_property_type_image_16}',  this.property_type_image_16 )
.replaceAll( '${' + keystarter + '_property_type_image_17}',  this.property_type_image_17 )
.replaceAll( '${' + keystarter + '_property_type_image_18}',  this.property_type_image_18 )
.replaceAll( '${' + keystarter + '_property_type_image_19}',  this.property_type_image_19 )
.replaceAll( '${' + keystarter + '_property_type_image_20}',  this.property_type_image_20 )
.replaceAll( '${' + keystarter + '_property_type_image_21}',  this.property_type_image_21 )
.replaceAll( '${' + keystarter + '_property_type_image_22}',  this.property_type_image_22 )
.replaceAll( '${' + keystarter + '_property_type_image_23}',  this.property_type_image_23 )
.replaceAll( '${' + keystarter + '_property_type_image_24}',  this.property_type_image_24 )
.replaceAll( '${' + keystarter + '_property_type_image_25}',  this.property_type_image_25 )

.replaceAll( '${' + keystarter + '_service_file_array_image_0}',  this.service_file_array_image_0 )
.replaceAll( '${' + keystarter + '_service_file_array_image_1}',  this.service_file_array_image_1 )
.replaceAll( '${' + keystarter + '_service_file_array_image_2}',  this.service_file_array_image_2 )
.replaceAll( '${' + keystarter + '_service_file_array_image_3}',  this.service_file_array_image_3 )
.replaceAll( '${' + keystarter + '_service_file_array_image_4}',  this.service_file_array_image_4 )
.replaceAll( '${' + keystarter + '_service_file_array_image_5}',  this.service_file_array_image_5 )
.replaceAll( '${' + keystarter + '_service_file_array_image_6}',  this.service_file_array_image_6 )
.replaceAll( '${' + keystarter + '_service_file_array_image_7}',  this.service_file_array_image_7 )
.replaceAll( '${' + keystarter + '_service_file_array_image_8}',  this.service_file_array_image_8 )
.replaceAll( '${' + keystarter + '_service_file_array_image_9}',  this.service_file_array_image_9 )
.replaceAll( '${' + keystarter + '_service_file_array_image_10}',  this.service_file_array_image_10 )
.replaceAll( '${' + keystarter + '_service_file_array_image_11}',  this.service_file_array_image_11 )
.replaceAll( '${' + keystarter + '_service_file_array_image_12}',  this.service_file_array_image_12 )
.replaceAll( '${' + keystarter + '_service_file_array_image_13}',  this.service_file_array_image_13 )
.replaceAll( '${' + keystarter + '_service_file_array_image_14}',  this.service_file_array_image_14 )
.replaceAll( '${' + keystarter + '_service_file_array_image_15}',  this.service_file_array_image_15 )
.replaceAll( '${' + keystarter + '_service_file_array_image_16}',  this.service_file_array_image_16 )
.replaceAll( '${' + keystarter + '_service_file_array_image_17}',  this.service_file_array_image_17 )
.replaceAll( '${' + keystarter + '_service_file_array_image_18}',  this.service_file_array_image_18 )
.replaceAll( '${' + keystarter + '_service_file_array_image_19}',  this.service_file_array_image_19 )
.replaceAll( '${' + keystarter + '_service_file_array_image_20}',  this.service_file_array_image_20 )
.replaceAll( '${' + keystarter + '_service_file_array_image_21}',  this.service_file_array_image_21 )
.replaceAll( '${' + keystarter + '_service_file_array_image_22}',  this.service_file_array_image_22 )
.replaceAll( '${' + keystarter + '_service_file_array_image_23}',  this.service_file_array_image_23 )
.replaceAll( '${' + keystarter + '_service_file_array_image_24}',  this.service_file_array_image_24 )
.replaceAll( '${' + keystarter + '_service_file_array_image_25}',  this.service_file_array_image_25 )



// hide anything null or undefined.
.replaceAll('${undefined}', '')
.replaceAll('${null}', '')
.replaceAll('undefined', '') // makes all undefined print empty
.replaceAll('null', '') // makes all undefined print empty
.replaceAll('Invalid date', '') // makes all undefined print empty


// model.email_template_primary_HTML_rendered
// email_subject_primary_rendered


// Convert the results to a form field value.
// model.email_template_primary_HTML_rendered = rendered_result;
return rendered_result;

}


  private getBrand(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        this.brand_data = data;
      //  this.job_data_paragraphs = data; // set here for the variables/paragraphs ?? uncommented jan 11 why is this setting the job_data_paragraphs... -- 
      // Solution I had this not loading the job variables, now loading job variables with a seperated function -- to load the job_data_paragraphs

        this.allClientEmailRecipients = data;

        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.name + ' - Client Report',
        //     recipient_email_address: res.email,
        //     recipient_brand_id: res.brand_id,
        //     recipient_brand_type_id: res.brand_type_id,
        //     recipient_user_id: null,
        //     recipient_user_level_id: null,
        //     recipient_type_name: 'Client Report',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.

      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }

  private getBrandAccount(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        this.brand_account_data = data;

        this.allClientInvoiceEmailRecipients = data;


        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.name + ' - Client Accounts',
        //     recipient_email_address: res.email,
        //     recipient_brand_id: res.brand_id,
        //     recipient_brand_type_id: res.brand_type_id,
        //     recipient_user_id: null,
        //     recipient_user_level_id: null,
        //     recipient_type_name: 'Client Accounts',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.


      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }

  getBrandUsers(brand_id) {
    this._demoService.getBrandUsers(brand_id).subscribe(
      (data) => {
        this.brand_user_data = data;

        this.allLoginEmailRecipients = data;

        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.first_name +  ' ' + res.surname + ' - Client User',
        //     recipient_email_address: res.email_address,
        //     recipient_brand_id: null,
        //     recipient_brand_type_id: null,
        //     recipient_user_id: res.user_id,
        //     recipient_user_level_id: res.access_level,
        //     recipient_type_name: 'Client User',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.

      },
      (err) => console.error(err),
      () => console.log('Candidates Loaded.')
    );
  }

  // get job
  getJob(job_id) {
    this._demoService.getJobID(job_id).subscribe(
      (data) => {
        this.job_data = data;
        let res = data[0];
        // lookup the brand to get the contact details to send to
        this.recipient_brand_id = res.brand_report_id;
        this.recipient_report_id = res.brand_report_id;
        this.accounts_brand_id = res.brand_invoice_id;
        this.getBrand(res.brand_report_id);
        this.getBrandAccount(res.brand_invoice_id);
        this.getBrandUsers(res.brand_report_id);
        this.getBrandPrimaryContact(this.recipient_report_id);
        this.getJobReportUserContact(res.brand_report_user_id);

        this.brand_report_id = res.brand_report_id;
        this.brand_invoice_id = res.brand_invoice_id;
        this.brand_report_user_id = res.brand_report_user_id;

        this.client_reference = res.owner_trace_code;

        // this.next_date = res.next_date;
        // this.final_date = res.final_date;
        // this.job_stati

        // Base veriables and paragraphs - for new email paragraph renders
                  this.getBrand_invoice_Q(res.brand_invoice_id) 
          this.getBrand_owner_Q('94'); // sharmans id in the database as the app owner SO.
          this.getJobReportUserContact_Q(res.brand_report_user_id)
           this.getCurrentUser_Q(this.gfunc.sessionUserId);


        this.getJobType_Q(res.job_type_id) // was missing may 24

        //this.model.brand_id = this.recipient_brand_id;
        ///console.log('check brand' + this.recipient_brand_id);
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  getSubjectAgentBrandsAssigned(subject_id) {
    this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
      (data) => {
        this.assignedBrandList = data;

        this.allEmailRecipients = data;

        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.name + ' - Agent',
        //     recipient_email_address: res.email,
        //     recipient_brand_id: res.brand_id,
        //     recipient_brand_type_id: res.brand_type_id,
        //     recipient_user_id: null,
        //     recipient_user_level_id: null,
        //     recipient_type_name: 'Agent',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.


      },
      (err) => console.error(err),
      // () => console.log('Loaded Assigned Agents Loaded.')
    );
  }

  getUrl(post, email_template) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://' + post + '/' + email_template
    );
  }


  // need to get user details
  getBrandPrimaryContact(brand_id) {
  this._demoService.getBrandPrimaryContact(brand_id).subscribe(
     data => { this.primary_contacts = data;

      // let newArr = data
      // let  count_of_items = Object.keys(newArr).length;
      //   // need to do a loop of subject_billing items (.length)
      //   for (let i = 0; i < count_of_items; i++) {
      //   let res = newArr[i];
      //   this.allRecipients.push({
      //     recipient_name: res.first_name +  ' ' + res.surname + ' - Primary Contact',
      //     recipient_email_address: res.email_address,
      //     recipient_brand_id: null,
      //     recipient_brand_type_id: null,
      //     recipient_user_id: res.user_id,
      //     recipient_user_level_id: res.access_level,
      //     recipient_type_name: 'Primary Contact',
      //   });
      //   } // end for loop
      // this.allRecipients = this.allRecipients; // ?? this may be causing errors.


    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


  // need to get user details
  getJobReportUserContact(brand_report_user_id) {
    this._demoService.getUsersById(brand_report_user_id).subscribe(
       data => { this.report_user_contacts = data;
        //  let res = data[0];
  // Run the job data queries.
        // :: Impliments automatic recipients based on chosen com template options (Moved and recoded into a seeperate function)
        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.first_name +  ' ' + res.surname + ' - Client Report User',
        //     recipient_email_address: res.email_address,
        //     recipient_brand_id: null,
        //     recipient_brand_type_id: null,
        //     recipient_user_id: res.user_id,
        //     recipient_user_level_id: res.access_level,
        //     recipient_type_name: 'Client Report User',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.


      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


  // Removes Email From Main List. (by ID's)

  RemoveElementFromAllEmailRecipients(key: number) {
    // removes agents
    this.allEmailRecipients.forEach((value, index) => {
      if (value.brand_id === key) {
        this.allEmailRecipients.splice(index, 1);
      }
    });
    // removes clients Report
    this.allClientEmailRecipients.forEach((value, index) => {
      if (value.brand_id === key) {
        this.allClientEmailRecipients.splice(index, 1);
      }
    });
    // removes clients Invoice
    this.allClientInvoiceEmailRecipients.forEach((value, index) => {
      if (value.brand_id === key) {
        this.allClientInvoiceEmailRecipients.splice(index, 1);
      }
    });
    // removes Login Users
    this.allLoginEmailRecipients.forEach((value, index) => {
      if (value.user_id === key) {
        this.allLoginEmailRecipients.splice(index, 1);
      }
    });

    // removes all attachments
    this.allAttachments.forEach((value, index) => {
      if (value.file_name === key) {
        this.allAttachments.splice(index, 1);
      }
    });
  }

  RemoveElementFromAllRecipients(key: number) {
    // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
    this.allRecipients.forEach((value, index) => {
      if (value.recipient_name === key) {
        this.allRecipients.splice(index, 1);
      }
    });

      // :: Specifcally removes the array item without there being
      // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

    if (this.allRecipients.length <= 0) {
      this.selected_tab = undefined;
      return;
    }

    if (this.selected_tab == null || this.selected_tab >= this.allRecipients.length) {
      this.selected_tab = 0;
    }

  };


  // MODAL
  // start of modal windows service as a template
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}



  createFile(model){
    this._demoService.createFile(model).subscribe(
      data => { this.file_created_response = data;
      // need to get the returned ID to send to log create action

      this.returned_created_file_id = this.file_created_response.last_insert_id;
      console.log(this.returned_created_file_id);


        /// moved here from createDocument_2023_Paragraphs()
      // this.allAttachments.push({
      //   file_name: this.created_file_name,
      //   job_file: 0,
      //   subject_file: 1,
      //   file_id: this.returned_created_file_id
      // });

            this.allAttachments.push({
              file_name: this.created_file_name,
              job_file: 0,
              subject_file: 1,
              subject_number: model.subject_number,
              job_id: model.job_id,
              file_server_location: model.file_server_location,
              file_id: this.returned_created_file_id,
      });
      

      
      model.allAttachments = this.allAttachments; // ?? this may be causing errors.




      const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
      console.log('Communication Type Task: ' +  subject_com_type_name);
          //  const subject_com_type_name = document.getElementById('subject_com_type_name').innerText;
           //  console.log('Communication Type Task: ' +  subject_com_type_name);
     const doc_name = document.getElementById('doc_name').innerText;
     console.log('Document Name: ' +  doc_name);

     const log_action = 'created';
     const log_name = 'Subject Communicaiton Task: ' + subject_com_type_name  + ' - ' + doc_name + '';

             let create_sys_log = {
               log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
               log_action: log_action, // automated / updated / created / uploaded / link_created / sent
               created_by: this.sessionUserId,
               created_date: this.today,
               subject_id: this.subject_id,
               job_id: this.job_id,
               job_reference_number: model.job_reference_number,
               file_number: model.file_number,
               reference_number: model.job_reference_number,
               subject_number: model.subject_number,
               log_type_id: 1, // see datatable system_log_types
               created_level: this.sessionUserLevel,
               brand_type_id: model.brand_type_id,
               subject_com_type_id: model.subject_com_type_id,
               subject_template_doc_id: model.doc_id,
               log_name: log_name + ' - ' + this.returned_created_file_id,
               file_id: this.returned_created_file_id,
               invoice_id: model.invoice_id,
             };


             // We need to brea this up into the commnuication types and ceate sepearte logs for each of these
            //  this.createSystemLog(create_sys_log); // retired to sepeate functions....

            //  Client Report Communication
             if(model.subject_com_type_id == 3 ){
              let _log_type_id = 67
               create_sys_log = {
                log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                log_action: log_action, // automated / updated / created / uploaded / link_created / sent
                created_by: this.sessionUserId,
                created_date: this.today,
                subject_id: this.subject_id,
                job_id: this.job_id,
                job_reference_number: model.job_reference_number,
                file_number: model.file_number,
                reference_number: model.job_reference_number,
                subject_number: model.subject_number,
                log_type_id: _log_type_id, // see datatable system_log_types
                created_level: this.sessionUserLevel,
                brand_type_id: model.brand_type_id,
                subject_com_type_id: model.subject_com_type_id,
                subject_template_doc_id: model.doc_id,
                log_name: log_name + ' - ' + this.returned_created_file_id,
                file_id: this.returned_created_file_id,
                invoice_id: model.invoice_id,
              };
              this.createSystemLog(create_sys_log);
             }

            //  Affidavit Creation - Communications
            if(model.subject_com_type_id == 4 ){
            let _log_type_id = 68
              create_sys_log = {
              log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
              log_action: log_action, // automated / updated / created / uploaded / link_created / sent
              created_by: this.sessionUserId,
              created_date: this.today,
              subject_id: this.subject_id,
              job_id: this.job_id,
              job_reference_number: model.job_reference_number,
              file_number: model.file_number,
              reference_number: model.job_reference_number,
              subject_number: model.subject_number,
              log_type_id: _log_type_id, // see datatable system_log_types
              created_level: this.sessionUserLevel,
              brand_type_id: model.brand_type_id,
              subject_com_type_id: model.subject_com_type_id,
              subject_template_doc_id: model.doc_id,
              log_name: log_name + ' - ' + this.returned_created_file_id,
              file_id: this.returned_created_file_id,
              invoice_id: model.invoice_id,
            };
            this.createSystemLog(create_sys_log);
            }

                  //  Agent Creation - Communications
                    if(model.subject_com_type_id == 2 ){
                      let _log_type_id = 69
                        create_sys_log = {
                        log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                        log_action: log_action, // automated / updated / created / uploaded / link_created / sent
                        created_by: this.sessionUserId,
                        created_date: this.today,
                        subject_id: this.subject_id,
                        job_id: this.job_id,
                        job_reference_number: model.job_reference_number,
                        file_number: model.file_number,
                        reference_number: model.job_reference_number,
                        subject_number: model.subject_number,
                        log_type_id: _log_type_id, // see datatable system_log_types
                        created_level: this.sessionUserLevel,
                        brand_type_id: model.brand_type_id,
                        subject_com_type_id: model.subject_com_type_id,
                        subject_template_doc_id: model.doc_id,
                        log_name: log_name + ' - ' + this.returned_created_file_id,
                        file_id: this.returned_created_file_id,
                        invoice_id: model.invoice_id,
                      };
                      this.createSystemLog(create_sys_log);
                      }    

                  //  Agent Instruct Creation - Communications
                  if(model.subject_com_type_id == 1 ){
                    let _log_type_id = 70
                      create_sys_log = {
                      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                      log_action: log_action, // automated / updated / created / uploaded / link_created / sent
                      created_by: this.sessionUserId,
                      created_date: this.today,
                      subject_id: this.subject_id,
                      job_id: this.job_id,
                      job_reference_number: model.job_reference_number,
                      file_number: model.file_number,
                      reference_number: model.job_reference_number,
                      subject_number: model.subject_number,
                      log_type_id: _log_type_id, // see datatable system_log_types
                      created_level: this.sessionUserLevel,
                      brand_type_id: model.brand_type_id,
                      subject_com_type_id: model.subject_com_type_id,
                      subject_template_doc_id: model.doc_id,
                      log_name: log_name + ' - ' + this.returned_created_file_id,
                      file_id: this.returned_created_file_id,
                      invoice_id: model.invoice_id,
                    };
                    this.createSystemLog(create_sys_log);
                    } 


                //  Agent Instruct Creation - Communications
                  if(model.subject_com_type_id == 5 ){
                    let _log_type_id = 71
                      create_sys_log = {
                      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                      log_action: log_action, // automated / updated / created / uploaded / link_created / sent
                      created_by: this.sessionUserId,
                      created_date: this.today,
                      subject_id: this.subject_id,
                      job_id: this.job_id,
                      job_reference_number: model.job_reference_number,
                      file_number: model.file_number,
                      reference_number: model.job_reference_number,
                      subject_number: model.subject_number,
                      log_type_id: _log_type_id, // see datatable system_log_types
                      created_level: this.sessionUserLevel,
                      brand_type_id: model.brand_type_id,
                      subject_com_type_id: model.subject_com_type_id,
                      subject_template_doc_id: model.doc_id,
                      log_name: log_name + ' - ' + this.returned_created_file_id,
                      file_id: this.returned_created_file_id,
                      invoice_id: model.invoice_id,
                    };
                    this.createSystemLog(create_sys_log);
                    } 

      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  createSystemLog(model){
    this._demoService.createSystemLog(model).subscribe(
      data => { this.system_log_created_response = data;
      // this.toastr.success('System Log Inserted')

      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  getSubjectInvoices(subject_id){
    this._demoService.getSubjectInvoices(subject_id).subscribe(
      data => {
        this.subject_invoices = data;
    let res = data[0];
    this.current_invoice_id = res.invoice_id;
       },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



// :: Invoice Upgrades ( Create Invoice From List.)

createDocument_Invoice(model, mergeJobData, invoice_id) {
  // generate more data first
  this._mysqlService.createDocument_Invoice(model, invoice_id).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      this.toastr.success('Creating Invoice.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string
      // this.created_file_name = res[0].text();
      this.created_file_name = res[0] as string;
      model.attached_file_name = this.created_file_name;
      this.refreshList(); // loads the file list (diretory)
      this.displaySubjectDocuments(this.subject_id, this.subject_number);


      this.set_document_password = res[1] as string;
      console.log('set_document_password: ' + this.set_document_password);

      if(model.encrypt_file == true){
        this.is_encrypted = 1; //  encrypted
      }else{
        this.is_encrypted = 0; // no encrypted
      }

    // set the invoice from the list of invoices (first record)
    if (invoice_id == null){
      invoice_id = this.current_invoice_id;
    }


      // push to global array -- no longer used // stops double ups
      // this.allAttachedFiles.push(this.created_file_name);

      // Start the new array of file
      // this.allAttachments.push(this.created_file_name);

      const pushed_file = {
        file_name: this.created_file_name,
        subject_file: 1,
        job_file: 0,
      }; // multidimentional array push
      // this.allAttachments.push(pushed_file); // old way only works for an array.

      // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      // this.allAttachments.push({
      //   file_name: this.created_file_name,
      //   job_file: 0,
      //   subject_file: 1,
      // });




      
      const file_server_location = this.gfunc.fileFolderDocs + model.subject_number;
      const file_url = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
      const file_folder = this.gfunc.fileFolderDocs + model.subject_number;
      const file_name = this.created_file_name.slice(0, -5); // removes the extension
      const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string


      // May need to move this to after the file is created....?
      // addition to add newly created PDF document.
                //       this.allAttachments.push({
                //         file_name: this.created_file_name,
                //         job_file: 0,
                //         subject_file: 1,
                //         subject_number: model.subject_number,
                //         job_id: model.job_id,
                //         file_server_location: file_server_location,
                //         file_id: this.returned_created_file_id,
                // });


      model.allAttachments = this.allAttachments; // ?? this may be causing errors.

      // [{name: currencyName, amount: this.ticker[currencyName].last} ]

      // Set the file locations
      //agent

      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      }
      //client
      if (model.brand_type_id === '2') {
        this.file_edit_level = '3'; // client cannot edit  (staff member can)
      }

      // UPGRADE Document Model (Insert the File into the database)
      // File Json
      const create_file = {
        file_name: file_name,
        file_display_name: file_name,
        file_ext: 'pdf',
        file_server_location: file_server_location,
        file_url: file_url,
        file_folder: file_folder,
        file_make: 'created', // automated / updated / created / uploaded / link_created
        file_notes: 'File created via subject communcation UI',
        file_job_id: this.job_id,
        file_subject_id: this.subject_id,
        file_subject_number: this.subject_number,
        created_by: this.gfunc.sessionUserId,
        created_date: this.gfunc.today,
        created_level: this.gfunc.sessionUserLevel,
        file_brand_id: model.brand_report_id,
        file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
        is_active: '1',
        file_password: this.set_document_password,
        file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
        updated_by: this.gfunc.sessionUserId,
        updated_date: this.gfunc.today,
        prev_file_id: '0',    // if updating
        brand_type_id: model.brand_type_id,  // if an agent or a client file
        subject_template_doc_id: model.doc_id,
        subject_com_type_id: model.subject_com_type_id,
        random_file_name: random_file_name,
        full_file_name: this.created_file_name,
        job_id: this.job_id,
        file_number: model.file_number,
        file_reference_number: model.file_reference_number,
        // arrays of sending to - based on subject_template_doc - setup
        agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
        report_access_array: JSON.stringify(this.brand_data), // collect client
        invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
        user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
        invoice_id: invoice_id,
        is_encrypted: this.is_encrypted
      };
     // console.log( (JSON.stringify(this.assignedBrandList)) );
      this.createFile(create_file);

        // :: @ Update the Invoice Status to Approved+PDF (4)
  let invoice_model = {
    invoice_id: invoice_id,
    invoice_status_id: 4,
      };
    this.updateInvoiceStatus(invoice_model);

      // const log_content
      // const log_action
      // Access DOM and get values from HTML template to send to logs
     // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
    // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value;
    // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
    // get the drop down value of text not id.



    },
    (error) => {
      this.toastr.error('Error Creating Document, (if encyption checked) please Check if there must be a Global Company Key set in file recipeint company profile');
     return console.log(error);
    }
  );
}


updateInvoiceStatus(invoice_model){
  this._demoService.updateInvoiceStatus(invoice_model).subscribe(
    data => { // this.trace_candidate_update = data;
      // refresh the invoice:

    },
    error => {
     // console.error('Error saving Event!');
    //  this.toastr.error('Error Changing Status of Subject');
      return console.error(error);
    }
   // err => console.error(err),
   //
  )};



  updateInvoiceCommunicationStatus(invoice_model){
    this._demoService.updateInvoiceCommunicationStatus(invoice_model).subscribe(
      data => { // this.trace_candidate_update = data;
        // refresh the invoice:
      },
      error => {
       // console.error('Error saving Event!');
      //  this.toastr.error('Error Changing Status of Subject');
        // return console.error(error);
      }
     // err => console.error(err),
     //
    )};

pushInvoiceFileToSend(file_name){
  // push to global array
  
  // this.allAttachedFiles.push(file_name);

  // Start the new array of file
  // this.allAttachments.push(this.created_file_name);

  const pushed_file = {
    file_name: file_name,
    subject_file: 1,
    job_file: 0,
  }; // multidimentional array push
  // this.allAttachments.push(pushed_file); // old way only works for an array.

  // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
  // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
 
 
  // this.allAttachments.push({
  //   file_name: file_name,
  //   job_file: 0,
  //   subject_file: 1,
  // });


  /// new
  const file_server_location = this.gfunc.fileFolderDocs + this.subject_number;
  this.allAttachments.push({
    file_name: file_name,
    job_file: 0,
    subject_file: 1,
    subject_number: this.subject_number,
    job_id: this.job_id,
    file_server_location: file_server_location,
    file_id: this.returned_created_file_id,
});


 // this.model.allAttachments = this.allAttachments; // ?? this may be causing errors.

 console.log('File_name: ' + file_name);
}



setFileID(file_id){
this.returned_created_file_id = file_id;
console.log('file_id updated: ' + file_id)
};




// syncfusion dialog simple sample
public onOpenDialog2 = function(event: any): void {
  this.DialogObj = DialogUtility.confirm({
    title: 'Communication Processed',
    content: 'Successfully Sent Your Communications.',
    okButton: {  text: 'Ok', click: this.okClick2.bind(this) },
  // cancelButton: {  text: '.', click: this.cancelClick.bind(this) },
  cancelButton: {  text: '.', click: this.okClick2.bind(this) },
  showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}
public okClick2(): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 // this.createJobSubjectsMultiple(this.JSON_job);
// this.createJobSubjectsMultiple(this.newSubject);
 this.DialogObj.hide();
 this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

}; // end functiiom

private cancelClick2(): void {
   // alert('you clicked Cancel button');
   this.DialogObj.hide();
   this.modalRef.hide(); // hide the modal?
   this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
}




subjectChangeDates(model, subject_id) {
  // model.subject_id = this.subject_id; // seemed to be undefined in model?
  if (model.change_dates == 1) {
  this._demoService.updateJobSubjectDates(model, subject_id).subscribe(
    (data) => {
      this.subject_notes = data;
      // console.log("Done loadng USER");
      // console.log(this.users);
      this.toastr.success('Subject Status and Dates Updated');
    },
    (error) => {
      //  console.error('Error Loading User!');
      this.toastr.error('Dates and Status updates failed.');
      return console.error(error);
    }
  );
   } // end if change_dates
}

// :: Parent / Child modal test
closeParentModelDefault(model) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
};


// :: Parent / Child modal test
// addRecipientFromModal(model) {
//   // alert('parent component function.');
//  // this.modalService.hide(1); - removed the scroll bard do not use!!!
//   // this.modalRef.hide();
//  // this.getJobPlaintiffs(this.job_id);
//  // this.refreshGrid(); // resets the grid if updated and closed.
// //  this.updateTypeClick = false; // closes the div
// // :: reset the entire page.
// // this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

// this.allRecipients.push({
//   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
//   recipient_email_address: model.recipient_email_address,
//   recipient_brand_id: null,
//   recipient_brand_type_id: null,
//   recipient_user_id: null,
//   recipient_user_level_id: null,
//   recipient_type_name: model.recipient_type_name,
// });
// this.modalRef.hide();
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
// };



// Upgraded fo new system.
addRecipientFromModal(model) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  // this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

this.prepareTemplateRenderLookups(model);

let email_template_primary_HTML = model.email_template_primary_HTML;
let email_subject_primary = model.email_subject_primary;
let note_template_HTML = model.note_template_HTML;
      // set the recipent variables in the model first so I have them
// model.recipient_name = model.recipient_name + ' - ' + model.recipient_type_name,
model.recipient_name = model.recipient_name,
model.recipient_email_address = model.recipient_email_address,
model.recipient_brand_id = null
model.recipient_brand_type_id = null
model.recipient_user_id  = null
model.recipient_user_level_id = null
model.recipient_type_name = model.recipient_type_name






let rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
let rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
let rendered_note = this.runReplaceAllVariables(note_template_HTML, model)


this.allRecipients.push({
  recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
  recipient_email_address: model.recipient_email_address,
  recipient_brand_id: null,
  recipient_brand_type_id: null,
  recipient_user_id: null,
  recipient_user_level_id: null,
  recipient_type_name: model.recipient_type_name,
  ...model,
  email_subject_primary_rendered: rendered_subject,
  email_template_primary_HTML_rendered: rendered_email,
  note_template_HTML_rendered: rendered_note
});

this.allRecipients = this.allRecipients;
this.model.allRecipients = this.allRecipients;
model.allRecipients = this.allRecipients;

this.modalRef.hide();
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};





// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned_comms(subject_id) {
  this.allAgentRecipients = [];
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { 
       this.assignedAgentsList2 = data;

       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
         // need to do a loop of subject_billing items (.length)
         for(let i=0;i < count_of_items; i++) {
         let res = newArr[i];
         this.allAgentRecipients.push({
           recipient_name: res.name + '',
           recipient_email_address: res.email,
           recipient_brand_id: res.brand_id,
           recipient_subject_id: res.subject_id,
           recipient_brand_type_id: res.brand_type_id,
           recipient_user_id: null,
           recipient_user_level_id: null,
           recipient_type_name: 'Agent',
         });
         } // end for loop
       this.allAgentRecipients = this.allAgentRecipients; // ?? this may be causing errors.
       // set records to send to subject_notes data table
       this.model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }



 RemoveElementFromAllRecipients_comms(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allAgentRecipients.forEach((value, index) => {
    if (value.recipient_name === key) {
      this.allAgentRecipients.splice(index, 1);
    }
  });
    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};



onChangeLoadAttachments(model){
  this.allAttachments = []; // now sets the varibales needed to send the email files attached.
  // this.allAttachments.push({
  //   file_name: 0,
  //   job_file: 0,
  //   subject_file: 0,
  // });
  model.allAttachments = this.allAttachments; // ?? this may be causing errors.
 // this.toastr.info("we just detected a change!");
}





// Display a modal window informing that there are no attachments on send.

onOpenDialogSendComms = function(event: any, model): void {

  if(this.allAttachments.length <= 0 && this.cancel_clicked != 1){ }// end if.

  this.DialogObj = DialogUtility.confirm({
    title: '<i class="fa fa-paperclip fa-2x text-warning font-bold pull-left"></i> Did you mean to attach or upload a file? ',
    // tslint:disable-next-line:max-line-length
    content: '<i class="fa fa-warning fa-2x text-warning font-bold pull-left"></i> <b> You have not added any files or attachments to this email, are you sure you wish to continue without any files attached?. Close this window to attach files.</p> ',
    okButton: {  text: '<i class="fa fa-check text-success font-bold pull-left"></i> Continue, and send.', click: this.okClickSaveSubject.bind(this, model) },
    cancelButton: {  text: '<i class="fa fa-times text-danger font-bold pull-left"></i> Cancel and Attach Files', click: this.cancelClickSaveSubject.bind(this, model) },
    showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});

 
}

public okClickSaveSubject(model): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 // this.createJobSubjectsMultiple(this.newSubject);
// this.clientJobSubmission(this.job_id);
this.cancel_clicked = 0;
this.click_continue = 1;

// missing checker to run the approriate function
// WAS MISSING BUILD 31 onwards
if(model.subject_com_type_id == 1){
  this.sendAgentInstructEmail(model);
}
if(model.subject_com_type_id == 2){
  this.sendAgentCommunicationEmail(model); //
}
if(model.subject_com_type_id == 3){
  this.sendAgentCommunicationEmail(model); //
}
if(model.subject_com_type_id == 4){
  this.sendAffidavitCommunicationEmail(model);
}
if(model.subject_com_type_id == 5){
  this.sendAgentCommunicationEmail(model); //
}



  // }else{
// this.sendAgentCommunicationEmail(model);
// }

this.DialogObj.hide();
}

public cancelClickSaveSubject(model): void {
   // alert('you clicked Cancel button');
   this.cancel_clicked = 1;
   this.click_continue = 0;
   this.DialogObj.hide();
}









// QuickVariable Functions
  

  
     
getSubjectServiceType_Q(subject_service_type_id) {
  this._demoService.getSubjectServiceType(subject_service_type_id).subscribe(
     data => { 
      // this.subject_service_type = data;
      let res = data[0]
      this.subject_service_type = DataUtil.parse.parseJson(res);
   


      
      // return res.subject_service_type_name
      // if ( subject_service_type_id <= 0 ){
      //   this.selected_subject_service_type_description = 'Please Set to default Individual Above';
      //   this.selected_subject_service_type_description = '';
      //   this.selected_subject_service_type_instructions = '';
      //   this.selected_subject_service_type_staff_instructions = '';

      // } else{
      // this.selected_subject_service_type_description = res.subject_service_type_description;
      // this.selected_subject_service_type_instructions = res.subject_service_type_instructions;
      // this.selected_subject_service_type_staff_instructions = res.subject_service_type_staff_instructions;
      // }

      // // initiate the change of service rule if different or select from drop down.
      // if (subject_service_type_id > 1) {
      // this.setJobServiceRule(res.job_service_rule_id_change_to);
      // this.getJobServiceRule(res.job_service_rule_id_change_to); // sets the descruption information on change.
      // }

    },
     err => console.log(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getJobServiceRule_Q(job_service_rule_id) {
  this._demoService.getJobServiceRule(job_service_rule_id).subscribe(
     data => { this.job_service_rule_paragraphs = data; 
      let res = data[0];
      if (job_service_rule_id <= 0 ){
        this.selected_job_service_rule_description = 'Not Applicable';
      };
      if (job_service_rule_id >= 1 ){
      this.selected_job_service_rule_description = res.job_service_rule_description;
      }
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getSubjectServiceOutcome_Q(subject_service_outcome_id) {
  this._demoService.getSubjectServiceOutcome(subject_service_outcome_id).subscribe(
    data => { 
      // this.subjectAttemptType = data;
    let res = data[0]
    this.subjectServiceOutcome = DataUtil.parse.parseJson(res);
    },
    err => console.error(err),
  );
  }

  
 getSubjectLocationStatus_Q(subject_location_status_id) {
  this._demoService.getSubjectLocationStatus(subject_location_status_id).subscribe(
    data => { 
      // this.subjectAttemptType = data;
    let res = data[0]
    this.subjectLocationStatus = DataUtil.parse.parseJson(res);
    },
    err => console.error(err),
  );
  }


  getSubjectLocationStatusFound_Q(subject_location_status_found_id) {
    this._demoService.getSubjectLocationStatusFound(subject_location_status_found_id).subscribe(
      data => { 
        // this.subjectAttemptType = data;
      let res = data[0]
      this.subjectLocationStatusFound = DataUtil.parse.parseJson(res);
      },
      err => console.error(err),
    );
    }


  getSubjectExactServiceMethod_Q(exact_service_method_id) {
    this._demoService.getExactServiceMethod(exact_service_method_id).subscribe(
      data => { 
        // this.subjectAttemptType = data;
      let res = data[0]
      this.subjectExactServiceMethod = DataUtil.parse.parseJson(res);
      },
      err => console.error(err),
    );
    }
  



 getSubjectAttemptType_Q(subject_service_type_id) {
  this._demoService.getSubjectAttemptType(subject_service_type_id).subscribe(
    data => { 
      // this.subjectAttemptType = data;
    let res = data[0]
    this.subject_attempt_type = DataUtil.parse.parseJson(res);
    },
    err => console.error(err),
  );
  }

  getSubjectRelationship_Q(subject_relationship_id) {
    this._demoService.getSubjectRelationship(subject_relationship_id).subscribe(
      data => { 
        let res = data[0]
        this.serviceFellowRelationship = data;
        this.subject_service_fellow_relationship = DataUtil.parse.parseJson(res);
      },
      err => console.error(err),
    );
    }


    // Look up Subject Service Agent
 getBrand_Q(brand_id) {
      this._demoService.getBrandById(brand_id).subscribe(
        (data) => {
          // this.brand_data = data;
  
          let res = data[0];
          // this.subject_service_agent = DataUtil.parse.parseJson(res);
          this.subject_service_agent = data[0];
          // this.allClientEmailRecipients = data;
  
this.toastr.success('Subject Service Agent Details Q')

          // let newArr = data
          // let  count_of_items = Object.keys(newArr).length;
          //   // need to do a loop of subject_billing items (.length)
          //   for (let i = 0; i < count_of_items; i++) {
          //   let res = newArr[i];
          //   this.allRecipients.push({
          //     recipient_name: res.name + ' - Client Report',
          //     recipient_email_address: res.email,
          //     recipient_brand_id: res.brand_id,
          //     recipient_brand_type_id: res.brand_type_id,
          //     recipient_user_id: null,
          //     recipient_user_level_id: null,
          //     recipient_type_name: 'Client Report',
          //   });
          //   } // end for loop
          // this.allRecipients = this.allRecipients; // ?? this may be causing errors.
  
        },
        (err) => console.error(err),
        () => console.log('Brand Loaded.')
      );
    }

    getBrand_report_Q(brand_id) {
      this._demoService.getBrandById(brand_id).subscribe(
        (data) => {
          // this.brand_data = data;
  
          let res = data[0];
          this.job_report_client = DataUtil.parse.parseJson(data);
          // this.allClientEmailRecipients = data;
  
          // let newArr = data
          // let  count_of_items = Object.keys(newArr).length;
          //   // need to do a loop of subject_billing items (.length)
          //   for (let i = 0; i < count_of_items; i++) {
          //   let res = newArr[i];
          //   this.allRecipients.push({
          //     recipient_name: res.name + ' - Client Report',
          //     recipient_email_address: res.email,
          //     recipient_brand_id: res.brand_id,
          //     recipient_brand_type_id: res.brand_type_id,
          //     recipient_user_id: null,
          //     recipient_user_level_id: null,
          //     recipient_type_name: 'Client Report',
          //   });
          //   } // end for loop
          // this.allRecipients = this.allRecipients; // ?? this may be causing errors.
  
        },
        (err) => console.error(err),
        () => console.log('Brand report Client Loaded.')
      );
    }




    getBrand_invoice_Q(brand_id) {
      this._demoService.getBrandById(brand_id).subscribe(
        (data) => {
          // this.brand_data = data;
  
          let res = data[0];
          // this.job_invoice_client_paragraphs = DataUtil.parse.parseJson(data);
          this.job_invoice_client_paragraphs = data;
  
        },
        (err) => console.error(err),
        () => console.log('Brand Invoice Loaded.')
      );
    }

    getBrand_owner_Q(brand_id) {
      this._demoService.getBrandById(brand_id).subscribe(
        (data) => {
          // this.brand_data = data;
  
          let res = data[0];
          this.job_owner_client_paragraphs = DataUtil.parse.parseJson(data);
  
        },
        (err) => console.error(err),
        () => console.log('Brand Owner Loaded.')
      );
    }


    getUserBrand_Q(brand_id) {
      this._demoService.getBrandById(brand_id).subscribe(
        (data) => {
          // this.brand_data = data;
  
          let res = data[0];
          this.user_brand_paragraphs = DataUtil.parse.parseJson(data);
  
        },
        (err) => console.error(err),
        () => console.log('Brand Owner Loaded.')
      );
    }

    getServiceMethod_Q(subject_service_method_id) {
      this._demoService.getServiceMethod(subject_service_method_id).subscribe(
        data => { 
          let res = data[0]
          this.serviceMethod = data;
          this.subject_service_method = DataUtil.parse.parseJson(res);
        },
        err => console.error(err),
      );
      }



// Subject Type Name Lookup
getJobSubjectType_Q(job_subject_type_id) {
this._demoService.getJobSubjectType(job_subject_type_id).subscribe(
   data => { 
    let res = data[0]
    this.job_subject_type = data;
    this.subject_job_subject_type = DataUtil.parse.parseJson(res);

  
  },
   err => console.error(err),
   // () => console.log('done loading Trace Types')
 );
}



    //   // get job and brands for paragraph - job Details.
    //   getJob_and_brands_Q(job_id, model) {
    //     this._demoService.getJobID(job_id).subscribe(
    //       (data) => {
    //         // this.job_data = data;
    //         let res = data[0];
    //         this.job_data_paragraphs = DataUtil.parse.parseJson(res);
    //         // this.job_data_paragraphs = data;


    // //
    //   // Need to load the drop downs (only if a process is selected.)

    //                           // this.getJobType_Q(res.job_type_id)

    //                           // this.getJobTypeLocation_Q(res.job_type_location_id); // 
    //                           // this.getJobTypeCourt_Q(res.job_type_court_id);       // 

    //                           // this.getJobTypeDocumentType_Q(res.job_type_document_type_id)
    //                           // this.getJobTypeAffidavitType_Q(res.job_type_affidavit_type_id);
                              
    //                           // this.getBrand_invoice_Q(res.brand_id) 
    //                           // this.getBrand_owner_Q('94'); // sharmans id in the database as the app owner SO.
    //                           // this.getJobReportUserContact_Q(res.brand_report_user_id)

    //                           // this.getCurrentUser_Q(this.gfunc.sessionUserId);
                              
    //                           //   // Get Subject Agent - F_agent
    //                           //   this.getSubjectAgentBrandsAssigned_Q(this.subject_id) // get the first agent ID.????
    //                           //   this.getJobServiceRule_Q(model.job_service_rule_id) //? -- from the send comms model
    //                           //   this.getJobServiceTimeframe_Q(model.job_service_timeframe_id)
    //                           //   this.getSubjectServiceType_model_Q(model.subject_service_type_id);

    //                           //   this.getSubjectContactNumbers_Q(model.subject_id)
    //                           //   this.getSubjectContactEmails_Q(model.subject_id)



    //       // this.getJobTypeDocumentTypes(res.job_type_court_id);
    //       // this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
    //       // // need to load client contact
    //       // this.getClientContactsSharmans_Q(res.client_id);
          
    //       // this.getBrandUsers(res.brand_report_id);


    //         this.toastr.success('Job Data Loaded For Vars')

    //         // lookup the brand to get the contact details to send to
    //             // this.recipient_brand_id = res.brand_report_id;
    //             // this.recipient_report_id = res.brand_report_id;
    //             // this.accounts_brand_id = res.brand_invoice_id;
    //             // this.getBrand(res.brand_report_id);
    //             // this.getBrandAccount(res.brand_invoice_id);
    //             // this.getBrandUsers(res.brand_report_id);
    //             // this.getBrandPrimaryContact(this.recipient_report_id);
    //             // this.getJobReportUserContact(res.brand_report_user_id);

    //             // this.brand_report_id = res.brand_report_id;
    //             // this.brand_invoice_id = res.brand_invoice_id;
    //             // this.brand_report_user_id = res.brand_report_user_id;

    //             // this.client_reference = res.owner_trace_code;

    //         // this.next_date = res.next_date;
    //         // this.final_date = res.final_date;
    //         // this.job_stati

    //         //this.model.brand_id = this.recipient_brand_id;
    //         ///console.log('check brand' + this.recipient_brand_id);
    //       },
    //       (err) => {
    //         this.toastr.error('Job Data NOT Loaded For Vars')
    
    //       }
    //       // () => console.log('done loading Trace Types')
    //     );
    //   }



  getJob_and_brands_Q(job_id, model) {
    this._demoService.getJobID(job_id).subscribe(
      (data) => {
        // this.job_data = data;
        let res = data[0];
        this.job_data_paragraphs = DataUtil.parse.parseJson(data);
        this.toastr.success('Job Data Loaded For Vars')

        // this.job_data_paragraphs = data;
        // if (job_service_timeframe_id <= 0 ){
        //   this.selected_job_service_timeframe_description = 'Not Applicable';
        // };
        // this.selected_job_service_timeframe_description = res.job_service_rule_time_frame_text;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



  getJobServiceTimeframe_Q(job_service_timeframe_id) {
    this._demoService.getJobServiceTimeframe(job_service_timeframe_id).subscribe(
       data => { this.job_service_timeframe_paragraphs = data; 
        let res = data[0];
        // if (job_service_timeframe_id <= 0 ){
        //   this.selected_job_service_timeframe_description = 'Not Applicable';
        // };
        // this.selected_job_service_timeframe_description = res.job_service_rule_time_frame_text;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

  getClientContactsSharmans_Q(client_id) {
    this._demoService.getClientContactsSharmans(client_id).subscribe(
       data => { 
        this.client_contacts = data;
       },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
// Job Variables.
   getJobTypeLocations_Q(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
      (data) => {
        this.job_type_locations_paragraphs = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  getJobTypeLocation_Q(job_type_location_id) {
    this._demoService.getJobTypeLocation(job_type_location_id).subscribe(
      (data) => {
        this.job_type_location_paragraphs = data;
        // this.toastr.success('Locations loaded')
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }


  getJobType_Q(job_type_id) {
    this._demoService.getJobType(job_type_id).subscribe(
      (data) => {
        this.job_type_paragraphs = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  getJobTypeCourts_Q(job_type_location_id) {
    this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
      (data) => {
        this.job_type_courts_paragraphs = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }


  
  getJobTypeCourt_Q(job_type_court_id) {
    this._demoService.getJobTypeCourt(job_type_court_id).subscribe(
      (data) => {
        this.job_type_court_paragraphs = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }



  getJobTypeDocumentType_Q(job_type_document_type_id) {
    this._demoService.getJobTypeDocumentType(job_type_document_type_id).subscribe(
      (data) => {
        this.job_type_document_type_paragraphs = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }




  getJobTypeAffidavitType_Q(job_type_affidavit_type_id) {
    this._demoService
      .getJobTypeAffidavit(job_type_affidavit_type_id)
      .subscribe(
        (data) => {
          this.job_type_affidavit_type_paragraphs = data;
        },
        (err) => console.error(err)
        // () => console.log('done loading Trace Types')
      );
  }


  getJobReportUserContact_Q(brand_report_user_id) {
    this._demoService.getUsersById(brand_report_user_id).subscribe(
       data => { 
            this.job_report_client_user_paragraphs = data;


      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getCurrentUser_Q(user_id) {
    this._demoService.getUsersById(user_id).subscribe(
       data => { 
            this.current_user_paragraphs = data;


      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getSubjectAgentBrandsAssigned_Q(subject_id) {
    this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
      (data) => {
        this.assignedBrandList_paragraphs = data;
// console.log(this.assignedBrandList_paragraphs)

        // this.allEmailRecipients = data;

        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.name + ' - Agent',
        //     recipient_email_address: res.email,
        //     recipient_brand_id: res.brand_id,
        //     recipient_brand_type_id: res.brand_type_id,
        //     recipient_user_id: null,
        //     recipient_user_level_id: null,
        //     recipient_type_name: 'Agent',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.


      },
      (err) => console.error(err),
      // () => console.log('Loaded Assigned Agents Loaded.')
    );
  }



  getSubjectServiceType_model_Q(subject_service_type_id) {
    this._demoService.getSubjectServiceType(subject_service_type_id).subscribe(
       data => { 
        this.subject_service_type_model_paragraphs = data;
        // let res = data[0];
        // if ( subject_service_type_id <= 0 ){
        //   this.selected_subject_service_type_description = 'Please Set to default Individual Above';
        //   this.selected_subject_service_type_description = '';
        //   this.selected_subject_service_type_instructions = '';
        //   this.selected_subject_service_type_staff_instructions = '';
  
        // } 
        // this.selected_subject_service_type_description = res.subject_service_type_description;
        // this.selected_subject_service_type_instructions = res.subject_service_type_instructions;
        // this.selected_subject_service_type_staff_instructions = res.subject_service_type_staff_instructions;
  
        // // initiate the change of service rule if different or select from drop down.
        // if (subject_service_type_id > 1) {
        // this.setJobServiceRule(res.job_service_rule_id_change_to);
        // this.getJobServiceRule(res.job_service_rule_id_change_to); // sets the descruption information on change.
        // }
  
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getSubjectContactNumbers_Q(subject_id) {
    this._demoService.getSubjectContactNumbers(subject_id).subscribe(
       data => { this.subject_contact_numbers_paragraphs = data;
      
        let count_of_items = this.subject_contact_numbers_paragraphs.length
        let c = 0; // count
        this.subject_contact_numbers = '';
        while (c < count_of_items) {
          this.subject_contact_numbers += this.subject_contact_numbers_paragraphs[c].subject_contact_phone_number + ', '
          c++;
        }


      },
       err => console.error(err),
        () => {
          // console.log('done loading SCN');
                      }
          );
   }



   getSubjectContactEmails_Q(subject_id) {
    this._demoService.getSubjectContactEmails(subject_id).subscribe(
       data => { this.subject_contact_emails_paragraphs = data; 
        let count_of_items = this.subject_contact_emails_paragraphs.length
        let c = 0; // count
        this.subject_contact_emails = '';
        while (c < count_of_items) {
          this.subject_contact_emails += this.subject_contact_emails_paragraphs[c].subject_contact_email_address + ', '
          c++;
        }
      
      },
       err => console.error(err),
        () => {
          // console.log('done loading SR');
                      }
          );
   }




// Start of Javascript Ordinaals -- First Second third etc - only goes to 10 so far
// :: @https://stackoverflow.com/questions/15998005/ordinals-in-words-javascript
ordinalInWord( cardinal ) {
  var ordinals = [ 'Zeroth', 'First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth', 'Nineth', 'Tenth' /* and so on up to "twentieth" */ ];
  var tens = {
      20: 'twenty',
      30: 'thirty',
      40: 'forty' /* and so on up to 90 */
  };
  var ordinalTens = {
      30: 'thirtieth',
      40: 'fortieth',
      50: 'fiftieth' /* and so on */
  };

  if( cardinal <= 20 ) {                    
      return ordinals[ cardinal ];
  }

  if( cardinal % 10 === 0 ) {
      return ordinalTens[ cardinal ];
  }

  return tens[ cardinal - ( cardinal % 10 ) ] + ordinals[ cardinal % 10 ];
}

// end of Javascript Ordinals


// Start Javascript Number to Text Function
// @:// https://stackoverflow.com/questions/5529934/javascript-numbers-to-words

number2text(value) {
  var fraction = Math.round(this.frac(value)*100);
  var f_text  = "";

  if(fraction > 0) {
      f_text = "AND "+this.convert_number(fraction)+" PAISE";
  }

  return this.convert_number(value)+" RUPEE "+f_text+" ONLY";
}

frac(f) {
  return f % 1;
}

convert_number(number)
{
  if ((number < 0) || (number > 999999999)) 
  { 
      return "NUMBER OUT OF RANGE!";
  }
  var Gn = Math.floor(number / 10000000);  /* Crore */ 
  number -= Gn * 10000000; 
  var kn = Math.floor(number / 100000);     /* lakhs */ 
  number -= kn * 100000; 
  var Hn = Math.floor(number / 1000);      /* thousand */ 
  number -= Hn * 1000; 
  var Dn = Math.floor(number / 100);       /* Tens (deca) */ 
  number = number % 100;               /* Ones */ 
  var tn= Math.floor(number / 10); 
  var one=Math.floor(number % 10); 
  var res = ""; 

  if (Gn>0) 
  { 
      res += (this.convert_number(Gn) + " CRORE"); 
  } 
  if (kn>0) 
  { 
          res += (((res=="") ? "" : " ") + 
          this.convert_number(kn) + " LAKH"); 
  } 
  if (Hn>0) 
  { 
      res += (((res=="") ? "" : " ") +
          this.convert_number(Hn) + " THOUSAND"); 
  } 

  if (Dn) 
  { 
      res += (((res=="") ? "" : " ") + 
          this.convert_number(Dn) + " HUNDRED"); 
  } 


  var ones = Array("", "ONE", "TWO", "THREE", "FOUR", "FIVE", "SIX","SEVEN", "EIGHT", "NINE", "TEN", "ELEVEN", "TWELVE", "THIRTEEN","FOURTEEN", "FIFTEEN", "SIXTEEN", "SEVENTEEN", "EIGHTEEN","NINETEEN"); 
var tens = Array("", "", "TWENTY", "THIRTY", "FOURTY", "FIFTY", "SIXTY","SEVENTY", "EIGHTY", "NINETY"); 

  if (tn>0 || one>0) 
  { 
      if (!(res=="")) 
      { 
          res += " AND "; 
      } 
      if (tn < 2) 
      { 
          res += ones[tn * 10 + one]; 
      } 
      else 
      { 

          res += tens[tn];
          if (one>0) 
          { 
              res += ("-" + ones[one]); 
          } 
      } 
  }

  if (res=="")
  { 
      res = "zero"; 
  } 
  return res;
}

// end number to text fucntions

 // gets the list of users assiciated for drop down.
getSubjectServicesOnly_Q(subject_id) {
  this._demoService.getSubjectServicesOnly(subject_id).subscribe(
     data => { 
      // this.subject_service_list_paragraphs = data;
      this.service_paragraphs_model = data[0] // single record

      if(this.service_paragraphs_model != '[]' && this.service_paragraphs_model != null && this.service_paragraphs_model != ''){
        this.getBrand_Q(this.service_paragraphs_model.who_service_id);
       }

    },
     err => console.error(err),
     () => console.log('Candidates Loaded.')
   );
 }




    // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
  // WORKS as I created my own function from this articel == pretty well convers
  transform2(value: any, args?: any): any {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.documentElement.textContent;
  }

      // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
      getHtml(html){
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
    

  /// TABS
  selectTab(tab_id: number) {
    if (this.staticTabs?.tabs?.[tab_id]) {
      this.staticTabs.tabs[tab_id].active = true;
    }
    this.selected_tab = tab_id; // so that we can load the queries only when the tabs clicked
  };


// gets the list of users assiciated for drop down.
getSubjectAttemptsAll_Q(subject_id) {
  this._demoService.getSubjectServiceAll(subject_id).subscribe(
     data => { 
      this.subject_service_list_paragraphs = data;
      this.attempts_paragraphs_model = data[0] // single record

      if(this.attempts_paragraphs_model != '[]' && this.attempts_paragraphs_model != null && this.attempts_paragraphs_model != '' ){
        this.getBrand_Q(this.attempts_paragraphs_model.who_service_id);
       }

    },
     err => console.error(err),
     () => console.log('Candidates Loaded.')
   );
 }








}





// I THINK THI IS GIVINGTHE WRON DATES??????????

// Allows formatting of dates etc...
export class DatePipeComponent {
  today: number = Date.now();
  fixedTimezone = '2018-04-11T09:03:01+1000'; // Fixed to Brisbane Australia
  // tslint:disable-next-line:eofline
}
